window.CHEM_OVERRIDE_MAP = {
 "seamlock pro i-transparent white - dripless sl9825": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "transparent white"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-white north - dripless sl9873": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "white north"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-cygnus pearl - dripless sl9864": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "cygnus pearl"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-crystal clear - dripless sl9863": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "crystal clear"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-pure white - dripless sl9837": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "pure white"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-baby's breath - dripless sl9959": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "baby's breath"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro anthracite - dripless sl9132": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "anthracite"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro pebble stone color adhesive cartridge - dripless sl9237": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "pebble"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro rhino stone color adhesive cartridge - dripless sl9238": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "rhino"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro sterling adhesive for countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "sterling"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro sahara stone color adhesive cartridge - dripless sl9240": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "sahara"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro bavarian cream - dripless sl9241": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "bavarian cream"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro timber wolf - dripless sl9259": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "timber wolf"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro veil adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "veil"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro burl white - dripless sl9265": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "burl white"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro argento stone color adhesive cartridge - dripless sl9272": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "argento"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro industrial - dripless sl9280": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "industrial"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro steak red - dripless sl9453": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "steak red"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-tuscan white - dripless sl9559": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "tuscan white"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro tower daybreak - dripless sl9572": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "daybreak"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "tower",
  "temp_range_f": "65-85"
 },
 "seamlock pro tower frosty white - dripless sl9574": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "frosty white"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "tower",
  "temp_range_f": "65-85"
 },
 "seamlock pro tower nubuck - dripless sl9575": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "nubuck"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "tower",
  "temp_range_f": "65-85"
 },
 "seamlock pro tower onias - dripless sl9576": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "onias"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "tower",
  "temp_range_f": "65-85"
 },
 "seamlock pro tower vanilla - dripless sl9577": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "vanilla"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "tower",
  "temp_range_f": "65-85"
 },
 "seamlock pro tower vellum - dripless sl9578": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "vellum"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "tower",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-crystal white - dripless sl9584": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "crystal white"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro raven stone color adhesive cartridge - dripless sl9645": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "raven"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro blanco stone color adhesive cartridge - dripless sl9646": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "blanco"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-wheat stone color adhesive cartridge - dripless sl9665": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "wheat"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-sand dollar - dripless sl9677": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "sand dollar"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-alabaster - dripless sl9679": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "alabaster"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro mountain stone color adhesive cartridge - dripless sl9687": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "mountain"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro birch stone color adhesive cartridge - dripless sl9689": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "birch"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro clamshell - dripless sl9699": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "clamshell"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro bone pro stone color adhesive cartridge - dripless sl9705": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "bone pro"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-cocoa stone color adhesive cartridge - dripless sl9716": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "cocoa"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-lunar stone color adhesive cartridge - dripless sl9751": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "lunar"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-weaping willow - dripless sl9758": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "weaping willow"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-lead stone color adhesive cartridge - dripless sl9761": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "lead"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-coffee stone color adhesive cartridge - dripless sl9762": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "coffee"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-wool stone color adhesive cartridge - dripless sl9763": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "wool"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-lily white - dripless sl9768": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "lily white"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-sabbia stone color adhesive cartridge - dripless sl9772": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "sabbia"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-sand stone color adhesive cartridge - dripless sl9331": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "sand"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-pumice stone color adhesive cartridge - dripless sl9777": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "pumice"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-warm grey - dripless sl9806": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "warm grey"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-river rock - dripless sl9807": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "river rock"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-suede stone color adhesive cartridge - dripless sl9898": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "suede"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-dove stone color adhesive cartridge - dripless sl9915": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "dove"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-cedar stone color adhesive cartridge - dripless sl9916": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "cedar"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-bisquit - dripless sl9919": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "bisquit"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro hadley stone color adhesive cartridge - dripless sl9930": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "hadley"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro c neutral - dripless sl9943": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "c neutral"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-polar stone color adhesive cartridge - dripless sl9945": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "polar"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro silverite - dripless sl9950": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "silverite"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-onyx stone color adhesive cartridge - dripless sl9953": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "onyx"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-midnight - dripless sl9954": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "midnight"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-raven stone color adhesive cartridge - dripless sl9955": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "raven"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-balsa stone color adhesive cartridge - dripless sl9958": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "balsa"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro nantucket - dripless sl9960": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "nantucket"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-ash stone color adhesive cartridge - dripless sl9961": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "ash"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro uliano adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "uliano"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro messina stone color adhesive cartridge - dripless sl9993": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "messina"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro salo stone color adhesive cartridge - dripless sl9995": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "salo"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro winter adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "winter"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro bright stone color adhesive cartridge - dripless sl9102": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "bright"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro brilliant - dripless sl9103": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "brilliant"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro cotton stone color adhesive cartridge - dripless sl9104": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "cotton"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro vanilla adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "vanilla"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro marble stone color adhesive cartridge - dripless sl9106": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "marble"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro porcelain - dripless sl9107": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "porcelain"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro snow adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "snow"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro antique stone seam adhesive -- dripless sl9109": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "antique stone seam"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro satin stone color adhesive cartridge - dripless sl9110": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "satin"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro glacier stone color adhesive cartridge - dripless sl9111": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "glacier"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro canvas stone color adhesive cartridge - dripless sl9112": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "canvas"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro blizzard stone color adhesive cartridge - dripless sl9113": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "blizzard"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro opal stone color adhesive cartridge - dripless sl9114": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "opal"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro ghost stone color adhesive cartridge - dripless sl9115": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "ghost"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro newport stone color adhesive cartridge - dripless sl9116": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "newport"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro designer white - dripless sl9117": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "designer white"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro cloud stone color adhesive cartridge - dripless sl9118": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "cloud"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro white adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "white"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro cameo stone color adhesive cartridge - dripless sl9120": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "cameo"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro arctic stone color adhesive cartridge - dripless sl9121": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "arctic"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro inf8701 stone color adhesive cartridge - dripless sl9122": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "inf8701"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro sterling white - dripless sl9125": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "sterling white"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro clear stone color adhesive cartridge - dripless sl9199": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "clear"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro fog stone color adhesive cartridge - dripless sl9200": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "fog"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro buff stone color adhesive cartridge - dripless sl9210": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "buff"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro natural stone color adhesive cartridge - dripless sl9214": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "natural"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro sand stone color adhesive cartridge - dripless sl9216": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "sand"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro ice stone color adhesive cartridge - dripless sl9218": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "ice"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro misty stone color adhesive cartridge - dripless sl9220": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "misty"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro stone adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro blonde stone color adhesive cartridge - dripless sl9225": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "blonde"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro butter stone color adhesive cartridge - dripless sl9226": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "butter"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro beach stone color adhesive cartridge - dripless sl9230": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "beach"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro manilla stone color adhesive cartridge - dripless sl9231": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "manilla"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro cream stone color adhesive cartridge - dripless sl9232": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "cream"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro caramel stone color adhesive cartridge - dripless sl9234": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "caramel"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro torano adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "torano"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro khaki stone color adhesive cartridge - dripless sl9236": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "khaki"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro warm nature - dripless sl9277": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "warm nature"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro grey nature - dripless sl9278": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "grey nature"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro redfire stone color adhesive cartridge - dripless sl9279": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "redfire"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro serene stone color adhesive cartridge - dripless sl9304": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "serene"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro dune stone color adhesive cartridge - dripless sl9310": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "dune"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro latte stone color adhesive cartridge - dripless sl9312": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "latte"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro willow adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "willow"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro fawn stone color adhesive cartridge - dripless sl9316": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "fawn"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro sonora adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "sonora"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro toffee adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "toffee"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro mocha stone color adhesive cartridge - dripless sl9322": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "mocha"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro cocoa stone color adhesive cartridge - dripless sl9323": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "cocoa"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro chocolate - dripless sl9324": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "chocolate"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro suede adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "suede"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro auburn stone color adhesive cartridge - dripless sl9330": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "auburn"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro roast stone color adhesive cartridge - dripless sl9332": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "roast"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro sunshine adhesive for countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "sunshine"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro orange zest - dripless sl9415": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "orange zest"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro copper stone color adhesive cartridge - dripless sl9418": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "copper"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro rust stone color adhesive cartridge - dripless sl9424": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "rust"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro hazel stone color adhesive cartridge - dripless sl9432": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "hazel"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro fuego stone color adhesive cartridge - dripless sl9450": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "fuego"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro red stone color adhesive cartridge - dripless sl9451": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "red"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro red lava stone color adhesive cartridge - dripless sl9452": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "red lava"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro universe adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "universe"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro skye adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "skye"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro elbert stone color adhesive cartridge - dripless sl9505": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "elbert"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro urban grey - dripless sl9506": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "urban grey"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro splendor gray - dripless sl9507": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "splendor gray"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro titanium grey - dripless sl9508": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "titanium grey"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro dove shimmer - dripless sl9509": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "dove shimmer"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro pearl stone color adhesive cartridge - dripless sl9510": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "pearl"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro archer grey - dripless sl9511": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "archer grey"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro slate adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "slate"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro gray s005 - dripless sl9513": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "gray s005"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro ore stone color adhesive cartridge - dripless sl9515": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "ore"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro prairie stone color adhesive cartridge - dripless sl9516": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "prairie"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro concrete gray - dripless sl9517": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "concrete gray"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro pewter stone color adhesive cartridge - dripless sl9518": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "pewter"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro mist gray - dripless sl9519": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "mist gray"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro olive stone color adhesive cartridge - dripless sl9520": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "olive"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro lava stone color adhesive cartridge - dripless sl9521": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "lava"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro thunder adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "thunder"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro smoke adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "smoke"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro deep cloud - dripless sl9524": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "deep cloud"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro shale adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "shale"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro clay stone color adhesive cartridge - dripless sl9526": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "clay"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro new concrete - dripless sl9527": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "new concrete"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro espresso stone color adhesive cartridge - dripless sl9528": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "espresso"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro oyster stone color adhesive cartridge - dripless sl9529": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "oyster"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro coal stone color adhesive cartridge - dripless sl9530": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "coal"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro sable stone color adhesive cartridge - dripless sl9531": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "sable"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro midnight stone color adhesive cartridge - dripless sl9532": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "midnight"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro titanium adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "titanium"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro pitch stone color adhesive cartridge - dripless sl9534": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "pitch"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-snow white - dripless sl9537": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "snow white"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro tornado gray - dripless sl9538": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "tornado gray"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-sandstone - dripless sl9539": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "sandstone"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro antique blue - dripless sl9540": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "antique blue"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro placid stone color adhesive cartridge - dripless sl9541": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "placid"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-fieldstone - dripless sl9776": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "fieldstone"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro green stone color adhesive cartridge - dripless sl9560": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "green"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro cherry pink - dripless sl9561": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "cherry pink"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro horizon haze - dripless sl9562": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "horizon haze"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro tower bisque - dripless sl9570": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "bisque"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "tower",
  "temp_range_f": "65-85"
 },
 "seamlock pro tower bone - dripless sl9571": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "bone"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "tower",
  "temp_range_f": "65-85"
 },
 "seamlock pro tower designer white - dripless sl9573": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "designer white"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "tower",
  "temp_range_f": "65-85"
 },
 "seamlock pro nova stone color adhesive cartridge - dripless sl9582": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "nova"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro design stone color adhesive cartridge - dripless sl9601": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "design"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro frosty stone color adhesive cartridge - dripless sl9603": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "frosty"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro mesa stone color adhesive cartridge - dripless sl9604": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "mesa"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro umber adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "umber"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro pudding stone color adhesive cartridge - dripless sl9606": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "pudding"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro adobe stone seam adhesive -- dripless sl9608": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "adobe stone seam"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro camel stone color adhesive cartridge - dripless sl9610": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "camel"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro sun color adhesive for countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "sun color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro hot stone color adhesive cartridge - dripless sl9617": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "hot"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro mandarin stone color adhesive cartridge - dripless sl9619": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "mandarin"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro fire stone color adhesive cartridge - dripless sl9621": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "fire"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro silver adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "silver"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro ash stone color adhesive cartridge - dripless sl9623": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "ash"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro malt stone color adhesive cartridge - dripless sl9624": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "malt"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro charcoal stone color adhesive cartridge - dripless sl9625": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "charcoal"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro flax stone color adhesive cartridge - dripless sl9627": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "flax"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro earth stone color adhesive cartridge - dripless sl9628": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "earth"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro lime stone color adhesive cartridge - dripless sl9632": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "lime"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro orange stone color adhesive cartridge - dripless sl9633": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "orange"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro nutmeg stone color adhesive cartridge - dripless sl9635": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "nutmeg"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro oregano stone color adhesive cartridge - dripless sl9636": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "oregano"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro ecru stone color adhesive cartridge - dripless sl9637": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "ecru"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro nickel stone color adhesive cartridge - dripless sl9638": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "nickel"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro chai stone color adhesive cartridge - dripless sl9639": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "chai"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro riverstone - dripless sl9641": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "riverstone"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro aluminum stone seam adhesive -- dripless sl9642": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "aluminum stone seam"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro coffee stone color adhesive cartridge - dripless sl9643": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "coffee"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro chestnut stone color adhesive cartridge - dripless sl9644": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "chestnut"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro moss stone color adhesive cartridge - dripless sl9647": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "moss"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro toscana adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "toscana"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro meridian stone color adhesive cartridge - dripless sl9649": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "meridian"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro banana stone color adhesive cartridge - dripless sl9650": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "banana"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro bala blue - dripless sl9652": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "bala blue"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro dover stone color adhesive cartridge - dripless sl9653": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "dover"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro devon stone color adhesive cartridge - dripless sl9654": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "devon"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro whisper adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "whisper"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro silt adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "silt"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro laguna stone color adhesive cartridge - dripless sl9658": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "laguna"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro cherry stone color adhesive cartridge - dripless sl9662": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "cherry"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro honeydew stone color adhesive cartridge - dripless sl9663": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "honeydew"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro pomegranite - dripless sl9666": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "pomegranite"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro rossa stone color adhesive cartridge - dripless sl9667": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "rossa"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro wood adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "wood"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro delfino stone color adhesive cartridge - dripless sl9671": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "delfino"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro shell adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "shell"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro clam stone color adhesive cartridge - dripless sl9673": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "clam"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro mojave stone color adhesive cartridge - dripless sl9674": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "mojave"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro danae stone color adhesive cartridge - dripless sl9675": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "danae"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro leather stone color adhesive cartridge - dripless sl9678": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "leather"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro marta stone color adhesive cartridge - dripless sl9680": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "marta"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro flannel stone color adhesive cartridge - dripless sl9682": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "flannel"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro sand storm - dripless sl9683": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "sand storm"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro botticino - dripless sl9684": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "botticino"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro happy red - dripless sl9691": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "happy red"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro hemp stone color adhesive cartridge - dripless sl9692": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "hemp"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro crimson stone color adhesive cartridge - dripless sl9693": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "crimson"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro tierra adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "tierra"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro battleship - dripless sl9718": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "battleship"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro conche stone color adhesive cartridge - dripless sl9719": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "conche"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro naranja stone color adhesive cartridge - dripless sl9729": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "naranja"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro bronze stone color adhesive cartridge - dripless sl9731": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "bronze"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro sandshire - dripless sl9732": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "sandshire"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro sussex adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "sussex"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro reading stone color adhesive cartridge - dripless sl9735": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "reading"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro brownie stone color adhesive cartridge - dripless sl9736": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "brownie"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro shadow adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "shadow"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro celestial - dripless sl9739": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "celestial"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-trufa stone color adhesive cartridge - dripless sl9742": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "trufa"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-glacier white - dripless sl9747": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "glacier white"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-bisque stone color adhesive cartridge - dripless sl9748": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "bisque"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro butternut - dripless sl9752": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "butternut"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro vicenza adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "vicenza"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro tempest adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "tempest"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-marone stone color adhesive cartridge - dripless sl9766": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "marone"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-cotton stone color adhesive cartridge - dripless sl9770": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "cotton"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-raton stone color adhesive cartridge - dripless sl9774": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "raton"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-nacreto - dripless sl9778": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "nacreto"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-arctic white - dripless sl9780": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "arctic white"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-cinder stone color adhesive cartridge - dripless sl9781": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "cinder"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-ginger stone color adhesive cartridge - dripless sl9782": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "ginger"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-graphite - dripless sl9783": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "graphite"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-medea stone color adhesive cartridge - dripless sl9784": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "medea"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-polar white - dripless sl9785": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "polar white"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-white linen - dripless sl9786": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "white linen"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-winter white - dripless sl9787": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "winter white"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-champagne - dripless sl9788": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "champagne"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-cinnamon spice - dripless sl9789": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "cinnamon spice"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-giallo stone color adhesive cartridge - dripless sl9792": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "giallo"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-iron grey - dripless sl9794": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "iron grey"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-natural almond - dripless sl9795": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "natural almond"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-natural grey - dripless sl9796": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "natural grey"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-nougat stone color adhesive cartridge - dripless sl9797": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "nougat"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-seashell - dripless sl9798": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "seashell"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-tan stone color adhesive cartridge - dripless sl9799": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "tan"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-chameleon - dripless sl9800": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "chameleon"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-casper stone color adhesive cartridge - dripless sl9801": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "casper"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-dawn stone color adhesive cartridge - dripless sl9802": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "dawn"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-taupe stone color adhesive cartridge - dripless sl9803": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "taupe"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-boulder - dripless sl9810": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "boulder"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-flint stone color adhesive cartridge - dripless sl9811": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "flint"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-white chocolate - dripless sl9813": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "white chocolate"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-pewter stone color adhesive cartridge - dripless sl9814": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "pewter"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-pearl grey - dripless sl9815": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "pearl grey"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-bone stone color adhesive cartridge - dripless sl9816": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "bone"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-cocoa brown - dripless sl9818": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "cocoa brown"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-slate stone color adhesive cartridge - dripless sl9819": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "slate"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-earth brown - dripless sl9820": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "earth brown"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-sage stone color adhesive cartridge - dripless sl9821": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "sage"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-bright white - dripless sl9822": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "bright white"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-charcoal - dripless sl9823": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "charcoal"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-butterscotch - dripless sl9824": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "butterscotch"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-magic stone color adhesive cartridge - dripless sl9826": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "magic"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-satin black - dripless sl9827": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "satin black"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-khaki stone color adhesive cartridge - dripless sl9828": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "khaki"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-acorn stone color adhesive cartridge - dripless sl9829": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "acorn"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-toffee stone color adhesive cartridge - dripless sl9830": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "toffee"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-aqueous - dripless sl9831": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "aqueous"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-ash stone color adhesive cartridge - dripless sl9832": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "ash"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-autumn light - dripless sl9833": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "autumn light"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-beach stone color adhesive cartridge - dripless sl9834": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "beach"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-cambrian gold - dripless sl9835": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "cambrian gold"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-desert stone color adhesive cartridge - dripless sl9836": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "desert"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-espresso - dripless sl9838": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "espresso"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-lunar pearl - dripless sl9842": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "lunar pearl"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-natural - dripless sl9844": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "natural"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-pearl stone color adhesive cartridge - dripless sl9845": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "pearl"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-pudding brown - dripless sl9846": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "pudding brown"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-rambone - dripless sl9847": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "rambone"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-rhin stone color adhesive cartridge - dripless sl9848": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "rhin"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro oat stone color adhesive cartridge - dripless sl9850": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "oat"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-silver stone color adhesive cartridge - dripless sl9851": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "silver"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-storm grey - dripless sl9852": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "storm grey"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-thunder grey - dripless sl9853": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "thunder grey"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-tidal sand - dripless sl9854": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "tidal sand"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-tusk stone color adhesive cartridge - dripless sl9855": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "tusk"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-uba tuba - dripless sl9856": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "uba tuba"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-transparent black - dripless sl9857": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "transparent black"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-aztec gold - dripless sl9858": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "aztec gold"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-amarillo - dripless sl9861": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "amarillo"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-coffee stone color adhesive cartridge - dripless sl9862": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "coffee"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-dusk stone color adhesive cartridge - dripless sl9865": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "dusk"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-mocha stone color adhesive cartridge - dripless sl9867": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "mocha"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-neutral - dripless sl9868": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "neutral"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-newport grey - dripless sl9869": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "newport grey"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-stellar grey - dripless sl9871": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stellar grey"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-white stone color adhesive cartridge - dripless sl9872": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "white"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-absolute grey - dripless sl9874": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "absolute grey"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-alabaster - dripless sl9875": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "alabaster"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-amazon stone color adhesive cartridge - dripless sl9876": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "amazon"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-beige olimpo - dripless sl9878": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "beige olimpo"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-black stone color adhesive cartridge - dripless sl9879": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "black"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-brazilian brown - dripless sl9881": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "brazilian brown"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-brie stone color adhesive cartridge - dripless sl9882": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "brie"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-cloud stone color adhesive cartridge - dripless sl9883": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "cloud"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-concrete - dripless sl9884": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "concrete"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-diana pearl - dripless sl9885": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "diana pearl"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-galaxy black - dripless sl9886": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "galaxy black"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-jet black - dripless sl9887": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "jet black"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-limestone - dripless sl9888": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "limestone"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-mercury grey - dripless sl9889": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "mercury grey"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-meteor grey - dripless sl9890": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "meteor grey"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-newgale grey - dripless sl9891": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "newgale grey"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-onyx stone color adhesive cartridge - dripless sl9892": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "onyx"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-oyster stone color adhesive cartridge - dripless sl9893": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "oyster"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-perfect white - dripless sl9894": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "perfect white"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-sahara stone color adhesive cartridge - dripless sl9895": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "sahara"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-vega rose - dripless sl9896": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "vega rose"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-zenith stone color adhesive cartridge - dripless sl9897": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "zenith"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-vela brown - dripless sl9899": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "vela brown"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-quarry stone color adhesive cartridge - dripless sl9900": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "quarry"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro brume stone color adhesive cartridge - dripless sl9904": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "brume"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro jungle stone color adhesive cartridge - dripless sl9905": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "jungle"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro mango stone color adhesive cartridge - dripless sl9906": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "mango"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro apple stone seam adhesive -- dripless sl9907": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "apple stone seam"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro putty stone color adhesive cartridge - dripless sl9908": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "putty"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro blue stone color adhesive cartridge - dripless sl9909": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "blue"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro vino adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "vino"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro azul stone color adhesive cartridge - dripless sl9911": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "azul"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro carbon stone color adhesive cartridge - dripless sl9912": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "carbon"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro rain stone color adhesive cartridge - dripless sl9913": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "rain"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro grey stone color adhesive cartridge - dripless sl9917": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "grey"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro rouge stone color adhesive cartridge - dripless sl9920": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "rouge"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro gris stone color adhesive cartridge - dripless sl9925": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "gris"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro tan color adhesive for countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "tan color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro tawny adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "tawny"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro pink stone color adhesive cartridge - dripless sl9931": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "pink"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro fossil stone color adhesive cartridge - dripless sl9946": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "fossil"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-steel grey - dripless sl9947": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "steel grey"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro pea stone color adhesive cartridge - dripless sl9951": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "pea"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro emperador - dripless sl9966": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "emperador"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro paprika stone color adhesive cartridge - dripless sl9967": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "paprika"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro coral stone color adhesive cartridge - dripless sl9977": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "coral"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro nirvana stone color adhesive cartridge - dripless sl9978": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "nirvana"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro moose stone color adhesive cartridge - dripless sl9979": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "moose"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro bourbon stone color adhesive cartridge - dripless sl9985": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "bourbon"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro bento stone color adhesive cartridge - dripless sl9986": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "bento"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro mystic gray - dripless sl9988": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "mystic gray"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro marmi stone color adhesive cartridge - dripless sl9989": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "marmi"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro dark roast - dripless sl9990": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "dark roast"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "big dog seamlock pro wax adhesive for stone countertop seaming": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "wax"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-crystal clear - dripless sl9999": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "crystal clear"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-slate stone color adhesive cartridge - dripless sl9760": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "slate"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-oxford brown - dripless sl9476": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "oxford brown"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "tenax colored knife grade polyester - professional grade": {
  "type": "adhesive",
  "subtype": "Polyester",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "fissures",
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "multiple pre-colored options"
  ],
  "warnings": [
   "Interior only - not UV stable.",
   "Requires Tenax hardener.",
   "Available in multiple pre-tinted colors.",
   "May yellow on light-colored marble over time.",
   "NOT recommended for engineered quartz or quartz surfaces - use vinyl-ester or methacrylate instead."
  ],
  "disc": false,
  "mix_ratio": "100:2-3 (resin to hardener by weight)",
  "work_time": "4-6 min",
  "cure_time": "20-30 min"
 },
 "tenax titanium transparent knife grade vinylester glue - 1 gallon": {
  "type": "adhesive",
  "subtype": "Vinyl-Ester",
  "vendor": "Tenax",
  "env": [
   "exterior",
   "interior"
  ],
  "app": [
   "rodding",
   "fissures",
   "mitering",
   "seaming",
   "laminating",
   "repair"
  ],
  "mat": [
   "engineered",
   "marble",
   "granite",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "warnings": [
   "Low yellowing but formulated for UV resistance.",
   "Store between 68-77F.",
   "12-month shelf life.",
   "1 gallon size."
  ],
  "disc": false,
  "mix_ratio": "100:2-3 (resin to catalyst by weight)",
  "work_time": "4-5 min (gel time)",
  "cure_time": "15 min"
 },
 "tenax strong edge professional stone adhesive system": {
  "type": "adhesive",
  "subtype": "Epoxy",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "rodding",
   "seaming",
   "mitering",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "granite",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "water clear (colorable)"
  ],
  "warnings": [
   "Strongest clear knife-grade epoxy in Tenax line.",
   "Polishable.",
   "Does not shrink.",
   "Prevents delamination.",
   "Long cure time compared to polyester adhesives."
  ],
  "disc": false,
  "mix_ratio": "2:1",
  "work_time": "30-60 min",
  "cure_time": "~45 min at 75F"
 },
 "tenax domo epoxy adhesive for stone fabrication": {
  "type": "adhesive",
  "subtype": "Epoxy",
  "vendor": "Tenax",
  "env": [
   "exterior",
   "interior"
  ],
  "app": [
   "rodding",
   "anchoring",
   "substrate-bonding",
   "seaming",
   "laminating",
   "repair"
  ],
  "mat": [
   "engineered",
   "marble",
   "concrete",
   "granite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "white (colorable with Tenax Universal Colors)"
  ],
  "warnings": [
   "Colors easily with Tenax pigments.",
   "Bonds to polished and damp surfaces.",
   "VOC compliant.",
   "2-year shelf life at 65-77F.",
   "Long cure time compared to polyester adhesives."
  ],
  "disc": false,
  "mix_ratio": "1:1",
  "work_time": "~2.5 hours (gel time at 77F)",
  "cure_time": "24 hours (full cure); tack-free ~4 hours"
 },
 "tenax multibond acrylic cartridge adhesive 250 ml - styrene-free color match for stone": {
  "type": "adhesive",
  "subtype": "Acrylic (Methacrylate)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair"
  ],
  "mat": [
   "engineered",
   "marble",
   "granite",
   "sintered",
   "porcelain"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Gel",
  "colors": [
   "multiple color-matched options"
  ],
  "warnings": [
   "Styrene-free formula.",
   "Dripless - suitable for vertical surfaces.",
   "Requires Tenax 10:1 cartridge gun.",
   "Super flexible."
  ],
  "disc": false,
  "mix_ratio": "10:1 (pre-dosed cartridge)",
  "work_time": "8-12 min",
  "cure_time": "20-30 min"
 },
 "tenax transparent flowing polyester adhesive big box (4 x 1.25 gallon)": {
  "type": "adhesive",
  "subtype": "Polyester",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "fissures",
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "quartzite",
   "marble",
   "granite"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "warnings": [
   "Interior only - not UV stable.",
   "Horizontal application only due to flowing consistency.",
   "Big box: 4 x 1.25 gallon.",
   "May yellow on light-colored marble over time.",
   "Runs on vertical surfaces - use knife-grade for vertical work.",
   "NOT recommended for engineered quartz or quartz surfaces - use vinyl-ester or methacrylate instead."
  ],
  "disc": false,
  "mix_ratio": "100:2-3 (resin to hardener by weight)",
  "work_time": "4-6 min",
  "cure_time": "20-30 min"
 },
 "tenax vertigo s colorless knife grade vinyl ester big box (4 x 1.25 gallon)": {
  "type": "adhesive",
  "subtype": "Vinyl-Ester",
  "vendor": "Tenax",
  "env": [
   "exterior",
   "interior"
  ],
  "app": [
   "rodding",
   "fissures",
   "mitering",
   "seaming",
   "laminating",
   "repair"
  ],
  "mat": [
   "engineered",
   "marble",
   "granite",
   "sintered",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "water clear"
  ],
  "warnings": [
   "Low yellowing - formulated for UV resistance.",
   "Drip-less formula.",
   "Big box: 4 x 1.25 gallon."
  ],
  "disc": false,
  "mix_ratio": "100:2-3 (resin to catalyst by weight)",
  "work_time": "4-5 min (gel time)",
  "cure_time": "25 min"
 },
 "tixo ex transparent knife grade adhesive 17 kg": {
  "type": "adhesive",
  "subtype": "Polyester",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "fissures",
   "repair"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "warnings": [
   "Interior only - not UV stable.",
   "17 kg bulk pail.",
   "May yellow on light-colored marble over time.",
   "NOT recommended for engineered quartz or quartz surfaces - use vinyl-ester or methacrylate instead.",
   "Tixo is a repair and fissure-fill product. NOT for structural seaming or lamination."
  ],
  "disc": false,
  "mix_ratio": "100:2-3 (resin to hardener by weight)",
  "work_time": "4-6 min",
  "cure_time": "20-30 min"
 },
 "tenax flowing titanium vinyl ester adhesive for granite and marble lamination": {
  "type": "adhesive",
  "subtype": "Vinyl-Ester",
  "vendor": "Tenax",
  "env": [
   "exterior",
   "interior"
  ],
  "app": [
   "rodding",
   "fissures",
   "seaming",
   "laminating",
   "repair"
  ],
  "mat": [
   "quartzite",
   "marble",
   "granite",
   "engineered"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "extra clear (slight blue-purple tint)"
  ],
  "warnings": [
   "Low yellowing - formulated for UV resistance.",
   "Store between 68-77F.",
   "12-month shelf life.",
   "Horizontal application only.",
   "Runs on vertical surfaces - use knife-grade for vertical work."
  ],
  "disc": false,
  "mix_ratio": "100:2-3 (resin to catalyst by weight)",
  "work_time": "4-5 min (gel time)",
  "cure_time": "15 min"
 },
 "tenax glaxs bb 65 epoxy adhesive for stone fabrication": {
  "type": "adhesive",
  "subtype": "Acrylic-Resin",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "fissures",
   "repair",
   "laminating"
  ],
  "mat": [
   "quartzite",
   "marble",
   "granite",
   "engineered"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "water clear"
  ],
  "warnings": [
   "Zero yellowing - UV stable.",
   "Zero VOC.",
   "Cures at any temperature including 0C.",
   "Ideal for white marble and porous stone.",
   "1-year shelf life at 65-77F.",
   "Runs on vertical surfaces - use knife-grade for vertical work."
  ],
  "disc": false,
  "mix_ratio": "100:65",
  "work_time": "8-12 min",
  "cure_time": "~20-25 min"
 },
 "proseal nano premium grade quartzite stone sealer": {
  "type": "sealer",
  "subtype": "Penetrating Impregnator With Nanotechnology, Solvent-Based",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "quartzite",
   "engineered",
   "granite",
   "concrete"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Solvent-based.",
   "Works on polished, honed, sandblasted, flamed finishes.",
   "Incompatible with acids, bases, strong oxidants, aluminium, plastics.",
   "Does not alter natural breathability."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "problems": [
   "water-damage"
  ]
 },
 "tenax hydrex natural effect sealer for natural and engineered stone": {
  "type": "sealer",
  "subtype": "Penetrating Impregnator, Solvent-Based, Natural Effect",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "quartzite",
   "marble",
   "granite",
   "engineered"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Does NOT change stone color - natural effect.",
   "Water and oil proof.",
   "Does NOT provide anti-etch protection on marble.",
   "Coverage: 215-323 sq ft per liter.",
   "2-year shelf life at 65-77F."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "24 hours full protection"
 },
 "stain rescue remover ( formerly known as tenax quartz extraclean pro ) 1 qt": {
  "type": "stain-remover",
  "subtype": "Solvent-Based Cleaner For Engineered Stone",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "engineered"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Designed to remove greasy suction cup rings from quartz slabs.",
   "Apply with cloth, leave 1-2 minutes, rub in circular motion.",
   "Coverage: 200-300 sq ft per quart."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax cera pasta clear wax paste (1 liter / 1 quart)": {
  "type": "wax",
  "subtype": "Paste Wax For Stone Finishing",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "mat": [
   "marble",
   "granite",
   "engineered",
   "travertine"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Paste",
  "colors": [
   "clear"
  ],
  "warnings": [
   "Increases polish and eliminates superficial defects.",
   "Accents stone color.",
   "For onyxes, marbles, agglomerates, and terrazzo."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "app": [
   "enhancing"
  ]
 },
 "tenax teclean stain remover 8 oz for stone surface restoration": {
  "type": "stain-remover",
  "subtype": "Poultice Powder Stain Remover",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "granite",
   "concrete",
   "engineered",
   "travertine"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Poultice powder format - mix with water to form paste.",
   "Apply to stain, cover, let dry, then remove."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax skudo shield - quartz shield - 1 l": {
  "type": "sealer",
  "subtype": "Penetrating Impregnator, Water-Based, Natural Effect",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "quartzite",
   "engineered",
   "granite",
   "porcelain"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Water-based formula.",
   "Food contact approved (EC Reg 1935/2004).",
   "Repels oil and water.",
   "Safe for quartz and engineered stone.",
   "Does not form surface films."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "problems": [
   "water-damage"
  ]
 },
 "tenax cera black g liquid wax for black granite": {
  "type": "wax",
  "subtype": "Liquid Wax For Dark Stone Maintenance",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "mat": [
   "granite"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [
   "black"
  ],
  "warnings": [
   "Specifically designed for black granite.",
   "Increases black effect without increasing gloss.",
   "Also known as Uniblack 2.",
   "Use after Toner Black for complete black restoration system.",
   "2-year shelf life at 65-77F."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "app": [
   "enhancing"
  ]
 },
 "tenax terust rust remover powder for stone and marble cleaning": {
  "type": "stain-remover",
  "subtype": "Rust Remover Powder",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "granite",
   "concrete",
   "engineered",
   "travertine"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Powder format - mix with water.",
   "Specifically for rust stain removal from stone."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax hydrex natural effect stone sealer for granite and marble": {
  "type": "sealer",
  "subtype": "Penetrating Impregnator, Solvent-Based, Natural Effect",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "quartzite",
   "marble",
   "granite",
   "engineered"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Does NOT change stone color - natural effect.",
   "Water and oil proof.",
   "Does NOT provide anti-etch protection on marble.",
   "Coverage: 215-323 sq ft per liter.",
   "2-year shelf life at 65-77F."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "24 hours full protection"
 },
 "tenax ager stone color enhancing sealer 1 quart": {
  "type": "enhancer",
  "subtype": "Penetrating Color Enhancer With Sealing, Solvent-Based",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "marble",
   "engineered",
   "concrete",
   "granite",
   "sintered",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Does NOT provide anti-etch protection on marble.",
   "UV resistant, non-yellowing.",
   "Wait 24 hours for finished surface.",
   "No foot traffic for 4-6 hours after treatment.",
   "1 quart size.",
   "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "not_for_restoration": true
 },
 "tenax ager tiger 1qt. (1l) exotic stone enhancer & sealer for granite - color enriching, stain protection": {
  "type": "enhancer",
  "subtype": "Penetrating Color Enhancer With Sealing, Solvent-Based, For Exotic Stone",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "marble",
   "concrete",
   "granite",
   "sintered",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Designed for exotic stones - darkens and enriches color.",
   "Does NOT provide anti-etch protection on marble.",
   "UV resistant, non-yellowing.",
   "Drying time ~1 hour.",
   "Wait 24 hours before foot traffic.",
   "Coverage: 140-323 sq ft per liter depending on porosity."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "24 hours water repellent",
  "not_for_restoration": true
 },
 "tenax booster alk easy alkaline stone treatment - 750 ml": {
  "type": "stain-remover",
  "subtype": "Ready-To-Use Alkaline Spray Cleaner/Degreaser",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "engineered",
   "concrete",
   "granite",
   "porcelain"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Do not dilute - use as-is.",
   "Maximum contact time: 30 minutes.",
   "Removes organic stains, wax residue, food stains.",
   "May affect alkali-sensitive surfaces.",
   "750 ml spray bottle."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax wax remover for natural stone surfaces - 1 quart": {
  "type": "cleaner",
  "subtype": "Solvent-Based Wax Remover",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "granite",
   "engineered"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Removes paste and liquid wax residue from stone surfaces.",
   "Solvent-based."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax stain rescue remover 250 ml for granite and marble care": {
  "type": "stain-remover",
  "subtype": "Solvent-Based Cleaner For Engineered Stone",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "engineered"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Designed to remove greasy suction cup rings from quartz slabs.",
   "Apply with cloth, leave 1-2 minutes, rub in circular motion.",
   "250 ml size."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax ager tiger exotic stone sealer 250 ml": {
  "type": "enhancer",
  "subtype": "Penetrating Color Enhancer With Sealing, Solvent-Based, For Exotic Stone",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "marble",
   "concrete",
   "granite",
   "sintered",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Designed for exotic stones - darkens and enriches color.",
   "Does NOT provide anti-etch protection on marble.",
   "UV resistant, non-yellowing.",
   "250 ml size."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "24 hours water repellent",
  "not_for_restoration": true
 },
 "tenax ager fs water-based sealer 250 ml food safe": {
  "type": "enhancer",
  "subtype": "Water-Based Color Enhancer With Sealing, Food-Safe Certified",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "marble",
   "engineered",
   "concrete",
   "granite",
   "sintered",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Food contact approved (EC Reg 90/128 ECC).",
   "Water-based - lower VOC.",
   "Conceals small scratches on engineered stone.",
   "UV stable - does not change color in sunlight.",
   "250 ml size.",
   "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "not_for_restoration": true
 },
 "tenax luxor spray 0.5 liter aerosol varnish": {
  "type": "polish",
  "subtype": "Aerosol Self-Polishing Varnish Spray",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "marble",
   "granite",
   "engineered",
   "travertine"
  ],
  "problems": [
   "fading",
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Forms hard anti-scratch film on surface.",
   "UV stable - does not yellow.",
   "Excellent for chiseled edges and underside of overhangs.",
   "Aerosol spray format - 0.5 liter."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax rust remover liquid 1 liter for natural stone surfaces": {
  "type": "stain-remover",
  "subtype": "Liquid Rust Remover For Stone",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "granite",
   "concrete",
   "engineered",
   "travertine"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Specifically for rust stain removal from stone.",
   "1 liter liquid format."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax lustro italiano reseal kit for natural stone surfaces": {
  "type": "sealer",
  "subtype": "Consumer Stone Resealing Kit",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "marble",
   "granite",
   "engineered"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Part of Lustro Italiano consumer stone care line.",
   "Kit includes sealer and application materials."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "problems": [
   "water-damage"
  ]
 },
 "tenax lustro italiano quartz stone sealer 16 fl oz": {
  "type": "sealer",
  "subtype": "Penetrating Impregnator For Engineered Stone",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "engineered"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Designed specifically for quartz and engineered stone.",
   "Part of Lustro Italiano consumer line.",
   "16 fl oz size."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "problems": [
   "water-damage"
  ]
 },
 "tenax lustro italiano stain remover poultice powder 8 oz": {
  "type": "stain-remover",
  "subtype": "Poultice Powder Stain Remover",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "granite",
   "concrete",
   "engineered",
   "travertine"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Poultice powder format - mix with water to form paste.",
   "Part of Lustro Italiano consumer line.",
   "8 oz size."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax concrete prowax 1 liter - protective polymer coating for cement surfaces": {
  "type": "sealer",
  "subtype": "Protective Polymer Coating For Cement",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "concrete"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Polymer blend creates protective film in pores.",
   "For cement and cement agglomerates.",
   "Protects from organic and inorganic substances."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "problems": [
   "water-damage"
  ]
 },
 "tenax cera fluida liquid stone wax 1 quart for marble & granite": {
  "type": "wax",
  "subtype": "Liquid Wax For Stone Finishing",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "mat": [
   "marble",
   "granite",
   "engineered",
   "travertine"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [
   "clear"
  ],
  "warnings": [
   "Increases polish and eliminates superficial defects on marble.",
   "Accents stone color.",
   "For onyxes, marbles, agglomerates, and terrazzo."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "app": [
   "enhancing"
  ]
 },
 "ager - the original color enhancer impregnataor sealer": {
  "type": "enhancer",
  "subtype": "Penetrating Color Enhancer With Sealing, Solvent-Based",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "marble",
   "engineered",
   "concrete",
   "granite",
   "sintered",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Does NOT provide anti-etch protection on marble.",
   "UV resistant, non-yellowing.",
   "Wait 24 hours for finished surface.",
   "No foot traffic for 4-6 hours after treatment.",
   "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "not_for_restoration": true
 },
 "tenax hydrex polished stone sealer - 5 l": {
  "type": "sealer",
  "subtype": "Penetrating Impregnator, Solvent-Based, Natural Effect",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "quartzite",
   "marble",
   "granite",
   "engineered"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Does NOT change stone color - natural effect.",
   "Water and oil proof.",
   "Does NOT provide anti-etch protection on marble.",
   "5 liter bulk size."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "24 hours full protection"
 },
 "tenax quarzo toner plus color enhancer sealer - 1 l": {
  "type": "enhancer",
  "subtype": "Color Enhancer With Sealing For Engineered Stone, Food-Safe",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "quartzite",
   "engineered",
   "granite"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Food contact approved (EC Reg 90/128 ECC).",
   "Conceals minor scratches and imperfections.",
   "UV stable - does not change color in sunlight.",
   "Oil and water resistance.",
   "1 liter size."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax marble stain and etch remover for natural stone surfaces": {
  "type": "stain-remover",
  "subtype": "Stain And Etch Remover For Marble",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "limestone",
   "marble",
   "travertine"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "For marble and limestone surfaces.",
   "Addresses both stains and etch marks."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax marble rust and etch remover for natural stone surfaces": {
  "type": "stain-remover",
  "subtype": "Rust And Etch Remover For Marble",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "limestone",
   "marble",
   "travertine"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "For marble and limestone surfaces.",
   "Addresses both rust stains and etch marks."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax booster concentrated stone performance enhancer - 1 liter": {
  "type": "cleaner",
  "subtype": "Concentrated Alkaline Hard Surface Cleaner",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "engineered",
   "granite",
   "sintered",
   "porcelain"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Concentrated formula - dilute before use.",
   "Alkaline cleaner for heavy-duty cleaning.",
   "1 liter size."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax ager fs water-based color enhancing sealer - 1 quart": {
  "type": "enhancer",
  "subtype": "Water-Based Color Enhancer With Sealing, Food-Safe Certified",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "marble",
   "engineered",
   "concrete",
   "granite",
   "sintered",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Food contact approved (EC Reg 90/128 ECC).",
   "Water-based - lower VOC.",
   "Conceals small scratches on engineered stone.",
   "UV stable - does not change color in sunlight.",
   "Coverage: 215-323 sq ft.",
   "2-year shelf life at 65-77F.",
   "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "not_for_restoration": true
 },
 "tenax booster alk alkaline stain remover for natural stone surfaces": {
  "type": "cleaner",
  "subtype": "Concentrated Alkaline Hard Surface Cleaner",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "engineered",
   "granite",
   "sintered",
   "porcelain"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Concentrated formula - dilute before use.",
   "Alkaline degreaser.",
   "Removes organic stains, grease, wax residue."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax petrolux trans 200 lt for stone fabrication": {
  "type": "enhancer",
  "subtype": "Penetrating Micro-Fissure Treatment And Color Enhancer",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "marble",
   "concrete",
   "granite",
   "sintered",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [
   "transparent"
  ],
  "warnings": [
   "Disguises superficial micro-porosities and web-cracks.",
   "Enhances color and adds topical polish.",
   "200 liter industrial drum.",
   "Test on hidden area first.",
   "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "not_for_restoration": true
 },
 "tenax ager 200 lt for natural stone for natural stone care": {
  "type": "enhancer",
  "subtype": "Penetrating Color Enhancer With Sealing, Solvent-Based",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "marble",
   "engineered",
   "concrete",
   "granite",
   "sintered",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Does NOT provide anti-etch protection on marble.",
   "UV resistant, non-yellowing.",
   "200 liter industrial drum.",
   "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "not_for_restoration": true
 },
 "tenax lustro italiano stone sealer 8.5 oz": {
  "type": "sealer",
  "subtype": "Consumer Spray Sealer With Polish",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "marble",
   "granite",
   "engineered",
   "travertine"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Part of Lustro Italiano consumer line.",
   "Aerosol spray with sealant.",
   "Coverage: ~120-150 sq ft per can.",
   "8.5 oz size."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "problems": [
   "water-damage"
  ]
 },
 "tenax toner black stone dye 1 quart - professional grade": {
  "type": "enhancer",
  "subtype": "Concentrated Black Color Enhancer/Dye",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "mat": [
   "granite"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [
   "black"
  ],
  "warnings": [
   "Very strong concentrated black dye.",
   "Designed for black granite restoration.",
   "Follow up with Cera Black G for maintenance.",
   "Store at 65-77F, 12-month shelf life."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "app": [
   "enhancing"
  ]
 },
 "tenax sealer and wax remover for natural and engineered stone": {
  "type": "cleaner",
  "subtype": "Solvent-Based Sealer And Wax Stripper",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "granite",
   "engineered"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Removes both sealers and waxes from stone.",
   "Use before resealing stone surfaces."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax sealer and wax remover 1 quart for natural and engineered stone": {
  "type": "cleaner",
  "subtype": "Solvent-Based Sealer And Wax Stripper",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "granite",
   "engineered"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Removes both sealers and waxes from stone.",
   "Use before resealing stone surfaces.",
   "1 quart size."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax zero purple liquid stain remover 1 liter": {
  "type": "stain-remover",
  "subtype": "Alkaline Active Chlorine Stain Remover",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "granite",
   "concrete",
   "travertine"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Contains active chlorine.",
   "Apply with roller or brush, leave 30-60 minutes, rinse.",
   "Not aggressive - safe for polished surfaces.",
   "Removes existing stains and prevents new spots."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax brioaction 2 mold remover for natural stone surfaces": {
  "type": "cleaner",
  "subtype": "Biodegradable Mold/Algae Remover And Sanitizer",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "concrete",
   "granite",
   "sintered",
   "porcelain"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Removes mold, moss, algae, musk, and fungus.",
   "Biodegradable (>90%).",
   "Non-toxic and environmentally friendly.",
   "Also an effective sanitizer.",
   "12-month shelf life at 65-77F."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax booster acid extra strong 1 quart - professional grade": {
  "type": "cleaner",
  "subtype": "Concentrated Acid Descaler/Cleaner",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "porcelain",
   "engineered",
   "sintered"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "ACID - Do NOT use on marble, limestone, or other acid-sensitive stone.",
   "Concentrated - dilute before use.",
   "For end-of-site cleaning.",
   "Removes limescale, mineral deposits, joint residues, rust traces."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax booster alk easy 200 liter - professional grade": {
  "type": "stain-remover",
  "subtype": "Ready-To-Use Alkaline Spray Cleaner/Degreaser",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "engineered",
   "concrete",
   "granite",
   "porcelain"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Maximum contact time: 30 minutes.",
   "Removes organic stains, wax residue, food stains.",
   "200 liter industrial drum."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax skudo stone sealer 1 quart for natural and engineered stone": {
  "type": "sealer",
  "subtype": "Penetrating Impregnator, Water-Based, Natural Effect",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "quartzite",
   "engineered",
   "granite",
   "porcelain"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Water-based formula.",
   "Food contact approved (EC Reg 1935/2004).",
   "Repels oil and water.",
   "Does not form surface films.",
   "1 quart size."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "problems": [
   "water-damage"
  ]
 },
 "tenax luxor wax for natural stone for natural stone finishing": {
  "type": "polish",
  "subtype": "Self-Polishing Varnish For Stone Finishing",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "marble",
   "granite",
   "engineered",
   "travertine"
  ],
  "problems": [
   "fading",
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Forms hard anti-scratch film on surface.",
   "UV stable - does not yellow.",
   "Excellent for chiseled edges and areas where mechanical polishing is difficult."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax concrete sealer and water repellant": {
  "type": "sealer",
  "subtype": "Penetrating Water Repellent For Concrete",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "concrete"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Penetrates deep into concrete.",
   "Protects against water without altering breathability.",
   "Protects against algae and mold."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax petrolux transparent microfissure repair and polish": {
  "type": "enhancer",
  "subtype": "Penetrating Micro-Fissure Treatment And Color Enhancer",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "marble",
   "concrete",
   "granite",
   "sintered",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [
   "transparent"
  ],
  "warnings": [
   "Disguises superficial micro-porosities and web-cracks on polished stone.",
   "Enhances color and adds topical polish.",
   "Best on polished dark granites.",
   "Test on hidden area first.",
   "Coverage: 215-323 sq ft per liter.",
   "2-year shelf life at 65-77F.",
   "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "not_for_restoration": true
 },
 "tenax ager stone enhancing sealer 55 liter keg": {
  "type": "enhancer",
  "subtype": "Penetrating Color Enhancer With Sealing, Solvent-Based",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "marble",
   "engineered",
   "concrete",
   "granite",
   "sintered",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Does NOT provide anti-etch protection on marble.",
   "UV resistant, non-yellowing.",
   "55 liter industrial keg.",
   "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "not_for_restoration": true
 },
 "tenax terust rust remover 8 oz liquid for stone surfaces": {
  "type": "stain-remover",
  "subtype": "Liquid Rust Remover For Stone",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "granite",
   "concrete",
   "engineered",
   "travertine"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Specifically for rust stain removal from stone.",
   "8 oz liquid format."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax lustro italiano stone cleaner 32 fl oz": {
  "type": "cleaner",
  "subtype": "PH-Balanced Daily Stone Cleaner",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "engineered",
   "granite",
   "sintered",
   "porcelain"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "PH balanced - no harmful solvents.",
   "Will not shorten life of stone sealant.",
   "Safe for daily use on all stone surfaces.",
   "Also works on ceramic, porcelain, stainless steel.",
   "32 fl oz size."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax lustro italiano quartz cleaner 16 fl oz": {
  "type": "cleaner",
  "subtype": "Cleaner For Engineered Stone Surfaces",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "engineered"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Designed specifically for quartz and engineered stone.",
   "Part of Lustro Italiano consumer line.",
   "16 fl oz size."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax quartz ax cleaner for engineered stone surfaces - 1 liter": {
  "type": "cleaner",
  "subtype": "Water-Based Acid Descaling Cleaner For Quartz",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "porcelain",
   "engineered",
   "sintered"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Do NOT use on marble or acid-sensitive stone - will cause corrosion and opacity.",
   "Do not use with hypochlorite-containing detergents.",
   "Leave 2-3 minutes, max 30 minutes, then rinse.",
   "Removes limescale and mineral deposits.",
   "1 liter size."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax lustro italiano stone care kit - professional stone care": {
  "type": "kit",
  "subtype": "Consumer Stone Cleaner And Polish Kit",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "mat": [
   "marble",
   "granite",
   "engineered",
   "travertine"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Kit includes 32 oz cleaner + 11 oz polish spray.",
   "Safe for granite, marble, quartz, Corian.",
   "Polish coverage: ~120-150 sq ft per 11 oz can."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "problems": [
   "general-cleaning"
  ],
  "app": [
   "cleaning"
  ]
 },
 "tenax lustro italiano rust remover 8 oz for natural stone surfaces": {
  "type": "stain-remover",
  "subtype": "Rust Remover For Consumer Stone CAre",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "granite",
   "concrete",
   "engineered",
   "travertine"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Part of Lustro Italiano consumer line.",
   "Specifically for rust stains.",
   "8 oz size."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax lustro italiano quartz stone care kit": {
  "type": "kit",
  "subtype": "Consumer Quartz Stone Cleaner And Polish Kit",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "mat": [
   "engineered"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Designed specifically for quartz and engineered stone.",
   "Part of Lustro Italiano consumer line."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "problems": [
   "general-cleaning"
  ],
  "app": [
   "cleaning"
  ]
 },
 "tenax lustro italiano quartz polish enhancer 8.5 oz": {
  "type": "polish",
  "subtype": "Consumer Aerosol Polish And Enhancer For Quartz",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "engineered"
  ],
  "problems": [
   "fading",
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Designed specifically for quartz and engineered stone.",
   "Aerosol spray format.",
   "Part of Lustro Italiano consumer line.",
   "8.5 oz size."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax lustro italiano stone polish 11 fl oz": {
  "type": "polish",
  "subtype": "Consumer Aerosol Stone Polish With Sealant",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "marble",
   "granite",
   "engineered",
   "travertine"
  ],
  "problems": [
   "fading",
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Spray-on polish includes sealer for added luster.",
   "Coverage: ~120-150 sq ft per can.",
   "Part of Lustro Italiano consumer line.",
   "11 fl oz aerosol."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax teblossom and teclean stain removal kit": {
  "type": "kit",
  "subtype": "Stain Removal Kit With Poultice And Treatment",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "mat": [
   "marble",
   "granite",
   "engineered",
   "travertine"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Includes TeBlossom (green/blue stain remover) and TeClean (poultice powder).",
   "TeBlossom removes discoloration from chip repair processes.",
   "Does not etch stone."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "app": [
   "cleaning"
  ]
 },
 "tenax cement remover descaling agent 1 liter": {
  "type": "cleaner",
  "subtype": "Acid Descaling Detergent For Cement Removal",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "porcelain",
   "engineered",
   "sintered"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "ACID - Do NOT use on marble, limestone, or acid-sensitive stone.",
   "Does not contain hydrochloric acid.",
   "Water-based.",
   "Concentrated - dilute with water.",
   "Leave max 30 minutes then rinse.",
   "Saturate surface with water before applying."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax brioaction 3 professional stain remover": {
  "type": "cleaner",
  "subtype": "Biodegradable Professional Stain Remover And Sanitizer",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "concrete",
   "granite",
   "sintered",
   "porcelain"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Heavy-duty cleanser for restoration and large areas.",
   "Biodegradable (>90%).",
   "Non-toxic and environmentally friendly.",
   "Also an effective sanitizer.",
   "12-month shelf life at 65-77F."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax lustro italiano stone cleaner for natural stone care": {
  "type": "cleaner",
  "subtype": "PH-Balanced Daily Stone Cleaner",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "engineered",
   "granite",
   "sintered",
   "porcelain"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "PH balanced - no harmful solvents.",
   "Will not shorten life of stone sealant.",
   "Safe for daily use on all stone surfaces.",
   "Part of Lustro Italiano consumer line."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "strongbond cartridge glue - strong epoxy adhesive for lapitec and engineered stone": {
  "type": "adhesive",
  "subtype": "Epoxy (Bi-Component)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "rodding",
   "seaming",
   "laminating",
   "repair"
  ],
  "mat": [
   "porcelain",
   "engineered",
   "sintered"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Gel",
  "colors": [
   "multiple Lapitec color-matched options"
  ],
  "warnings": [
   "Zero yellowing - UV stable.",
   "Solvent free.",
   "Requires Tenax 2:1 cartridge gun.",
   "Specifically designed for Lapitec sintered stone."
  ],
  "disc": false,
  "mix_ratio": "2:1 (pre-dosed cartridge)",
  "work_time": "30-60 min",
  "cure_time": "4-24 hr"
 },
 "tenax cd mastidek 215 ml - professional grade": {
  "type": "adhesive",
  "subtype": "Acrylic (Bi-Component Color-Matched)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair"
  ],
  "mat": [
   "porcelain",
   "engineered",
   "sintered"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Gel",
  "colors": [
   "multiple Dekton/Cosentino color-matched options"
  ],
  "warnings": [
   "Zero yellowing - UV stable.",
   "Requires Tenax 2:1 cartridge gun.",
   "Color-matched for Dekton and Cosentino surfaces.",
   "215 ml cartridge."
  ],
  "disc": false,
  "mix_ratio": "2:1 (pre-dosed cartridge)",
  "work_time": "8-12 min",
  "cure_time": "20-30 min"
 },
 "tenax colored flowing polyester 1 quart - professional grade": {
  "type": "adhesive",
  "subtype": "Polyester",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "fissures",
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "quartzite",
   "marble",
   "granite"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "multiple pre-colored options"
  ],
  "warnings": [
   "Interior only - not UV stable.",
   "Horizontal application only due to flowing consistency.",
   "Available in multiple pre-tinted colors.",
   "May yellow on light-colored marble over time.",
   "Runs on vertical surfaces - use knife-grade for vertical work.",
   "NOT recommended for engineered quartz or quartz surfaces - use vinyl-ester or methacrylate instead."
  ],
  "disc": false,
  "mix_ratio": "100:2-3 (resin to hardener by weight)",
  "work_time": "4-6 min",
  "cure_time": "20-30 min"
 },
 "tenax epoxart kit 3:1 epoxy system for resin coating and stone repair": {
  "type": "adhesive",
  "subtype": "Epoxy Resining System",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "rodding",
   "repair"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "problems": [
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "warnings": [
   "For slab resining with fiberglass reinforcement.",
   "High transparency, high penetration, slow curing.",
   "Ideal for small batches.",
   "Stone must be completely dry and clean.",
   "Runs on vertical surfaces - use knife-grade for vertical work."
  ],
  "disc": false,
  "mix_ratio": "3:1 (resin to hardener)",
  "work_time": "30-60 min",
  "cure_time": "4-24 hr"
 },
 "tenax fixtop a&b 1+1 liter two-part stone epoxy adhesive": {
  "type": "adhesive",
  "subtype": "Epoxy",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "rodding",
   "anchoring",
   "substrate-bonding",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "concrete",
   "granite",
   "porcelain"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "white (colorable)"
  ],
  "warnings": [
   "100% epoxy - not water-based.",
   "Does not dissolve or break down in water.",
   "Suitable for shower applications.",
   "VOC compliant.",
   "1+1 liter kit.",
   "Long cure time compared to polyester adhesives."
  ],
  "disc": false,
  "mix_ratio": "1:1",
  "work_time": "30-60 min",
  "cure_time": "4-24 hr"
 },
 "tenax fixtop and fixdeck epoxy parts for stone and porcelain bonding": {
  "type": "adhesive",
  "subtype": "Epoxy",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "rodding",
   "anchoring",
   "substrate-bonding",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "concrete",
   "granite",
   "porcelain"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "white (colorable)"
  ],
  "warnings": [
   "100% epoxy - not water-based.",
   "Does not dissolve or break down in water.",
   "Suitable for shower applications.",
   "VOC compliant.",
   "Long cure time compared to polyester adhesives."
  ],
  "disc": false,
  "mix_ratio": "1:1",
  "work_time": "30-60 min",
  "cure_time": "4-24 hr"
 },
 "tenax fixtop fixdeck a+b slow curing tile and stone epoxy": {
  "type": "adhesive",
  "subtype": "Epoxy",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "rodding",
   "substrate-bonding",
   "repair"
  ],
  "mat": [
   "engineered",
   "marble",
   "concrete",
   "granite",
   "porcelain"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Paste",
  "colors": [],
  "warnings": [
   "Slow-cure formula for extended working time.",
   "Water-resistant - suitable for outdoor/shower use.",
   "Apply in thin layers.",
   "Service temp range: -13 to 143F after cure.",
   "Long cure time compared to polyester adhesives."
  ],
  "disc": false,
  "mix_ratio": "1:1",
  "work_time": "90 min (gel time at 77F)",
  "cure_time": "tack-free ~4 hours"
 },
 "tenax glaxs color match cartridge adhesive 215 ml": {
  "type": "adhesive",
  "subtype": "Acrylic",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "repair",
   "mitering",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "granite",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Gel",
  "colors": [
   "50+ color-matched options"
  ],
  "warnings": [
   "Zero VOC.",
   "Zero yellowing.",
   "Requires Tenax 2:1 cartridge gun.",
   "Cures down to 34F.",
   "12-month shelf life at 65-77F.",
   "Service temp: -13 to 140F."
  ],
  "disc": false,
  "mix_ratio": "2:1 (pre-dosed cartridge)",
  "work_time": "3-5 min (gel time at 77F)",
  "cure_time": "~15-25 min"
 },
 "tenax glaxs easy tube epoxy adhesive for granite and marble": {
  "type": "adhesive",
  "subtype": "Acrylic-Resin",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "fissures",
   "repair",
   "laminating"
  ],
  "mat": [
   "quartzite",
   "marble",
   "granite",
   "engineered"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "warnings": [
   "Zero yellowing - 15-year guarantee.",
   "Solvent free, low viscosity, odorless.",
   "Cure time not affected by temperature.",
   "Easy squeeze-tube format - no gun needed.",
   "Good for pitholes and slab filling.",
   "Runs on vertical surfaces - use knife-grade for vertical work."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "8-12 min",
  "cure_time": "~20-25 min"
 },
 "tenax glaxs ultra fast transparent chip repair 50 ml": {
  "type": "adhesive",
  "subtype": "Acrylic Chip Repair",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "repair"
  ],
  "mat": [
   "porcelain",
   "marble",
   "granite",
   "engineered"
  ],
  "problems": [
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "warnings": [
   "Ultra-fast curing - 1 minute gel time.",
   "Zero yellowing - UV stable.",
   "Zero VOC.",
   "Requires 2:1 ratio cartridge gun.",
   "Cures at low temperatures (down to 1C).",
   "50 ml size.",
   "Runs on vertical surfaces - use knife-grade for vertical work."
  ],
  "disc": false,
  "mix_ratio": "2:1 (pre-dosed cartridge)",
  "work_time": "~1 min (gel time at 77F)",
  "cure_time": "tack-free ~4 min"
 },
 "tenax micto two-part protective coating system for stone - 2 liter kit": {
  "type": "adhesive",
  "subtype": "Epoxy",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "rodding",
   "fissures",
   "repair"
  ],
  "mat": [
   "quartzite",
   "marble",
   "granite",
   "engineered"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "water clear"
  ],
  "warnings": [
   "Will yellow when exposed to sunlight (use in non-visible areas outdoors).",
   "VOC compliant.",
   "2-year shelf life at 65-77F.",
   "2 liter kit.",
   "Runs on vertical surfaces - use knife-grade for vertical work.",
   "Long cure time compared to polyester adhesives."
  ],
  "disc": false,
  "mix_ratio": "1:1",
  "work_time": "30-60 min",
  "cure_time": "~15 min"
 },
 "tenax poxart kit 2:1 epoxy system for resin coating and stone repair": {
  "type": "adhesive",
  "subtype": "Epoxy Resining System",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "rodding",
   "repair"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "problems": [
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "warnings": [
   "For slab resining with fiberglass reinforcement.",
   "High penetration.",
   "Stone must be completely dry and clean.",
   "Runs on vertical surfaces - use knife-grade for vertical work."
  ],
  "disc": false,
  "mix_ratio": "2:1 (resin to hardener)",
  "work_time": "30-60 min",
  "cure_time": "4-24 hr"
 },
 "tenax poxart kit 4:1 epoxy system for resin coating and stone repair": {
  "type": "adhesive",
  "subtype": "Epoxy Resining System",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "rodding",
   "repair"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "problems": [
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "warnings": [
   "For slab resining with fiberglass reinforcement.",
   "Highest dilution ratio - most penetration, slowest cure.",
   "Stone must be completely dry and clean.",
   "Runs on vertical surfaces - use knife-grade for vertical work."
  ],
  "disc": false,
  "mix_ratio": "4:1 (resin to hardener)",
  "work_time": "30-60 min",
  "cure_time": "4-24 hr"
 },
 "tenax rivo a&b 1+1 liter two-part stone bonding epoxy": {
  "type": "adhesive",
  "subtype": "Epoxy",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "rodding",
   "anchoring",
   "substrate-bonding",
   "seaming",
   "laminating",
   "repair"
  ],
  "mat": [
   "engineered",
   "marble",
   "concrete",
   "granite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "straw (colorable with Tenax Universal Colors)"
  ],
  "warnings": [
   "VOC compliant.",
   "Bonds to nearly any surface.",
   "1+1 liter kit.",
   "Long cure time compared to polyester adhesives."
  ],
  "disc": false,
  "mix_ratio": "1:1",
  "work_time": "15 min (gel time)",
  "cure_time": "~90 min"
 },
 "tenax semisolido wet buff semi-solid polish for granite marble - 4 liter": {
  "type": "polish",
  "subtype": "Semi-Solid Polishing Compound",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "marble",
   "granite",
   "travertine"
  ],
  "problems": [
   "fading",
   "general-cleaning"
  ],
  "viscosity": "Semi Solid",
  "colors": [],
  "warnings": [
   "For wet buffing/polishing stone surfaces.",
   "Apply with buffing machine and felt pad.",
   "4 liter container."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax tixo extra knife grade transparent": {
  "type": "adhesive",
  "subtype": "Polyester",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "fissures",
   "repair"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "warnings": [
   "Interior only - not UV stable.",
   "May yellow on light-colored marble over time.",
   "NOT recommended for engineered quartz or quartz surfaces - use vinyl-ester or methacrylate instead.",
   "Tixo is a repair and fissure-fill product. NOT for structural seaming or lamination."
  ],
  "disc": false,
  "mix_ratio": "100:2-3 (resin to hardener by weight)",
  "work_time": "4-6 min",
  "cure_time": "20-30 min"
 },
 "tenax tixo x prism polyester knife grade adhesive for granite and marble": {
  "type": "adhesive",
  "subtype": "Polyester",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "fissures",
   "repair"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "warnings": [
   "Interior only - not UV stable.",
   "May yellow on light-colored marble over time.",
   "NOT recommended for engineered quartz or quartz surfaces - use vinyl-ester or methacrylate instead.",
   "Tixo is a repair and fissure-fill product. NOT for structural seaming or lamination."
  ],
  "disc": false,
  "mix_ratio": "100:2-3 (resin to hardener by weight)",
  "work_time": "4-6 min",
  "cure_time": "20-30 min"
 },
 "tenax transparent flowing polyester - professional grade": {
  "type": "adhesive",
  "subtype": "Polyester",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "fissures",
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "quartzite",
   "marble",
   "granite"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "warnings": [
   "Interior only - not UV stable.",
   "Horizontal application only due to flowing consistency.",
   "May yellow on light-colored marble over time.",
   "Runs on vertical surfaces - use knife-grade for vertical work.",
   "NOT recommended for engineered quartz or quartz surfaces - use vinyl-ester or methacrylate instead."
  ],
  "disc": false,
  "mix_ratio": "100:2-3 (resin to hardener by weight)",
  "work_time": "4-6 min",
  "cure_time": "20-30 min"
 },
 "tenax transparent knife grade h - professional grade": {
  "type": "adhesive",
  "subtype": "Polyester",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "fissures",
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "warnings": [
   "Interior only - not UV stable.",
   "Requires Tenax hardener.",
   "May yellow on light-colored marble over time.",
   "NOT recommended for engineered quartz or quartz surfaces - use vinyl-ester or methacrylate instead."
  ],
  "disc": false,
  "mix_ratio": "100:2-3 (resin to hardener by weight)",
  "work_time": "4-6 min",
  "cure_time": "20-30 min"
 },
 "tenax ultra-fast epoxy plus cartridge glue 210 ml": {
  "type": "adhesive",
  "subtype": "Epoxy",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "rodding",
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "porcelain",
   "marble",
   "granite",
   "engineered"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Gel",
  "colors": [
   "transparent"
  ],
  "warnings": [
   "Ultra-fast curing.",
   "Requires Tenax 2:1 cartridge gun.",
   "210 ml cartridge.",
   "Long cure time compared to polyester adhesives."
  ],
  "disc": false,
  "mix_ratio": "2:1 (pre-dosed cartridge)",
  "work_time": "30-60 min",
  "cure_time": "4-24 hr"
 },
 "tenax vertigo s vinyl ester knife grade - 1 gallon": {
  "type": "adhesive",
  "subtype": "Vinyl-Ester",
  "vendor": "Tenax",
  "env": [
   "exterior",
   "interior"
  ],
  "app": [
   "rodding",
   "fissures",
   "mitering",
   "seaming",
   "laminating",
   "repair"
  ],
  "mat": [
   "engineered",
   "marble",
   "granite",
   "sintered",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "water clear"
  ],
  "warnings": [
   "Low yellowing - formulated for UV resistance.",
   "Drip-less formula.",
   "1 gallon size."
  ],
  "disc": false,
  "mix_ratio": "100:2-3 (resin to catalyst by weight)",
  "work_time": "4-5 min (gel time)",
  "cure_time": "25 min"
 },
 "tenax vertigo t vinyl ester knife grade - professional grade": {
  "type": "adhesive",
  "subtype": "Vinyl-Ester",
  "vendor": "Tenax",
  "env": [
   "exterior",
   "interior"
  ],
  "app": [
   "rodding",
   "fissures",
   "mitering",
   "seaming",
   "laminating",
   "repair"
  ],
  "mat": [
   "engineered",
   "marble",
   "granite",
   "sintered",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "water clear"
  ],
  "warnings": [
   "Low yellowing - formulated for UV resistance.",
   "Thicker consistency than Vertigo S."
  ],
  "disc": false,
  "mix_ratio": "100:2-3 (resin to catalyst by weight)",
  "work_time": "4-5 min (gel time)",
  "cure_time": "20 min"
 },
 "tenax teblossom green blossom stain removal kit": {
  "type": "stain-remover",
  "subtype": "Two-Part Chemical Poultice For Green/Blue Stain Removal",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "granite",
   "concrete",
   "engineered",
   "travertine"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Removes green/blue stains caused by chip repair kits.",
   "Two-part poultice process.",
   "Does not etch stone."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "tenax ager pen 6-piece stone scratch concealer & color enhancer set": {
  "type": "enhancer",
  "subtype": "Pen-Format Color Enhancer For Scratch Concealment",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "marble",
   "engineered",
   "concrete",
   "granite",
   "sintered",
   "porcelain"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "",
  "colors": [
   "6-piece set with assorted colors"
  ],
  "warnings": [
   "Pen format for precision scratch concealment.",
   "Color enhancing.",
   "Set of 6 pens.",
   "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "not_for_restoration": true
 },
 "tenax titanium kg stone sealer & color enhancer - 1 qt": {
  "type": "enhancer",
  "subtype": "Penetrating Color Enhancer With Sealing",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "marble",
   "engineered",
   "concrete",
   "granite",
   "sintered",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Color enriching stone enhancer and sealer.",
   "UV resistant.",
   "1 quart size.",
   "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "not_for_restoration": true
 },
 "tenax water ager water-based color enhancing sealer - 1 liter": {
  "type": "enhancer",
  "subtype": "Water-Based Color Enhancer With Sealing",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "marble",
   "engineered",
   "concrete",
   "granite",
   "sintered",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Water-based formula - lower VOC than solvent-based Ager.",
   "Color enhancing with sealing properties.",
   "1 liter size.",
   "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "not_for_restoration": true
 },
 "tenax pectro black 1 quart dark stone micro fissure & webbing concealer": {
  "type": "enhancer",
  "subtype": "Micro-Fissure And Webbing Concealer For Dark Stone",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "granite"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [
   "black"
  ],
  "warnings": [
   "For dark granites only (black, brown, green).",
   "Hides micro fissures and webbing.",
   "UV resistant for outdoor use.",
   "Immediately buff with clean cloth after application.",
   "2-year shelf life at 65-77F."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "5 min drying time"
 },
 "tenax universal stone chip repair kit - professional stone care": {
  "type": "kit",
  "subtype": "Chip Repair Kit For Stone Surfaces",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "mat": [
   "marble",
   "granite",
   "engineered"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Kit includes repair components for various chip sizes.",
   "For scratches, chips, and blemishes on stone."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "problems": [
   "crack"
  ],
  "app": [
   "cleaning"
  ]
 },
 "akemi akenova lion grip 50 (cc 1100 white) - 290 ml cartridge": {
  "type": "adhesive",
  "subtype": "Polyhybrid",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "anchoring",
   "substrate-bonding",
   "repair"
  ],
  "mat": [
   "marble",
   "glass",
   "ceramic",
   "wood",
   "metal",
   "concrete",
   "granite"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Paste",
  "colors": [
   "white"
  ],
  "warnings": [
   "For professional use only."
  ],
  "disc": false,
  "mix_ratio": "N/A - 1 component",
  "work_time": "adjustable",
  "cure_time": "24 hours full cure"
 },
 "akemi marble filler super 1 kg. - highly liquid acrylic adhesive": {
  "type": "adhesive",
  "subtype": "Acrylic",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "mat": [
   "limestone",
   "marble",
   "granite",
   "travertine"
  ],
  "problems": [
   "crack"
  ],
  "viscosity": "Highly Liquid / Super Flowing",
  "colors": [
   "transparent"
  ],
  "warnings": [
   "Interior use only.",
   "For professional use only.",
   "Runs on vertical surfaces - use knife-grade for vertical work."
  ],
  "disc": false,
  "mix_ratio": "resin + 1-4% BPO hardener",
  "work_time": "5-10 minutes at 68 degrees F",
  "cure_time": "20-50 minutes at 68 degrees F",
  "app": [
   "seaming",
   "repair"
  ]
 },
 "akemi marble filler 1000 transparent l-special waterclear - quart": {
  "type": "filler",
  "subtype": "Polyester",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "fissures",
   "repair"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "problems": [
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent water-clear"
  ],
  "warnings": [
   "Interior use only.",
   "Less BPO hardener needed in hot temperatures.",
   "May yellow on light-colored marble over time.",
   "Runs on vertical surfaces - use knife-grade for vertical work."
  ],
  "disc": false,
  "mix_ratio": "resin + 1-4% BPO hardener",
  "work_time": "5-10 minutes at 68 degrees F (20 degrees C)",
  "cure_time": "20-50 minutes at 68 degrees F (20 degrees C)"
 },
 "akemi marble filler 1000 transparent l-special 1 kg. - knife-grade polyester adhesive": {
  "type": "filler",
  "subtype": "Polyester",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "fissures",
   "repair"
  ],
  "mat": [
   "estremoz",
   "marble",
   "thassos",
   "limestone",
   "palisandro",
   "granite",
   "carrara",
   "onyx",
   "travertine"
  ],
  "problems": [
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent water-clear"
  ],
  "warnings": [
   "Interior use only.",
   "Less BPO hardener needed in extremely hot temperatures.",
   "May yellow on light-colored marble over time."
  ],
  "disc": false,
  "mix_ratio": "resin + 2-4% BPO hardener by weight",
  "work_time": "4-6 minutes at 70 degrees F (20 degrees C)",
  "cure_time": "20-30 minutes at 70 degrees F (20 degrees C)"
 },
 "akemi acrylic penetrant 900 ml - deep penetrating adhesive for marble repair": {
  "type": "adhesive",
  "subtype": "Acrylic",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "mat": [
   "limestone",
   "marble",
   "granite",
   "travertine"
  ],
  "problems": [
   "crack"
  ],
  "viscosity": "Highly Liquid / Penetrating",
  "colors": [
   "transparent"
  ],
  "warnings": [
   "Interior use only.",
   "For professional use only."
  ],
  "disc": false,
  "mix_ratio": "resin + 1-4% BPO hardener",
  "work_time": "5-10 minutes at 68 degrees F",
  "cure_time": "20-50 minutes at 68 degrees F",
  "app": [
   "fissures",
   "repair"
  ]
 },
 "akemi platinum 5.0 p+ epoxyacrylate knife grade 4500 ml - large format adhesive": {
  "type": "adhesive",
  "subtype": "Epoxyacrylate",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "rodding",
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "granite",
   "sintered",
   "quartz",
   "porcelain"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent-opaque (very light base color)"
  ],
  "warnings": [
   "For professional use only."
  ],
  "disc": false,
  "mix_ratio": "1:1",
  "work_time": "10-12",
  "cure_time": "1440"
 },
 "akemi everclear 505 flowing uv resistant urethane adhesive 2 liter 1900g": {
  "type": "filler",
  "subtype": "Polyurethane",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "repair"
  ],
  "mat": [
   "engineered",
   "granite",
   "marble"
  ],
  "problems": [
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "warnings": [
   "For professional use only.",
   "Runs on vertical surfaces - use knife-grade for vertical work."
  ],
  "disc": false,
  "mix_ratio": "4:3",
  "work_time": "15",
  "cure_time": "360"
 },
 "akemi akenova crystal clear adhesive sealant 290 ml - paintable sink adhesive": {
  "type": "adhesive",
  "subtype": "Polyhybrid",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "substrate-bonding",
   "repair"
  ],
  "mat": [
   "engineered",
   "marble",
   "ceramic",
   "granite",
   "stainless steel"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Paste",
  "colors": [
   "crystal clear"
  ],
  "warnings": [
   "For professional use only."
  ],
  "disc": false,
  "mix_ratio": "N/A - 1 component",
  "work_time": "4-6 min",
  "cure_time": "24 hours full cure"
 },
 "akenova clear 300 cc 2200 290ml cartridge": {
  "type": "adhesive",
  "subtype": "Polyhybrid",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "substrate-bonding",
   "repair"
  ],
  "mat": [
   "engineered",
   "marble",
   "ceramic",
   "granite",
   "stainless steel"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Paste",
  "colors": [
   "crystal clear"
  ],
  "warnings": [
   "For professional use only."
  ],
  "disc": false,
  "mix_ratio": "N/A - 1 component",
  "work_time": "4-6 min",
  "cure_time": "24 hours full cure"
 },
 "akenova elastic 100 grey 1830 290ml cartridge": {
  "type": "adhesive",
  "subtype": "Polyhybrid",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "substrate-bonding",
   "repair"
  ],
  "mat": [
   "glass",
   "marble",
   "ceramic",
   "wood",
   "metal",
   "granite"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Paste",
  "colors": [
   "grey"
  ],
  "warnings": [
   "For professional use only."
  ],
  "disc": false,
  "mix_ratio": "N/A - 1 component",
  "work_time": "4-6 min",
  "cure_time": "24 hours full cure"
 },
 "akenova rocket 200 white 1130 290ml cartridge": {
  "type": "adhesive",
  "subtype": "Polyhybrid",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "substrate-bonding",
   "repair"
  ],
  "mat": [
   "glass",
   "marble",
   "ceramic",
   "wood",
   "metal",
   "granite"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Paste",
  "colors": [
   "white"
  ],
  "warnings": [
   "For professional use only."
  ],
  "disc": false,
  "mix_ratio": "N/A - 1 component",
  "work_time": "4-6 min",
  "cure_time": "fast initial tack, 24 hours full cure"
 },
 "akemi white cc 1130 two-component stone adhesive cartridge 400 ml": {
  "type": "adhesive",
  "subtype": "Epoxy (Two-Component CArtridge)",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "rodding",
   "mitering",
   "seaming",
   "laminating",
   "repair"
  ],
  "mat": [
   "engineered",
   "granite",
   "marble"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "white"
  ],
  "warnings": [
   "Requires mixing nozzle.",
   "For professional use only."
  ],
  "disc": false,
  "mix_ratio": "auto-metered dual cartridge",
  "work_time": "30-60 min",
  "cure_time": "4-24 hr"
 },
 "akemi triple effect 500 ml - food-safe stone care and impregnation spray": {
  "type": "sealer",
  "subtype": "Impregnation Spray",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "engineered",
   "granite",
   "marble",
   "travertine"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "Liquid Spray",
  "colors": [],
  "warnings": [
   "Shake well before use."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": ""
 },
 "afin acryclean 500ml solvent-based ready-to-use silicone remover for natural stone": {
  "type": "cleaner",
  "subtype": "Solvent-Based",
  "vendor": "Akemi (Afin sub-brand)",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Solvent-based - ensure ventilation.",
   "Test on inconspicuous area first."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": ""
 },
 "akemi natural stone basic cleaner 500 ml - food-safe alkaline cleaning agent": {
  "type": "cleaner",
  "subtype": "Water-Based",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "limestone",
   "marble",
   "granite"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": ""
 },
 "akemi rust remover 1l - acidic cleaning agent": {
  "type": "cleaner",
  "subtype": "Acidic",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "granite",
   "sandstone"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Do NOT use on acid-sensitive stones (marble, limestone, travertine).",
   "For professional use only."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": ""
 },
 "akemi good-bye stain 500 ml - alcaline cleaning agent": {
  "type": "cleaner",
  "subtype": "Water-Based",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "engineered",
   "granite",
   "marble"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": ""
 },
 "akemi transformer 500 ml - premium protection and colour intensification sealer": {
  "type": "enhancer",
  "subtype": "Solvent-Based",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "marble",
   "terrazzo",
   "limestone",
   "concrete",
   "granite",
   "sintered",
   "quartz",
   "porcelain"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Solvent-based impregnation sealer.",
   "Ground shipping only.",
   "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use, single component",
  "work_time": "",
  "cure_time": "5-10 minutes at 20 degrees C for color intensification",
  "not_for_restoration": true
 },
 "akemi quartz clean & care 500 ml - food-safe daily quartz cleaning agent": {
  "type": "cleaner",
  "subtype": "Water-Based",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "engineered",
   "quartz"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": ""
 },
 "akemi stone sealer mat finish 1l - acrylic sealer": {
  "type": "sealer",
  "subtype": "Acrylic",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "limestone",
   "marble",
   "granite",
   "sandstone"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "For professional use only."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": ""
 },
 "akemi quartz polish 250 ml - food-safe quartz care product": {
  "type": "polish",
  "subtype": "Polish",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "engineered",
   "quartz"
  ],
  "problems": [
   "fading",
   "general-cleaning"
  ],
  "viscosity": "Liquid/Cream",
  "colors": [],
  "warnings": [],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": ""
 },
 "akemi rust remover marble 1l - alkaline cleaning agent": {
  "type": "cleaner",
  "subtype": "Alkaline",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "granite"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Safe for acid-sensitive stones unlike standard rust remover."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": ""
 },
 "akemi stone cleaner 1l - concentrated alkaline cleaning agent": {
  "type": "cleaner",
  "subtype": "Water-Based",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "limestone",
   "marble",
   "granite"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [],
  "disc": false,
  "mix_ratio": "concentrated - dilutable",
  "work_time": "",
  "cure_time": ""
 },
 "akemi crystal clean 500 ml - food-safe daily cleaning agent": {
  "type": "cleaner",
  "subtype": "Water-Based",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "engineered",
   "granite",
   "marble"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": ""
 },
 "akemi oil and grease remover paste 250 ml": {
  "type": "cleaner",
  "subtype": "Paste Poultice",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "engineered",
   "granite",
   "marble"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Paste",
  "colors": [],
  "warnings": [
   "Apply paste, cover, let draw out stain, remove after drying."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": ""
 },
 "akemi darkener plus 1l - colour-intensifying sealer": {
  "type": "enhancer",
  "subtype": "Solvent-Based",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "marble",
   "terrazzo",
   "limestone",
   "concrete",
   "slate",
   "granite",
   "sintered",
   "porcelain",
   "cotto"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Solvent-based product.",
   "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use, single component",
  "work_time": "",
  "cure_time": "protective effect begins approx. 24-48 hours at 20 degrees C",
  "not_for_restoration": true
 },
 "akemi impregnation remover 1l - alkaline cleaning agent": {
  "type": "cleaner",
  "subtype": "Alkaline",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Removes existing impregnation/sealer - reapply sealer after use."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": ""
 },
 "akemi stone impregnation sealer for granite & natural stone": {
  "type": "sealer",
  "subtype": "Solvent-Based Impregnation",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "limestone",
   "marble",
   "granite",
   "sandstone"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Stone must be totally dry before application (1-2 days minimum)."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use, single component",
  "work_time": "",
  "cure_time": "fully effective after 2-3 hours; initial protection in 10-20 minutes at 20 degrees C"
 },
 "akemi transformer quartz 1000 ml - color enhancer for quartz": {
  "type": "enhancer",
  "subtype": "Solvent-Based",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "engineered",
   "quartz"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Designed specifically for engineered quartz surfaces."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": ""
 },
 "akemi triple effect 250 ml spray - 3-in-1 stone cleaner, sealer, and polish": {
  "type": "sealer",
  "subtype": "Impregnation Spray",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "engineered",
   "granite",
   "marble",
   "travertine"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "Liquid Spray",
  "colors": [],
  "warnings": [
   "Shake well before use."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": ""
 },
 "akemi liqui polish universal 650 ml - liquid polishing compound": {
  "type": "polish",
  "subtype": "Liquid Polishing Compound",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "engineered",
   "granite",
   "marble",
   "travertine"
  ],
  "problems": [
   "fading",
   "general-cleaning"
  ],
  "viscosity": "Liquid/Cream",
  "colors": [],
  "warnings": [
   "For professional use only."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": ""
 },
 "akemi stone polish wax based 1 liter - natural wax polish for stone surfaces": {
  "type": "polish",
  "subtype": "Wax-Based",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "marble",
   "granite",
   "travertine"
  ],
  "problems": [
   "fading",
   "general-cleaning"
  ],
  "viscosity": "Liquid/Cream",
  "colors": [],
  "warnings": [],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": ""
 },
 "akemi antigraffiti protective coating - special order": {
  "type": "sealer",
  "subtype": "Protective Coating",
  "vendor": "Akemi",
  "env": [
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "marble",
   "granite",
   "concrete"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Special order item - longer lead time."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": "",
  "problems": [
   "water-damage"
  ]
 },
 "akemi pearl fast curing impregnator - stain blocker for quartzite": {
  "type": "sealer",
  "subtype": "Impregnation",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "quartzite",
   "granite"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": "fast curing"
 },
 "akemi transformer quartz enhancer and sealer for engineered quartz": {
  "type": "enhancer",
  "subtype": "Solvent-Based",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "engineered",
   "quartz"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Designed specifically for engineered quartz surfaces."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": ""
 },
 "akemi transformer exotic enhancer impregnator - for exotic stones": {
  "type": "enhancer",
  "subtype": "Solvent-Based",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "marble",
   "concrete",
   "granite",
   "sintered",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Solvent-based product.",
   "For exotic stones with high absorption.",
   "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": "",
  "not_for_restoration": true
 },
 "akemi transformer enhancer and impregnator - color enhancing sealer": {
  "type": "enhancer",
  "subtype": "Solvent-Based",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "marble",
   "terrazzo",
   "limestone",
   "concrete",
   "granite",
   "sintered",
   "quartz",
   "porcelain"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Solvent-based impregnation sealer.",
   "Ground shipping only.",
   "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use, single component",
  "work_time": "",
  "cure_time": "5-10 minutes at 20 degrees C for color intensification",
  "not_for_restoration": true
 },
 "akemi marble rust remover 500 ml - safe rust stain removal for marble": {
  "type": "cleaner",
  "subtype": "Alkaline",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "granite"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Safe for acid-sensitive stones."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": ""
 },
 "akemi marble rust remover 1000 ml - professional rust stain removal for marble": {
  "type": "cleaner",
  "subtype": "Alkaline",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "granite"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Safe for acid-sensitive stones."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": ""
 },
 "akemi rust remover paste 1l - acidic cleaning paste": {
  "type": "cleaner",
  "subtype": "Acidic Paste",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "granite",
   "sandstone"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Paste",
  "colors": [],
  "warnings": [
   "Do NOT use on acid-sensitive stones (marble, limestone, travertine).",
   "Paste form for vertical application."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": ""
 },
 "akemi spider 1000 ml - flexible stone joint sealer and enhancer": {
  "type": "sealer",
  "subtype": "Flexible Joint Sealer",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": "",
  "app": [
   "sealing"
  ]
 },
 "akemi wax stripper 1 liter - wax and coating remover for stone": {
  "type": "cleaner",
  "subtype": "Stripping Agent",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Removes protective wax coatings - reapply sealer after use."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use or dilutable",
  "work_time": "",
  "cure_time": ""
 },
 "akemi algae and mildew remover longlife 1 liter - extended protection": {
  "type": "cleaner",
  "subtype": "Water-Based",
  "vendor": "Akemi",
  "env": [
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "granite",
   "brick",
   "concrete",
   "marble",
   "travertine"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Extended protection formula - prevents regrowth."
  ],
  "disc": false,
  "mix_ratio": "concentrated",
  "work_time": "",
  "cure_time": ""
 },
 "akemi algae and mildew remover power 1 liter - fast-acting outdoor cleaner": {
  "type": "cleaner",
  "subtype": "Water-Based",
  "vendor": "Akemi",
  "env": [
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "granite",
   "brick",
   "concrete",
   "marble",
   "travertine"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Fast-acting formula for immediate results."
  ],
  "disc": false,
  "mix_ratio": "ready to use",
  "work_time": "",
  "cure_time": ""
 },
 "akemi wax stripper 1 liter - professional wax and coating remover for stone": {
  "type": "cleaner",
  "subtype": "Stripping Agent",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Removes protective wax coatings - reapply sealer after use."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use or dilutable",
  "work_time": "",
  "cure_time": ""
 },
 "akemi graffiti remover 1 liter - paint and graffiti cleaner for stone": {
  "type": "cleaner",
  "subtype": "Solvent-Based",
  "vendor": "Akemi",
  "env": [
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "granite",
   "concrete"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Solvent-based - ensure ventilation.",
   "Test on inconspicuous area first."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": ""
 },
 "akemi algae and mildew remover longlife 1 liter - long-lasting protection": {
  "type": "cleaner",
  "subtype": "Water-Based",
  "vendor": "Akemi",
  "env": [
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "granite",
   "brick",
   "concrete",
   "marble",
   "travertine"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Extended protection formula - prevents regrowth."
  ],
  "disc": false,
  "mix_ratio": "concentrated",
  "work_time": "",
  "cure_time": ""
 },
 "akemi quartz intensive cleaner and stain remover 250 ml for engineered stone": {
  "type": "cleaner",
  "subtype": "Water-Based",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "engineered",
   "quartz"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": ""
 },
 "akemi epoxy remover 1000 ml - professional epoxy residue cleaner for stone": {
  "type": "cleaner",
  "subtype": "Solvent-Based",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Solvent-based - ensure ventilation.",
   "Test on inconspicuous area first."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": ""
 },
 "akemi transformer exotic 500 ml - premium protection and colour intensification sealer for exotic stones": {
  "type": "enhancer",
  "subtype": "Solvent-Based",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "marble",
   "concrete",
   "granite",
   "sintered",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "Solvent-based product.",
   "For exotic stones with high absorption.",
   "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": "",
  "not_for_restoration": true
 },
 "akemi everclear 510 knife-grade - quart": {
  "type": "adhesive",
  "subtype": "Polyurethane",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "repair"
  ],
  "mat": [
   "engineered",
   "granite",
   "marble"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Gel / Knife Grade",
  "colors": [],
  "warnings": [
   "For professional use only."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "10 minutes",
  "cure_time": "60-90 min"
 },
 "akemi solid wax transparent 750 ml - clear protective stone wax": {
  "type": "polish",
  "subtype": "Solid Wax",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "marble",
   "granite",
   "travertine"
  ],
  "problems": [
   "fading",
   "general-cleaning"
  ],
  "viscosity": "Solid Wax",
  "colors": [
   "transparent"
  ],
  "warnings": [],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": ""
 },
 "akemi hyperclear 1 kg. - ultra strong 2-component clear urethane adhesive": {
  "type": "adhesive",
  "subtype": "Polyurethane (Two-Component)",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "granite",
   "marble"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Flowing To Gel",
  "colors": [],
  "warnings": [
   "Two-component system - mix per instructions.",
   "For professional use only.",
   "Runs on vertical surfaces - use knife-grade for vertical work."
  ],
  "disc": false,
  "mix_ratio": "1:1",
  "work_time": "5-8",
  "cure_time": "120"
 },
 "superior gold acrylic vinyl ester knife grade adhesives": {
  "type": "adhesive",
  "subtype": "Acrylic Vinyl Ester",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "rodding",
   "seaming",
   "mitering",
   "laminating"
  ],
  "mat": [
   "engineered",
   "granite",
   "marble"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "clear/translucent"
  ],
  "warnings": [
   "Indoor use only."
  ],
  "disc": false,
  "mix_ratio": "1%-2% BPO hardener by weight",
  "work_time": "4-6 minutes @ 70 degrees F",
  "cure_time": "20-25 minutes @ 70 degrees F",
  "problems": [
   "crack"
  ]
 },
 "superior polyester transparent knife grade adhesives": {
  "type": "adhesive",
  "subtype": "Polyester",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "limestone",
   "marble",
   "granite"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "warnings": [
   "Indoor use only.",
   "May yellow on light-colored marble over time."
  ],
  "disc": false,
  "mix_ratio": "1-4% BPO hardener by weight",
  "work_time": "4-6 minutes @ 70 degrees F",
  "cure_time": "20-30 minutes @ 70 degrees F",
  "problems": [
   "crack"
  ]
 },
 "superior ice instant color enhancement for natural stone": {
  "type": "enhancer",
  "subtype": "Color Enhancer",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "mat": [
   "marble",
   "limestone",
   "concrete",
   "granite",
   "sintered",
   "porcelain"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "For natural stone only - not engineered stone.",
   "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": "",
  "not_for_restoration": true,
  "app": [
   "enhancing"
  ]
 },
 "superior pearl ehc thicker knife grade adhesives": {
  "type": "adhesive",
  "subtype": "Polyester",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "mitering",
   "laminating"
  ],
  "mat": [
   "limestone",
   "marble",
   "granite"
  ],
  "viscosity": "Thick Knife Grade",
  "colors": [
   "transparent/pearl"
  ],
  "warnings": [
   "Indoor use only.",
   "Extra thick - ideal for vertical applications.",
   "May yellow on light-colored marble over time."
  ],
  "disc": false,
  "mix_ratio": "1-4% BPO hardener by weight",
  "work_time": "4-6 minutes @ 70 degrees F",
  "cure_time": "20-30 minutes @ 70 degrees F",
  "problems": [
   "crack"
  ]
 },
 "superior v-max premium vinyl ester sv-9 adhesives": {
  "type": "adhesive",
  "subtype": "Vinyl Ester",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "rodding",
   "seaming",
   "mitering",
   "laminating"
  ],
  "mat": [
   "engineered",
   "granite",
   "marble"
  ],
  "viscosity": "Thick Knife Grade (Sv 9)",
  "colors": [
   "clear/translucent"
  ],
  "warnings": [
   "Suitable for exterior use."
  ],
  "disc": false,
  "mix_ratio": "1%-2% BPO hardener by weight",
  "work_time": "4-6 minutes @ 70 degrees F",
  "cure_time": "20-30 minutes @ 70 degrees F",
  "problems": [
   "crack"
  ]
 },
 "superior bronze polyester flowing adhesives": {
  "type": "adhesive",
  "subtype": "Polyester",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "repair",
   "laminating"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "warnings": [
   "Indoor use only.",
   "May yellow on light-colored marble over time.",
   "Runs on vertical surfaces - use knife-grade for vertical work."
  ],
  "disc": false,
  "mix_ratio": "1-4% BPO hardener by weight",
  "work_time": "4-6 minutes @ 70 degrees F",
  "cure_time": "20-30 minutes @ 70 degrees F",
  "problems": [
   "crack"
  ]
 },
 "superior bronze polyester knife grade adhesives": {
  "type": "adhesive",
  "subtype": "Polyester",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "warnings": [
   "Indoor use only.",
   "May yellow on light-colored marble over time."
  ],
  "disc": false,
  "mix_ratio": "1-4% BPO hardener by weight",
  "work_time": "4-6 minutes @ 70 degrees F",
  "cure_time": "20-30 minutes @ 70 degrees F",
  "problems": [
   "crack"
  ]
 },
 "superior polyester white knife grade adhesives": {
  "type": "adhesive",
  "subtype": "Polyester",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "white"
  ],
  "warnings": [
   "Indoor use only.",
   "Pre-colored white - not transparent.",
   "May yellow on light-colored marble over time."
  ],
  "disc": false,
  "mix_ratio": "1-4% BPO hardener by weight",
  "work_time": "4-6 minutes @ 70 degrees F",
  "cure_time": "20-30 minutes @ 70 degrees F",
  "problems": [
   "crack"
  ]
 },
 "superior fire instant color enhancement for exotic natural stone": {
  "type": "enhancer",
  "subtype": "Color Enhancer",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "mat": [
   "quartzite",
   "granite"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "For exotic natural stone only."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": "",
  "app": [
   "enhancing"
  ]
 },
 "superior acrylic super flowing adhesive - special order": {
  "type": "adhesive",
  "subtype": "Acrylic",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "viscosity": "Super Flowing (Very Low Viscosity)",
  "colors": [],
  "warnings": [
   "Special order item - longer lead time.",
   "Indoor use only.",
   "Runs on vertical surfaces - use knife-grade for vertical work."
  ],
  "disc": false,
  "mix_ratio": "1-4% BPO hardener by weight",
  "work_time": "5-10 minutes @ 70 degrees F",
  "cure_time": "20-50 minutes @ 70 degrees F",
  "app": [
   "fissures",
   "repair"
  ],
  "problems": [
   "crack"
  ]
 },
 "superior acrylic quickset flowing adhesives - special order": {
  "type": "adhesive",
  "subtype": "Acrylic",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "viscosity": "Flowing",
  "colors": [],
  "warnings": [
   "Special order item - longer lead time.",
   "Indoor use only.",
   "Runs on vertical surfaces - use knife-grade for vertical work."
  ],
  "disc": false,
  "mix_ratio": "1-4% BPO hardener by weight",
  "work_time": "8-12 min",
  "cure_time": "fast (quickset formula)",
  "app": [
   "fissures",
   "repair"
  ],
  "problems": [
   "crack"
  ]
 },
 "superior gold evolution ev-9 thick knife grade adhesives": {
  "type": "adhesive",
  "subtype": "Modified Acrylic Vinyl Ester With Colored Hardener",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "rodding",
   "mitering",
   "seaming",
   "laminating",
   "repair"
  ],
  "mat": [
   "engineered",
   "granite",
   "sintered",
   "quartz",
   "porcelain"
  ],
  "viscosity": "Thick Knife Grade",
  "colors": [
   "20 colored hardener options"
  ],
  "warnings": [
   "Temperature dependent cure times."
  ],
  "disc": false,
  "mix_ratio": "3%-5% GOLD EVOLUTION Colored Hardener by weight",
  "work_time": "3-5 minutes @ 70 degrees F",
  "cure_time": "13 minutes average",
  "problems": [
   "crack"
  ]
 },
 "superior gold evolution ev-1 flowing adhesives": {
  "type": "adhesive",
  "subtype": "Modified Acrylic Vinyl Ester With Colored Hardener",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "rodding",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "granite",
   "sintered",
   "quartz",
   "porcelain"
  ],
  "viscosity": "Flowing",
  "colors": [
   "20 colored hardener options"
  ],
  "warnings": [
   "Temperature dependent cure times.",
   "Runs on vertical surfaces - use knife-grade for vertical work."
  ],
  "disc": false,
  "mix_ratio": "3%-5% GOLD EVOLUTION Colored Hardener by weight",
  "work_time": "3-5 minutes @ 70 degrees F",
  "cure_time": "13 minutes average",
  "problems": [
   "crack"
  ]
 },
 "superior gold gv-9 thicker knife grade adhesives": {
  "type": "adhesive",
  "subtype": "Acrylic Vinyl Ester",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "rodding",
   "seaming",
   "mitering",
   "laminating"
  ],
  "mat": [
   "engineered",
   "granite",
   "marble"
  ],
  "viscosity": "Thick Knife Grade (Gv 9 = Thicker)",
  "colors": [
   "clear/translucent"
  ],
  "warnings": [
   "Indoor use only.",
   "Thicker than GV-5 for vertical applications."
  ],
  "disc": false,
  "mix_ratio": "1%-2% BPO hardener by weight",
  "work_time": "4-6 minutes @ 70 degrees F",
  "cure_time": "20-25 minutes @ 70 degrees F",
  "problems": [
   "crack"
  ]
 },
 "superior gold gv-1 flowing adhesive for stone laminating and seaming": {
  "type": "adhesive",
  "subtype": "Acrylic Vinyl Ester",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "rodding",
   "seaming",
   "laminating"
  ],
  "mat": [
   "engineered",
   "granite",
   "marble"
  ],
  "viscosity": "Flowing",
  "colors": [
   "clear/translucent"
  ],
  "warnings": [
   "Indoor use only.",
   "Runs on vertical surfaces - use knife-grade for vertical work."
  ],
  "disc": false,
  "mix_ratio": "1%-2% BPO hardener by weight",
  "work_time": "4-6 minutes @ 70 degrees F",
  "cure_time": "20-25 minutes @ 70 degrees F",
  "problems": [
   "crack"
  ]
 },
 "superior v-max sv-1 flowing adhesive for outdoor stone fabrication": {
  "type": "adhesive",
  "subtype": "Vinyl Ester",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "rodding",
   "seaming",
   "laminating"
  ],
  "mat": [
   "engineered",
   "granite",
   "marble"
  ],
  "viscosity": "Flowing",
  "colors": [
   "clear/translucent"
  ],
  "warnings": [
   "Suitable for exterior use.",
   "Runs on vertical surfaces - use knife-grade for vertical work."
  ],
  "disc": false,
  "mix_ratio": "1%-2% BPO hardener by weight",
  "work_time": "4-6 minutes @ 70 degrees F",
  "cure_time": "20-30 minutes @ 70 degrees F",
  "problems": [
   "crack"
  ]
 },
 "superior pearl flowing adhesive for marble and natural stone seaming": {
  "type": "adhesive",
  "subtype": "Polyester",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating"
  ],
  "mat": [
   "limestone",
   "marble",
   "granite"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent/pearl"
  ],
  "warnings": [
   "Indoor use only.",
   "May yellow on light-colored marble over time.",
   "Runs on vertical surfaces - use knife-grade for vertical work."
  ],
  "disc": false,
  "mix_ratio": "1-4% BPO hardener by weight",
  "work_time": "4-6 minutes @ 70 degrees F",
  "cure_time": "20-30 minutes @ 70 degrees F",
  "problems": [
   "crack"
  ]
 },
 "superior travertine filler polyester adhesive": {
  "type": "filler",
  "subtype": "Polyester",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "repair"
  ],
  "mat": [
   "travertine",
   "marble",
   "granite"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "travertine-matched (ivory/buff)"
  ],
  "warnings": [
   "Indoor use only.",
   "Specifically formulated for travertine hole filling.",
   "May yellow on light-colored marble over time."
  ],
  "disc": false,
  "mix_ratio": "1-4% BPO hardener by weight",
  "work_time": "4-6 minutes @ 70 degrees F",
  "cure_time": "20-30 minutes @ 70 degrees F",
  "problems": [
   "crack"
  ]
 },
 "superior black polyester knife grade adhesive": {
  "type": "adhesive",
  "subtype": "Polyester",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "granite",
   "dark stone"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "black"
  ],
  "warnings": [
   "Indoor use only.",
   "Pre-colored black."
  ],
  "disc": false,
  "mix_ratio": "1-4% BPO hardener by weight",
  "work_time": "4-6 minutes @ 70 degrees F",
  "cure_time": "20-30 minutes @ 70 degrees F",
  "problems": [
   "crack"
  ]
 },
 "superior white polyester flowing adhesive": {
  "type": "adhesive",
  "subtype": "Polyester",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "repair",
   "laminating"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "viscosity": "Flowing",
  "colors": [
   "white"
  ],
  "warnings": [
   "Indoor use only.",
   "Pre-colored white.",
   "May yellow on light-colored marble over time.",
   "Runs on vertical surfaces - use knife-grade for vertical work."
  ],
  "disc": false,
  "mix_ratio": "1-4% BPO hardener by weight",
  "work_time": "4-6 minutes @ 70 degrees F",
  "cure_time": "20-30 minutes @ 70 degrees F",
  "problems": [
   "crack"
  ]
 },
 "superior buff polyester knife grade adhesive": {
  "type": "adhesive",
  "subtype": "Polyester",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "travertine",
   "marble",
   "granite"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "buff/beige"
  ],
  "warnings": [
   "Indoor use only.",
   "Pre-colored buff.",
   "May yellow on light-colored marble over time."
  ],
  "disc": false,
  "mix_ratio": "1-4% BPO hardener by weight",
  "work_time": "4-6 minutes @ 70 degrees F",
  "cure_time": "20-30 minutes @ 70 degrees F",
  "problems": [
   "crack"
  ]
 },
 "superior buff polyester flowing adhesive": {
  "type": "adhesive",
  "subtype": "Polyester",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "repair",
   "laminating"
  ],
  "mat": [
   "travertine",
   "marble",
   "granite"
  ],
  "viscosity": "Flowing",
  "colors": [
   "buff/beige"
  ],
  "warnings": [
   "Indoor use only.",
   "Pre-colored buff.",
   "May yellow on light-colored marble over time.",
   "Runs on vertical surfaces - use knife-grade for vertical work."
  ],
  "disc": false,
  "mix_ratio": "1-4% BPO hardener by weight",
  "work_time": "4-6 minutes @ 70 degrees F",
  "cure_time": "20-30 minutes @ 70 degrees F",
  "problems": [
   "crack"
  ]
 },
 "superior water-clear polyester flowing adhesive": {
  "type": "adhesive",
  "subtype": "Polyester",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "repair",
   "laminating"
  ],
  "mat": [
   "marble",
   "granite",
   "white stone"
  ],
  "viscosity": "Flowing",
  "colors": [
   "water-clear"
  ],
  "warnings": [
   "Indoor use only.",
   "Premium clarity for white/light stones.",
   "May yellow on light-colored marble over time.",
   "Runs on vertical surfaces - use knife-grade for vertical work."
  ],
  "disc": false,
  "mix_ratio": "1-4% BPO hardener by weight",
  "work_time": "4-6 minutes @ 70 degrees F",
  "cure_time": "20-30 minutes @ 70 degrees F",
  "problems": [
   "crack"
  ]
 },
 "superior polyester transparent flowing adhesives": {
  "type": "adhesive",
  "subtype": "Polyester",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "repair",
   "laminating"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "warnings": [
   "Indoor use only.",
   "May yellow on light-colored marble over time.",
   "Runs on vertical surfaces - use knife-grade for vertical work."
  ],
  "disc": false,
  "mix_ratio": "1-4% BPO hardener by weight",
  "work_time": "4-6 minutes @ 70 degrees F",
  "cure_time": "20-30 minutes @ 70 degrees F",
  "problems": [
   "crack"
  ]
 },
 "superior water clear polyester knife grade adhesive": {
  "type": "adhesive",
  "subtype": "Polyester",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "marble",
   "granite",
   "white stone"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "water-clear"
  ],
  "warnings": [
   "Indoor use only.",
   "Premium clarity for white/light stones.",
   "May yellow on light-colored marble over time."
  ],
  "disc": false,
  "mix_ratio": "1-4% BPO hardener by weight",
  "work_time": "4-6 minutes @ 70 degrees F",
  "cure_time": "20-30 minutes @ 70 degrees F",
  "problems": [
   "crack"
  ]
 },
 "superior acrylic penetrating adhesive - quart": {
  "type": "adhesive",
  "subtype": "Acrylic",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "viscosity": "Super Flowing / Penetrating",
  "colors": [],
  "warnings": [
   "Indoor use only.",
   "Very low viscosity - penetrates deep into stone.",
   "Runs on vertical surfaces - use knife-grade for vertical work."
  ],
  "disc": false,
  "mix_ratio": "1-4% BPO hardener by weight",
  "work_time": "8-12 min",
  "cure_time": "20-30 min",
  "app": [
   "fissures",
   "repair"
  ],
  "problems": [
   "crack"
  ]
 },
 "superior stone cleanser degreaser for granite marble and natural stone": {
  "type": "cleaner",
  "subtype": "Degreaser",
  "vendor": "Superior Stone Products",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": ""
 },
 "superior e-1000 flowing epoxy parts for stone laminating and seaming": {
  "type": "adhesive",
  "subtype": "Epoxy (Two-Part)",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "rodding",
   "seaming",
   "laminating"
  ],
  "mat": [
   "engineered",
   "granite"
  ],
  "viscosity": "Flowing (Syrup Consistency)",
  "colors": [
   "extra clear (translucent/colorless)"
  ],
  "warnings": [
   "Suitable for freeze/thaw conditions.",
   "Withstands vibrations and shock loads.",
   "Runs on vertical surfaces - use knife-grade for vertical work."
  ],
  "disc": false,
  "mix_ratio": "1:1 by volume (1.15 Part A to 1.0 Part B by weight)",
  "work_time": "5-10 minutes",
  "cure_time": "2-4 hours",
  "problems": [
   "crack"
  ]
 },
 "superior e-1000 gallon flowing epoxy unit": {
  "type": "adhesive",
  "subtype": "Epoxy (Two-Part)",
  "vendor": "Superior Stone Products",
  "env": [
   "interior and exterior"
  ],
  "app": [
   "rodding",
   "seaming",
   "laminating"
  ],
  "mat": [
   "engineered",
   "granite"
  ],
  "viscosity": "Flowing (Syrup Consistency)",
  "colors": [
   "extra clear (translucent/colorless)"
  ],
  "warnings": [
   "Suitable for freeze/thaw conditions.",
   "Runs on vertical surfaces - use knife-grade for vertical work."
  ],
  "disc": false,
  "mix_ratio": "1:1 by volume (1.15 Part A to 1.0 Part B by weight)",
  "work_time": "5-10 minutes",
  "cure_time": "2-4 hours",
  "problems": [
   "crack"
  ]
 },
 "superior e-1000 quart flowing epoxy unit": {
  "type": "adhesive",
  "subtype": "Epoxy (Two-Part)",
  "vendor": "Superior Stone Products",
  "env": [
   "interior and exterior"
  ],
  "app": [
   "rodding",
   "seaming",
   "laminating"
  ],
  "mat": [
   "engineered",
   "granite"
  ],
  "viscosity": "Flowing (Syrup Consistency)",
  "colors": [
   "extra clear (translucent/colorless)"
  ],
  "warnings": [
   "Suitable for freeze/thaw conditions.",
   "Runs on vertical surfaces - use knife-grade for vertical work."
  ],
  "disc": false,
  "mix_ratio": "1:1 by volume (1.15 Part A to 1.0 Part B by weight)",
  "work_time": "5-10 minutes",
  "cure_time": "2-4 hours",
  "problems": [
   "crack"
  ]
 },
 "superior e-1010 gallon knife grade epoxy unit": {
  "type": "adhesive",
  "subtype": "Epoxy (Two-Part)",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "rodding",
   "seaming",
   "mitering",
   "laminating",
   "repair"
  ],
  "mat": [
   "engineered",
   "fiberglass",
   "concrete",
   "metals",
   "granite"
  ],
  "viscosity": "Knife Grade (Paste)",
  "colors": [
   "extra clear (translucent/colorless)"
  ],
  "warnings": [
   "Suitable for freeze/thaw conditions.",
   "No sag on vertical surfaces."
  ],
  "disc": false,
  "mix_ratio": "1:1 by volume (1.15 Part A to 1.0 Part B by weight)",
  "work_time": "5-10 minutes",
  "cure_time": "2-4 hours",
  "problems": [
   "crack"
  ]
 },
 "superior e-1010 knife grade epoxy parts for stone vertical bonding": {
  "type": "adhesive",
  "subtype": "Epoxy (Two-Part)",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "rodding",
   "seaming",
   "mitering",
   "laminating",
   "repair"
  ],
  "mat": [
   "engineered",
   "fiberglass",
   "concrete",
   "metals",
   "granite"
  ],
  "viscosity": "Knife Grade (Paste)",
  "colors": [
   "extra clear (translucent/colorless)"
  ],
  "warnings": [
   "Suitable for freeze/thaw conditions.",
   "No sag on vertical surfaces."
  ],
  "disc": false,
  "mix_ratio": "1:1 by volume (1.15 Part A to 1.0 Part B by weight)",
  "work_time": "5-10 minutes",
  "cure_time": "2-4 hours",
  "problems": [
   "crack"
  ]
 },
 "superior e-1010 quart knife grade epoxy unit": {
  "type": "adhesive",
  "subtype": "Epoxy (Two-Part)",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "rodding",
   "seaming",
   "mitering",
   "laminating",
   "repair"
  ],
  "mat": [
   "engineered",
   "fiberglass",
   "concrete",
   "metals",
   "granite"
  ],
  "viscosity": "Knife Grade (Paste)",
  "colors": [
   "extra clear (translucent/colorless)"
  ],
  "warnings": [
   "Suitable for freeze/thaw conditions.",
   "No sag on vertical surfaces."
  ],
  "disc": false,
  "mix_ratio": "1:1 by volume (1.15 Part A to 1.0 Part B by weight)",
  "work_time": "5-10 minutes",
  "cure_time": "2-4 hours",
  "problems": [
   "crack"
  ]
 },
 "superior e-1500s knife grade gallon epoxy unit": {
  "type": "adhesive",
  "subtype": "Epoxy (Two-Part)",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "rodding",
   "mitering",
   "seaming",
   "laminating",
   "repair"
  ],
  "mat": [
   "engineered",
   "granite"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "translucent"
  ],
  "warnings": [
   "For professional use only."
  ],
  "disc": false,
  "mix_ratio": "per manufacturer instructions",
  "work_time": "30-60 min",
  "cure_time": "4-24 hr",
  "problems": [
   "crack"
  ]
 },
 "superior gold evolution ext 250ml cartridges": {
  "type": "adhesive",
  "subtype": "Modified Acrylic Vinyl Ester (CArtridge Format)",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "rodding",
   "seaming",
   "repair",
   "mitering"
  ],
  "mat": [
   "engineered",
   "granite",
   "sintered",
   "quartz",
   "porcelain"
  ],
  "viscosity": "Knife Grade (Cartridge Dispensed)",
  "colors": [
   "various - color-matched cartridges"
  ],
  "warnings": [
   "Requires cartridge dispensing gun and mixing nozzle."
  ],
  "disc": false,
  "mix_ratio": "pre-metered dual cartridge",
  "work_time": "5-8 min",
  "cure_time": "20-30 min",
  "problems": [
   "crack"
  ]
 },
 "superior lightning instant color enhancer for engineered quartz": {
  "type": "enhancer",
  "subtype": "Color Enhancer",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "mat": [
   "engineered"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "warnings": [
   "For engineered quartz only - not natural stone."
  ],
  "disc": false,
  "mix_ratio": "N/A - ready to use",
  "work_time": "",
  "cure_time": "",
  "app": [
   "enhancing"
  ]
 },
 "bellinzoni idea stonager antistain color intensifier 1 l": {
  "type": "enhancer",
  "subtype": "Penetrating, Solvent-Based, Color Intensifier",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "mat": [
   "marble",
   "engineered",
   "concrete",
   "granite",
   "sintered",
   "porcelain"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Surface must be dry and clean before application.",
   "Remove existing stains and mold first.",
   "Wait 24 hours before foot traffic.",
   "For unpolished/textured surfaces.",
   "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "not_for_restoration": true,
  "app": [
   "enhancing"
  ]
 },
 "bellinzoni mangiamacchia spot remover 250 ml": {
  "type": "stain-remover",
  "subtype": "Poultice, Paste",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "granite",
   "concrete"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Apply thick layer over stain.",
   "Cover with plastic wrap.",
   "Allow 12-24 hours to draw out stain.",
   "May require repeat applications."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni b-refresh top gentle cleaner for kitchen and bathroom countertops 750 ml": {
  "type": "cleaner",
  "subtype": "Ready-To-Use, Spray, Gentle",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "granite",
   "countertops",
   "engineered"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "For daily maintenance use.",
   "Gentle formula safe for natural stone."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni idea dark antistain deep enhancer protective agent 1 l": {
  "type": "enhancer",
  "subtype": "Penetrating, Solvent-Based, Nano-Tech, Deep Color Enhancer",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "marble",
   "absorbent stone",
   "rough stone",
   "leather finish stone",
   "concrete",
   "dark colored stone",
   "granite",
   "sintered",
   "porcelain"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Extra dark effect - changes appearance significantly.",
   "Apply between 10-30C.",
   "Turn off underfloor heating before application.",
   "PFAS-free.",
   "Remove excess after 10-15 minutes.",
   "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "not_for_restoration": true,
  "app": [
   "enhancing"
  ]
 },
 "bellinzoni b-listo maintenance cream 250 ml": {
  "type": "polish",
  "subtype": "Cream, Solvent-Free",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "marble",
   "granite",
   "countertops",
   "tables",
   "quartz resin",
   "window sills",
   "travertine"
  ],
  "problems": [
   "fading",
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Apply with cotton cloth in circular motions.",
   "Allow 10-15 minutes drying before buffing.",
   "Surface must be clean and dry."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni b-rust remover gel for stone & tile surfaces": {
  "type": "stain-remover",
  "subtype": "Gel, Rust-Specific",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "concrete",
   "ceramic tile",
   "granite",
   "porcelain"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Gel formula for vertical and horizontal surfaces.",
   "Test on inconspicuous area first."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni idea gold antistain protective agent natural color 1 l": {
  "type": "sealer",
  "subtype": "Penetrating, Nano-Tech, Natural Effect",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Does not alter natural color - pearl effect.",
   "UV resistant.",
   "Allows stone to breathe.",
   "Apply between 10-30C.",
   "Turn off underfloor heating before application."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni idea quarzo color enhancer protective agent 1 l": {
  "type": "enhancer",
  "subtype": "Penetrating, Solvent-Based, Nano-Tech",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "engineered",
   "marble",
   "synthetic stone",
   "porcelain",
   "quartz resin"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "PFAS-free.",
   "Apply between 10-30C.",
   "Turn off underfloor heating first.",
   "UV resistant.",
   "Surface must be free of dirt and salt deposits.",
   "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "not_for_restoration": true,
  "app": [
   "enhancing"
  ]
 },
 "bellinzoni idea tropical antistain color intensifier 1 l": {
  "type": "enhancer",
  "subtype": "Penetrating, Solvent-Based, Color Intensifier",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "For professional use only.",
   "Test before application.",
   "Wait 24 hours before foot traffic.",
   "UV resistant.",
   "Breathable formula."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "app": [
   "enhancing"
  ]
 },
 "bellinzoni wall clean spray paint, marker and grafitti remover 1 l": {
  "type": "cleaner",
  "subtype": "Gel, Voc-Free, Graffiti Remover",
  "vendor": "Bellinzoni",
  "env": [
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "glass",
   "granite",
   "aluminum",
   "metal"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "High (Gel, Non Drip)",
  "colors": [],
  "warnings": [
   "VOC-free.",
   "Non-drip gel for vertical surfaces.",
   "Minimum 10 minutes dwell time.",
   "Test on painted or plastic surfaces first.",
   "No acids, alkalines, oxidants, or reducers."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni eureka marble polishing gel 1 l": {
  "type": "polish",
  "subtype": "Gel, Lead-Free",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "limestone",
   "marble",
   "terrazzo",
   "calcareous stone",
   "travertine"
  ],
  "problems": [
   "fading",
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Use with buffing machine or grinder at 800-1500 rpm.",
   "Optimal speed 1000 rpm.",
   "Surface must be polished above grit 400.",
   "Lead-free.",
   "Wash floor with alkaline solution after use."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni quartz care system kit for engineered quartz surfaces": {
  "type": "kit",
  "subtype": "CAre System, Multi-Product",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "mat": [
   "quartz resin",
   "engineered",
   "countertops"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Specifically formulated for engineered quartz.",
   "Follow kit instructions for each product."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "problems": [
   "general-cleaning"
  ],
  "app": [
   "cleaning"
  ]
 },
 "bellinzoni b-27 exxtra concentrated acidic based detergent 1 l": {
  "type": "cleaner",
  "subtype": "Concentrated, Acid-Based, Heavy-Duty",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "ceramic",
   "granite",
   "acid resistant stone",
   "cement",
   "sintered",
   "porcelain",
   "engineered",
   "concrete"
  ],
  "problems": [
   "epoxy-haze",
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "ACID-BASED - DO NOT use on marble, limestone, travertine, or calcium-based stones.",
   "For acid-resistant surfaces only.",
   "Concentrated - requires dilution."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni b-3 action doccia limescale and heavy water deposits remover 750 ml": {
  "type": "cleaner",
  "subtype": "Ready-To-Use, Spray, Limescale Remover",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "glass",
   "chrome fixtures",
   "bathroom tile",
   "shower surfaces"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Do not use on marble or acid-sensitive stone.",
   "For bathroom/shower use."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni b-3 action inox greasy fingerprint and smudge remover 750 ml": {
  "type": "cleaner",
  "subtype": "Ready-To-Use, Spray, Stainless-Steel Specific",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "metal appliances",
   "inox surfaces",
   "stainless steel"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "For stainless steel surfaces only."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni b-3 action top 3 in 1 formula; cleans, protects and polishes 750 ml": {
  "type": "cleaner",
  "subtype": "Ready-To-Use, Spray, 3-In-1",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "granite",
   "countertops",
   "travertine"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "3-in-1: cleans, protects, and polishes in one step."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni b-3 action wood clean, protect and polish for wood surfaces 750 ml": {
  "type": "cleaner",
  "subtype": "Ready-To-Use, Spray, Wood-Specific",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "wood furniture",
   "wood floors",
   "wood surfaces"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "For wood surfaces only - not for stone."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni b-clean inox multi surface cleaner for all stainless-steel surfaces 750 ml": {
  "type": "cleaner",
  "subtype": "Ready-To-Use, Spray, Stainless-Steel Specific",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "inox",
   "metal surfaces",
   "stainless steel"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "For stainless steel surfaces."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni b-dural brill surface strengthening polish 1 l": {
  "type": "polish",
  "subtype": "Liquid, Surface Strengthener",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "marble",
   "granite",
   "terrazzo",
   "travertine"
  ],
  "problems": [
   "fading",
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Professional-grade polish.",
   "Apply with buffing machine for best results."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni b-gtx grout joint cleaner 750 ml": {
  "type": "cleaner",
  "subtype": "Ready-To-Use, Spray, Grout-Specific",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "cement grout",
   "tile grout joints"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "For cementitious grout joints.",
   "Test on inconspicuous area first."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni b-grayout grey stain remover for wood surfaces 750 ml": {
  "type": "cleaner",
  "subtype": "Ready-To-Use, Wood-Specific, Stain Remover",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "wood surfaces",
   "outdoor wood",
   "grey weathered wood"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "For wood surfaces only - not for stone.",
   "Removes grey patina from weathered wood."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni b-lem3 exxtra mg foaming detergent for floors 1 l": {
  "type": "cleaner",
  "subtype": "Concentrated, Foaming, Neutral PH",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "ceramic",
   "terracotta",
   "concrete",
   "granite"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Concentrated - requires dilution.",
   "Neutral pH safe for all stone types.",
   "Foaming formula."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni b-oil 4 cleaner foaming detergent for oil treated parquet and wood surfaces 1 l": {
  "type": "cleaner",
  "subtype": "Foaming, Wood-Specific",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "oil treated parquet",
   "wood floors",
   "oil treated wood"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Specifically for oil-treated wood surfaces.",
   "Not for stone surfaces."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni b-pro joint protection for cementitous based joints from oil and water-based stains 750 ml": {
  "type": "sealer",
  "subtype": "Grout Sealer, Spray",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "cementitious joints",
   "cement grout"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "For cementitious grout only, not epoxy grout."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni b-remoxy cleaning gel for epoxy residues 1 kg": {
  "type": "cleaner",
  "subtype": "Gel, Epoxy Remover",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "glass mosaic",
   "marble",
   "quartzite",
   "ceramic tile",
   "granite",
   "sintered",
   "porcelain",
   "engineered",
   "concrete"
  ],
  "problems": [
   "epoxy-haze",
   "general-cleaning"
  ],
  "viscosity": "High (Gel)",
  "colors": [],
  "warnings": [
   "For removing cured epoxy residue.",
   "Apply and allow dwell time.",
   "Do not use on absorbent untreated stone without testing."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni b-sanychlor mold and mildew stain remover 750 ml": {
  "type": "cleaner",
  "subtype": "Ready-To-Use, Spray, Sanitizing",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "grout",
   "granite",
   "tile",
   "marble"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Contains chlorine-based active ingredients.",
   "Test on inconspicuous area first.",
   "Rinse after use."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni b-sanyfloor ph neutral sanitizing detergent 1 l": {
  "type": "cleaner",
  "subtype": "Concentrated, PH-Neutral, Sanitizing",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "ceramic tile",
   "granite",
   "sintered",
   "porcelain"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "PH neutral - safe for natural stone.",
   "Concentrated - requires dilution."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni b-super cleaner degreasing solvent cleaner 1 l": {
  "type": "cleaner",
  "subtype": "Solvent-Based, Degreaser",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "granite",
   "concrete"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Solvent-based - use in well-ventilated area.",
   "For heavy-duty degreasing."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni b-top restorer polishing cream 250 ml": {
  "type": "polish",
  "subtype": "Cream, Restoration",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "marble",
   "granite",
   "countertops",
   "travertine"
  ],
  "problems": [
   "fading",
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Apply with soft cloth in circular motions.",
   "Buff to shine after drying."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni b-wash & polish 2-in-1 detergent and polish for hard floors 1 l": {
  "type": "cleaner",
  "subtype": "Concentrated, 2-In-1, Cleaner-Polish",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "granite",
   "terrazzo",
   "travertine"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "2-in-1: cleans and polishes in one step.",
   "For hard floors only."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni b-xtreme hd cleaner ck high-concentrate cleaner for terracotta, clinker, glazed ceramic and quarry tile 1l": {
  "type": "cleaner",
  "subtype": "Concentrated, Heavy-Duty",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "glazed ceramic",
   "terracotta",
   "clinker",
   "quarry tile"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "High-concentrate - dilute before use.",
   "Specific for terracotta, clinker, and quarry tile."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni b- lem3 exxtra wd neutral detergent 1l": {
  "type": "cleaner",
  "subtype": "Concentrated, Neutral PH",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "ceramic",
   "terracotta",
   "gres",
   "concrete",
   "granite"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Neutral pH - safe for all stone types.",
   "Concentrated - requires dilution."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni epox premium set (a and b) epoxy mastic for gluing, jointing and filling": {
  "type": "adhesive",
  "subtype": "Two-Component Epoxy, 2:1 Ratio",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "rodding",
   "repair"
  ],
  "mat": [
   "marble",
   "glass",
   "terrazzo",
   "concrete",
   "stone honeycomb panels",
   "granite",
   "agglomerates",
   "plexiglass"
  ],
  "viscosity": "Paste (Knife Grade)",
  "colors": [
   "colorless/transparent"
  ],
  "warnings": [
   "Mix 2:1 ratio.",
   "Workable 20-30 minutes at 20C.",
   "Movable after 6-8 hours.",
   "Polishable after 14-16 hours.",
   "Max stability 7 days.",
   "Do not apply below 10C.",
   "Very low yellowing."
  ],
  "disc": false,
  "mix_ratio": "2:1",
  "work_time": "20-30",
  "cure_time": "480",
  "problems": [
   "crack"
  ]
 },
 "bellinzoni eureka granite polishing gel for granite 1 l": {
  "type": "polish",
  "subtype": "Gel, Lead-Free",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "granite",
   "gres",
   "hard silica containing stone"
  ],
  "problems": [
   "fading",
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Use with orbital sander at 800-1500 rpm.",
   "Optimal 1000 rpm.",
   "Works on surfaces from grit 220+.",
   "Lead-free.",
   "Alternative to tin oxide."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "bellinzoni eureka quartz resin polishing gel 1 l": {
  "type": "polish",
  "subtype": "Gel, Engineered-Stone Specific",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "engineered",
   "silestone",
   "sm quartz",
   "okite",
   "quartz resin"
  ],
  "problems": [
   "fading",
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Use with orbital sander at 800-1500 rpm.",
   "Optimal 1000 rpm.",
   "For countertops: 10-15g per application."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "fila norust rust stain remover for natural stone and tile": {
  "type": "stain-remover",
  "subtype": "Gel, Non-Acidic, Rust-Specific",
  "vendor": "FILA",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "terrazzo",
   "terracotta",
   "concrete",
   "granite",
   "porcelain"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "Gel",
  "colors": [],
  "warnings": [
   "Non-acidic - safe for marble, limestone, travertine.",
   "Turns purple when reacting with rust.",
   "15-minute dwell time.",
   "Repeat for stubborn stains.",
   "May strip wax from treated surfaces."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "fila deterdek qt. - cement grout haze remover": {
  "type": "cleaner",
  "subtype": "Water-Based, Acidic",
  "vendor": "FILA",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "terracotta",
   "quarry tile",
   "ceramic tile",
   "granite",
   "acid resistant stone",
   "sintered",
   "quartzite",
   "porcelain",
   "engineered",
   "concrete"
  ],
  "problems": [
   "epoxy-haze",
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Do NOT use on marble, limestone, or travertine.",
   "Only for cement-based grouts.",
   "Alternative to muriatic acid.",
   "No harmful fumes."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "fila ps87 1 gallon heavy duty stone and tile cleaner concentrate": {
  "type": "cleaner",
  "subtype": "Water-Based, Alkaline, Concentrated, Degreaser",
  "vendor": "FILA",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "terracotta",
   "unpolished agglomerates",
   "concrete",
   "quarry tile",
   "glazed ceramic",
   "granite",
   "sintered",
   "porcelain",
   "linoleum",
   "pvc"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Do not use on polished marble or polished stone.",
   "Do not use on wood.",
   "Concentrated - dilute 1:5 to 1:20.",
   "Biodegradable."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "fila kitchenkare 24 oz. - kitchen stain remover": {
  "type": "cleaner",
  "subtype": "Ready-To-Use, Spray, Kitchen-Specific",
  "vendor": "FILA",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "metal",
   "ceramic tile",
   "plastic",
   "kitchen surfaces",
   "sintered",
   "porcelain"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Spray and wipe application.",
   "Gentle on hands.",
   "Biodegradable.",
   "Pleasantly scented."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "fila groutrenew - grout cleaner & deep stain remover spray": {
  "type": "cleaner",
  "subtype": "Ready-To-Use, Spray, Non-Acidic, Grout-Specific",
  "vendor": "FILA",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "cementitious grout",
   "mosaic",
   "ceramic tile",
   "sintered",
   "porcelain"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Non-acidic formula.",
   "Do NOT use on polished marble, travertine, or limestone.",
   "Do NOT use on waxed surfaces.",
   "Causes plastic/polished surfaces to dull.",
   "Biodegradable.",
   "Seal grout after cleaning with GROUT PROOF."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "fila epoxyoff qt. - epoxy grout haze remover": {
  "type": "cleaner",
  "subtype": "Water-Based, Alkaline, Gel",
  "vendor": "FILA",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "sintered",
   "porcelain",
   "engineered",
   "concrete"
  ],
  "problems": [
   "epoxy-haze",
   "general-cleaning"
  ],
  "viscosity": "Gel",
  "colors": [],
  "warnings": [
   "CRITICAL: Do NOT use on marble, granite, quartzite, limestone, travertine, or any natural stone. For porcelain and engineered surfaces ONLY.",
   "Do NOT use on absorbent materials (natural stone, wood, plastic).",
   "Wait 24 hours after grouting before use.",
   "Ensure grout is fully cured.",
   "30-minute action time.",
   "Biodegradable."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "fila showerclean & shine 24 oz. - bathroom soap scum remover": {
  "type": "cleaner",
  "subtype": "Ready-To-Use, Spray, Bathroom-Specific",
  "vendor": "FILA",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "glass",
   "shower surfaces",
   "ceramic tile",
   "granite",
   "sintered",
   "porcelain"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "For bathroom and shower surfaces.",
   "Spray and wipe."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "fila refresh & reseal 24 oz. - neutral cleaner & resealer spray": {
  "type": "cleaner",
  "subtype": "Ready-To-Use, Spray, Neutral PH, Cleaner + Resealer",
  "vendor": "FILA",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "travertine",
   "marble",
   "limestone",
   "granite",
   "quartz",
   "quartzite"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "No rinsing required.",
   "Spray and wipe with dry cloth.",
   "PFOA and PFOS free.",
   "Food-contact safe.",
   "Biodegradable."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "fila cleanall spray 24 oz. - neutral everyday cleaner": {
  "type": "cleaner",
  "subtype": "Ready-To-Use, Spray, Neutral PH",
  "vendor": "FILA",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "wood",
   "ceramic tile",
   "granite",
   "laminate",
   "sintered",
   "porcelain"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "PH neutral - safe for natural stone.",
   "No rinsing needed.",
   "Biodegradable."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "fila - contractor's choice sealer - 1 gallon": {
  "type": "sealer",
  "subtype": "Penetrating, Water-Based, Eco-Friendly",
  "vendor": "FILA Solutions",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "cement grout",
   "granite",
   "concrete",
   "terracotta"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Water-based, VOC-free.",
   "Odorless.",
   "PFOA and PFOS not intentionally added."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "k-bond vivid vinyl ester adhesive knife grade": {
  "type": "adhesive",
  "subtype": "Vinyl Ester, Knife Grade",
  "vendor": "K-Bond",
  "env": [
   "interior"
  ],
  "app": [
   "rodding",
   "laminating",
   "repair"
  ],
  "mat": [
   "quartzite",
   "engineered",
   "granite",
   "marble"
  ],
  "viscosity": "Knife Grade (Thick Paste)",
  "colors": [
   "clear/colorless"
  ],
  "warnings": [
   "Vinyl ester - superior UV resistance vs polyester.",
   "Better outdoor durability than polyester.",
   "Requires hardener/catalyst."
  ],
  "disc": false,
  "mix_ratio": "1-3% BPO hardener",
  "work_time": "4-6",
  "cure_time": "20-30",
  "problems": [
   "crack"
  ],
  "uv_stable": null
 },
 "k-bond polyester stone adhesive transparent paste - quart": {
  "type": "adhesive",
  "subtype": "Polyester, Transparent, Paste",
  "vendor": "K-Bond",
  "env": [
   "interior"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "viscosity": "Paste (Knife Grade)",
  "colors": [
   "transparent"
  ],
  "warnings": [
   "Requires hardener/catalyst (BPO).",
   "Can be tinted with pigments.",
   "Quart size."
  ],
  "disc": false,
  "mix_ratio": "1-3% BPO hardener",
  "work_time": "4-6",
  "cure_time": "30-60",
  "app": [
   "seaming",
   "repair"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ]
 },
 "k-bond - icon colorless knife grade styren free adhesive": {
  "type": "adhesive",
  "subtype": "Styrene-Free, Knife Grade",
  "vendor": "K-Bond",
  "env": [
   "interior"
  ],
  "mat": [
   "engineered",
   "marble",
   "granite",
   "quartz",
   "quartzite"
  ],
  "viscosity": "Knife Grade (Thick Paste)",
  "colors": [
   "colorless"
  ],
  "warnings": [
   "Styrene-free - low odor, better indoor air quality.",
   "Requires hardener/catalyst."
  ],
  "disc": false,
  "mix_ratio": "2-3% BPO hardener",
  "work_time": "5-7",
  "cure_time": "20-30",
  "app": [
   "seaming",
   "repair"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ]
 },
 "k-bond elite stone adhesive knife grade for granite and marble seams": {
  "type": "adhesive",
  "subtype": "Polyester, Knife Grade, Premium",
  "vendor": "K-Bond",
  "env": [
   "interior"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "viscosity": "Knife Grade (Thick Paste)",
  "colors": [],
  "warnings": [
   "Premium formula for stone seams.",
   "Requires hardener/catalyst."
  ],
  "disc": false,
  "mix_ratio": "1-3% BPO hardener",
  "work_time": "4-6",
  "cure_time": "20-30",
  "app": [
   "seaming",
   "repair"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ]
 },
 "k-bond high performance polyester white paste stone adhesive": {
  "type": "adhesive",
  "subtype": "Polyester, Paste, White",
  "vendor": "K-Bond",
  "env": [
   "interior"
  ],
  "app": [
   "repair"
  ],
  "mat": [
   "marble",
   "granite",
   "light colored stone"
  ],
  "viscosity": "Paste",
  "colors": [
   "white"
  ],
  "warnings": [
   "White color - for light-colored stone.",
   "Requires hardener/catalyst."
  ],
  "disc": false,
  "mix_ratio": "1-3% BPO hardener",
  "work_time": "5-7",
  "cure_time": "30-60",
  "problems": [
   "crack"
  ]
 },
 "k-bond ultimate perormance poly-epoxy knife grade - quart": {
  "type": "adhesive",
  "subtype": "Poly-Epoxy Hybrid, Knife Grade",
  "vendor": "K-Bond",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "rodding",
   "laminating",
   "repair"
  ],
  "mat": [
   "quartzite",
   "engineered",
   "granite",
   "marble"
  ],
  "viscosity": "Knife Grade (Thick Paste)",
  "colors": [],
  "warnings": [
   "Poly-epoxy hybrid - combines polyester speed with epoxy strength.",
   "Quart size.",
   "Requires hardener/catalyst."
  ],
  "disc": false,
  "mix_ratio": "1-3% BPO hardener",
  "work_time": "4-6",
  "cure_time": "25-30",
  "problems": [
   "crack"
  ]
 },
 "kraken bond ultra grab high tack - white construction adhesive 300ml 10.1 fl oz": {
  "type": "adhesive",
  "subtype": "Construction Adhesive, High-Tack, Ms Polymer",
  "vendor": "Kraken Bond",
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "foam",
   "ceramic",
   "wood",
   "metal",
   "stone",
   "concrete",
   "most building materials",
   "pvc"
  ],
  "viscosity": "Paste (Cartridge)",
  "colors": [
   "white"
  ],
  "warnings": [
   "High initial grab - holds without bracing.",
   "Paintable.",
   "Interior and exterior use.",
   "Isocyanate-free."
  ],
  "disc": false,
  "mix_ratio": "N/A (single component)",
  "work_time": "10-15",
  "cure_time": "1440",
  "app": [
   "repair"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ]
 },
 "hot stuff instant glue (thin, medium, thick) - 2 oz": {
  "type": "adhesive",
  "subtype": "Cyanoacrylate (CA) Glue",
  "vendor": "Satellite City",
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "engineered",
   "marble",
   "ceramic",
   "wood",
   "metal",
   "rubber",
   "granite",
   "plastic"
  ],
  "viscosity": "Thin (Water Like, Wicking) / Medium (Honey Like, Gap Filling) / Thick (Gel, Vertical Surfaces)",
  "colors": [
   "clear"
  ],
  "warnings": [
   "Thin: wicks into hairline cracks, 5-second bond.",
   "Medium: fills small gaps, 10-15 second bond.",
   "Thick: fills larger gaps, 30-60 second bond.",
   "Bonds skin instantly - use with care.",
   "Use accelerator for instant full cure.",
   "TEMPORARY BOND ONLY. Do NOT use for permanent seams - use methacrylate or epoxy."
  ],
  "disc": false,
  "mix_ratio": "N/A (single component CA)",
  "work_time": "0",
  "cure_time": "0.08-1",
  "app": [
   "seaming"
  ],
  "problems": [
   "crack"
  ]
 },
 "dry-treat - stain-proof original - premium impregnating sealer - qt": {
  "type": "sealer",
  "subtype": "Penetrating, Water-Based Impregnator",
  "vendor": "Stain-Proof",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "travertine",
   "marble",
   "terracotta",
   "limestone",
   "concrete",
   "slate",
   "brick",
   "granite",
   "sandstone",
   "grout"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Premium impregnating sealer.",
   "Does not alter appearance.",
   "Breathable.",
   "15-year warranty when professionally applied."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "dry-treat - stain-proof plus - premium countertop/dense impregnating sealer - 16oz": {
  "type": "sealer",
  "subtype": "Penetrating, For Dense/Polished Surfaces",
  "vendor": "Stain-Proof",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "porcelain",
   "engineered",
   "granite",
   "marble"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "For dense, polished, and low-porosity surfaces.",
   "Penetrates where standard sealers cannot.",
   "Does not alter appearance."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "dry-treat - eff-erayza rust remover - safe acid stone & masonry cleaner - qt": {
  "type": "cleaner",
  "subtype": "Acid-Based, Rust Remover, Safe For Stone",
  "vendor": "Stain-Proof",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "grout",
   "granite",
   "concrete",
   "masonry"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Safe acid formula - won't damage polished stone when used as directed.",
   "Test first.",
   "Quart size."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "stain-proof porcelain & quartz sealer - 1 quart (formerly porcelain plus)": {
  "type": "sealer",
  "subtype": "Penetrating, For Ultra-Dense Surfaces",
  "vendor": "Stain-Proof",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "porcelain",
   "engineered",
   "ultra compact surfaces",
   "sintered"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "For ultra-dense surfaces that resist standard sealers.",
   "Formerly called Porcelain Plus."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "dry-treat - oxy-klenza stain remover - triple action cleaner - 2.2lb": {
  "type": "cleaner",
  "subtype": "Powder, Oxygen-Based, Triple Action",
  "vendor": "Stain-Proof",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "masonry",
   "limestone",
   "concrete",
   "granite",
   "grout"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Oxygen-based - safe for natural stone.",
   "Mix with water to form paste/solution.",
   "Triple action: cleans, deodorizes, whitens."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "miracle sealants stone polish color and gloss enhancer (quart)": {
  "type": "enhancer",
  "subtype": "Topical Polish, Color Enhancer",
  "vendor": "Miracle Sealants (Rust-Oleum)",
  "env": [
   "interior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "marble",
   "engineered",
   "concrete",
   "granite",
   "sintered",
   "porcelain",
   "travertine"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Topical product - not a penetrating sealer.",
   "Reapply as needed for maintenance.",
   "WARNING: This product DARKENS and enriches stone color. Do NOT use on white marble (Calacatta, Carrara, Thassos) unless darkening is desired. For dull/worn marble, use a marble polish or etch remover instead."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "not_for_restoration": true
 },
 "miracle sealants 511qt6 511 impregnator sealer, quart, clear (new version, improved)": {
  "type": "sealer",
  "subtype": "Penetrating Impregnator",
  "vendor": "Miracle Sealants (Rust-Oleum)",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "travertine",
   "marble",
   "terrazzo",
   "limestone",
   "concrete",
   "slate",
   "ceramic tile",
   "granite",
   "quartz",
   "porcelain",
   "grout"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Invisible barrier - does not change surface appearance.",
   "Dry to touch 1-3 hours.",
   "Full cure 72 hours.",
   "Available in water-based and oil-based versions."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "miracle sealants plusgal4 511 porous plus sealer, gallon, yellow": {
  "type": "sealer",
  "subtype": "Penetrating, Solvent-Based, For Porous Surfaces",
  "vendor": "Miracle Sealants (Rust-Oleum)",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "travertine",
   "marble",
   "limestone",
   "slate",
   "granite",
   "quartzite",
   "grout"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Solvent-based: VOC <750 g/L.",
   "For porous surfaces.",
   "Will not alter natural look.",
   "Not a surface coating."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "miracle sealants coukl32oz6 spray counter kleen, 32 ounce, 32 fl oz": {
  "type": "cleaner",
  "subtype": "Ready-To-Use, Spray, PH-Neutral, Daily",
  "vendor": "Miracle Sealants (Rust-Oleum)",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "engineered",
   "granite",
   "backsplash",
   "quartz",
   "tile"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "PH neutral - acid-free.",
   "No rinsing required.",
   "Streak-free.",
   "Safe for sealed and unsealed stone."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "crown acetone solvent cleaner 1 gallon for stone fabrication": {
  "type": "solvent",
  "subtype": "Pure Acetone",
  "vendor": "Crown",
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "glass",
   "marble",
   "granite",
   "metal"
  ],
  "viscosity": "Liquid (Water Like)",
  "colors": [],
  "warnings": [
   "Highly flammable.",
   "Use in well-ventilated area.",
   "Avoid contact with skin and eyes.",
   "Keep away from ignition sources.",
   "Not for use on plastic, rubber, or painted surfaces."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "app": [
   "cleaning"
  ],
  "problems": [
   "general-cleaning"
  ]
 },
 "crown denatured alcohol 1 gallon (3.78 l)": {
  "type": "solvent",
  "subtype": "Denatured Alcohol (Ethanol)",
  "vendor": "Crown",
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "glass",
   "marble",
   "granite",
   "metal"
  ],
  "viscosity": "Liquid (Water Like)",
  "colors": [],
  "warnings": [
   "Flammable.",
   "Use in well-ventilated area.",
   "Evaporates quickly leaving no residue.",
   "Good for pre-sealer surface prep."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "app": [
   "cleaning"
  ],
  "problems": [
   "general-cleaning"
  ]
 },
 "icr sprint l17 anti-drop solvent base sealer": {
  "type": "sealer",
  "subtype": "Penetrating, Solvent-Based, Anti-Drip",
  "vendor": "ICR",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "marble",
   "granite",
   "concrete"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "Solvent-based.",
   "Anti-drip formula for vertical surfaces.",
   "Italian manufacturer."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "italian craftsman stone polish for granite and marble surfaces": {
  "type": "polish",
  "subtype": "Topical, Spray Or Liquid",
  "vendor": "Italian Craftsman",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "marble",
   "granite",
   "countertops",
   "travertine"
  ],
  "problems": [
   "fading",
   "general-cleaning"
  ],
  "viscosity": "",
  "colors": [],
  "warnings": [
   "For maintenance polishing, not restoration.",
   "Spray and wipe application."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "rust stain remover (rsr-2000) rust stain remover in gel form": {
  "type": "stain-remover",
  "subtype": "Gel, Rust-Specific",
  "vendor": "Alpha Professional Tools",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "marble",
   "granite",
   "tile",
   "concrete"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "Gel",
  "colors": [],
  "warnings": [
   "Gel formula stays in place on vertical surfaces.",
   "Apply and allow dwell time.",
   "Rinse thoroughly after use."
  ],
  "disc": false,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": ""
 },
 "akemi, epoxy adhesive, akepox 5010, knife grade, part a&b": {
  "type": "epoxy",
  "subtype": "2-Component Epoxy Knife Grade",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "repair",
   "substrate-bonding"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "quartz",
   "engineered",
   "porcelain",
   "concrete",
   "glass"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "disc": false
 },
 "5 gal. polyester transparent knife grade k-bond": {
  "type": "adhesive",
  "subtype": "Polyester",
  "vendor": "K-Bond",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "uv_stable": false,
  "disc": false
 },
 "mp90 eco plus high performance penetrating sealer - lifetime perfor...": {
  "type": "sealer",
  "subtype": "Water-based Penetrating Impregnator",
  "vendor": "FILA",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "quartz",
   "engineered",
   "porcelain",
   "travertine",
   "limestone"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "tenax micto two-part protective coating system for stone \u2014 2 liter kit": {
  "type": "epoxy",
  "subtype": "2-Component Fast Transparent Epoxy (1:1)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "rodding",
   "repair",
   "fissures",
   "substrate-bonding"
  ],
  "mat": [
   "granite",
   "marble",
   "quartz",
   "engineered",
   "limestone"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "uv_stable": false,
  "disc": false
 },
 "akemi darkener plus": {
  "type": "enhancer",
  "subtype": "Solvent-based Color-Intensifying Impregnator",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "granite",
   "marble",
   "limestone",
   "concrete"
  ],
  "problems": [
   "stain",
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [
   "clear"
  ],
  "uv_stable": true,
  "disc": false
 },
 "tenax proseal p (old name: protex) natural effect 1 qt tenax": {
  "type": "sealer",
  "subtype": "Penetrating Natural-Effect Impregnator",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartz",
   "engineered",
   "limestone"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "Liquid",
  "colors": [
   "clear"
  ],
  "uv_stable": null,
  "disc": false
 },
 "stain-proof\u00ae porcelain & quartz sealer \u2014 1 quart (formerly porcelain plus\u2122)": {
  "type": "sealer",
  "subtype": "Nano Impregnating Sealer (low-absorption surfaces)",
  "vendor": "Stain-Proof",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "porcelain",
   "quartz"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [
   "clear"
  ],
  "uv_stable": null,
  "disc": false
 },
 "acetone - 5 gallon": {
  "type": "cleaner",
  "subtype": "Solvent (Acetone)",
  "vendor": "DST",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [],
  "problems": [
   "cleaning",
   "epoxy-haze"
  ],
  "viscosity": "Liquid",
  "colors": [
   "clear"
  ],
  "uv_stable": null,
  "disc": false
 },
 "tenax skudo shield \u2013 quartz shield \u2013 1 l": {
  "type": "sealer",
  "subtype": "Water-based Penetrating Impregnator",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "quartz",
   "engineered",
   "granite",
   "marble"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [
   "clear"
  ],
  "uv_stable": null,
  "disc": false
 },
 "tenax ager tiger exotic stone enhancer & sealer": {
  "type": "enhancer",
  "subtype": "Solvent-based Color-Enhancing Sealer",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing",
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "travertine",
   "limestone",
   "onyx"
  ],
  "problems": [
   "fading",
   "stain"
  ],
  "viscosity": "Liquid",
  "colors": [
   "clear"
  ],
  "uv_stable": null,
  "disc": false
 },
 "denatured alcohol 5gl": {
  "type": "cleaner",
  "subtype": "Solvent (Denatured Alcohol)",
  "vendor": "Crown",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [],
  "problems": [
   "cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [
   "clear"
  ],
  "uv_stable": null,
  "disc": false
 },
 "hsk-2 hot stuff pro kit- complete ca glue set with stone accelerator and debonder": {
  "type": "adhesive",
  "subtype": "Cyanoacrylate Kit (3 viscosities + accelerator)",
  "vendor": "Satellite City",
  "env": [
   "interior"
  ],
  "app": [
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "onyx",
   "travertine",
   "limestone"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Thin/Medium/Thick",
  "colors": [
   "clear"
  ],
  "uv_stable": null,
  "disc": false
 },
 "tenax strongedge 45 a&b 1.5kg transparent knife-grade epoxy": {
  "type": "epoxy",
  "subtype": "2-Component Transparent Knife-Grade Epoxy (45 min)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "quartz",
   "engineered",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "uv_stable": null,
  "disc": false
 },
 "miracle sealants 511 seal & enhance (quart)": {
  "type": "enhancer",
  "subtype": "Solvent-based Sealer + Color Enhancer (one-step)",
  "vendor": "Miracle Sealants",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing",
   "enhancing",
   "restoration"
  ],
  "mat": [
   "granite",
   "marble",
   "limestone"
  ],
  "problems": [
   "stain",
   "fading",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": true,
  "disc": false
 },
 "fila mp90 natural look penetrating sealer - 30 years performance": {
  "type": "sealer",
  "subtype": "Solvent-based Natural-Look Penetrating Sealer",
  "vendor": "FILA",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "marble",
   "granite",
   "porcelain",
   "quartz"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": true,
  "disc": false
 },
 "akemi platinum 5.0 p+ flowing - transparent-opaque epoxy-acrylate adhesive (quart)": {
  "type": "adhesive",
  "subtype": "Epoxy-Acrylate Flowing",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair",
   "fissures",
   "substrate-bonding"
  ],
  "mat": [
   "granite",
   "marble",
   "limestone",
   "quartz",
   "porcelain",
   "solid surface",
   "concrete",
   "glass"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "uv_stable": false,
  "disc": false
 },
 "akemi platinum 5.0 p+ epoxyacrylate 900 ml": {
  "type": "adhesive",
  "subtype": "Epoxy-Acrylate Flowing",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair",
   "fissures",
   "substrate-bonding"
  ],
  "mat": [
   "granite",
   "marble",
   "limestone",
   "quartz",
   "porcelain",
   "solid surface",
   "concrete",
   "glass"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "uv_stable": false,
  "disc": false
 },
 "fila \u2013 contractor\u2019s choice sealer \u2014 1 gallon": {
  "type": "sealer",
  "subtype": "Water-based Penetrating Natural-Look Sealer",
  "vendor": "FILA",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "travertine",
   "limestone",
   "concrete"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "akemi darkener super - food-safe colour-intensifying sealers": {
  "type": "enhancer",
  "subtype": "Solvent-based Reactive-Siloxane Color Intensifier (food-safe)",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "travertine",
   "limestone"
  ],
  "problems": [
   "fading",
   "stain"
  ],
  "viscosity": "Liquid",
  "colors": [
   "darkening"
  ],
  "uv_stable": true,
  "disc": false
 },
 "bellinzoni idea hp antistain protective afent natural color": {
  "type": "sealer",
  "subtype": "Solvent-based Penetrating Anti-Stain Protective",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "marble",
   "granite",
   "quartzite",
   "travertine",
   "limestone",
   "concrete"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": true,
  "disc": false
 },
 "superior gold gv-5 knife grade": {
  "type": "adhesive",
  "subtype": "Styrene-free Acrylic/Vinyl Ester Hybrid Knife Grade",
  "vendor": "Superior Stone Products",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "laminating",
   "rodding",
   "repair",
   "substrate-bonding"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz",
   "solid surface"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "disc": false
 },
 "superior poly-epoxy knife grade adhesive": {
  "type": "adhesive",
  "subtype": "Polyester/Vinyl Ester Hybrid Knife Grade",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "rodding",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "quartz",
   "solid surface"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "uv_stable": false,
  "disc": false
 },
 "akemi colourbond pre-tinted epoxy 250 ml cartridge": {
  "type": "epoxy",
  "subtype": "Pre-tinted 2-Component Epoxy Acrylate Cartridge (10:1)",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "fissures",
   "substrate-bonding"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "52 pre-tinted stone colors"
  ],
  "uv_stable": null,
  "disc": false
 },
 "k-bond poly-epoxy knife grade adhesive": {
  "type": "adhesive",
  "subtype": "100% Vinyl Ester Knife Grade",
  "vendor": "K-Bond",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair",
   "substrate-bonding"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "quartz"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "uv_stable": false,
  "disc": false
 },
 "tenax ager fs water-based color enhancing sealer \u2014 1 quart": {
  "type": "enhancer",
  "subtype": "Water-based Penetrating Color Enhancer + Sealer (food-safe)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing",
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz"
  ],
  "problems": [
   "stain",
   "fading",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [
   "clear"
  ],
  "uv_stable": null,
  "disc": false
 },
 "tenax ager stone enhancing sealer": {
  "type": "enhancer",
  "subtype": "Solvent-based Color-Enhancing Impregnating Sealer",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing",
   "enhancing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "travertine",
   "limestone"
  ],
  "problems": [
   "stain",
   "fading",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [
   "clear"
  ],
  "uv_stable": true,
  "disc": false
 },
 "bellinzoni marmo care system kit for marble & stone surfaces": {
  "type": "cleaner",
  "subtype": "3-Part Care Kit (Cleaner + Protection + Shine)",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning",
   "sealing",
   "restoration"
  ],
  "mat": [
   "marble",
   "granite",
   "travertine",
   "limestone",
   "engineered"
  ],
  "problems": [
   "stain",
   "cleaning",
   "fading"
  ],
  "viscosity": null,
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "ncf stone aerosol accelerator for ca glue, 6oz, ncfs-6": {
  "type": "hardener",
  "subtype": "CA Glue Aerosol Accelerator (non-discoloring, light stone safe)",
  "vendor": "Satellite City",
  "env": [
   "interior"
  ],
  "app": [
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Spray",
  "colors": [
   "clear"
  ],
  "uv_stable": null,
  "disc": false
 },
 "tenax tepox q indoor/outdoor stone dye and color enhancement system": {
  "type": "enhancer",
  "subtype": "Color-Match Tint System for Resined Slabs (use with Ager)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing",
   "restoration"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [
   "black",
   "blue brilliante",
   "blue marine",
   "blue rio",
   "bordeaux",
   "brown",
   "coliseum",
   "esmeralda",
   "ferrato",
   "iron",
   "red",
   "yellow"
  ],
  "uv_stable": null,
  "disc": false
 },
 "tenax marble polishing powder 2 lb (1 kg)": {
  "type": "polish",
  "subtype": "Marble Polishing Powder (calcite stones)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "marble",
   "travertine",
   "limestone"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Powder",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "miracle tile & stone cleaner - quart size": {
  "type": "cleaner",
  "subtype": "pH-Neutral Tile & Stone Cleaner Concentrate",
  "vendor": "Miracle Sealants",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz",
   "porcelain",
   "concrete",
   "travertine",
   "limestone",
   "onyx"
  ],
  "problems": [
   "cleaning",
   "stain"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "akemi stain repellent nano-effect - food-safe sealers": {
  "type": "sealer",
  "subtype": "Solvent-based Nano-Effect Impregnating Stain Repellent (food-safe)",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz",
   "porcelain",
   "concrete",
   "travertine",
   "limestone",
   "sintered"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "akemi solid wax black stone finish wax - 1 quart": {
  "type": "wax",
  "subtype": "Solid Paste Wax (black)",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "restoration",
   "enhancing"
  ],
  "mat": [
   "marble",
   "granite",
   "travertine",
   "engineered"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Paste",
  "colors": [
   "black"
  ],
  "uv_stable": null,
  "disc": false
 },
 "seamlock pro i-zenith stone color adhesive cartridge \u2014 dripless sl9897": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "mitering",
   "laminating",
   "substrate-bonding"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "quartz",
   "sintered",
   "porcelain",
   "glass",
   "solid surface"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "zenith"
  ],
  "uv_stable": true,
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "series": "i-series"
 },
 "tenax transparent flowing polyester \u2014 professional grade": {
  "type": "adhesive",
  "subtype": "Polyester Flowing (self-leveling)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair",
   "fissures"
  ],
  "mat": [
   "marble",
   "granite",
   "travertine",
   "limestone",
   "onyx"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "uv_stable": false,
  "disc": false
 },
 "tenax proseal - impregnating stone sealer": {
  "type": "sealer",
  "subtype": "Solvent-based Impregnating Sealer",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz",
   "concrete",
   "travertine",
   "limestone",
   "onyx"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [
   "clear"
  ],
  "uv_stable": null,
  "disc": false
 },
 "tenax transparent knife grade h \u2014 professional grade": {
  "type": "adhesive",
  "subtype": "Polyester Knife Grade H (high viscosity)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair",
   "fissures",
   "rodding"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "travertine",
   "limestone",
   "onyx"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "uv_stable": false,
  "disc": false
 },
 "tenax vertigo s vinyl ester knife grade \u2013 1 gallon": {
  "type": "adhesive",
  "subtype": "Vinyl Ester Knife Grade (extra-clear, low-yellowing)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "quartz",
   "engineered",
   "porcelain",
   "sintered"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "disc": false
 },
 "k-bond transparent flowing polyester adhesive": {
  "type": "adhesive",
  "subtype": "Polyester Flowing (self-leveling)",
  "vendor": "K-Bond",
  "env": [
   "interior"
  ],
  "app": [
   "rodding",
   "repair",
   "fissures",
   "laminating"
  ],
  "mat": [
   "granite",
   "marble",
   "quartz",
   "quartzite"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "uv_stable": false,
  "disc": false
 },
 "akemi triple effect spray": {
  "type": "cleaner",
  "subtype": "3-in-1 Clean + Protect + Luster Spray",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning",
   "sealing",
   "enhancing"
  ],
  "mat": [
   "marble",
   "granite",
   "quartz",
   "engineered",
   "concrete"
  ],
  "problems": [
   "cleaning",
   "stain",
   "fading"
  ],
  "viscosity": "Spray",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "satellite city qa-6 ncf quick aerosol accelerator 6 oz": {
  "type": "hardener",
  "subtype": "CA Glue Aerosol Accelerator (NCF Quick)",
  "vendor": "Satellite City",
  "env": [
   "interior"
  ],
  "app": [
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "quartz",
   "engineered"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Spray",
  "colors": [
   "clear"
  ],
  "uv_stable": null,
  "disc": false
 },
 "tenax travertine filler \u2014 polyester mastic for stone repair": {
  "type": "filler",
  "subtype": "Semisolid Polyester Travertine Filler",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "repair",
   "fissures"
  ],
  "mat": [
   "travertine",
   "limestone",
   "marble"
  ],
  "problems": [
   "crack"
  ],
  "viscosity": "Paste",
  "colors": [
   "buff",
   "brown"
  ],
  "uv_stable": false,
  "disc": false
 },
 "fila silicone finishing kit 24 oz. - smooth finishing kit for fresh silicone & caulk": {
  "type": "sealant",
  "subtype": "Silicone Smoothing/Finishing Spray + Tool",
  "vendor": "FILA",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartz",
   "engineered",
   "porcelain",
   "glass",
   "solid surface"
  ],
  "problems": [],
  "viscosity": "Spray",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "tenax colored knife grade polyester \u2014 professional grade": {
  "type": "adhesive",
  "subtype": "Colored Polyester Knife Grade",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "repair",
   "fissures",
   "laminating",
   "seaming"
  ],
  "mat": [
   "marble",
   "granite",
   "engineered"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "black",
   "buff",
   "white"
  ],
  "uv_stable": false,
  "disc": false
 },
 "hot stuff instant glue (thin, medium, thick) \u2013 2 oz": {
  "type": "adhesive",
  "subtype": "Cyanoacrylate (thin/medium/thick)",
  "vendor": "Satellite City",
  "env": [
   "interior"
  ],
  "app": [
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "quartz",
   "engineered"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Thin/Medium/Thick",
  "colors": [
   "clear"
  ],
  "uv_stable": null,
  "disc": false
 },
 "tenax colored flowing polyester 1 quart \u2014 professional grade": {
  "type": "adhesive",
  "subtype": "Colored Flowing Polyester",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "rodding",
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "quartz",
   "engineered",
   "travertine",
   "limestone",
   "onyx"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Flowing",
  "colors": [
   "white",
   "buff"
  ],
  "uv_stable": false,
  "disc": false
 },
 "tenax lustro italiano etch remover 8oz for marble and limestone": {
  "type": "stain-remover",
  "subtype": "Etch & Watermark Remover Powder",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "restoration",
   "repair"
  ],
  "mat": [
   "marble",
   "travertine",
   "limestone",
   "onyx"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "Powder",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "tenax booster alk easy alkaline stone treatment \u2014 750 ml": {
  "type": "stain-remover",
  "subtype": "Alkaline Quartz Stain Remover (RTU)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning",
   "restoration"
  ],
  "mat": [
   "quartz",
   "engineered"
  ],
  "problems": [
   "stain",
   "cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "tenax solido xq quartz \u2014 professional grade": {
  "type": "adhesive",
  "subtype": "Color-Matched Knife-Grade Polyester (Solido XQ quartz line)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair",
   "fissures"
  ],
  "mat": [
   "quartz",
   "engineered",
   "granite",
   "marble"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "white",
   "optical white",
   "paper white"
  ],
  "uv_stable": false,
  "disc": false
 },
 "tenax teetch etch remover for marble and stone surface restoration": {
  "type": "stain-remover",
  "subtype": "Etch & Water-Mark Remover Compound",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "restoration",
   "repair"
  ],
  "mat": [
   "marble",
   "travertine",
   "limestone",
   "onyx"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "Paste",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "akemi epoxy colorant 30 ml tube - color tint for akepox products": {
  "type": "enhancer",
  "subtype": "Adhesive Coloring Paste (for AKEPOX)",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [],
  "mat": [],
  "problems": [],
  "viscosity": "Paste",
  "colors": [
   "red",
   "fawn brown",
   "white",
   "black",
   "ochre",
   "green",
   "blue",
   "red brown"
  ],
  "uv_stable": null,
  "disc": false
 },
 "akemi akenova tiger grip 50 adhesive 290 ml cartridge": {
  "type": "adhesive",
  "subtype": "1-Component Polyhybrid High-Tack Assembly Adhesive",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "substrate-bonding",
   "anchoring"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "quartz",
   "engineered"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Paste",
  "colors": [
   "white"
  ],
  "uv_stable": true,
  "disc": false
 },
 "alpha rust stain remover": {
  "type": "stain-remover",
  "subtype": "Rust-Removal Gel (RSR-2000)",
  "vendor": "Alpha Professional Tools",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "restoration",
   "cleaning"
  ],
  "mat": [
   "granite",
   "marble",
   "travertine",
   "limestone",
   "concrete"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "Gel",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "tenax ager pen stone scratch concealer & color enhancer": {
  "type": "enhancer",
  "subtype": "Color-Enhancing Scratch Concealer Pen",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing",
   "restoration",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartz",
   "quartzite"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [
   "clear"
  ],
  "uv_stable": true,
  "disc": false
 },
 "xtrabond 150 rtv silicone sealant for stone countertop installation": {
  "type": "sealant",
  "subtype": "Acetoxy RTV Silicone (ASTM C920)",
  "vendor": "Premier Building Solutions",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartz",
   "engineered",
   "glass",
   "porcelain"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "Paste",
  "colors": [
   "clear",
   "white",
   "translucent"
  ],
  "uv_stable": true,
  "disc": false
 },
 "stanley all purpose rtv silicone (s421 series)": {
  "type": "sealant",
  "subtype": "Acetoxy-Cure 100% RTV Silicone",
  "vendor": "Stanley",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartz",
   "glass",
   "porcelain"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "Paste",
  "colors": [
   "clear",
   "translucent",
   "white"
  ],
  "uv_stable": true,
  "disc": false
 },
 "k\u2011bond polyester hardener \u2014 4 oz tube": {
  "type": "hardener",
  "subtype": "BPO Cream Paste Hardener (polyester catalyst)",
  "vendor": "K-Bond",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "travertine",
   "limestone",
   "onyx"
  ],
  "problems": [],
  "viscosity": "Paste",
  "colors": [
   "white"
  ],
  "uv_stable": null,
  "disc": false
 },
 "kraken bond silicone all purpose all purpose rtv silicone 10.1 fl oz": {
  "type": "sealant",
  "subtype": "Acetoxy-Cure RTV Silicone",
  "vendor": "Kraken Bond",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "glass",
   "porcelain",
   "granite",
   "marble",
   "quartz"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "Paste",
  "colors": [
   "blue marine",
   "transparent"
  ],
  "uv_stable": true,
  "disc": false
 },
 "akfix 100e universal silicone sealant - white": {
  "type": "sealant",
  "subtype": "Acetoxy-Cure 100% Silicone (universal)",
  "vendor": "Akfix",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "glass",
   "porcelain"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "Paste",
  "colors": [
   "white"
  ],
  "uv_stable": true,
  "disc": false
 },
 "kraken bond kitchen & bathroom silicone (10.1 fl oz)": {
  "type": "sealant",
  "subtype": "Acetoxy-Cure Kitchen & Bath Silicone (mold-resistant)",
  "vendor": "Kraken Bond",
  "env": [
   "interior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "glass"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "Paste",
  "colors": [
   "white",
   "transparent"
  ],
  "uv_stable": true,
  "disc": false
 },
 "xtrabond 50 siliconized acrylic sealant for stone countertop joints": {
  "type": "sealant",
  "subtype": "Siliconized Acrylic Latex (paintable)",
  "vendor": "Premier Building Solutions",
  "env": [
   "interior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "solid surface"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "Paste",
  "colors": [
   "clear",
   "blue marine"
  ],
  "uv_stable": null,
  "disc": false
 },
 "kraken bond clear seal acrylic caulk - clear": {
  "type": "sealant",
  "subtype": "Plasto-Elastic Acrylic Caulk (dries clear, paintable)",
  "vendor": "Kraken Bond",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "concrete"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "Paste",
  "colors": [
   "clear"
  ],
  "uv_stable": null,
  "disc": false
 },
 "kraken bond premium siliconized caulk sealant - 300 ml 10.1 fl oz white": {
  "type": "sealant",
  "subtype": "Siliconized Acrylic Caulk (paintable)",
  "vendor": "Kraken Bond",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "concrete"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "Paste",
  "colors": [
   "white"
  ],
  "uv_stable": null,
  "disc": false
 },
 "kraken bond as 103 premium siliconized caulk sealant 10.1 fl oz white": {
  "type": "sealant",
  "subtype": "Siliconized Acrylic Caulk AS-103 (paintable)",
  "vendor": "Kraken Bond",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "concrete"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "Paste",
  "colors": [
   "white"
  ],
  "uv_stable": null,
  "disc": false
 },
 "akemi ceramic smart repair kit": {
  "type": "repair",
  "subtype": "Chip/Scratch Repair Kit (PLATINUM MAXI POWER + 46 color cards)",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "repair",
   "mitering"
  ],
  "mat": [
   "porcelain",
   "sintered"
  ],
  "problems": [
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "color-match system"
  ],
  "uv_stable": null,
  "disc": false
 },
 "tenax booster alk easy 200 liter \u2014 professional grade": {
  "type": "stain-remover",
  "subtype": "Alkaline Quartz Stain Remover (200 L drum)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning",
   "restoration"
  ],
  "mat": [
   "quartz",
   "engineered"
  ],
  "problems": [
   "stain",
   "cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "k-bond elite acrylic blend knife grade adhesive (5 gallon ship saver - 17 kg unit)": {
  "type": "adhesive",
  "subtype": "Acrylic/Epoxy Blend Knife Grade (ultra-transparent)",
  "vendor": "K-Bond",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair",
   "fissures",
   "rodding"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz",
   "travertine",
   "limestone",
   "onyx"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "disc": false
 },
 "k-bond poly-epoxy knife grade adhesive (5 gallon ship saver - 17 kg unit)": {
  "type": "adhesive",
  "subtype": "100% Vinyl Ester Knife Grade",
  "vendor": "K-Bond",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair",
   "fissures",
   "rodding"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz",
   "travertine",
   "limestone",
   "onyx"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "clear"
  ],
  "uv_stable": false,
  "disc": false
 },
 "k-bond vivid ultra low color acrylic knife grade stone adhesive": {
  "type": "adhesive",
  "subtype": "Vinyl Ester Knife Grade (ultra low color)",
  "vendor": "K-Bond",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "repair",
   "substrate-bonding"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "quartz",
   "engineered",
   "porcelain"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "uv_stable": null,
  "disc": false
 },
 "tenax universal stone chip repair kit \u2014 professional stone care": {
  "type": "repair",
  "subtype": "Universal Chip Repair Kit (6x50ml + tint pastes)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "limestone",
   "quartz",
   "engineered",
   "porcelain"
  ],
  "problems": [
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "white",
   "yellow",
   "red",
   "blue",
   "black"
  ],
  "uv_stable": null,
  "disc": false
 },
 "akemi darkener plus 5 liter - deep color impregnation for stone": {
  "type": "enhancer",
  "subtype": "Solvent-based Color-Intensifying Impregnator (5 L)",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing",
   "sealing"
  ],
  "mat": [
   "marble",
   "granite",
   "limestone",
   "concrete",
   "travertine"
  ],
  "problems": [
   "fading",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [
   "clear darkening"
  ],
  "uv_stable": true,
  "disc": false
 },
 "k-bond polyester white knife grade adhesive (5 gallon pail)": {
  "type": "adhesive",
  "subtype": "Polyester Knife Grade (white)",
  "vendor": "K-Bond",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "rodding",
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "travertine",
   "engineered"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "white"
  ],
  "uv_stable": false,
  "disc": false
 },
 "k-bond polyester transparent flowing adhesive (5 gallon ship saver unit)": {
  "type": "adhesive",
  "subtype": "Polyester Flowing (self-leveling)",
  "vendor": "K-Bond",
  "env": [
   "interior"
  ],
  "app": [
   "rodding",
   "laminating",
   "repair",
   "fissures",
   "substrate-bonding"
  ],
  "mat": [
   "granite",
   "marble",
   "travertine",
   "engineered"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "uv_stable": false,
  "disc": false
 },
 "akemi akepox 5010 waterclear knifegrade epoxy - premium clear adhesive": {
  "type": "epoxy",
  "subtype": "Water-Clear Knife-Grade 2-Component Epoxy (2:1)",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "repair",
   "fissures",
   "substrate-bonding"
  ],
  "mat": [
   "granite",
   "marble",
   "quartz",
   "engineered",
   "porcelain",
   "glass",
   "concrete"
  ],
  "problems": [
   "bond-failure",
   "crack",
   "epoxy-haze"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "disc": false
 },
 "superior e-1000 flowing epoxy unit": {
  "type": "epoxy",
  "subtype": "Transparent Flowing 2-Component Epoxy (1:1)",
  "vendor": "Superior Stone Products",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "laminating",
   "seaming",
   "rodding",
   "substrate-bonding"
  ],
  "mat": [
   "granite",
   "marble",
   "quartz",
   "engineered",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "disc": false
 },
 "tenax polishing powder 33 pound (15 kg) for natural stone": {
  "type": "polish",
  "subtype": "Granite Polishing Powder (15 kg)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "granite"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Powder",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "alpha akemi everclear 300": {
  "type": "adhesive",
  "subtype": "2-Component PUR Cartridge (2:1, color-coded)",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "mitering",
   "laminating",
   "substrate-bonding"
  ],
  "mat": [
   "sintered",
   "porcelain",
   "engineered",
   "quartz",
   "granite",
   "quartzite"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent",
   "black",
   "white",
   "cream",
   "beige",
   "grey",
   "khaki",
   "brown"
  ],
  "uv_stable": true,
  "disc": false
 },
 "tenax flowing white polish for natural stone \u2014 1 gallon": {
  "type": "adhesive",
  "subtype": "Colored Flowing Polyester (white)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair",
   "fissures",
   "rodding"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz",
   "travertine",
   "limestone"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Flowing",
  "colors": [
   "white"
  ],
  "uv_stable": false,
  "disc": false
 },
 "tenax flowing buff polish for granite marble stone \u2014 1 gallon": {
  "type": "adhesive",
  "subtype": "Colored Flowing Polyester (buff)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair",
   "fissures",
   "rodding"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz",
   "travertine",
   "limestone"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Flowing",
  "colors": [
   "buff"
  ],
  "uv_stable": false,
  "disc": false
 },
 "akemi everclear clear knife grade urethane adhesive (395 ml cartridge)": {
  "type": "adhesive",
  "subtype": "2-Component PUR Knife-Grade (dual cartridge)",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "repair",
   "fissures",
   "substrate-bonding"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz",
   "sintered",
   "porcelain",
   "glass",
   "limestone",
   "concrete"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "disc": false
 },
 "tilerepairkit \u2013 professional tile & surface repair wax kit with soldering iron": {
  "type": "repair",
  "subtype": "Hard-Wax Chip/Crack Repair Kit (11 shades + iron)",
  "vendor": "Mechanic (Distar)",
  "env": [
   "interior"
  ],
  "app": [
   "repair",
   "restoration",
   "fissures"
  ],
  "mat": [
   "porcelain",
   "sintered",
   "granite",
   "marble",
   "engineered",
   "quartz"
  ],
  "problems": [
   "crack"
  ],
  "viscosity": "Paste",
  "colors": [
   "11 blendable shades"
  ],
  "uv_stable": null,
  "disc": false
 },
 "akemi everclear 510 knife\u2011grade \u2014 quart": {
  "type": "adhesive",
  "subtype": "2-Component PUR Knife-Grade (1:1)",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "repair",
   "fissures",
   "substrate-bonding"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz",
   "sintered",
   "porcelain",
   "glass",
   "limestone",
   "concrete"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "disc": false
 },
 "superior gold evolution colored hardener assorted": {
  "type": "hardener",
  "subtype": "Colored Hardener Set (GOLD EVOLUTION EXT, 20 colors)",
  "vendor": "Superior Stone Products",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "rodding"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz",
   "sintered",
   "porcelain",
   "solid surface"
  ],
  "problems": [],
  "viscosity": "Paste",
  "colors": [
   "20 assorted colors"
  ],
  "uv_stable": null,
  "disc": false
 },
 "akemi akepox 2030 high strength knifegrade - fast set stone epoxy": {
  "type": "epoxy",
  "subtype": "2-Component Knife-Grade Construction Epoxy (2:1)",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "laminating",
   "anchoring",
   "repair",
   "substrate-bonding"
  ],
  "mat": [
   "granite",
   "marble",
   "limestone",
   "engineered",
   "quartz",
   "glass"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent",
   "grey-green",
   "brick-red",
   "light-ivory"
  ],
  "uv_stable": false,
  "disc": false
 },
 "glaxs bm 1:1 kit": {
  "type": "adhesive",
  "subtype": "Glaxs 2-Part Transparent 1:1 Kit (zero-yellowing, porcelain/UCS)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "repair",
   "substrate-bonding"
  ],
  "mat": [
   "porcelain",
   "sintered",
   "granite",
   "marble",
   "quartz",
   "engineered"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "disc": false
 },
 "stain-proof original premium impregnating sealer - quart": {
  "type": "sealer",
  "subtype": "Premium Deep-Penetrating Impregnating Sealer",
  "vendor": "Stain-Proof",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "travertine",
   "limestone",
   "concrete"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [
   "clear"
  ],
  "uv_stable": null,
  "disc": false
 },
 "tenax quarzo toner plus color enhancer sealer \u2013 1 l": {
  "type": "enhancer",
  "subtype": "Wet-Effect Color Enhancer Sealer (quartz)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing",
   "sealing"
  ],
  "mat": [
   "quartz",
   "engineered",
   "granite",
   "marble"
  ],
  "problems": [
   "fading",
   "stain"
  ],
  "viscosity": "Liquid",
  "colors": [
   "clear"
  ],
  "uv_stable": null,
  "disc": false
 },
 "superior gold evolution colored hardener 4oz/10 pack": {
  "type": "hardener",
  "subtype": "Colored Hardener (GOLD EVOLUTION EXT, 4oz x10)",
  "vendor": "Superior Stone Products",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "rodding",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "quartz",
   "engineered",
   "sintered",
   "porcelain",
   "solid surface"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Paste",
  "colors": [
   "20-color system"
  ],
  "uv_stable": true,
  "disc": false
 },
 "tenax knife grade white polyester adhesive \u2014 4 liter for granite and marble": {
  "type": "adhesive",
  "subtype": "White Knife-Grade Polyester Mastic (4 L)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair",
   "fissures",
   "substrate-bonding"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "white"
  ],
  "uv_stable": false,
  "disc": false
 },
 "k-bond k-150 setting epoxy - thick setting paste 3:1 (1 gallon)": {
  "type": "epoxy",
  "subtype": "3:1 Thick-Paste Setting/Installation Epoxy",
  "vendor": "K-Bond",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "anchoring",
   "substrate-bonding",
   "rodding"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "travertine",
   "limestone"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Paste",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "superior coloring paste assorted box 10/2oz": {
  "type": "enhancer",
  "subtype": "Adhesive Coloring Paste Kit (10x2oz)",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "travertine"
  ],
  "problems": [],
  "viscosity": "Paste",
  "colors": [
   "black",
   "white",
   "red",
   "red-brown",
   "green",
   "blue",
   "brown",
   "ochre",
   "buff",
   "gray"
  ],
  "uv_stable": null,
  "disc": false
 },
 "stain-proof plus dense stone impregnating sealer - 16 oz": {
  "type": "sealer",
  "subtype": "Dense-Stone Impregnating Sealer (Stain-Proof Plus)",
  "vendor": "Stain-Proof",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "travertine",
   "limestone",
   "concrete"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": true,
  "disc": false
 },
 "tenax semisolido wet buff semi-solid polish for granite marble \u2014 4 liter": {
  "type": "filler",
  "subtype": "Semi-Solid Polyester Mastic (wet-surface, ultra-fast)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "repair",
   "fissures",
   "substrate-bonding"
  ],
  "mat": [
   "travertine",
   "marble",
   "granite",
   "limestone"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Paste",
  "colors": [
   "buff"
  ],
  "uv_stable": false,
  "disc": false
 },
 "seamking pigment - sk004 primary colors pigment kit": {
  "type": "enhancer",
  "subtype": "SeamKing Pigment Kit (adhesive tint, 10 colors)",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz"
  ],
  "problems": [],
  "viscosity": "Liquid",
  "colors": [
   "white",
   "red",
   "black",
   "blue",
   "red-brown",
   "buff",
   "grey",
   "green",
   "ochre",
   "brown"
  ],
  "uv_stable": null,
  "disc": false
 },
 "k-bond quick set paste clear 1:1 epoxy stone adhesive": {
  "type": "epoxy",
  "subtype": "1:1 Quick-Set Knife-Grade Epoxy",
  "vendor": "K-Bond",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "repair",
   "substrate-bonding"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "travertine",
   "limestone"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "clear"
  ],
  "uv_stable": null,
  "disc": false
 },
 "k-bond true bond 2:1 flowing epoxy stone adhesive": {
  "type": "epoxy",
  "subtype": "2:1 High-Strength Structural Flowing Epoxy",
  "vendor": "K-Bond",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "laminating",
   "seaming",
   "substrate-bonding",
   "rodding"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "travertine",
   "limestone"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "disc": false
 },
 "k-bond quick set flowing clear 1:1 epoxy stone adhesive": {
  "type": "epoxy",
  "subtype": "1:1 Quick-Set Flowing Epoxy",
  "vendor": "K-Bond",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "laminating",
   "rodding",
   "repair",
   "fissures",
   "substrate-bonding"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "travertine",
   "limestone"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "clear"
  ],
  "uv_stable": null,
  "disc": false
 },
 "akemi small care set - stone cleaning and maintenance starter kit": {
  "type": "cleaner",
  "subtype": "Cleaning & Care Kit (Crystal Clean + Triple Effect + cloth)",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "limestone",
   "travertine",
   "concrete"
  ],
  "problems": [
   "cleaning"
  ],
  "viscosity": null,
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "satellite city hot stuff pro kit complete ca glue set with accelerator and debonder": {
  "type": "adhesive",
  "subtype": "Cyanoacrylate Kit HK-1 (3 viscosities + accelerator + debonder)",
  "vendor": "Satellite City",
  "env": [
   "interior"
  ],
  "app": [
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "travertine",
   "limestone",
   "onyx"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Thin/Medium/Thick",
  "colors": [
   "clear"
  ],
  "uv_stable": null,
  "disc": false
 },
 "akemi stain repellent super - food safe forever-chemical-free": {
  "type": "sealer",
  "subtype": "Fluorine-Free Penetrating Impregnator (PFAS-free, food-safe)",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "marble",
   "limestone",
   "travertine",
   "granite",
   "engineered",
   "porcelain"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": true,
  "disc": false
 },
 "fila fob xtreme - extreme water and oil repellent protection": {
  "type": "sealer",
  "subtype": "Solvent-based Penetrating Water/Oil Repellent (premium)",
  "vendor": "FILA",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "travertine",
   "limestone",
   "concrete",
   "engineered",
   "quartzite"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": true,
  "disc": false
 },
 "stoneplus penetrating stone enhancer - quart": {
  "type": "enhancer",
  "subtype": "Solvent-based Penetrating Color Enhancer + Stain Protection",
  "vendor": "FILA (StonePlus)",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing",
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "travertine",
   "limestone"
  ],
  "problems": [
   "stain",
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [
   "wet-look"
  ],
  "uv_stable": null,
  "disc": false
 },
 "tenax antislip g treatment 1 liter \u2014 professional grade": {
  "type": "cleaner",
  "subtype": "Anti-Slip Surface Treatment (chemical etch, irreversible)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "granite",
   "porcelain"
  ],
  "problems": [],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "akemi marble filler 1000 transparent l\u2011special waterclear \u2014 quart": {
  "type": "filler",
  "subtype": "2-Component Polyester Filler (waterclear, L-Special knife grade)",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "fissures",
   "laminating"
  ],
  "mat": [
   "marble",
   "granite",
   "travertine",
   "limestone",
   "onyx",
   "engineered"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "uv_stable": false,
  "disc": false
 },
 "tenax toner black stone dye 1 quart \u2014 professional grade": {
  "type": "enhancer",
  "subtype": "Black Stone Dye / Color Enhancer (Uniblack, black granite)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing",
   "restoration",
   "fissures"
  ],
  "mat": [
   "granite"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [
   "black"
  ],
  "uv_stable": null,
  "disc": false
 },
 "strongbond cartridge glue \u2014 strong epoxy adhesive for lapitec and engineered stone": {
  "type": "adhesive",
  "subtype": "Bi-Component Epoxy Mastic Cartridge (Lapitec/sintered, zero yellowing)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "laminating",
   "mitering"
  ],
  "mat": [
   "sintered",
   "engineered",
   "quartz"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Paste",
  "colors": [
   "bianco assoluto",
   "bianco polare",
   "bianco crema",
   "artico",
   "grigio cemento",
   "grigio piombo",
   "terra avana",
   "terra ebano",
   "nero antracite",
   "nero assoluto"
  ],
  "uv_stable": true,
  "disc": false
 },
 "superior coloring paste assorted box 10/1oz": {
  "type": "enhancer",
  "subtype": "Adhesive Coloring Paste Kit (10x1oz)",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz",
   "travertine",
   "limestone"
  ],
  "problems": [],
  "viscosity": "Paste",
  "colors": [
   "white",
   "black",
   "red",
   "green",
   "blue",
   "ochre",
   "brown",
   "buff",
   "gray",
   "red-brown"
  ],
  "uv_stable": null,
  "disc": false
 },
 "akemi lettering color 400 ml - monument paint including metallic options": {
  "type": "enhancer",
  "subtype": "Monument Lettering Paint (alkyd lacquer, metallic options)",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing",
   "restoration"
  ],
  "mat": [
   "granite",
   "marble",
   "limestone"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [
   "black",
   "white",
   "antique gold",
   "antique silver"
  ],
  "uv_stable": true,
  "disc": false
 },
 "revolution maximum stone sealer - premium solvent-based fluoropolymer impregnator": {
  "type": "sealer",
  "subtype": "Solvent-based Fluoropolymer Impregnator (premium)",
  "vendor": "Revolution (InnoChem)",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "travertine",
   "limestone",
   "onyx"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [
   "clear"
  ],
  "uv_stable": null,
  "disc": false
 },
 "tenax wax remover for natural stone surfaces \u2014 1 quart": {
  "type": "cleaner",
  "subtype": "Wax Remover (solvent)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning",
   "restoration"
  ],
  "mat": [
   "granite",
   "marble",
   "travertine",
   "limestone"
  ],
  "problems": [
   "cleaning",
   "stain"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "superior gold evolution colored hardener 1oz/10 pack": {
  "type": "hardener",
  "subtype": "Colored Hardener (GOLD EVOLUTION, 1oz x10)",
  "vendor": "Superior Stone Products",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "rodding",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "quartz",
   "porcelain",
   "sintered",
   "solid surface"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Paste",
  "colors": [
   "20-color system"
  ],
  "uv_stable": null,
  "disc": false
 },
 "superior acrylic quickset flowing adhesives \u2014 special order": {
  "type": "adhesive",
  "subtype": "Fast-Set Flowing Acrylic (water-clear)",
  "vendor": "Superior Stone Products",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "travertine",
   "limestone",
   "quartz",
   "engineered"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "disc": false
 },
 "revolution invincible stone sealer - maximum performance water-based impregnator": {
  "type": "sealer",
  "subtype": "Water-based Fluoropolymer Impregnator",
  "vendor": "Revolution (InnoChem)",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "travertine",
   "limestone",
   "onyx"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [
   "clear"
  ],
  "uv_stable": null,
  "disc": false
 },
 "akemi transformer max - premium sealer for all surfaces and quartzite": {
  "type": "sealer",
  "subtype": "Color-Enhancing Impregnating Sealer (quartzite-rated)",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing",
   "enhancing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz",
   "limestone",
   "travertine",
   "concrete"
  ],
  "problems": [
   "stain",
   "fading",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [
   "clear"
  ],
  "uv_stable": true,
  "disc": false
 },
 "tenax stain rescue remover (formerly quartz extraclean pro)": {
  "type": "stain-remover",
  "subtype": "Solvent Grease/Vacuum-Ring Remover (quartz)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning",
   "restoration"
  ],
  "mat": [
   "quartz",
   "engineered"
  ],
  "problems": [
   "stain",
   "cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "superior coloring paste assorted box 8/1oz": {
  "type": "enhancer",
  "subtype": "Adhesive Coloring Paste Kit (8x1oz)",
  "vendor": "Superior Stone Products",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz",
   "travertine",
   "limestone"
  ],
  "problems": [],
  "viscosity": "Paste",
  "colors": [
   "assorted 8-color box"
  ],
  "uv_stable": null,
  "disc": false
 },
 "superior acrylic super flowing adhesive \u2014 special order": {
  "type": "adhesive",
  "subtype": "Acrylic Super-Flowing (penetrating, hairline cracks)",
  "vendor": "Superior Stone Products",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "fissures",
   "repair",
   "laminating"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "travertine",
   "limestone",
   "onyx"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "disc": false
 },
 "superior fusion fv-5 adhesive": {
  "type": "adhesive",
  "subtype": "Vinyl Ester + Acrylic Blend Knife Grade (FV-5)",
  "vendor": "Superior Stone Products",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "mitering",
   "laminating",
   "rodding",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz",
   "sintered",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "disc": false
 },
 "superior fusion fv-9 thicker knife grade adhesives": {
  "type": "adhesive",
  "subtype": "Vinyl Ester + MMA Blend Thick Knife Grade (FV-9)",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "mitering",
   "laminating",
   "rodding",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz",
   "sintered",
   "solid surface",
   "onyx"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "uv_stable": null,
  "disc": false
 },
 "tenax glaxs fast cartridge adhesive 215 ml": {
  "type": "adhesive",
  "subtype": "Glaxs Fast 2:1 Cartridge (porcelain/UCS, zero yellowing)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "mitering",
   "laminating",
   "repair"
  ],
  "mat": [
   "porcelain",
   "sintered",
   "granite",
   "marble",
   "quartzite"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "transparent",
   "white"
  ],
  "uv_stable": true,
  "disc": false
 },
 "tenax titanium kg stone sealer & color enhancer \u2014 1 qt": {
  "type": "adhesive",
  "subtype": "Vinyl Ester Knife Grade (Titanium, extra clear)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "mitering",
   "laminating",
   "rodding",
   "repair"
  ],
  "mat": [
   "marble",
   "granite",
   "quartz",
   "engineered",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "disc": false
 },
 "tenax granite polishing powder 2 lb (1 kg)": {
  "type": "polish",
  "subtype": "Granite Polishing Powder (1 kg)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "granite"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Powder",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "k-bond elite acrylic blend flowing stone adhesive": {
  "type": "adhesive",
  "subtype": "Acrylic Blend Flowing (self-leveling)",
  "vendor": "K-Bond",
  "env": [
   "interior"
  ],
  "app": [
   "laminating",
   "rodding",
   "seaming",
   "fissures",
   "repair"
  ],
  "mat": [
   "granite",
   "quartz",
   "engineered",
   "marble",
   "quartzite"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "uv_stable": null,
  "disc": false
 },
 "tenax vertigo water clear flowing vinyl ester": {
  "type": "adhesive",
  "subtype": "Water-Clear Flowing Vinyl Ester",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "quartz",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "disc": false
 },
 "tenax cd mastidek 215 ml \u2014 professional grade": {
  "type": "adhesive",
  "subtype": "Mastidek 2:1 Cartridge (Cosentino-approved, Dekton)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "mitering",
   "laminating",
   "repair"
  ],
  "mat": [
   "sintered"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "grey",
   "white",
   "black",
   "galema",
   "dark grey",
   "kelya",
   "keranium",
   "kira",
   "laos",
   "light white",
   "onirika",
   "standard cream",
   "trilium",
   "embers",
   "fossil",
   "grigio",
   "keon",
   "micron",
   "nacre",
   "valterra"
  ],
  "uv_stable": true,
  "disc": false
 },
 "tenax shinex liquid silicone wax 1 liter": {
  "type": "wax",
  "subtype": "Liquid Silicone Wax (transparent opalescent)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "restoration",
   "enhancing"
  ],
  "mat": [
   "granite",
   "marble",
   "travertine",
   "quartz",
   "engineered"
  ],
  "problems": [
   "fading",
   "stain",
   "cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [
   "transparent"
  ],
  "uv_stable": null,
  "disc": false
 },
 "glaxs sulzer absolute black tenax": {
  "type": "adhesive",
  "subtype": "Glaxs Color-Match 2:1 Cartridge (porcelain/ceramic)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "mitering",
   "laminating",
   "repair",
   "substrate-bonding"
  ],
  "mat": [
   "porcelain",
   "sintered",
   "granite",
   "marble"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "absolute black",
   "asphalt",
   "basalt",
   "cane sugar",
   "casper",
   "cirrus",
   "city grey",
   "clean white",
   "dew",
   "eggshell",
   "foggy",
   "heather grey",
   "kilimanjaro",
   "kona white",
   "magnesium",
   "milk paint",
   "natural spring",
   "obsidian",
   "optical white",
   "paper white",
   "platinum",
   "polar white",
   "pure white",
   "quartzite",
   "shell",
   "starch",
   "starlight",
   "white sail",
   "black",
   "transparent",
   "coastline",
   "shade",
   "slate",
   "sonoran"
  ],
  "uv_stable": true,
  "disc": false
 },
 "superior gold evolution ev-5 knife grade adhesives": {
  "type": "adhesive",
  "subtype": "Modified Acrylic/Vinyl Ester Knife Grade (GOLD EVOLUTION EV-5)",
  "vendor": "Superior Stone Products",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "rodding",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartz",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "neutral (colored via 20-color hardener)"
  ],
  "uv_stable": true,
  "disc": false
 },
 "tenax vertigo t vinyl ester knife grade \u2014 professional grade": {
  "type": "adhesive",
  "subtype": "Vinyl Ester Knife Grade T (thick, extra-clear)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "repair"
  ],
  "mat": [
   "granite",
   "quartzite",
   "engineered",
   "quartz",
   "marble"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "disc": false
 },
 "tenax lustro italiano stone care kit \u2014 professional stone care": {
  "type": "cleaner",
  "subtype": "Stone Care Kit (cleaner + polish/sealer spray)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning",
   "sealing",
   "enhancing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartz",
   "solid surface"
  ],
  "problems": [
   "cleaning",
   "stain",
   "water-damage"
  ],
  "viscosity": null,
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "k-bond vivid ultra low color acrylic flowing stone adhesive": {
  "type": "adhesive",
  "subtype": "Vinyl Ester Flowing (VIVID ultra low color)",
  "vendor": "K-Bond",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "substrate-bonding",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz",
   "porcelain",
   "sintered"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "uv_stable": null,
  "disc": false
 },
 "k-bond prime lv vinyl ester adhesive for engineered stone": {
  "type": "adhesive",
  "subtype": "Low-Viscosity Vinyl Ester (PRIME LV, engineered stone)",
  "vendor": "K-Bond",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "repair"
  ],
  "mat": [
   "engineered",
   "quartz",
   "porcelain",
   "sintered",
   "granite",
   "marble"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "clear"
  ],
  "uv_stable": null,
  "disc": false
 },
 "seamlock pro pebble stone color adhesive cartridge \u2014 dripless sl9237": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro rhino stone color adhesive cartridge \u2014 dripless sl9238": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro sahara stone color adhesive cartridge \u2014 dripless sl9240": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro argento stone color adhesive cartridge \u2014 dripless sl9272": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro raven stone color adhesive cartridge \u2014 dripless sl9645": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro blanco stone color adhesive cartridge \u2014 dripless sl9646": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-wheat stone color adhesive cartridge \u2014 dripless sl9665": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro mountain stone color adhesive cartridge \u2014 dripless sl9687": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro birch stone color adhesive cartridge \u2014 dripless sl9689": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro bone pro stone color adhesive cartridge \u2014 dripless sl9705": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-cocoa stone color adhesive cartridge \u2014 dripless sl9716": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-lunar stone color adhesive cartridge \u2014 dripless sl9751": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-lead stone color adhesive cartridge \u2014 dripless sl9761": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-coffee stone color adhesive cartridge \u2014 dripless sl9762": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-wool stone color adhesive cartridge \u2014 dripless sl9763": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-sabbia stone color adhesive cartridge \u2014 dripless sl9772": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-sand stone color adhesive cartridge \u2014 dripless sl9331": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-pumice stone color adhesive cartridge \u2014 dripless sl9777": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-suede stone color adhesive cartridge \u2014 dripless sl9898": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-dove stone color adhesive cartridge \u2014 dripless sl9915": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-cedar stone color adhesive cartridge \u2014 dripless sl9916": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro hadley stone color adhesive cartridge \u2014 dripless sl9930": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-polar stone color adhesive cartridge \u2014 dripless sl9945": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-onyx stone color adhesive cartridge \u2014 dripless sl9953": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-raven stone color adhesive cartridge \u2014 dripless sl9955": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-balsa stone color adhesive cartridge \u2014 dripless sl9958": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-ash stone color adhesive cartridge \u2014 dripless sl9961": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro messina stone color adhesive cartridge \u2014 dripless sl9993": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro salo stone color adhesive cartridge \u2014 dripless sl9995": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro bright stone color adhesive cartridge \u2014 dripless sl9102": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro cotton stone color adhesive cartridge \u2014 dripless sl9104": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro marble stone color adhesive cartridge \u2014 dripless sl9106": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro satin stone color adhesive cartridge \u2014 dripless sl9110": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro glacier stone color adhesive cartridge \u2014 dripless sl9111": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro canvas stone color adhesive cartridge \u2014 dripless sl9112": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro blizzard stone color adhesive cartridge \u2014 dripless sl9113": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro opal stone color adhesive cartridge \u2014 dripless sl9114": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro ghost stone color adhesive cartridge \u2014 dripless sl9115": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro newport stone color adhesive cartridge \u2014 dripless sl9116": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro cloud stone color adhesive cartridge \u2014 dripless sl9118": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro cameo stone color adhesive cartridge \u2014 dripless sl9120": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro arctic stone color adhesive cartridge \u2014 dripless sl9121": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro inf8701 stone color adhesive cartridge \u2014 dripless sl9122": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro clear stone color adhesive cartridge \u2014 dripless sl9199": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro fog stone color adhesive cartridge \u2014 dripless sl9200": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro buff stone color adhesive cartridge \u2014 dripless sl9210": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro natural stone color adhesive cartridge \u2014 dripless sl9214": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro sand stone color adhesive cartridge \u2014 dripless sl9216": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro ice stone color adhesive cartridge \u2014 dripless sl9218": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro misty stone color adhesive cartridge \u2014 dripless sl9220": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro blonde stone color adhesive cartridge \u2014 dripless sl9225": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro butter stone color adhesive cartridge \u2014 dripless sl9226": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro beach stone color adhesive cartridge \u2014 dripless sl9230": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro manilla stone color adhesive cartridge \u2014 dripless sl9231": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro cream stone color adhesive cartridge \u2014 dripless sl9232": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro caramel stone color adhesive cartridge \u2014 dripless sl9234": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro khaki stone color adhesive cartridge \u2014 dripless sl9236": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro redfire stone color adhesive cartridge \u2014 dripless sl9279": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro sable stone color adhesive cartridge \u2014 dripless sl9531": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro devon stone color adhesive cartridge \u2014 dripless sl9654": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-black stone color adhesive cartridge \u2014 dripless sl9879": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro grey stone color adhesive cartridge \u2014 dripless sl9917": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro serene stone color adhesive cartridge \u2014 dripless sl9304": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro dune stone color adhesive cartridge \u2014 dripless sl9310": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro latte stone color adhesive cartridge \u2014 dripless sl9312": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro fawn stone color adhesive cartridge \u2014 dripless sl9316": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro mocha stone color adhesive cartridge \u2014 dripless sl9322": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro cocoa stone color adhesive cartridge \u2014 dripless sl9323": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro auburn stone color adhesive cartridge \u2014 dripless sl9330": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro roast stone color adhesive cartridge \u2014 dripless sl9332": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro copper stone color adhesive cartridge \u2014 dripless sl9418": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro rust stone color adhesive cartridge \u2014 dripless sl9424": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro hazel stone color adhesive cartridge \u2014 dripless sl9432": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro fuego stone color adhesive cartridge \u2014 dripless sl9450": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro red stone color adhesive cartridge \u2014 dripless sl9451": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro red lava stone color adhesive cartridge \u2014 dripless sl9452": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro elbert stone color adhesive cartridge \u2014 dripless sl9505": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro pearl stone color adhesive cartridge \u2014 dripless sl9510": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro ore stone color adhesive cartridge \u2014 dripless sl9515": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro prairie stone color adhesive cartridge \u2014 dripless sl9516": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro pewter stone color adhesive cartridge \u2014 dripless sl9518": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro olive stone color adhesive cartridge \u2014 dripless sl9520": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro lava stone color adhesive cartridge \u2014 dripless sl9521": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro clay stone color adhesive cartridge \u2014 dripless sl9526": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro espresso stone color adhesive cartridge \u2014 dripless sl9528": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro oyster stone color adhesive cartridge \u2014 dripless sl9529": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro coal stone color adhesive cartridge \u2014 dripless sl9530": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro midnight stone color adhesive cartridge \u2014 dripless sl9532": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro pitch stone color adhesive cartridge \u2014 dripless sl9534": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro placid stone color adhesive cartridge \u2014 dripless sl9541": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro green stone color adhesive cartridge \u2014 dripless sl9560": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro nova stone color adhesive cartridge \u2014 dripless sl9582": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro design stone color adhesive cartridge \u2014 dripless sl9601": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro frosty stone color adhesive cartridge \u2014 dripless sl9603": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro mesa stone color adhesive cartridge \u2014 dripless sl9604": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro pudding stone color adhesive cartridge \u2014 dripless sl9606": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro camel stone color adhesive cartridge \u2014 dripless sl9610": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro hot stone color adhesive cartridge \u2014 dripless sl9617": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro mandarin stone color adhesive cartridge \u2014 dripless sl9619": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro fire stone color adhesive cartridge \u2014 dripless sl9621": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro ash stone color adhesive cartridge \u2014 dripless sl9623": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro malt stone color adhesive cartridge \u2014 dripless sl9624": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro charcoal stone color adhesive cartridge \u2014 dripless sl9625": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro flax stone color adhesive cartridge \u2014 dripless sl9627": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro earth stone color adhesive cartridge \u2014 dripless sl9628": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro lime stone color adhesive cartridge \u2014 dripless sl9632": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro orange stone color adhesive cartridge \u2014 dripless sl9633": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro nutmeg stone color adhesive cartridge \u2014 dripless sl9635": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro oregano stone color adhesive cartridge \u2014 dripless sl9636": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro ecru stone color adhesive cartridge \u2014 dripless sl9637": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro nickel stone color adhesive cartridge \u2014 dripless sl9638": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro chai stone color adhesive cartridge \u2014 dripless sl9639": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro coffee stone color adhesive cartridge \u2014 dripless sl9643": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro chestnut stone color adhesive cartridge \u2014 dripless sl9644": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro moss stone color adhesive cartridge \u2014 dripless sl9647": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro meridian stone color adhesive cartridge \u2014 dripless sl9649": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro banana stone color adhesive cartridge \u2014 dripless sl9650": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro dover stone color adhesive cartridge \u2014 dripless sl9653": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro laguna stone color adhesive cartridge \u2014 dripless sl9658": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro cherry stone color adhesive cartridge \u2014 dripless sl9662": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro honeydew stone color adhesive cartridge \u2014 dripless sl9663": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro rossa stone color adhesive cartridge \u2014 dripless sl9667": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro delfino stone color adhesive cartridge \u2014 dripless sl9671": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro clam stone color adhesive cartridge \u2014 dripless sl9673": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro mojave stone color adhesive cartridge \u2014 dripless sl9674": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro danae stone color adhesive cartridge \u2014 dripless sl9675": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro leather stone color adhesive cartridge \u2014 dripless sl9678": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro marta stone color adhesive cartridge \u2014 dripless sl9680": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro flannel stone color adhesive cartridge \u2014 dripless sl9682": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro hemp stone color adhesive cartridge \u2014 dripless sl9692": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro crimson stone color adhesive cartridge \u2014 dripless sl9693": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro conche stone color adhesive cartridge \u2014 dripless sl9719": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro naranja stone color adhesive cartridge \u2014 dripless sl9729": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro bronze stone color adhesive cartridge \u2014 dripless sl9731": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro reading stone color adhesive cartridge \u2014 dripless sl9735": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro brownie stone color adhesive cartridge \u2014 dripless sl9736": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-trufa stone color adhesive cartridge \u2014 dripless sl9742": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-bisque stone color adhesive cartridge \u2014 dripless sl9748": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-marone stone color adhesive cartridge \u2014 dripless sl9766": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-cotton stone color adhesive cartridge \u2014 dripless sl9770": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-raton stone color adhesive cartridge \u2014 dripless sl9774": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-cinder stone color adhesive cartridge \u2014 dripless sl9781": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-ginger stone color adhesive cartridge \u2014 dripless sl9782": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-medea stone color adhesive cartridge \u2014 dripless sl9784": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-giallo stone color adhesive cartridge \u2014 dripless sl9792": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-nougat stone color adhesive cartridge \u2014 dripless sl9797": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-tan stone color adhesive cartridge \u2014 dripless sl9799": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-casper stone color adhesive cartridge \u2014 dripless sl9801": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-dawn stone color adhesive cartridge \u2014 dripless sl9802": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-taupe stone color adhesive cartridge \u2014 dripless sl9803": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-flint stone color adhesive cartridge \u2014 dripless sl9811": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-pewter stone color adhesive cartridge \u2014 dripless sl9814": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-bone stone color adhesive cartridge \u2014 dripless sl9816": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-slate stone color adhesive cartridge \u2014 dripless sl9819": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-sage stone color adhesive cartridge \u2014 dripless sl9821": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-magic stone color adhesive cartridge \u2014 dripless sl9826": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-khaki stone color adhesive cartridge \u2014 dripless sl9828": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-acorn stone color adhesive cartridge \u2014 dripless sl9829": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-toffee stone color adhesive cartridge \u2014 dripless sl9830": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-ash stone color adhesive cartridge \u2014 dripless sl9832": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-beach stone color adhesive cartridge \u2014 dripless sl9834": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-desert stone color adhesive cartridge \u2014 dripless sl9836": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-pearl stone color adhesive cartridge \u2014 dripless sl9845": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-rhin stone color adhesive cartridge \u2014 dripless sl9848": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro oat stone color adhesive cartridge \u2014 dripless sl9850": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-silver stone color adhesive cartridge \u2014 dripless sl9851": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-tusk stone color adhesive cartridge \u2014 dripless sl9855": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-coffee stone color adhesive cartridge \u2014 dripless sl9862": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-dusk stone color adhesive cartridge \u2014 dripless sl9865": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-mocha stone color adhesive cartridge \u2014 dripless sl9867": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-white stone color adhesive cartridge \u2014 dripless sl9872": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-amazon stone color adhesive cartridge \u2014 dripless sl9876": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-brie stone color adhesive cartridge \u2014 dripless sl9882": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-cloud stone color adhesive cartridge \u2014 dripless sl9883": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-onyx stone color adhesive cartridge \u2014 dripless sl9892": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-oyster stone color adhesive cartridge \u2014 dripless sl9893": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-sahara stone color adhesive cartridge \u2014 dripless sl9895": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro i-quarry stone color adhesive cartridge \u2014 dripless sl9900": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "i-series",
  "temp_range_f": "65-85"
 },
 "seamlock pro brume stone color adhesive cartridge \u2014 dripless sl9904": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro jungle stone color adhesive cartridge \u2014 dripless sl9905": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro mango stone color adhesive cartridge \u2014 dripless sl9906": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro putty stone color adhesive cartridge \u2014 dripless sl9908": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro blue stone color adhesive cartridge \u2014 dripless sl9909": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro azul stone color adhesive cartridge \u2014 dripless sl9911": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro carbon stone color adhesive cartridge \u2014 dripless sl9912": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro rain stone color adhesive cartridge \u2014 dripless sl9913": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro rouge stone color adhesive cartridge \u2014 dripless sl9920": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro gris stone color adhesive cartridge \u2014 dripless sl9925": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro pink stone color adhesive cartridge \u2014 dripless sl9931": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro fossil stone color adhesive cartridge \u2014 dripless sl9946": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro pea stone color adhesive cartridge \u2014 dripless sl9951": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro paprika stone color adhesive cartridge \u2014 dripless sl9967": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro coral stone color adhesive cartridge \u2014 dripless sl9977": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro nirvana stone color adhesive cartridge \u2014 dripless sl9978": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro moose stone color adhesive cartridge \u2014 dripless sl9979": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro bourbon stone color adhesive cartridge \u2014 dripless sl9985": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro bento stone color adhesive cartridge \u2014 dripless sl9986": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro marmi stone color adhesive cartridge \u2014 dripless sl9989": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "standard",
  "temp_range_f": "65-85"
 },
 "seamlock pro p-slate stone color adhesive cartridge \u2014 dripless sl9760": {
  "type": "adhesive",
  "subtype": "Methacrylate",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "mat": [
   "engineered",
   "marble",
   "glass",
   "granite",
   "sintered",
   "quartz",
   "solid surface",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "stone color"
  ],
  "warnings": [
   "Flammable.",
   "Skin irritant.",
   "Eye irritant.",
   "Exothermic reaction."
  ],
  "disc": false,
  "mix_ratio": "10:1",
  "work_time": "8-12",
  "cure_time": "20-25",
  "uv_stable": true,
  "series": "p-series",
  "temp_range_f": "65-85"
 },
 "revolution advanced stone sealer - water-based fluoropolymer impregnator": {
  "type": "sealer",
  "subtype": "Water-based Fluoropolymer Impregnator",
  "vendor": "Revolution (InnoChem)",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "travertine",
   "limestone",
   "onyx"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "revolution regal stone sealer - solvent-based fluoropolymer impregnator": {
  "type": "sealer",
  "subtype": "Solvent-based Fluoropolymer Impregnator",
  "vendor": "Revolution (InnoChem)",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "travertine",
   "limestone"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "akemi pro scrub concentrated cleaner (500 ml bottle)": {
  "type": "cleaner",
  "subtype": "Mildly Alkaline Abrasive Cream Cleaner",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "granite",
   "marble",
   "limestone",
   "engineered",
   "quartz"
  ],
  "problems": [
   "cleaning",
   "stain"
  ],
  "viscosity": "Paste",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "tenax strongedge express epoxy parts for stone and porcelain bonding": {
  "type": "epoxy",
  "subtype": "StrongEdge Express Flowing Epoxy (A/B parts)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "substrate-bonding",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz",
   "porcelain",
   "sintered"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "uv_stable": null,
  "disc": false
 },
 "akemi lettering color 100 ml - monument and memorial stone paint": {
  "type": "enhancer",
  "subtype": "Monument Lettering Lacquer (100 ml)",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "restoration",
   "enhancing"
  ],
  "mat": [
   "granite",
   "marble",
   "limestone"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [
   "black",
   "white",
   "brown",
   "light grey",
   "dark grey",
   "rust brown"
  ],
  "uv_stable": true,
  "disc": false
 },
 "tenax multibond acrylic cartridge adhesive 250 ml \u2014 styrene-free color match for stone": {
  "type": "adhesive",
  "subtype": "Multibond 10:1 Methacrylate Color-Match Cartridge (73 shades)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "substrate-bonding"
  ],
  "mat": [
   "porcelain",
   "sintered",
   "glass",
   "engineered",
   "quartz",
   "marble",
   "granite"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "73 color-match shades"
  ],
  "uv_stable": true,
  "disc": false
 },
 "gravity vinyl ester knife grade": {
  "type": "adhesive",
  "subtype": "Gravity Vinyl Ester Knife Grade (extra-clear, fast)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "substrate-bonding",
   "fissures"
  ],
  "mat": [
   "marble",
   "granite",
   "quartz",
   "engineered",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "disc": false
 },
 "fila wet eco quart wet look sealer for stone and tile surfaces": {
  "type": "enhancer",
  "subtype": "Water-based Wet-Look Color-Enhancing Sealer (unpolished stone)",
  "vendor": "FILA",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing",
   "enhancing"
  ],
  "mat": [
   "granite",
   "marble",
   "travertine",
   "limestone"
  ],
  "problems": [
   "stain",
   "water-damage",
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": true,
  "disc": false
 },
 "stain-proof eff-erayza rust remover - safe acid stone and masonry cleaner - quart": {
  "type": "stain-remover",
  "subtype": "Safe-Acid Cleaner (rust/efflorescence/limescale) \u2014 ETCHES calcite stones",
  "vendor": "Stain-Proof",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning",
   "restoration"
  ],
  "mat": [
   "granite",
   "porcelain"
  ],
  "problems": [
   "stain",
   "cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "superior coloring paste individual colors": {
  "type": "enhancer",
  "subtype": "Polyester Coloring Paste (individual colors, adhesive tint)",
  "vendor": "Superior Stone Products",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz",
   "travertine",
   "limestone",
   "onyx"
  ],
  "problems": [],
  "viscosity": "Paste",
  "colors": [
   "black",
   "white",
   "red",
   "green",
   "blue",
   "ochre",
   "brown",
   "buff",
   "gray",
   "red-brown"
  ],
  "uv_stable": false,
  "disc": false
 },
 "big dog adhesives b0bvgfp4wz polyester adhesive cartridge": {
  "type": "adhesive",
  "subtype": "Polyester Flowing Cartridge",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "uv_stable": false,
  "disc": false
 },
 "big dog 1053-20 transparent flowing polyester adhesive cartridge": {
  "type": "adhesive",
  "subtype": "Polyester Flowing Cartridge (1053-20)",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "uv_stable": false,
  "disc": false
 },
 "k-bond polyester white flowing stone adhesive": {
  "type": "adhesive",
  "subtype": "Polyester Flowing (white)",
  "vendor": "K-Bond",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair",
   "substrate-bonding"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Flowing",
  "colors": [
   "white"
  ],
  "uv_stable": false,
  "disc": false
 },
 "big dog adhesives seamking hardener 4oz for stone seam adhesive": {
  "type": "hardener",
  "subtype": "SeamKing Hardener (4oz catalyst)",
  "vendor": "Big Dog Adhesives",
  "env": [
   "interior"
  ],
  "app": [
   "seaming"
  ],
  "mat": [
   "granite",
   "marble",
   "quartz",
   "engineered",
   "sintered",
   "porcelain",
   "solid surface"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Paste",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "tenax booster acid extra strong 1 quart \u2014 professional grade": {
  "type": "cleaner",
  "subtype": "Extra-Strong Acid Descaler (quartz)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning",
   "restoration"
  ],
  "mat": [
   "quartz",
   "engineered"
  ],
  "problems": [
   "stain",
   "cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "tenax quartz ax cleaner for engineered stone surfaces \u2014 1 liter": {
  "type": "cleaner",
  "subtype": "Water-based Descaling Cleaner (quartz)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "cleaning"
  ],
  "mat": [
   "quartz",
   "engineered"
  ],
  "problems": [
   "cleaning",
   "stain"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "stain-proof oxy-klenza triple action stain remover - 2.2 lb": {
  "type": "stain-remover",
  "subtype": "Oxy/Alkaline Triple-Action Powder Cleaner",
  "vendor": "Stain-Proof",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning",
   "restoration"
  ],
  "mat": [
   "granite",
   "marble",
   "travertine",
   "limestone",
   "concrete",
   "porcelain",
   "quartzite"
  ],
  "problems": [
   "stain",
   "cleaning"
  ],
  "viscosity": "Powder",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "tenax antislip m treatment 1 liter \u2014 professional grade": {
  "type": "cleaner",
  "subtype": "Anti-Slip Surface Treatment M (marble/limestone, irreversible)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "marble",
   "limestone"
  ],
  "problems": [],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "tenax epoxart kit 3 to 1 part b \u2014 professional stone care": {
  "type": "epoxy",
  "subtype": "Epoxart 3:1 Part B (slow-cure resining epoxy hardener)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "repair",
   "fissures",
   "laminating",
   "substrate-bonding"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "travertine",
   "onyx"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "uv_stable": null,
  "disc": false
 },
 "tenax concrete prowax 1 liter \u2014 protective polymer coating for cement surfaces": {
  "type": "wax",
  "subtype": "Polymer Protective Coating (cement surfaces)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "concrete"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "k-bond polyester buff knife grade stone adhesive - matte finish": {
  "type": "adhesive",
  "subtype": "Polyester Knife Grade (buff, matte)",
  "vendor": "K-Bond",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "mitering",
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "travertine",
   "limestone",
   "onyx"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "buff"
  ],
  "uv_stable": false,
  "disc": false
 },
 "k-bond polyester buff knife grade stone adhesive - gloss finish": {
  "type": "adhesive",
  "subtype": "Polyester Knife Grade (buff, gloss)",
  "vendor": "K-Bond",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "mitering",
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "travertine",
   "limestone",
   "onyx"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "buff"
  ],
  "uv_stable": false,
  "disc": false
 },
 "k-bond polyester buff flowing stone adhesive": {
  "type": "adhesive",
  "subtype": "Polyester Flowing (buff)",
  "vendor": "K-Bond",
  "env": [
   "interior"
  ],
  "app": [
   "laminating",
   "rodding",
   "seaming",
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "travertine",
   "limestone",
   "onyx"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "buff"
  ],
  "uv_stable": false,
  "disc": false
 },
 "k-bond revolution polyester transparent knife grade stone adhesive": {
  "type": "adhesive",
  "subtype": "Revolution Polyester Knife Grade (value line)",
  "vendor": "K-Bond",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "mitering",
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "travertine",
   "limestone",
   "onyx"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "uv_stable": false,
  "disc": false
 },
 "k-bond revolution polyester transparent flowing stone adhesive": {
  "type": "adhesive",
  "subtype": "Revolution Polyester Flowing (value line)",
  "vendor": "K-Bond",
  "env": [
   "interior"
  ],
  "app": [
   "laminating",
   "rodding",
   "seaming",
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "travertine",
   "limestone",
   "onyx"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "uv_stable": false,
  "disc": false
 },
 "akemi marble silicone 310 ml transparent - stone-safe silicone sealant": {
  "type": "sealant",
  "subtype": "Neutral-Cure Stone-Safe Silicone (non-staining)",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "marble",
   "granite",
   "quartzite",
   "travertine",
   "limestone",
   "concrete",
   "glass",
   "engineered"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "Paste",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "disc": false
 },
 "fila nospot oil stain remover for natural stone and tile": {
  "type": "stain-remover",
  "subtype": "Aerosol Oil/Grease Stain Remover (spray-on, brush-off)",
  "vendor": "FILA",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning",
   "restoration"
  ],
  "mat": [
   "granite",
   "marble",
   "travertine",
   "limestone",
   "concrete"
  ],
  "problems": [
   "stain",
   "cleaning"
  ],
  "viscosity": "Spray",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "akfix 710 stone & marble chip repair kit": {
  "type": "repair",
  "subtype": "CA Adhesive + Activator Chip Repair Kit",
  "vendor": "Akfix",
  "env": [
   "interior"
  ],
  "app": [
   "repair",
   "substrate-bonding",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "travertine",
   "limestone",
   "onyx",
   "quartzite"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "Gel",
  "colors": [
   "clear"
  ],
  "uv_stable": null,
  "disc": false
 },
 "tenax booster concentrated stone performance enhancer \u2014 1 liter": {
  "type": "cleaner",
  "subtype": "Concentrated Deep Cleaner (dilutable; removes epoxy residue)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning",
   "restoration"
  ],
  "mat": [
   "porcelain",
   "granite",
   "marble",
   "concrete"
  ],
  "problems": [
   "stain",
   "cleaning",
   "epoxy-haze"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "tenax tefill chip repair components \u2014 professional grade": {
  "type": "repair",
  "subtype": "TeFill CA Chip-Repair Components (thin/thick/activator)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz",
   "travertine",
   "limestone"
  ],
  "problems": [
   "crack"
  ],
  "viscosity": "Thin/Thick",
  "colors": [
   "clear"
  ],
  "uv_stable": null,
  "disc": false
 },
 "fila sr95 - stain removal for natural stone and porcelain": {
  "type": "stain-remover",
  "subtype": "Penetrating Colored-Organic-Stain Remover",
  "vendor": "FILA",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "cleaning",
   "restoration"
  ],
  "mat": [
   "marble",
   "travertine",
   "limestone",
   "porcelain",
   "engineered"
  ],
  "problems": [
   "stain",
   "cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "akemi polyester colorant 8 per box - tint for polyester adhesives": {
  "type": "enhancer",
  "subtype": "Adhesive Coloring Paste (polyester/epoxyacrylate/PUR)",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz"
  ],
  "problems": [],
  "viscosity": "Paste",
  "colors": [
   "red",
   "red-brown",
   "white",
   "black",
   "ochre",
   "green",
   "brown",
   "blue"
  ],
  "uv_stable": true,
  "disc": false
 },
 "superior gold evolution installation kit": {
  "type": "adhesive",
  "subtype": "GOLD EVOLUTION 10:1 Cartridge Installation Kit",
  "vendor": "Superior Stone Products",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "mitering",
   "laminating",
   "rodding",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "quartz",
   "sintered",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "12 pre-matched colors"
  ],
  "uv_stable": true,
  "disc": false
 },
 "tenax rtv silicone sealant clear 305 ml for stone installation": {
  "type": "sealant",
  "subtype": "100% RTV Silicone (mildew-resistant)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "marble",
   "granite",
   "glass",
   "porcelain",
   "concrete"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "Paste",
  "colors": [
   "clear"
  ],
  "uv_stable": true,
  "disc": false
 },
 "tenax polyester hardener for stone adhesives \u2014 180 ml": {
  "type": "hardener",
  "subtype": "BPO Paste Catalyst 180 ml (Tenax polyester)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "travertine",
   "quartzite"
  ],
  "problems": [],
  "viscosity": "Paste",
  "colors": [
   "white"
  ],
  "uv_stable": null,
  "disc": false
 },
 "sxad2033-a770 ultimate grab high tack pro-white 9.8 fl.oz": {
  "type": "adhesive",
  "subtype": "Hybrid Polymer High-Tack Grab Adhesive (Stanley A770)",
  "vendor": "Stanley",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "substrate-bonding",
   "anchoring"
  ],
  "mat": [
   "granite",
   "marble",
   "concrete",
   "glass",
   "porcelain"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Paste",
  "colors": [
   "white"
  ],
  "uv_stable": true,
  "disc": false
 },
 "sil-flex rtv-7500 industrial/construction grade silicone sealant - trans white": {
  "type": "sealant",
  "subtype": "Neutral-Cure Low-Modulus Silicone (non-bleeding)",
  "vendor": "Silco",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "quartzite",
   "marble",
   "porcelain",
   "granite",
   "concrete",
   "glass"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "Paste",
  "colors": [
   "trans white"
  ],
  "uv_stable": true,
  "disc": false
 },
 "tenax rtv silicone sealant 305 ml \u2014 professional grade": {
  "type": "sealant",
  "subtype": "100% RTV Silicone (mildew-resistant, multi-color)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "marble",
   "granite",
   "glass",
   "porcelain",
   "concrete"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "Paste",
  "colors": [
   "white",
   "transparent"
  ],
  "uv_stable": true,
  "disc": false
 },
 "kraken bond neutral cure silicone (10.1 fl oz)": {
  "type": "sealant",
  "subtype": "Neutral-Cure Building Silicone (odorless, non-corrosive)",
  "vendor": "Kraken Bond",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "glass",
   "concrete"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "Paste",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "disc": false
 },
 "mildew resistant silicon - trans white rtv3500": {
  "type": "sealant",
  "subtype": "Acetoxy RTV Silicone 3500 (mildew-resistant)",
  "vendor": "Silco",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "marble",
   "granite",
   "glass"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "Paste",
  "colors": [
   "trans white"
  ],
  "uv_stable": true,
  "disc": false
 },
 "silco gen-sil rtv 45 industrial silicone sealant \ufffd uv stable": {
  "type": "sealant",
  "subtype": "Acetoxy RTV Silicone Gen-Sil 45 (industrial)",
  "vendor": "Silco",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartz",
   "engineered",
   "glass"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "Paste",
  "colors": [
   "clear",
   "white"
  ],
  "uv_stable": true,
  "disc": false
 },
 "superior extra white paste bpo hardener for stone adhesive systems": {
  "type": "hardener",
  "subtype": "BPO Extra-White Paste Catalyst",
  "vendor": "Superior Stone Products",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartz",
   "sintered",
   "porcelain"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Paste",
  "colors": [
   "extra white"
  ],
  "uv_stable": null,
  "disc": false
 },
 "tenax hardener for polyester adhesives for stone fabrication": {
  "type": "hardener",
  "subtype": "Catalyst Family (Tenax polyester mastics)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "travertine",
   "limestone",
   "onyx"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Paste",
  "colors": [
   "extra white",
   "natural"
  ],
  "uv_stable": null,
  "disc": false
 },
 "stanley painter\u2019s choice latex caulk pro (s501)": {
  "type": "sealant",
  "subtype": "Siliconized Acrylic Latex Caulk (paintable)",
  "vendor": "Stanley",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "concrete"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "Paste",
  "colors": [
   "white"
  ],
  "uv_stable": null,
  "disc": false
 },
 "tenax hardener 33 ml (1.1 oz) for professional stone adhesive system": {
  "type": "hardener",
  "subtype": "BPO Catalyst 33 ml (Tenax polyester)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "travertine",
   "limestone",
   "onyx"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Paste",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "k-bond bpo hardener tube (1 oz)": {
  "type": "hardener",
  "subtype": "BPO Cream Hardener 1 oz",
  "vendor": "K-Bond",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartz",
   "engineered"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Paste",
  "colors": [],
  "uv_stable": null,
  "disc": false
 },
 "alpha akemi akenova rocket, elastic & clear": {
  "type": "adhesive",
  "subtype": "Polyhybrid MS-Polymer Elastic Adhesive (Akenova line)",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "substrate-bonding",
   "anchoring",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "porcelain",
   "sintered",
   "concrete"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Paste",
  "colors": [
   "grey",
   "white",
   "clear"
  ],
  "uv_stable": true,
  "disc": false
 },
 "pid:8488447213638": {
  "type": "adhesive",
  "subtype": "Polyester, UV-stabilized waterclear (flowing)",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "mix_ratio": "1-2 g Hardener B Liquid per 100 g filler (1-2%; 25-50 drops)",
  "work_time": "approx. 12-24 min at 68\u00b0F (20-24 min at 1%, 12-16 min at 2% hardener)",
  "cure_time": "loadable after 6-8 h; machinable after approx. 12 h at 68\u00b0F",
  "disc": false
 },
 "pid:8488447082566": {
  "type": "adhesive",
  "subtype": "Polyester, knife-grade gel (styrene-reduced)",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "uv_stable": false,
  "mix_ratio": "1-4 g white hardener paste per 100 g (1-4%)",
  "work_time": "approx. 3-10 min at 68\u00b0F (8-10 min at 1%, 3-4 min at 4% hardener)",
  "cure_time": "machinable after approx. 20-60 min at 68\u00b0F",
  "disc": false
 },
 "pid:8488446918726": {
  "type": "adhesive",
  "subtype": "Polyester, flowing (styrene-reduced)",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "uv_stable": false,
  "mix_ratio": "1-4 g white hardener paste per 100 g (1-4%)",
  "work_time": "approx. 4-14 min at 68\u00b0F (12-14 min at 1%, 4-5 min at 4% hardener)",
  "cure_time": "machinable after approx. 20-60 min at 68\u00b0F",
  "disc": false
 },
 "pid:8488446787654": {
  "type": "adhesive",
  "subtype": "Polyester, flowing (styrene-reduced)",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "uv_stable": false,
  "mix_ratio": "1-4 g white hardener paste per 100 g (1-4%)",
  "work_time": "approx. 4-14 min at 68\u00b0F (12-14 min at 1%, 4-5 min at 4% hardener)",
  "cure_time": "machinable after approx. 20-60 min at 68\u00b0F",
  "disc": false
 },
 "pid:8488445739078": {
  "type": "hardener",
  "subtype": "Benzoyl-peroxide (BPO) hardener paste for polyester fillers",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Paste",
  "colors": [
   "white"
  ],
  "uv_stable": null,
  "mix_ratio": "1-4 g per 100 g of polyester filler (1-4%)",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8488445083718": {
  "type": "epoxy",
  "subtype": "Filled knife-grade 2-component epoxy (cycloaliphatic polyamine), 2:1",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "substrate-bonding",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "porcelain",
   "concrete"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "light beige"
  ],
  "uv_stable": true,
  "mix_ratio": "2:1 (A:B) by weight or volume",
  "work_time": "approx. 40-50 min at 68\u00b0F",
  "cure_time": "move after 6-8 h; machinable after 12-16 h; full strength after 7 days at 68\u00b0F",
  "disc": false
 },
 "pid:8488444985414": {
  "type": "epoxy",
  "subtype": "Gel-like 2-component epoxy in 2:1 cartridge (cycloaliphatic polyamine)",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "mitering"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain",
   "concrete"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Gel",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "mix_ratio": "2:1 (A:B), pre-metered cartridge with static mixing nozzle",
  "work_time": "approx. 20-30 min at 68\u00b0F",
  "cure_time": "move after 6-8 h; machinable after 12-16 h; full strength after 7 days at 68\u00b0F",
  "disc": false
 },
 "pid:8488444854342": {
  "type": "epoxy",
  "subtype": "Low-viscosity 2-component epoxy (cycloaliphatic polyamine), 2:1",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "laminating",
   "fissures",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "porcelain",
   "concrete"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "mix_ratio": "2:1 (A:B) by weight or volume",
  "work_time": "approx. 20-30 min at 68\u00b0F",
  "cure_time": "move after 6-8 h; machinable after 12-16 h; full strength after 7 days at 68\u00b0F",
  "disc": false
 },
 "pid:8488444624966": {
  "type": "epoxy",
  "subtype": "Fast-curing gel-like 2-component epoxy, 1:1 cartridge",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "substrate-bonding"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "porcelain",
   "concrete"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Gel",
  "colors": [
   "black"
  ],
  "uv_stable": false,
  "mix_ratio": "1:1, pre-metered cartridge with static mixing nozzle",
  "work_time": "approx. 3-5 min at 68\u00b0F",
  "cure_time": "initial strength after 30-60 min; loadable after 3-5 h; full strength after 24 h at 68\u00b0F",
  "disc": false
 },
 "pid:8488337965126": {
  "type": "adhesive",
  "subtype": "Polyester, mineral-filled flowing/creamy filler",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "fissures",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "black"
  ],
  "uv_stable": false,
  "mix_ratio": "1-4 g white hardener paste per 100 g (1-4%)",
  "work_time": "approx. 3-10 min at 68\u00b0F (8-10 min at 1%, 3-4 min at 4% hardener)",
  "cure_time": "machinable after 15-35 min at 68\u00b0F",
  "disc": false
 },
 "pid:8488337670214": {
  "type": "filler",
  "subtype": "Very low-viscosity 2-component epoxy penetrating/strengthening resin, 4:1",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "fissures",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "problems": [
   "crack"
  ],
  "viscosity": "Liquid",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "mix_ratio": "4:1 (A:B) by weight; 7:2 by volume",
  "work_time": "approx. 20-25 min at 68\u00b0F",
  "cure_time": "grind/polish after approx. 24 h at 68\u00b0F (approx. 3 h on slabs pre-warmed to 140\u00b0F)",
  "disc": false
 },
 "pid:8468693549126": {
  "type": "adhesive",
  "subtype": "Polyester, thixotropic knife-grade filler (mineral-filled)",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "white",
   "black",
   "buff"
  ],
  "uv_stable": false,
  "mix_ratio": "1-4 g white hardener paste per 100 g (1-4%)",
  "work_time": "approx. 3-10 min at 68\u00b0F (8-10 min at 1%, 3-4 min at 4% hardener)",
  "cure_time": "machinable after 10-20 min at 68\u00b0F",
  "disc": false
 },
 "pid:8434403737670": {
  "type": "epoxy",
  "subtype": "Gel-like 2-component epoxy (cycloaliphatic polyamine), 2:1, waterclear",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "mitering",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain",
   "concrete"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Gel",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "mix_ratio": "2:1 (A:B) by weight or volume; cartridges pre-metered",
  "work_time": "approx. 20-30 min at 68\u00b0F",
  "cure_time": "move after 6-8 h; machinable after 12-16 h; full strength after 7 days at 68\u00b0F",
  "disc": false
 },
 "pid:8488446492742": {
  "type": "sealer",
  "subtype": "Solvent-based acrylic topical sealer (satin gloss)",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "sealing",
   "enhancing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "problems": [
   "water-damage",
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "Ready to use (undiluted)",
  "work_time": "",
  "cure_time": "Dries in 10-60 min (temperature dependent)",
  "disc": false
 },
 "pid:8488446361670": {
  "type": "polish",
  "subtype": "Reactive-silicone care polish (solvent-based, wax-free)",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "concrete"
  ],
  "problems": [
   "fading",
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "Ready to use - shake before use",
  "work_time": "",
  "cure_time": "Dry, then buff; ventilate approx. 2-3 days before food-area use",
  "disc": false
 },
 "pid:8488445640774": {
  "type": "sealer",
  "subtype": "Solvent-based silane/siloxane penetrating impregnator for calcareous stone",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "marble",
   "concrete"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": true,
  "mix_ratio": "Ready to use; on low-absorbency stone dilute 1:1 with Akemi Nitro-Thinner",
  "work_time": "Wipe off excess approx. 20 min after application",
  "cure_time": "Water repellency after 4-6 hrs; full effect after approx. 1 week",
  "disc": false
 },
 "pid:8488445542470": {
  "type": "enhancer",
  "subtype": "Solvent-based color-intensifying impregnator (reactive modified silicates), matte wet look",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing",
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "problems": [
   "fading",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "Ready to use (undiluted)",
  "work_time": "Re-spread or wipe off excess 10-15 min after application",
  "cure_time": "Protection begins approx. 24 hrs at 68 F; ventilate 2-3 days before food-area use",
  "disc": false
 },
 "pid:8488338096198": {
  "type": "sealer",
  "subtype": "Solvent-based high-gloss lacquer (synthetic resins and waxes)",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "sealing",
   "enhancing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "Ready to use (undiluted)",
  "work_time": "",
  "cure_time": "Dries in 10-60 min (temperature dependent)",
  "disc": false
 },
 "pid:8434403835974": {
  "type": "wax",
  "subtype": "Solvent-based wax and synthetic-resin polishing fluid",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "enhancing",
   "restoration"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "Use as supplied (apply thin)",
  "work_time": "",
  "cure_time": "Fast-drying; buff when the surface turns dull",
  "disc": false
 },
 "pid:8434403868742": {
  "type": "wax",
  "subtype": "Solvent-based solid paste wax",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing",
   "restoration"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "concrete"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Paste",
  "colors": [
   "transparent",
   "black"
  ],
  "uv_stable": null,
  "mix_ratio": "Ready to use; thin with Akemi Universal Thinner to slow drying",
  "work_time": "Buff when the surface turns dull",
  "cure_time": "Fast-drying",
  "disc": false
 },
 "pid:8304793976902": {
  "type": "polish",
  "subtype": "Water-based inorganic polishing suspension (wax-free, pH 8-9)",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "granite",
   "marble",
   "concrete"
  ],
  "problems": [
   "fading",
   "water-damage"
  ],
  "viscosity": "Cream",
  "colors": [
   "white",
   "black"
  ],
  "uv_stable": null,
  "mix_ratio": "Ready to use - shake well",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304792830022": {
  "type": "cleaner",
  "subtype": "Solvent-based wax, coating and tar stripper (no chlorinated solvents)",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "porcelain",
   "concrete"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "Use undiluted",
  "work_time": "Dwell 10-20 min",
  "cure_time": "",
  "disc": false
 },
 "pid:8304790732870": {
  "type": "stain-remover",
  "subtype": "Water-based slightly alkaline rust stain remover (acid-free, pH approx. 9)",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "Ready to use (undiluted)",
  "work_time": "Dwell 5-10 min (never longer than 10 min)",
  "cure_time": "",
  "disc": false
 },
 "pid:8304790667334": {
  "type": "wax",
  "subtype": "Water-based polymer-reinforced wax emulsion (solvent-free)",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "Undiluted on absorbent stone; 1:1 to 1:3 with water on polished stone; upkeep 1-2 cups per 2.6 gal water",
  "work_time": "Buff while slightly damp",
  "cure_time": "Do not clean for 1-2 days",
  "disc": false
 },
 "pid:8304383688774": {
  "type": "stain-remover",
  "subtype": "Solvent-based absorbent poultice paste (no acids, lyes, waxes or silicones)",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "Paste",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "Ready to use",
  "work_time": "",
  "cure_time": "Dries in approx. 30-60 min, then remove residue",
  "disc": false
 },
 "pid:7916491931718": {
  "type": "stain-remover",
  "subtype": "Ready-to-use slightly alkaline active-chlorine (hypochlorite) organic stain remover",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "porcelain",
   "concrete"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "Ready to use (undiluted)",
  "work_time": "Dwell 10-30 min - do not let it dry",
  "cure_time": "",
  "disc": false
 },
 "pid:8304382050374": {
  "type": "cleaner",
  "subtype": "Concentrated acid-based post-installation / descaling cleaner",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [],
  "mat": [
   "granite",
   "porcelain"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304382017606": {
  "type": "cleaner",
  "subtype": "Ready-to-use acidic shower & tile descaler (3-in-1 clean, protect, sanitize)",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "porcelain"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Spray",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304381820998": {
  "type": "polish",
  "subtype": "Wax-based nano-silica floor polish & surface hardener",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "marble",
   "granite",
   "engineered",
   "concrete"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304381788230": {
  "type": "cleaner",
  "subtype": "Ready-to-use high-alkaline grout joint cleaner & degreaser",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "porcelain",
   "granite"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Spray",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304381722694": {
  "type": "cleaner",
  "subtype": "Super-concentrated pH-neutral no-rinse daily floor cleaner",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "concrete"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304409182278": {
  "type": "polish",
  "subtype": "Water-based, solvent-free maintenance cream (cleans and shines; non-abrasive)",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered"
  ],
  "problems": [
   "general-cleaning",
   "fading"
  ],
  "viscosity": "Cream",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304381591622": {
  "type": "cleaner",
  "subtype": "Ready-to-use pH-neutral daily countertop cleaner/sanitizer",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Spray",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304381558854": {
  "type": "cleaner",
  "subtype": "Neutral-pH epoxy residue / epoxy grout haze remover gel",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [],
  "mat": [
   "porcelain",
   "granite",
   "marble",
   "quartzite",
   "engineered"
  ],
  "problems": [
   "epoxy-haze"
  ],
  "viscosity": "Gel",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304382607430": {
  "type": "stain-remover",
  "subtype": "Non-acidic thioglycolate rust-removal gel",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [],
  "mat": [
   "marble",
   "granite",
   "quartzite",
   "engineered",
   "concrete"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "Gel",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304381493318": {
  "type": "cleaner",
  "subtype": "pH-neutral no-rinse sanitizing floor detergent concentrate",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "marble",
   "granite",
   "porcelain"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304381460550": {
  "type": "cleaner",
  "subtype": "Low-alkaline, solvent-enhanced deep cleaner & degreaser (wax stripper)",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete",
   "porcelain"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304381427782": {
  "type": "polish",
  "subtype": "Mild-abrasive polishing cream (etch mark & light scratch remover)",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "marble",
   "engineered",
   "concrete"
  ],
  "problems": [
   "fading",
   "stain"
  ],
  "viscosity": "Cream",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304381395014": {
  "type": "cleaner",
  "subtype": "Concentrated 2-in-1 wash & wax floor detergent",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "marble",
   "granite",
   "porcelain"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304381362246": {
  "type": "cleaner",
  "subtype": "Alkaline heavy-duty degreaser and wax stripper, concentrate (pH 13.5)",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "porcelain"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8488338194502": {
  "type": "cleaner",
  "subtype": "Alkaline heavy-duty degreaser and wax stripper, concentrate (pH 13.5)",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "concrete"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304382705734": {
  "type": "wax",
  "subtype": "Solvent-based paste wax (Preparato Speciale), clear or black-pigmented",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "restoration",
   "enhancing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "concrete"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Paste",
  "colors": [
   "clear",
   "black"
  ],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304382214214": {
  "type": "epoxy",
  "subtype": "Two-part 2:1 epoxy mastic, UV-filtered, very low yellowing, colorless",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "laminating",
   "substrate-bonding",
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "concrete"
  ],
  "problems": [
   "crack",
   "bond-failure"
  ],
  "viscosity": "",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "mix_ratio": "2:1 (A:B) by volume or weight",
  "work_time": "20-30 min at 68\u00b0F",
  "cure_time": "Handle after 6-8 h; machine/polish after 14-16 h; full strength after 7 days (68\u00b0F)",
  "disc": false
 },
 "pid:8304382574662": {
  "type": "polish",
  "subtype": "Water-based polishing gel and gloss maintainer, ready to use",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "granite"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Gel",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304382541894": {
  "type": "polish",
  "subtype": "Water-based polishing gel and gloss maintainer for calcium-carbonate stone, ready to use",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "marble"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Gel",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304382509126": {
  "type": "polish",
  "subtype": "Water-based polishing gel and gloss maintainer for quartz/resin and engineered stone",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "engineered"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Gel",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304382476358": {
  "type": "enhancer",
  "subtype": "Solvent-based nano-tech penetrating extra-dark color enhancer and anti-stain protector, PFAS-free",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing",
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "concrete"
  ],
  "problems": [
   "stain",
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": true,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "Dry 24 h before use; full protection after 7 days",
  "disc": false
 },
 "pid:8304382443590": {
  "type": "sealer",
  "subtype": "Solvent-based nano-tech penetrating anti-stain, water/oil-repellent protector, natural look",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "concrete"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "Dry 24 h before use; full protection after 7 days",
  "disc": false
 },
 "pid:8304382410822": {
  "type": "enhancer",
  "subtype": "Solvent-based nano-tech penetrating color enhancer and anti-stain protector for engineered stone, PFAS-free",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing",
   "sealing"
  ],
  "mat": [
   "engineered"
  ],
  "problems": [
   "stain",
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": true,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "Dry 24 h before use; full protection after 7 days",
  "disc": false
 },
 "pid:8304382378054": {
  "type": "enhancer",
  "subtype": "Solvent-based penetrating color enhancer, anti-stain, water/oil repellent for non-polished stone",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing",
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite"
  ],
  "problems": [
   "stain",
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "Dry 48 h before use; full protection after 7 days",
  "disc": false
 },
 "pid:8304382345286": {
  "type": "enhancer",
  "subtype": "Solvent-based deep color enhancer, anti-stain, water/oil repellent for textured exotic stone",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing",
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite"
  ],
  "problems": [
   "stain",
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": true,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "Dry 48 h before use; full protection after 7 days",
  "disc": false
 },
 "pid:8304382279750": {
  "type": "wax",
  "subtype": "Solvent-based liquid wax, resin-free, color-enhancing wet look",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "enhancing",
   "restoration"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "concrete"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304382115910": {
  "type": "kit",
  "subtype": "Two-step care kit: water-based Quartz Cleaner + water-based Quartz Protection polish",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "engineered"
  ],
  "problems": [
   "general-cleaning",
   "stain"
  ],
  "viscosity": "",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304382083142": {
  "type": "wax",
  "subtype": "Water-based emulsified re-polishable floor wax (natural + synthetic waxes), pH 8",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "concrete"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304382312518": {
  "type": "stain-remover",
  "subtype": "Non-acidic absorbing poultice paste for oil and organic stains",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "concrete"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "Paste",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304382640198": {
  "type": "polish",
  "subtype": "Crystallizing polishing powder for floors, sold as two formulas: 'for Granite' and 'for Marble'",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "granite",
   "marble",
   "concrete"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Powder",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304382246982": {
  "type": "polish",
  "subtype": "Self-polishing solvent-based liquid varnish / color enhancer (no buffing)",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing",
   "restoration"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "20-30 min",
  "disc": false
 },
 "pid:8304409280582": {
  "type": "stain-remover",
  "subtype": "Non-drip gel paint, marker and graffiti remover; free of acids, alkalis, oxidizers and reducers",
  "vendor": "Bellinzoni",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "concrete"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "Gel",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8488338554950": {
  "type": "stain-remover",
  "subtype": "Absorbent poultice powder (non-bleach)",
  "vendor": "Miracle Sealants",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "Powder",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "Mix with distilled water (or a stain-specific chemical) to a peanut-butter paste",
  "work_time": "",
  "cure_time": "Dries under plastic in 24-48 hr",
  "disc": false
 },
 "pid:8488338325574": {
  "type": "enhancer",
  "subtype": "Solvent-based wet-look color-enhancing sealer for unpolished stone",
  "vendor": "FILA",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing",
   "enhancing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": true,
  "mix_ratio": "Ready to use - no dilution",
  "work_time": "Recoat after 24 hr (2-3 coats)",
  "cure_time": "Foot traffic and full cure after 24 hr",
  "disc": false
 },
 "pid:8304413376582": {
  "type": "cleaner",
  "subtype": "Ready-to-use grout & tile deep-cleaner spray",
  "vendor": "FILA",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "porcelain"
  ],
  "problems": [
   "stain",
   "general-cleaning"
  ],
  "viscosity": "Spray",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "Ready to use",
  "work_time": "Let sit a few seconds, then scrub",
  "cure_time": "",
  "disc": false
 },
 "pid:8304384016454": {
  "type": "cleaner",
  "subtype": "Ready-to-use pH-neutral countertop spray",
  "vendor": "Miracle Sealants",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Spray",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "Ready to use",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304381198406": {
  "type": "sealer",
  "subtype": "Solvent-based oil- & water-repellent impregnator (no surface film)",
  "vendor": "ICR",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite"
  ],
  "problems": [],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": true,
  "mix_ratio": "Ready to use",
  "work_time": "",
  "cure_time": "Fully effective 6 hr after application",
  "disc": false
 },
 "pid:7916497207366": {
  "type": "cleaner",
  "subtype": "Water-based alkaline gel epoxy/urethane grout-haze remover",
  "vendor": "FILA",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [],
  "mat": [
   "porcelain"
  ],
  "problems": [
   "epoxy-haze",
   "stain"
  ],
  "viscosity": "Gel",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "Ready to use - shake well",
  "work_time": "Let sit 30 min, then scrub",
  "cure_time": "Apply only after grout has cured (min. 24 hr after grouting)",
  "disc": false
 },
 "pid:7916496945222": {
  "type": "cleaner",
  "subtype": "Ready-to-use kitchen degreaser & stain-remover spray",
  "vendor": "FILA",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "porcelain"
  ],
  "problems": [
   "stain",
   "general-cleaning"
  ],
  "viscosity": "Spray",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "Ready to use",
  "work_time": "Let sit a few seconds, then wipe",
  "cure_time": "",
  "disc": false
 },
 "pid:7916496846918": {
  "type": "stain-remover",
  "subtype": "Rust-remover gel, safe on polished stone (thioglycolate)",
  "vendor": "FILA",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "porcelain",
   "concrete"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "Gel",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "Ready to use - no dilution",
  "work_time": "Let sit 15 min",
  "cure_time": "",
  "disc": false
 },
 "pid:7916496781382": {
  "type": "cleaner",
  "subtype": "Concentrated heavy-duty cleaner, degreaser & wax stripper",
  "vendor": "FILA",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "porcelain",
   "concrete"
  ],
  "problems": [
   "general-cleaning",
   "stain"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "1:10 regular; 1:5 heavy dirt/wax strip; 1:20 polished stone & maintenance; undiluted on porcelain stains",
  "work_time": "Let sit 4-5 min (15 min to strip wax), then scrub",
  "cure_time": "",
  "disc": false
 },
 "pid:7916496715846": {
  "type": "cleaner",
  "subtype": "Ready-to-use acidic (citric acid) foam soap-scum & limescale remover",
  "vendor": "FILA",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "porcelain"
  ],
  "problems": [
   "general-cleaning",
   "water-damage"
  ],
  "viscosity": "Spray",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "Ready to use",
  "work_time": "Let sit a few seconds, then rinse",
  "cure_time": "",
  "disc": false
 },
 "pid:7916494225478": {
  "type": "cleaner",
  "subtype": "Ready-to-use neutral cleaner that renews an existing sealer",
  "vendor": "FILA",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Spray",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "Ready to use - do not rinse",
  "work_time": "Spray, then wipe dry",
  "cure_time": "",
  "disc": false
 },
 "pid:7916486688838": {
  "type": "cleaner",
  "subtype": "Ready-to-use neutral everyday cleaner spray",
  "vendor": "FILA",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "porcelain",
   "concrete"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Spray",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "Ready to use - no rinse",
  "work_time": "Spray, then wipe dry",
  "cure_time": "",
  "disc": false
 },
 "pid:8499185582150": {
  "type": "polish",
  "subtype": "Marble polishing powder (oxalate-based, wet or wet-to-dry)",
  "vendor": "MB Stone Care",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "marble"
  ],
  "problems": [
   "fading",
   "water-damage"
  ],
  "viscosity": "Powder",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8499185549382": {
  "type": "stain-remover",
  "subtype": "Ready-to-use poultice paste for oil and organic stains",
  "vendor": "MB Stone Care",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "Paste",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8499185418310": {
  "type": "cleaner",
  "subtype": "Ready-to-use alkaline mold & mildew stain remover (chlorine-based, pH 13)",
  "vendor": "MB Stone Care",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "Spray",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8499185385542": {
  "type": "cleaner",
  "subtype": "pH-neutral ready-to-use multi-surface spray cleaner",
  "vendor": "MB Stone Care",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Spray",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8499185352774": {
  "type": "polish",
  "subtype": "Quartz polishing cream (professional, machine-applied)",
  "vendor": "MB Stone Care",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "engineered",
   "granite"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Cream",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8499185320006": {
  "type": "cleaner",
  "subtype": "Non-acid alkaline soap scum & mineral deposit remover (concentrate)",
  "vendor": "MB Stone Care",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "1 part MB-3 to 2 parts warm water",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8499185287238": {
  "type": "sealer",
  "subtype": "Water-based penetrating impregnating sealer (fluorosurfactant)",
  "vendor": "MB Stone Care",
  "env": [
   "interior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "24-36 hours (full cure)",
  "disc": false
 },
 "pid:8499185221702": {
  "type": "polish",
  "subtype": "Granite polishing cream (professional, wet-to-dry)",
  "vendor": "MB Stone Care",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "granite",
   "quartzite",
   "engineered"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Cream",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8499185188934": {
  "type": "cleaner",
  "subtype": "Heavy-duty alkaline stone, tile & grout cleaner (concentrate, pH 12.5)",
  "vendor": "MB Stone Care",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "general-cleaning",
   "stain"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "3 / 6 / 8 fl oz per gallon of hot water (light / medium / heavy soil)",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8499185090630": {
  "type": "polish",
  "subtype": "Wet polishing powder for calcite stone (5X-type, oxalic)",
  "vendor": "MB Stone Care",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "marble"
  ],
  "problems": [
   "fading",
   "water-damage"
  ],
  "viscosity": "Powder",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8499184992326": {
  "type": "polish",
  "subtype": "Wet-to-dry 'hot' polishing powder for calcite stone and terrazzo",
  "vendor": "MB Stone Care",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "marble",
   "concrete"
  ],
  "problems": [
   "fading",
   "water-damage"
  ],
  "viscosity": "Powder",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8499184861254": {
  "type": "cleaner",
  "subtype": "Biological growth (mold, mildew, algae) cleaner, bleach-free quaternary ammonium",
  "vendor": "MB Stone Care",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "problems": [
   "stain",
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8499184828486": {
  "type": "cleaner",
  "subtype": "EPA Safer Choice ready-to-use daily multi-surface cleaner",
  "vendor": "MB Stone Care",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Spray",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8499184730182": {
  "type": "polish",
  "subtype": "Ready-to-use silicone finishing spray polish (semi-impregnating)",
  "vendor": "MB Stone Care",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "granite",
   "quartzite",
   "engineered"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Spray",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8499184697414": {
  "type": "cleaner",
  "subtype": "Mildly abrasive deep-cleaning cream (pH 8-10)",
  "vendor": "MB Stone Care",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "engineered"
  ],
  "problems": [
   "general-cleaning",
   "water-damage",
   "stain"
  ],
  "viscosity": "Cream",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8499184631878": {
  "type": "cleaner",
  "subtype": "pH-neutral oxygenated (hydrogen peroxide) multi-surface spray cleaner",
  "vendor": "MB Stone Care",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite"
  ],
  "problems": [
   "general-cleaning",
   "stain"
  ],
  "viscosity": "Spray",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8499184238662": {
  "type": "cleaner",
  "subtype": "Slightly alkaline no-rinse floor cleaner concentrate with optical brighteners",
  "vendor": "MB Stone Care",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "porcelain"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "1-3 fl oz per gallon of warm water",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8488448819270": {
  "type": "sealant",
  "subtype": "Acetoxy-cure one-component RTV silicone sealant",
  "vendor": "Stanley",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "porcelain"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "Paste",
  "colors": [
   "gray"
  ],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "Skins in 8-20 min",
  "cure_time": "Min. 0.1 in/day (73F, 50% RH)",
  "disc": false
 },
 "pid:8488448426054": {
  "type": "adhesive",
  "subtype": "100% acrylic, water-thin penetrating stone adhesive/filler (two-part, with hardener)",
  "vendor": "K-Bond",
  "env": [
   "interior"
  ],
  "app": [
   "fissures",
   "repair",
   "laminating",
   "rodding"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered"
  ],
  "problems": [
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8488337080390": {
  "type": "sealant",
  "subtype": "Acetoxy-cure one-component silicone sealant (general sealing/glazing)",
  "vendor": "Akfix",
  "env": [
   "interior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "porcelain"
  ],
  "problems": [
   "water-damage"
  ],
  "viscosity": "Paste",
  "colors": [
   "translucent"
  ],
  "uv_stable": false,
  "mix_ratio": "",
  "work_time": "Skins in 8-20 min",
  "cure_time": "Min. 2.5 mm (about 0.1 in) per day (73F, 50% RH)",
  "disc": false
 },
 "pid:8369989779526": {
  "type": "polish",
  "subtype": "3-step liquid polishing system for engineered stone/quartz (Step 1 snakeskin texture, Step 2 polish, Step 3 final polish)",
  "vendor": "Alpha Professional Tools",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "engineered"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304407478342": {
  "type": "adhesive",
  "subtype": "Cyanoacrylate (CA) instant glue set: Hot Stuff Original thin (3 cps), Super T medium (200-300 cps), Special T thick (1,150-1,500 cps)",
  "vendor": "Satellite City",
  "env": [
   "interior"
  ],
  "app": [
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite"
  ],
  "problems": [
   "crack"
  ],
  "viscosity": "",
  "colors": [
   "clear"
  ],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "Hot Stuff ~5 s (tight non-porous joints); Super T 10-25 s; Special T 50-60 s (about 20 s with accelerator)",
  "disc": false
 },
 "pid:8304404922438": {
  "type": "adhesive",
  "subtype": "Polyester mastic, knife grade (transparent)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "mix_ratio": "100 + 2-3 (2-3% liquid hardener by weight)",
  "work_time": "Gel 6-8 min at 77\u00b0F",
  "cure_time": "Tack-free about 1.5-2 h at 77\u00b0F; cut/polish after about 2-3 h",
  "disc": false
 },
 "pid:8304396173382": {
  "type": "adhesive",
  "subtype": "Vinylester glue, flowing (transparent)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Flowing",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "mix_ratio": "100 + 1-2 (1-2% hardener paste by weight; 2% max for best color)",
  "work_time": "Gel 4.5-5.5 min at 77\u00b0F",
  "cure_time": "Tack-free 30-45 min at 77\u00b0F; cut/polish after 45-60 min",
  "disc": false
 },
 "pid:8304365633606": {
  "type": "epoxy",
  "subtype": "Two-part epoxy mastic, knife grade (1:1)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "laminating",
   "substrate-bonding"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain",
   "concrete"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Knife Grade",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "1:1 by weight (100 + 100)",
  "work_time": "Gel 30-40 min at 77\u00b0F",
  "cure_time": "Tack-free about 3.5 h at 77\u00b0F (about 2 h at 104\u00b0F); cut/polish after 24 h",
  "disc": false
 },
 "pid:8303768928326": {
  "type": "epoxy",
  "subtype": "Extra-clear two-part epoxy mastic, knife grade (2:1)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain",
   "sintered"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "mix_ratio": "2:1 by weight (100 + 50)",
  "work_time": "Gel 10-15 min at 77\u00b0F",
  "cure_time": "Tack-free 3-3.5 h at 77\u00b0F; cut/polish after 24 h",
  "disc": false
 },
 "pid:8303768764486": {
  "type": "epoxy",
  "subtype": "Two-part epoxy cartridge glue (2:1)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "laminating",
   "anchoring",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain",
   "concrete"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Dripless Cartridge",
  "colors": [
   "white"
  ],
  "uv_stable": null,
  "mix_ratio": "2:1 (pre-dosed cartridge)",
  "work_time": "Gel 10-15 min at 77\u00b0F",
  "cure_time": "Tack-free about 90 min at 77\u00b0F; cut/polish after 8 h",
  "disc": false
 },
 "pid:8301667844166": {
  "type": "adhesive",
  "subtype": "Two-part transparent zero-yellowing glue (Glaxs, 1:1)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "mitering",
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Gel",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "mix_ratio": "1:1 by weight (100 + 100)",
  "work_time": "Gel 6-8 min at 77\u00b0F",
  "cure_time": "Tack-free about 1 h 40 min at 77\u00b0F; cut/polish after 2.5 h",
  "disc": false
 },
 "pid:7938912419910": {
  "type": "adhesive",
  "subtype": "Vinylester glue, knife grade (transparent)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "laminating",
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "uv_stable": true,
  "mix_ratio": "100 + 1-3 (1-3% hardener paste by weight; 2% max for best color)",
  "work_time": "Gel 4-5 min at 77\u00b0F",
  "cure_time": "Tack-free 25-40 min at 77\u00b0F; cut/polish after 40-60 min",
  "disc": false
 },
 "pid:8488449507398": {
  "type": "kit",
  "subtype": "Marble rust-stain removal & restoration kit (5 pieces)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "restoration",
   "sealing"
  ],
  "mat": [
   "marble"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8488449409094": {
  "type": "kit",
  "subtype": "Marble stain & etch removal and restoration kit (5 pieces)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "restoration",
   "sealing"
  ],
  "mat": [
   "marble"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8488338817094": {
  "type": "kit",
  "subtype": "Marble stain & etch remover kit (poultice + etch remover)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "marble"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8343773052998": {
  "type": "polish",
  "subtype": "Granite polishing powder",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "granite"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Powder",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304524329030": {
  "type": "polish",
  "subtype": "Self-polishing spray varnish (film-forming)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Spray",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304523968582": {
  "type": "kit",
  "subtype": "Countertop clean / polish / reseal kit (3 pieces)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "Sealer: 6 hrs before food contact; 24 hrs on floors",
  "disc": false
 },
 "pid:8304404987974": {
  "type": "wax",
  "subtype": "Solvent-based concentrated liquid wax",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing",
   "restoration"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "concrete"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304524263494": {
  "type": "stain-remover",
  "subtype": "Acidic liquid rust remover (pH 2)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "granite"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "Dwell 1-2 hrs, then rinse",
  "cure_time": "",
  "disc": false
 },
 "pid:8304524034118": {
  "type": "stain-remover",
  "subtype": "Poultice powder for organic and oil stains",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "Powder",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "Dwell 24-48 hrs under pierced plastic wrap",
  "cure_time": "",
  "disc": false
 },
 "pid:8302894972998": {
  "type": "cleaner",
  "subtype": "Concentrated alkaline degreaser / stain remover (pH 12)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "porcelain",
   "concrete"
  ],
  "problems": [
   "stain",
   "epoxy-haze"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "1:20 water standard; 1:10 tough dirt; 1:5 stubborn dirt; undiluted for stains/epoxy",
  "work_time": "5-10 min diluted; ~10 min neat on porcelain",
  "cure_time": "",
  "disc": false
 },
 "pid:8300849201222": {
  "type": "sealer",
  "subtype": "Solvent-based penetrating (impregnating) sealer",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "6 hrs before food contact; 24 hrs before floor traffic",
  "disc": false
 },
 "pid:8300849070150": {
  "type": "enhancer",
  "subtype": "Color-enhancing polish for quartz (food-safe)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "engineered"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "48 hrs before use",
  "disc": false
 },
 "pid:8300849004614": {
  "type": "polish",
  "subtype": "Aerosol stone polish with sealer",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "concrete"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Spray",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8300847923270": {
  "type": "cleaner",
  "subtype": "Solvent-based sealer, wax & treatment remover",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8300844580934": {
  "type": "sealer",
  "subtype": "Water-based penetrating water/oil-repellent sealer (food-contact)",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "48 hrs for full stain protection; 24 hrs before foot traffic",
  "disc": false
 },
 "pid:8300842483782": {
  "type": "cleaner",
  "subtype": "Ready-to-use daily natural-stone cleaner",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain",
   "concrete"
  ],
  "problems": [
   "general-cleaning"
  ],
  "viscosity": "Spray",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8300842451014": {
  "type": "polish",
  "subtype": "Self-polishing liquid varnish (film-forming)",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "Dry 10 min; fully dry 60 min at 77F",
  "disc": false
 },
 "pid:7978762960966": {
  "type": "stain-remover",
  "subtype": "Two-part chemical + poultice system for green/blue chip-repair stains",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "problems": [
   "stain"
  ],
  "viscosity": "",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "Dwell 24-48 hrs under pierced plastic wrap",
  "cure_time": "",
  "disc": false
 },
 "pid:7932575449158": {
  "type": "wax",
  "subtype": "Solvent-based concentrated paste wax",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing",
   "restoration"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "concrete"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Paste",
  "colors": [
   "clear",
   "black"
  ],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:7852949045318": {
  "type": "sealer",
  "subtype": "Solvent-based nano impregnating sealer",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "quartzite",
   "granite",
   "marble",
   "engineered",
   "concrete"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "24 hrs for full stain protection; 24 hrs before foot traffic",
  "disc": false
 },
 "pid:7852943147078": {
  "type": "sealer",
  "subtype": "Solvent-based natural-effect penetrating sealer",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "sealing"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered"
  ],
  "problems": [
   "stain",
   "water-damage"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "24 hrs for full stain protection; 24 hrs before foot traffic",
  "disc": false
 },
 "pid:7852935249990": {
  "type": "enhancer",
  "subtype": "Solvent-based color enhancer / micro-fissure concealer",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "enhancing"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8369990139974": {
  "app": [
   "restoration"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "disc": false,
  "type": "stain-remover",
  "colors": [],
  "vendor": "Alpha Professional Tools",
  "subtype": "rust stain remover gel",
  "problems": [
   "stain"
  ],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Gel",
  "work_time": "~10 min reaction time"
 },
 "pid:8303772270662": {
  "app": [],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain"
  ],
  "disc": false,
  "type": "cleaner",
  "colors": [],
  "vendor": "Tenax",
  "subtype": "alkaline degreaser spray",
  "problems": [
   "stain",
   "general-cleaning"
  ],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Spray",
  "work_time": "3-10 minutes dwell, do not exceed 30 minutes"
 },
 "pid:8300847333446": {
  "app": [],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain"
  ],
  "disc": false,
  "type": "cleaner",
  "colors": [],
  "vendor": "Tenax",
  "subtype": "Ready-to-Use Alkaline Spray Degreaser/Cleaner",
  "problems": [
   "stain",
   "general-cleaning"
  ],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Spray",
  "work_time": ""
 },
 "pid:8300847759430": {
  "app": [
   "restoration"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "porcelain"
  ],
  "disc": false,
  "type": "stain-remover",
  "colors": [],
  "vendor": "Tenax",
  "subtype": "Active-chlorine liquid stain & color-shading remover",
  "problems": [
   "stain"
  ],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:8488338456646": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "porcelain",
   "concrete"
  ],
  "disc": false,
  "type": "sealer",
  "colors": [],
  "vendor": "Miracle Sealants",
  "subtype": "Solvent-based penetrating silicone impregnator for porous surfaces (natural look)",
  "problems": [],
  "cure_time": "Dry to touch 1-3 hr (light use); keep dry and stain-free 72 hr",
  "mix_ratio": "Ready to use - do not dilute or thin",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": "Let stand 3-5 min, then buff off all excess"
 },
 "pid:8342864003142": {
  "app": [
   "enhancing"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "marble",
   "granite",
   "engineered",
   "concrete"
  ],
  "disc": false,
  "type": "polish",
  "colors": [],
  "vendor": "Miracle Sealants",
  "subtype": "Solvent-based topical stone polish (color & gloss)",
  "problems": [
   "fading"
  ],
  "cure_time": "Allow 3-72 hr before food contact",
  "mix_ratio": "Use straight from the container - do not thin or dilute",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": "Let dry to a haze, then buff off"
 },
 "pid:8304412852294": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "porcelain",
   "concrete"
  ],
  "disc": false,
  "type": "sealer",
  "colors": [],
  "vendor": "Miracle Sealants",
  "subtype": "Solvent-based penetrating silicone impregnator for porous surfaces (natural look)",
  "problems": [],
  "cure_time": "Dry to touch 1-3 hr (light use); keep dry and stain-free 72 hr",
  "mix_ratio": "Ready to use - do not dilute or thin",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": "Let stand 3-5 min, then buff off all excess"
 },
 "pid:7916497371206": {
  "app": [],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "porcelain",
   "granite",
   "quartzite"
  ],
  "disc": false,
  "type": "cleaner",
  "colors": [],
  "vendor": "FILA",
  "subtype": "Acidic (15-16% sulfamic acid, pH 0.8) cement-grout-haze & efflorescence remover, concentrate",
  "problems": [
   "water-damage",
   "stain"
  ],
  "cure_time": "",
  "mix_ratio": "1:5 post-installation/porcelain/terracotta; 1:5-1:10 acid-resistant stone; 1:10 outdoor dirt",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": "Let sit 5-10 min, then scrub"
 },
 "pid:7916487868486": {
  "app": [
   "repair",
   "fissures",
   "laminating"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "disc": false,
  "type": "filler",
  "colors": [
   "clear"
  ],
  "vendor": "Akemi",
  "subtype": "Two-part polyester knife-grade filler (L-Special, vertical-application formula)",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "20-90 min at 20C before grinding/milling/polishing (tin pack: 20-60 min; cartridge: 30-90 min)",
  "mix_ratio": "1-4% white hardener paste by weight, typically 2% (hardener >4% reduces adhesion and surface drying; <1% + temps under 5C delay hardening)",
  "uv_stable": null,
  "viscosity": "Knife Grade",
  "work_time": "3-16 min at 20C (68F) depending on hardener %; L-Special at 2% hardener: ~5-6 min"
 },
 "pid:8330944151622": {
  "app": [
   "seaming",
   "laminating",
   "repair",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered"
  ],
  "disc": false,
  "type": "epoxy",
  "colors": [
   "clear"
  ],
  "vendor": "K-Bond",
  "subtype": "Quick Set Knife-Grade Epoxy (Paste)",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "Tack-free in under 2-3 hours; full cure within 24 hours",
  "mix_ratio": "1:1 (Part A : Part B, by volume)",
  "uv_stable": null,
  "viscosity": "Knife Grade",
  "work_time": "8-15 minutes working time; pot life ~10 min at 75F"
 },
 "pid:8499185254470": {
  "app": [
   "restoration"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "marble",
   "concrete"
  ],
  "disc": false,
  "type": "polish",
  "colors": [],
  "vendor": "MB Stone Care",
  "subtype": "Wet polishing powder for terrazzo and calcite stone (buffered acids)",
  "problems": [
   "fading",
   "water-damage"
  ],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": true,
  "viscosity": "Powder",
  "work_time": ""
 },
 "pid:8499185057862": {
  "app": [],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "porcelain"
  ],
  "disc": false,
  "type": "cleaner",
  "colors": [],
  "vendor": "MB Stone Care",
  "subtype": "pH-neutral no-rinse spray cleaner for stone, glass & wood (ready-to-use)",
  "problems": [
   "general-cleaning"
  ],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:8304408854598": {
  "app": [
   "repair"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "engineered"
  ],
  "disc": false,
  "type": "repair",
  "colors": [
   "clear"
  ],
  "vendor": "FillaChip",
  "subtype": "UV-curable acrylate chip-repair adhesive kit (clear syringes, polish syringe, UV flashlight, tips, release sheets)",
  "problems": [
   "crack"
  ],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "",
  "work_time": ""
 },
 "pid:7781399265350": {
  "app": [
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "porcelain",
   "concrete"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "white"
  ],
  "vendor": "Kraken Bond",
  "subtype": "Acrylic-dispersion (water-based, solvent-free) high-tack construction adhesive",
  "problems": [],
  "cure_time": "Skin 30-40 min; cures min. 1-2 mm (0.04-0.08 in) per day (73F, 50% RH)",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "",
  "work_time": ""
 },
 "pid:8304522756166": {
  "app": [
   "seaming",
   "mitering",
   "repair"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "transparent"
  ],
  "vendor": "Tenax",
  "subtype": "Polyester knife grade (ultra-clear)",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "Tack-free in thin layer (77F, 50% RH): about 30 min; allow about 35-50 min before cutting or polishing",
  "mix_ratio": "100 parts adhesive to 2-3% paste hardener by weight (TDS ratio 100 + 2/3)",
  "uv_stable": null,
  "viscosity": "Knife Grade",
  "work_time": "Gel time in bulk at 77F (25C): 2-5 min"
 },
 "pid:8304401350726": {
  "app": [
   "rodding",
   "anchoring"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [],
  "vendor": "Tenax",
  "subtype": "Two-part methacrylate (acrylic-based) rodding adhesive, 1:1 cartridge",
  "problems": [],
  "cure_time": "Tack-free 12-15 min; ~90% strength in 10-15 min; cut/polish after 25-30 min at 77F",
  "mix_ratio": "1:1 (dual cartridge with static mixer)",
  "uv_stable": false,
  "viscosity": "Dripless Cartridge",
  "work_time": "Gel 3-6 min at 77F"
 },
 "pid:8300842614854": {
  "app": [
   "laminating",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain",
   "concrete"
  ],
  "disc": false,
  "type": "epoxy",
  "colors": [],
  "vendor": "Tenax",
  "subtype": "Two-part epoxy setting adhesive: Fixtop A resin with Fixtop B (fast-cure, 24h) or Fixdeck B (slow-cure, 48h, deck/countertop installs over plywood)",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Tack-free at 77F/50%RH: Fixtop approx 3.5h (approx 2h at 104F); Fixdeck approx 5-6h (approx 3h at 104F). Time before cutting/polishing at 77F: Fixtop 24h; Fixdeck 48h. Minimum reaction temperature 50F; service range -13F to 140F.",
  "mix_ratio": "Fixtop A + Fixtop B (or Fixdeck B): 100+100, 1:1 by weight or volume - same ratio for both the fast-cure and slow-cure systems.",
  "uv_stable": null,
  "viscosity": "Knife Grade",
  "work_time": "Gel time at 77F: Fixtop approx 30-40 min; Fixdeck approx 2h30min (slower, for hot climates and large surfaces)."
 },
 "pid:8304791027782": {
  "app": [
   "seaming",
   "laminating",
   "repair",
   "fissures"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain",
   "concrete"
  ],
  "disc": false,
  "type": "epoxy",
  "colors": [],
  "vendor": "Akemi",
  "subtype": "Epoxyacrylate, Knife Grade",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "15-40 minutes (fast hardening, per Akemi Platinum P+ TDS)",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Knife Grade",
  "work_time": "Short (manufacturer states 'short working time'; exact minutes not published)"
 },
 "pid:8342864035910": {
  "app": [],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "porcelain",
   "concrete"
  ],
  "disc": false,
  "type": "cleaner",
  "colors": [],
  "vendor": "Miracle Sealants",
  "subtype": "pH-neutral all-purpose cleaner/degreaser",
  "problems": [
   "general-cleaning",
   "stain"
  ],
  "cure_time": "",
  "mix_ratio": "Concentrate: dilutable up to 10:1 (or greater) with water for routine cleaning; use a stronger (less diluted) mix for heavy soil",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:7916487311430": {
  "app": [
   "restoration"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "porcelain",
   "concrete"
  ],
  "disc": false,
  "type": "cleaner",
  "colors": [],
  "vendor": "Akemi",
  "subtype": "alkaline concentrate cleaner",
  "problems": [
   "stain",
   "general-cleaning"
  ],
  "cure_time": "",
  "mix_ratio": "1:1 to 1:50 with water (more dilute for light soil, less dilute for heavy soil)",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:7916487770182": {
  "app": [],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "concrete",
   "porcelain"
  ],
  "disc": false,
  "type": "cleaner",
  "colors": [],
  "vendor": "Akemi",
  "subtype": "alkaline cleaner",
  "problems": [
   "general-cleaning",
   "stain"
  ],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Spray",
  "work_time": ""
 },
 "pid:8304525115462": {
  "app": [],
  "env": [
   "interior"
  ],
  "mat": [
   "engineered",
   "granite",
   "quartzite",
   "porcelain"
  ],
  "disc": false,
  "type": "stain-remover",
  "colors": [],
  "vendor": "Tenax",
  "subtype": "Solvent-based suction-cup / vacuum-ring mark remover",
  "problems": [
   "stain"
  ],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:8304401088582": {
  "app": [],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "concrete"
  ],
  "disc": false,
  "type": "stain-remover",
  "colors": [],
  "vendor": "Tenax",
  "subtype": "Chelating poultice powder for rust stains",
  "problems": [
   "stain"
  ],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Powder",
  "work_time": "Dwell 24-48 hrs under pierced plastic wrap"
 },
 "pid:8300849168454": {
  "app": [],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "concrete"
  ],
  "disc": false,
  "type": "stain-remover",
  "colors": [],
  "vendor": "Tenax",
  "subtype": "Sodium bisulfite / sodium dithionite reducing poultice powder for rust stains",
  "problems": [
   "stain"
  ],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Powder",
  "work_time": "Dwell 24-48 hours under pierced plastic wrap"
 },
 "pid:7938912583750": {
  "app": [],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "quartzite",
   "engineered",
   "porcelain"
  ],
  "disc": false,
  "type": "stain-remover",
  "colors": [],
  "vendor": "Tenax",
  "subtype": "Solvent-based suction-cup / vacuum-ring mark remover",
  "problems": [
   "stain"
  ],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:7916490195014": {
  "app": [
   "repair",
   "restoration"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "quartzite"
  ],
  "disc": false,
  "type": "kit",
  "colors": [],
  "vendor": "NSI Solutions",
  "subtype": "diamond abrasive top-polish / scratch-repair kit (3 Floating Turbo grits, 3 Redeemer Resin grits, natural-blend tan fiber buffing pads, MB-20 granite polishing cream)",
  "problems": [],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Cream",
  "work_time": ""
 },
 "pid:8304524296262": {
  "app": [
   "fissures"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite"
  ],
  "disc": false,
  "type": "repair",
  "colors": [],
  "vendor": "Tenax",
  "subtype": "Solvent-based clear micro-fissure and webbing concealer for polished granite",
  "problems": [
   "crack"
  ],
  "cure_time": "5 minutes",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:8304381034566": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "porcelain"
  ],
  "disc": false,
  "type": "sealant",
  "colors": [
   "clear",
   "white",
   "translucent"
  ],
  "vendor": "Premier Building Solutions",
  "subtype": "RTV acetoxy-cure silicone sealant",
  "problems": [],
  "cure_time": "Tack-free less than 45 min at 70F / 50% RH; 1/4 in bead cures in 48 hours",
  "mix_ratio": "",
  "uv_stable": true,
  "viscosity": "Paste",
  "work_time": "Skin time less than 15 min at 70F / 50% RH"
 },
 "pid:8300841730118": {
  "app": [
   "seaming",
   "mitering"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "asphalt",
   "basalt",
   "cane sugar",
   "casper",
   "cirrus",
   "city grey",
   "clean white",
   "dew",
   "eggshell",
   "foggy",
   "heather grey",
   "kilimanjaro",
   "kona white",
   "magnesium",
   "milk paint",
   "natural spring",
   "obsidian",
   "optical white",
   "paper white",
   "platinum",
   "polar white",
   "quartzite",
   "shell",
   "starch",
   "starlight",
   "white sail",
   "black",
   "original transparent",
   "coastline",
   "shade",
   "slate"
  ],
  "vendor": "Tenax",
  "subtype": "two-component (2:1) isocyanate-cured cartridge adhesive, GlaXS Fast line",
  "problems": [],
  "cure_time": "Minimum reaction temp 34F (1C); Shore D 80 after post-cure at 122F for 12h; service range -13F to 140F after full cure",
  "mix_ratio": "2:1 (Part A : Part B) by volume, pre-dosed in dual 215 ml cartridge",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "Gel time (bulk) 3-5 min at 77F; tack-free approx 25 min at 77F/50% RH; workable (cuttable/polishable) after 45-60 min at 77F"
 },
 "pid:8304532488262": {
  "app": [],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain",
   "concrete"
  ],
  "disc": false,
  "type": "cleaner",
  "colors": [],
  "vendor": "Superior Stone Products",
  "subtype": "alkaline degreaser",
  "problems": [
   "general-cleaning"
  ],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:7781393924166": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "porcelain"
  ],
  "disc": false,
  "type": "sealant",
  "colors": [
   "blue marine",
   "clear"
  ],
  "vendor": "Kraken Bond",
  "subtype": "acetoxy-cure RTV silicone",
  "problems": [],
  "cure_time": "Min. 0.1 in/day cure rate (73F/23C, 50% RH); shelf life 15 months unopened",
  "mix_ratio": "",
  "uv_stable": false,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-20 min tack-free/skin time (73F/23C, 50% RH)"
 },
 "pid:8488444231750": {
  "app": [
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain",
   "concrete"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "white"
  ],
  "vendor": "Akemi",
  "subtype": "1-component polyhybrid (MS-polymer) elastic adhesive, moisture-curing",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "handling strength approx. 20 min; cures approx. 1/16 in. (1.5-2 mm) per day; thick beads or vapor-tight substrates can take several weeks to cure through",
  "mix_ratio": "1-component (no mixing)",
  "uv_stable": true,
  "viscosity": "Paste",
  "work_time": "join parts within 10 min; skin forms in 10-15 min"
 },
 "pid:8488337768518": {
  "app": [
   "seaming",
   "repair"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "porcelain",
   "concrete"
  ],
  "disc": false,
  "type": "epoxy",
  "colors": [
   "honey"
  ],
  "vendor": "Akemi",
  "subtype": "Gel-like 2-component epoxy (modified polyamine hardener), 2:1, pre-dosed 400 ml dual cartridge (AKEPOX 2010 Gel Mix, Art. 10615)",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "move after 6-8 h; machinable after 12-16 h; full strength after 7 days at 68\u00b0F",
  "mix_ratio": "2:1 (A:B) by volume, pre-dosed in the cartridge chambers - metered automatically through the static mixing nozzle",
  "uv_stable": false,
  "viscosity": "Gel",
  "work_time": "approx. 20-30 min at 68\u00b0F (20\u00b0C); faster in heat, slower in cold"
 },
 "pid:8488444330054": {
  "app": [
   "seaming",
   "laminating",
   "fissures"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "disc": false,
  "type": "epoxy",
  "colors": [
   "honey"
  ],
  "vendor": "Akemi",
  "subtype": "Liquid 2-component epoxy (modified polyamine), 2:1",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "move after 6-8 h; machinable after 12-16 h; full strength after 7 days at 68\u00b0F",
  "mix_ratio": "2:1 (A:B) by weight or volume",
  "uv_stable": false,
  "viscosity": "Flowing",
  "work_time": "approx. 20-30 min at 68\u00b0F"
 },
 "pid:8304381624390": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "porcelain"
  ],
  "disc": false,
  "type": "sealer",
  "colors": [],
  "vendor": "Bellinzoni",
  "subtype": "Water-based fluoroalkyl-silane / fluoropolymer anti-stain protector for cement-based grout joints",
  "problems": [
   "stain",
   "water-damage"
  ],
  "cure_time": "12 hours",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Spray",
  "work_time": ""
 },
 "pid:7916487573574": {
  "app": [
   "restoration"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "disc": false,
  "type": "stain-remover",
  "colors": [],
  "vendor": "Akemi",
  "subtype": "Water-based, ready-to-use, slightly alkaline (pH about 9) rust stain remover for acid-sensitive stone",
  "problems": [
   "stain"
  ],
  "cure_time": "",
  "mix_ratio": "Ready to use - apply undiluted",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": "Dwell 5-10 minutes; never exceed 10 minutes"
 },
 "pid:8488447443014": {
  "app": [
   "seaming",
   "repair",
   "fissures",
   "rodding",
   "anchoring"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "concrete"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "transparent"
  ],
  "vendor": "Bellinzoni",
  "subtype": "Two-part unsaturated polyester mastic, transparent, liquid (flowing) grade, tintable",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "Sand, machine or polish after about 2 hours at 68F",
  "mix_ratio": "100:2 by weight (2% Part B dibenzoyl peroxide paste hardener; up to 3% in cold weather, never over 4%)",
  "uv_stable": null,
  "viscosity": "Flowing",
  "work_time": "3-15 min at 68F (gel time 6-8 min)"
 },
 "pid:8298345201734": {
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "substrate-bonding"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "white",
   "grey",
   "cream",
   "khaki",
   "beige",
   "black",
   "brown"
  ],
  "vendor": "Akemi",
  "subtype": "2-component epoxy-acrylate (vinyl ester) stone adhesive, styrene-based",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "~20-30 min at 68F before grinding/polishing; full handling cure under 1 hour",
  "mix_ratio": "10:1",
  "uv_stable": null,
  "viscosity": "Gel",
  "work_time": "5-7 min working time at 68F/20C (6-min cartridge variant); begins setting at ~6 min"
 },
 "pid:7916487999558": {
  "app": [
   "seaming",
   "laminating",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain",
   "concrete"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "clear"
  ],
  "vendor": "Akemi",
  "subtype": "polyurethane (PUR), two-component",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "movable approx. 1 hr; grindable/polishable approx. 2 hr; further processing approx. 4 hr; maximum stability approx. 24 hr (all at 68F/20C)",
  "mix_ratio": "1:1 by volume",
  "uv_stable": true,
  "viscosity": "Knife Grade",
  "work_time": "approx. 5-8 minutes at room temperature (68F/20C)"
 },
 "pid:8304531439686": {
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "rodding",
   "repair"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "epoxy",
  "colors": [],
  "vendor": "Superior Stone Products",
  "subtype": "two-part knife-grade epoxy adhesive (1:1), no-sag",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "2-4 hr handling cure (temperature dependent); manufacturer states no separate full-cure figure",
  "mix_ratio": "1:1 by volume (1.15:1 by weight, Part A : Part B)",
  "uv_stable": null,
  "viscosity": "Knife Grade",
  "work_time": "5-10 min gel time (temperature dependent)"
 },
 "pid:8304531472454": {
  "app": [
   "substrate-bonding",
   "mitering"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "epoxy",
  "colors": [],
  "vendor": "Superior Stone Products",
  "subtype": "knife grade, slow-set two-part setting epoxy",
  "problems": [],
  "cure_time": "24 hours",
  "mix_ratio": "2.4:1 by weight (Part A:Part B)",
  "uv_stable": null,
  "viscosity": "Knife Grade",
  "work_time": "2-3 hours at 70F"
 },
 "pid:8304531570758": {
  "app": [
   "mitering",
   "seaming",
   "laminating",
   "rodding",
   "repair"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [],
  "vendor": "Superior Stone Products",
  "subtype": "acrylic / methyl methacrylate (MMA), colored-hardener activated",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "Under 20 minutes (temperature dependent)",
  "mix_ratio": "3-5% Colored Hardener by weight",
  "uv_stable": null,
  "viscosity": "Flowing",
  "work_time": "3-5 minutes at 70F (temperature dependent)"
 },
 "pid:8304531669062": {
  "app": [
   "seaming",
   "laminating",
   "repair",
   "rodding",
   "mitering"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "pure white",
   "perfect white",
   "transparent white",
   "glacier white",
   "white north",
   "newport grey",
   "cloud",
   "oyster",
   "graphite",
   "dark grey",
   "transparent black",
   "dusk",
   "galaxy black",
   "beach",
   "dirty white",
   "beige olimpo",
   "medium brown",
   "dark brown",
   "chameleon",
   "translucent"
  ],
  "vendor": "Superior Stone Products",
  "subtype": "Two-Part Modified Acrylic Vinyl Ester (MMA) Knife-Grade Adhesive, 250ml 10:1 Dual Cartridge",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "13 minutes (avg)",
  "mix_ratio": "",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "10 minutes (avg)"
 },
 "pid:8304533667910": {
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "rodding",
   "repair"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "epoxy",
  "colors": [],
  "vendor": "Superior Stone Products",
  "subtype": "Two-part epoxy/amine adhesive",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "2-4 hr handling cure (temperature dependent)",
  "mix_ratio": "1:1 by volume (1.15 Part A to 1.0 Part B by weight)",
  "uv_stable": null,
  "viscosity": "Knife Grade",
  "work_time": "5-10 min gel time (temperature dependent)"
 },
 "pid:8300847956038": {
  "app": [
   "enhancing",
   "restoration",
   "fissures"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite"
  ],
  "disc": false,
  "type": "enhancer",
  "colors": [
   "black"
  ],
  "vendor": "Tenax",
  "subtype": "Solvent-Based Color Enhancer / Dye for Black Granite",
  "problems": [
   "fading"
  ],
  "cure_time": "24 hours before foot traffic on treated floors",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:8314234601542": {
  "app": [
   "anchoring",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "quartzite",
   "engineered",
   "concrete"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "white",
   "grey"
  ],
  "vendor": "Akemi",
  "subtype": "1-component polyhybrid (MS polymer) adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Handling strength approx. 20 minutes; final cure is by atmospheric moisture (full cure time not stated by manufacturer)",
  "mix_ratio": "",
  "uv_stable": true,
  "viscosity": "Paste",
  "work_time": "Short - handling strength develops in about 20 minutes after application"
 },
 "pid:8343771840582": {
  "app": [
   "seaming",
   "repair",
   "mitering"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain"
  ],
  "disc": false,
  "type": "epoxy",
  "colors": [
   "transparent"
  ],
  "vendor": "Tenax",
  "subtype": "Glaxs BM 1:1 two-part epoxy adhesive (zero-yellowing, UV-stable)",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "Workable/polishable in ~2-2.5 hours at 77F; cured service range -13F to 140F",
  "mix_ratio": "1:1 by weight (Part A : Part B)",
  "uv_stable": true,
  "viscosity": "Knife Grade",
  "work_time": "Gel time ~8-10 min at 77F (25C)"
 },
 "pid:7715059204166": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered"
  ],
  "disc": false,
  "type": "sealer",
  "colors": [],
  "vendor": "Tenax",
  "subtype": "Solvent-Based Impregnating Sealer",
  "problems": [
   "stain",
   "water-damage"
  ],
  "cure_time": "24 hours",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:8304381526086": {
  "app": [],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "marble",
   "granite",
   "quartzite",
   "concrete",
   "porcelain"
  ],
  "disc": false,
  "type": "stain-remover",
  "colors": [],
  "vendor": "Bellinzoni",
  "subtype": "Sanitizing sodium hypochlorite (bleach) active-foam mold and mildew stain remover",
  "problems": [
   "stain"
  ],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Spray",
  "work_time": ""
 },
 "pid:8304408952902": {
  "app": [
   "repair"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite"
  ],
  "disc": false,
  "type": "repair",
  "colors": [
   "clear"
  ],
  "vendor": "FillaChip",
  "subtype": "UV-curable acrylate chip-repair adhesive refill (adhesive syringes, polish, tips, release sheets)",
  "problems": [
   "crack"
  ],
  "cure_time": "~30 seconds under UV light exposure",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "",
  "work_time": ""
 },
 "pid:8304412917830": {
  "app": [
   "restoration"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "marble"
  ],
  "disc": false,
  "type": "polish",
  "colors": [],
  "vendor": "Miracle Sealants",
  "subtype": "Acid-polishing powder (potassium oxalate / acrylic acid / ammonium bifluoride) for calcareous stone",
  "problems": [
   "water-damage",
   "fading"
  ],
  "cure_time": "",
  "mix_ratio": "Sprinkle on a wetted area; keep a watery/milky slurry",
  "uv_stable": null,
  "viscosity": "Powder",
  "work_time": "Buff 1-2 min per 2-4 sq ft; never let the slurry dry"
 },
 "pid:8488445902918": {
  "app": [],
  "env": [
   "interior"
  ],
  "mat": [
   "engineered"
  ],
  "disc": false,
  "type": "kit",
  "colors": [],
  "vendor": "Akemi",
  "subtype": "Quartz cleaning & care kit (Quartz Intensive Cleaner + Quartz Clean & Care spray + microfiber cloth)",
  "problems": [
   "stain",
   "general-cleaning"
  ],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Spray",
  "work_time": ""
 },
 "pid:8303772631110": {
  "app": [
   "restoration"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "marble"
  ],
  "disc": false,
  "type": "kit",
  "colors": [],
  "vendor": "Tenax / Lustro Italiano",
  "subtype": "Marble rust and stain removal maintenance kit",
  "problems": [
   "stain",
   "general-cleaning"
  ],
  "cure_time": "24-48 hrs poultice dwell time per manufacturer instructions",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "",
  "work_time": ""
 },
 "pid:7916496814150": {
  "app": [
   "restoration"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "concrete"
  ],
  "disc": false,
  "type": "stain-remover",
  "colors": [],
  "vendor": "FILA",
  "subtype": "Aerosol Oil & Grease Stain Remover (spray-on, brush-off)",
  "problems": [
   "stain"
  ],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Spray",
  "work_time": ""
 },
 "pid:8304790896710": {
  "app": [
   "anchoring",
   "substrate-bonding",
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "concrete",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "clear"
  ],
  "vendor": "Akemi",
  "subtype": "MS-polymer (polyhybrid) one-component moisture-cure adhesive sealant",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "~2mm (0.08 in) cured after 24 hrs at 68F/50% RH; thicker or vapor-tight joints (metal, ceramics, glass) cure much slower, up to several weeks",
  "mix_ratio": "",
  "uv_stable": true,
  "viscosity": "Paste",
  "work_time": "Join parts within 10 min of application; skin forms in 10-15 min"
 },
 "pid:7712142393414": {
  "app": [
   "restoration"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "porcelain",
   "concrete"
  ],
  "disc": false,
  "type": "cleaner",
  "colors": [],
  "vendor": "DryTreat",
  "subtype": "Alkaline oxygen cleaner (poultice-capable stain remover)",
  "problems": [
   "stain",
   "general-cleaning"
  ],
  "cure_time": "For set-in stains, mix into a paste poultice and leave covered 24 hr before removing",
  "mix_ratio": "2 scoops (180 g) per 1 gal (4 L) warm water for routine cleaning, covering about 80 sq ft; for heavy-duty cleaning use roughly 1/3 of the 2.2 lb container per 2 gal warm water, covering up to 500 sq ft per container",
  "uv_stable": null,
  "viscosity": "Powder",
  "work_time": "Apply and let dwell about 3 minutes without drying before scrubbing"
 },
 "pid:7714921971782": {
  "app": [
   "seaming",
   "mitering",
   "laminating",
   "rodding",
   "repair"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [],
  "vendor": "Superior Stone Products",
  "subtype": "Vinyl Ester / Modified Acrylic Knife Grade Adhesive (FV-5)",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "20-25 minutes",
  "mix_ratio": "1-2% BPO paste hardener",
  "uv_stable": null,
  "viscosity": "Knife Grade",
  "work_time": "Gel time 3-6 minutes"
 },
 "pid:7916487901254": {
  "app": [
   "restoration"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "quartzite",
   "concrete",
   "porcelain"
  ],
  "disc": false,
  "type": "cleaner",
  "colors": [],
  "vendor": "Akemi",
  "subtype": "",
  "problems": [
   "stain",
   "general-cleaning"
  ],
  "cure_time": "",
  "mix_ratio": "Undiluted or diluted up to 1:5 with water",
  "uv_stable": null,
  "viscosity": "Gel",
  "work_time": "Dwell 30 min minimum, up to 24 hrs for heavy residue"
 },
 "pid:7938921758790": {
  "app": [
   "seaming",
   "laminating",
   "repair",
   "mitering"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [],
  "vendor": "Tenax",
  "subtype": "Vinyl ester (vinylester) knife-grade mastic, two-part (resin paste + hardener paste)",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "Tack-free ~20 min (thin layer, 25C/50% RH); full postcure 50C for 12h for max adhesion/hardness",
  "mix_ratio": "100 parts Vertigo S paste : 1-3 parts hardener paste by weight",
  "uv_stable": true,
  "viscosity": "Knife Grade",
  "work_time": "~25-35 min workable/cuttable at 25C; gel time 3.5-4.5 min in bulk"
 },
 "pid:8304531275846": {
  "app": [
   "seaming",
   "laminating",
   "repair",
   "rodding",
   "mitering"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "epoxy",
  "colors": [
   "clear"
  ],
  "vendor": "Superior",
  "subtype": "1:1 Flowing",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "2-4 hours full cure (temperature dependent); 1 year shelf life stored indoors below 75F",
  "mix_ratio": "1:1 by volume (1.15 Part A to 1.0 Part B by weight)",
  "uv_stable": null,
  "viscosity": "Flowing",
  "work_time": "5-10 minutes gel time at 70F (temperature dependent)"
 },
 "pid:8330940350534": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "disc": false,
  "type": "sealer",
  "colors": [],
  "vendor": "InnoChem LLC (Revolution Advanced)",
  "subtype": "water-based fluoropolymer impregnator",
  "problems": [
   "stain",
   "water-damage"
  ],
  "cure_time": "24 to 72 hours",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:8330940579910": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "concrete"
  ],
  "disc": false,
  "type": "sealer",
  "colors": [],
  "vendor": "Revolution Stone Products (InnoChem LLC)",
  "subtype": "Water-based fluoropolymer impregnator",
  "problems": [
   "stain",
   "water-damage"
  ],
  "cure_time": "24-72 hours full cure; light foot traffic after 5-7 hours",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": "20-30 min dwell/penetration before wipe-off; second coat after 30 min if needed"
 },
 "pid:8304381919302": {
  "app": [],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "engineered"
  ],
  "disc": false,
  "type": "cleaner",
  "colors": [],
  "vendor": "Bellinzoni",
  "subtype": "Ready-to-use, mildly acidic (pH 5.5) 3-in-1 spray cleaner, protector and polish",
  "problems": [
   "general-cleaning"
  ],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Spray",
  "work_time": ""
 },
 "pid:8304412983366": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain",
   "concrete"
  ],
  "disc": false,
  "type": "sealer",
  "colors": [],
  "vendor": "Miracle Sealants",
  "subtype": "Solvent-based penetrating silicone impregnator for medium-to-dense stone (natural look)",
  "problems": [],
  "cure_time": "Dry to touch 1-3 hr (light use); full cure 72 hr",
  "mix_ratio": "Ready to use - do not dilute or thin",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": "Let stand 3-5 min, then buff off all excess"
 },
 "pid:8304796172358": {
  "app": [
   "seaming",
   "laminating",
   "fissures",
   "repair",
   "substrate-bonding"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "porcelain",
   "concrete"
  ],
  "disc": false,
  "type": "epoxy",
  "colors": [
   "grey-green",
   "light-ivory",
   "brick-red"
  ],
  "vendor": "Akemi",
  "subtype": "knife-grade, fast-set",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "Transportable 3-5 hr; load-bearing ~8-10 hr; full strength ~7 days (all at 68F/20C)",
  "mix_ratio": "2:1 (Part A resin : Part B hardener, by volume or weight, mixed to a uniform shade)",
  "uv_stable": false,
  "viscosity": "Knife Grade",
  "work_time": "~20-30 min at 68F (20C)"
 },
 "pid:8304380215366": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "porcelain",
   "concrete"
  ],
  "disc": false,
  "type": "sealant",
  "colors": [
   "trans white"
  ],
  "vendor": "Silco Inc. (Sil-Bond)",
  "subtype": "Acetoxy-cure 1-part RTV silicone sealant",
  "problems": [],
  "cure_time": "Approximately 1/8 inch depth per 24 hours at 77F / 50% RH; full cure depends on joint depth",
  "mix_ratio": "",
  "uv_stable": true,
  "viscosity": "Paste",
  "work_time": "Skins over approximately 10 minutes, tack-free approximately 17 minutes at 77F / 50% RH"
 },
 "pid:7916488097862": {
  "app": [],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain"
  ],
  "disc": false,
  "type": "cleaner",
  "colors": [],
  "vendor": "Akemi",
  "subtype": "ready-to-use daily stone and tile cleaning spray, not the Concentrate line",
  "problems": [
   "general-cleaning"
  ],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Spray",
  "work_time": ""
 },
 "pid:8304531603526": {
  "app": [
   "mitering",
   "seaming",
   "laminating",
   "repair"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [],
  "vendor": "Superior Stone Products",
  "subtype": "Modified Acrylic Vinyl Ester, Knife Grade (Gold Evolution EV-5 color-and-activate system)",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "13 minutes average (temperature dependent)",
  "mix_ratio": "3%-5% GOLD EVOLUTION Colored Hardener by weight",
  "uv_stable": null,
  "viscosity": "Knife Grade",
  "work_time": "10 minutes average gel time (temperature dependent)"
 },
 "pid:8304790470726": {
  "app": [
   "restoration"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "disc": false,
  "type": "cleaner",
  "colors": [],
  "vendor": "Akemi",
  "subtype": "Active-chlorine (sodium hypochlorite) based algae/moss/mildew remover, alkaline pH ~11",
  "problems": [
   "stain",
   "general-cleaning"
  ],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:7916497862726": {
  "app": [],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "porcelain"
  ],
  "disc": false,
  "type": "solvent",
  "colors": [],
  "vendor": "AKEMI (afin)",
  "subtype": "Silicone/Adhesive Residue Remover (Aerosol Spray)",
  "problems": [
   "general-cleaning"
  ],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Spray",
  "work_time": ""
 },
 "pid:8304378740806": {
  "app": [
   "seaming",
   "laminating",
   "repair",
   "mitering"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [],
  "vendor": "Tenax",
  "subtype": "Vinyl ester knife-grade adhesive, extra clear, two-part (resin + peroxide paste hardener)",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "~15 min to initial cure at 77\u00b0F; min. application/cure temperature 41\u00b0F (5\u00b0C)",
  "mix_ratio": "100 parts resin : 2/3 part hardener by weight (use included Tenax paste hardener)",
  "uv_stable": true,
  "viscosity": "Knife Grade",
  "work_time": "Gel 4-6 min, tacky-free 18-20 min, working time ~20-25 min, all at 77\u00b0F/25\u00b0C"
 },
 "pid:7712142229574": {
  "app": [
   "restoration"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "porcelain"
  ],
  "disc": false,
  "type": "stain-remover",
  "colors": [],
  "vendor": "Dry-Treat / STAIN-PROOF",
  "subtype": "Safe-acid stone & masonry cleaner \u2014 rust, efflorescence, limescale, grout haze, mortar and soot remover",
  "problems": [
   "stain"
  ],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:7938921660486": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "engineered"
  ],
  "disc": false,
  "type": "sealer",
  "colors": [],
  "vendor": "Tenax",
  "subtype": "penetrating sealer",
  "problems": [
   "stain",
   "water-damage"
  ],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:8300844613702": {
  "app": [
   "enhancing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "porcelain",
   "engineered"
  ],
  "disc": false,
  "type": "enhancer",
  "colors": [],
  "vendor": "Tenax",
  "subtype": "anti-slip surface etch treatment",
  "problems": [],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": "1-15 min dwell/contact time before rinse"
 },
 "pid:8303771582534": {
  "app": [
   "sealing",
   "enhancing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered"
  ],
  "disc": false,
  "type": "enhancer",
  "colors": [],
  "vendor": "Tenax",
  "subtype": "color-enhancing impregnating sealer (wet-look, siloxane/solvent-based)",
  "problems": [
   "stain",
   "fading"
  ],
  "cure_time": "24 hours to full stain resistance; keep foot traffic off treated floors that long",
  "mix_ratio": "",
  "uv_stable": true,
  "viscosity": "Liquid",
  "work_time": "10-15 min absorption per coat at ~68 F; apply 2nd coat 20 min after the 1st"
 },
 "pid:8304365535302": {
  "app": [
   "enhancing",
   "restoration"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite"
  ],
  "disc": false,
  "type": "polish",
  "colors": [],
  "vendor": "Tenax",
  "subtype": "polishing powder",
  "problems": [
   "fading"
  ],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Powder",
  "work_time": ""
 },
 "pid:8304386146374": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "disc": false,
  "type": "sealer",
  "colors": [],
  "vendor": "Akemi",
  "subtype": "solvent-based silicone impregnator",
  "problems": [
   "stain",
   "water-damage"
  ],
  "cure_time": "water-repellent effect in minutes; full protection after 2-3 hours (manufacturer TDS); effective for several years",
  "mix_ratio": "",
  "uv_stable": true,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:8304794075206": {
  "app": [
   "enhancing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered"
  ],
  "disc": false,
  "type": "enhancer",
  "colors": [],
  "vendor": "Akemi",
  "subtype": "Solvent-Based",
  "problems": [
   "stain",
   "fading"
  ],
  "cure_time": "Protective effect begins in 1-2 hours at 68F (20C)",
  "mix_ratio": "",
  "uv_stable": true,
  "viscosity": "Liquid",
  "work_time": "Penetrates in about 10 minutes before wipe-off"
 },
 "pid:8304794337350": {
  "app": [
   "enhancing"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered"
  ],
  "disc": false,
  "type": "enhancer",
  "colors": [
   "black",
   "clear"
  ],
  "vendor": "Akemi",
  "subtype": "solvent-based color-enhancing polish (wax/resin base)",
  "problems": [
   "fading"
  ],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:7916487508038": {
  "app": [
   "restoration"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite"
  ],
  "disc": false,
  "type": "stain-remover",
  "colors": [],
  "vendor": "Akemi",
  "subtype": "rust remover paste",
  "problems": [
   "stain"
  ],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Paste",
  "work_time": "Dwell up to 24 hours"
 },
 "pid:8304792535110": {
  "app": [
   "restoration"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete",
   "porcelain"
  ],
  "disc": false,
  "type": "cleaner",
  "colors": [],
  "vendor": "AKEMI",
  "subtype": "algae & moss remover - LongLife long-life preventive (quaternary ammonium biocide)",
  "problems": [
   "stain",
   "general-cleaning"
  ],
  "cure_time": "Keep treated surface dry (no rain) for at least 4 hours after application",
  "mix_ratio": "1:10 to 1:50 with water",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:8304531636294": {
  "app": [
   "seaming",
   "laminating",
   "repair",
   "rodding",
   "mitering"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [],
  "vendor": "Superior Stone Products",
  "subtype": "Modified Acrylic Vinyl Ester (MMA-based)",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "fully cured within 20 min at 70F",
  "mix_ratio": "3-5% by weight Superior GOLD EVOLUTION Colored Hardener, dispensed as a separate bead alongside the adhesive bead and mixed together",
  "uv_stable": true,
  "viscosity": "Knife Grade",
  "work_time": "3-5 min at 70F (shorter in heat, longer in cold)"
 },
 "pid:8435197345862": {
  "app": [
   "substrate-bonding",
   "anchoring"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain",
   "concrete"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "white"
  ],
  "vendor": "Akemi",
  "subtype": "1-component polyhybrid (silane-modified polymer) moisture-cure stress-compensating assembly adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "approx. 1.5 mm cure depth per 24 hrs at 20C/50% RH; thin or vapor-tight joints (metal, glass, ceramic) can take several weeks to cure to the core unless surfaces are pre-moistened",
  "mix_ratio": "",
  "uv_stable": true,
  "viscosity": "Paste",
  "work_time": "Bond parts within approx. 10 min of application; skin formation 10-20 min"
 },
 "pid:8343772168262": {
  "app": [
   "seaming",
   "laminating",
   "repair"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "clear"
  ],
  "vendor": "Tenax",
  "subtype": "two-part vinyl ester knife-grade resin adhesive (paste + benzoyl-peroxide hardener)",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "Gel time in bulk 3.5-4.5 min; tack-free in thin layer 20-35 min, both at 77F (25C); adhesion data also measured after a 122F (50C)/12h post-cure",
  "mix_ratio": "100 parts resin : 1-3 parts paste hardener by weight (manufacturer TDS: color paste/metal oxide added before hardener; max ~2% peroxide recommended for best post-cure color)",
  "uv_stable": true,
  "viscosity": "Knife Grade",
  "work_time": "25-40 min working/cutting-polishing window at 77F (25C)"
 },
 "pid:8304385916998": {
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "rodding",
   "repair"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [],
  "vendor": "Superior Stone Products",
  "subtype": "Vinyl Ester Stone Adhesive (Knife Grade)",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "20 minutes",
  "mix_ratio": "1-3% BPO paste hardener by weight",
  "uv_stable": null,
  "viscosity": "Knife Grade",
  "work_time": "3-4 min gel time at 70F"
 },
 "pid:8304533635142": {
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "rodding",
   "repair"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "epoxy",
  "colors": [],
  "vendor": "Superior Stone Products",
  "subtype": "flowing",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "2-4 hours (temperature dependent); 1 year shelf life unmixed",
  "mix_ratio": "1:1 by volume (1.15 Part A to 1.0 Part B by weight)",
  "uv_stable": null,
  "viscosity": "Flowing",
  "work_time": "Gel time 5-10 minutes (temperature dependent)"
 },
 "pid:8304531341382": {
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "rodding",
   "repair"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "epoxy",
  "colors": [],
  "vendor": "Superior Stone Products",
  "subtype": "Knife Grade 1:1 two-part epoxy/amine adhesive",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "2-4 hours handling cure (temperature dependent)",
  "mix_ratio": "1:1 equal volumes Part A to Part B (approx. 1.15:1.0 by weight)",
  "uv_stable": null,
  "viscosity": "Knife Grade",
  "work_time": "5-10 min gel time (temperature dependent)"
 },
 "pid:8304531210310": {
  "app": [
   "seaming",
   "mitering",
   "laminating",
   "rodding",
   "repair",
   "fissures"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [],
  "vendor": "Superior Stone Products",
  "subtype": "Vinyl Ester - Flowing (Syrup)",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "~20 minutes",
  "mix_ratio": "1-3% BPO paste hardener",
  "uv_stable": null,
  "viscosity": "Flowing",
  "work_time": "3-4 minutes (gel time)"
 },
 "pid:8342859317318": {
  "app": [
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "porcelain",
   "concrete"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "white"
  ],
  "vendor": "Stanley",
  "subtype": "Hybrid polymer (MS polymer) moisture-curing construction adhesive",
  "problems": [],
  "cure_time": "Moisture-cure; minimum 0.14 in/day drying rate; full cure depends on bead thickness, humidity and temperature",
  "mix_ratio": "",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "15-20 min skin/tack-free time at 73F, 50% RH"
 },
 "pid:8304382672966": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "disc": false,
  "type": "sealer",
  "colors": [],
  "vendor": "Bellinzoni",
  "subtype": "Solvent-based penetrating anti-stain hydro/oil repellent protector",
  "problems": [
   "stain",
   "water-damage"
  ],
  "cure_time": "45-60 minutes at 68F (20C)",
  "mix_ratio": "",
  "uv_stable": true,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:8304407969862": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete",
   "porcelain"
  ],
  "disc": false,
  "type": "sealant",
  "colors": [
   "trans white"
  ],
  "vendor": "Silco",
  "subtype": "Neutral-cure (oxime) one-part silicone sealant/adhesive",
  "problems": [
   "water-damage"
  ],
  "cure_time": "Cure rate ~1/8 in per 30 hrs at 77F/50% RH; full cure is depth/humidity dependent",
  "mix_ratio": "",
  "uv_stable": true,
  "viscosity": "Paste",
  "work_time": "Skin-over ~12 min, tack-free ~25 min (77F/50% RH)"
 },
 "pid:8304411902022": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "concrete"
  ],
  "disc": false,
  "type": "sealer",
  "colors": [],
  "vendor": "FILA",
  "subtype": "penetrating water & oil repellent impregnator (solvent-based)",
  "problems": [
   "stain",
   "water-damage"
  ],
  "cure_time": "Walkable after 8 hours; full stain-repellent effect after 24 hours",
  "mix_ratio": "",
  "uv_stable": true,
  "viscosity": "Liquid",
  "work_time": "10-15 min open time before wiping/buffing excess"
 },
 "pid:8488444461126": {
  "type": "epoxy",
  "subtype": "Filled, solvent-free two-component epoxy adhesive (modified polyamine hardener), paste-like knife-grade, 2:1",
  "vendor": "Akemi",
  "env": [
   "interior"
  ],
  "app": [
   "anchoring",
   "substrate-bonding",
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "concrete"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [],
  "uv_stable": false,
  "mix_ratio": "2:1 (Part A : Part B) by weight or volume",
  "work_time": "About 45-55 min at 68\u00b0F (20\u00b0C)",
  "cure_time": "Movable after 6-8 h, processable after 12-16 h, full strength after 7 days (68\u00b0F)",
  "disc": false
 },
 "pid:8304790339654": {
  "type": "cleaner",
  "subtype": "Water-based alkaline epoxy-residue and epoxy-grout-haze remover (professional, ready to use)",
  "vendor": "Akemi",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [],
  "mat": [
   "granite",
   "quartzite",
   "concrete",
   "porcelain"
  ],
  "problems": [
   "epoxy-haze"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8488447541318": {
  "type": "adhesive",
  "subtype": "Two-component unsaturated polyester mastic, transparent, solid (knife-grade, thixotropic)",
  "vendor": "Bellinzoni",
  "env": [
   "interior"
  ],
  "app": [
   "seaming",
   "repair",
   "rodding"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "problems": [
   "bond-failure",
   "crack"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "transparent"
  ],
  "uv_stable": null,
  "mix_ratio": "100:2 by weight with Part B paste hardener (dibenzoyl peroxide); up to 3% when cold, never over 4%",
  "work_time": "3-15 min at 68\u00b0F (20\u00b0C); gel time 6-8 min",
  "cure_time": "Can be sanded and polished after about 2 hours (68\u00b0F)",
  "disc": false
 },
 "pid:8304402169926": {
  "type": "epoxy",
  "subtype": "Two-component thixotropic epoxy mastic, knife-grade, 1:1 by weight",
  "vendor": "Tenax",
  "env": [
   "interior",
   "exterior"
  ],
  "app": [
   "seaming",
   "laminating",
   "substrate-bonding"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain",
   "concrete"
  ],
  "problems": [
   "bond-failure"
  ],
  "viscosity": "Knife Grade",
  "colors": [
   "white"
  ],
  "uv_stable": null,
  "mix_ratio": "1:1 by weight (100 + 100)",
  "work_time": "Bulk gel time about 2 h 30 min at 77\u00b0F (25\u00b0C)",
  "cure_time": "Tack-free in a thin layer about 4 h at 77\u00b0F (25\u00b0C), 50% RH",
  "disc": false
 },
 "pid:8304408756294": {
  "type": "repair",
  "subtype": "UV-cured chip, nick and gouge repair system (clear, color and polish syringes with UV flashlights); cosmetic fill, not a structural seam adhesive",
  "vendor": "FillaChip",
  "env": [
   "interior"
  ],
  "app": [
   "repair"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered"
  ],
  "problems": [
   "crack"
  ],
  "viscosity": "",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "UV light held on the release sheet at least 60 seconds per layer",
  "disc": false
 },
 "pid:8499184959558": {
  "type": "polish",
  "subtype": "Hand-applied etch remover and marble polishing powder (oxalate-based; light etching, water rings and light scratches)",
  "vendor": "MB Stone Care",
  "env": [
   "interior"
  ],
  "app": [
   "restoration"
  ],
  "mat": [
   "marble"
  ],
  "problems": [
   "fading",
   "water-damage"
  ],
  "viscosity": "Powder",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8499185516614": {
  "type": "polish",
  "subtype": "Non-acidic post-polish rinse, optical brightener and water-repellent sealer for polished stone",
  "vendor": "MB Stone Care",
  "env": [
   "interior"
  ],
  "app": [
   "restoration",
   "sealing"
  ],
  "mat": [
   "marble",
   "granite"
  ],
  "problems": [
   "fading"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "",
  "disc": false
 },
 "pid:8304400924742": {
  "type": "repair",
  "subtype": "Dual-viscosity cyanoacrylate chip and fissure repair kit with activator",
  "vendor": "Tenax",
  "env": [
   "interior"
  ],
  "app": [
   "repair",
   "fissures"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered"
  ],
  "problems": [
   "crack"
  ],
  "viscosity": "Liquid",
  "colors": [],
  "uv_stable": null,
  "mix_ratio": "",
  "work_time": "",
  "cure_time": "Sets in seconds when activated",
  "disc": false
 },
 "pid:8330940809286": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "disc": false,
  "type": "sealer",
  "colors": [],
  "vendor": "Revolution Stone Products",
  "subtype": "solvent-based fluoropolymer impregnator",
  "problems": [
   "stain",
   "water-damage"
  ],
  "cure_time": "24-72 hours full cure; light foot traffic OK after 5-7 hours",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": "Penetrate 15-30 min, wipe off excess; second coat 30 min after first if needed"
 },
 "pid:8330941399110": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "disc": false,
  "type": "sealer",
  "colors": [],
  "vendor": "Revolution Stone Products",
  "subtype": "solvent-based fluoropolymer impregnator",
  "problems": [
   "stain",
   "water-damage"
  ],
  "cure_time": "24-72 hours (light foot traffic ok after 5-7 hours)",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:8304794009670": {
  "app": [
   "enhancing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "concrete"
  ],
  "disc": false,
  "type": "enhancer",
  "colors": [],
  "vendor": "Akemi",
  "subtype": "solvent-based color-intensifying impregnation (polysiloxane-forming)",
  "problems": [
   "fading"
  ],
  "cure_time": "~6 hours to full color-intensification effect (vs 24 hr on predecessor product); stone must be fully dry 1-2 days before application",
  "mix_ratio": "",
  "uv_stable": true,
  "viscosity": "Liquid",
  "work_time": "5-10 min open time before wiping off excess (up to 60 min on low-absorbent stone)"
 },
 "pid:8330945265734": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "concrete"
  ],
  "disc": false,
  "type": "sealer",
  "colors": [],
  "vendor": "Akemi",
  "subtype": "solvent-based silicone penetrating impregnator",
  "problems": [
   "stain",
   "water-damage"
  ],
  "cure_time": "Protective effect begins 24-48 hours at 20C (68F); full cure per label",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:8384284328006": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain"
  ],
  "disc": false,
  "type": "sealer",
  "colors": [],
  "vendor": "FILA",
  "subtype": "solvent-based impregnating penetrating sealer",
  "problems": [
   "stain"
  ],
  "cure_time": "Foot traffic after 8 hours, full cure in 24 hours",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": "10-15 min dwell time, keep surface wet with sealer"
 },
 "pid:7712142458950": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "disc": false,
  "type": "sealer",
  "colors": [],
  "vendor": "Dry-Treat / Stain-Proof",
  "subtype": "Dense Stone Impregnating Sealer (solvent-based penetrating)",
  "problems": [
   "stain",
   "water-damage"
  ],
  "cure_time": "Usable after 24 hours; full cure up to 4 weeks",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:8304380117062": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "concrete"
  ],
  "disc": false,
  "type": "sealant",
  "colors": [
   "clear"
  ],
  "vendor": "Kraken Bond",
  "subtype": "Acrylic caulk (acrylic dispersion base, not siliconized)",
  "problems": [
   "water-damage"
  ],
  "cure_time": "7-14 days to full clear cure, depending on bead thickness, humidity, temperature and surface type",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Paste",
  "work_time": "Tool bead within 5 minutes of application; skin time 15-30 min at 73F/50% RH"
 },
 "pid:8304525770822": {
  "app": [
   "seaming",
   "laminating",
   "repair"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "obsidian",
   "andromeda",
   "midnight",
   "shade",
   "verde bahia",
   "walnut",
   "leather",
   "shore",
   "topeka",
   "arabica",
   "doe",
   "molasses",
   "dark emperador",
   "cafe au lait",
   "chert",
   "imperial brown",
   "grizzly bear",
   "emperador",
   "quartzite",
   "asphalt",
   "natural spring",
   "twilight",
   "basalt",
   "shale",
   "davys gray",
   "soapstone",
   "comet gray",
   "gainsboro",
   "platinum",
   "spanish gray",
   "rhyolite",
   "gallium",
   "rubble",
   "mollusk",
   "heather grey",
   "gunmetal",
   "marengo",
   "pancake",
   "gamboge",
   "fallen leaves",
   "coastline",
   "dijon",
   "bavarian cream",
   "cane sugar",
   "saki",
   "tawny",
   "napkin",
   "custard",
   "maize",
   "welded tuff",
   "lemon chiffon",
   "mudstone",
   "sonoran",
   "grain",
   "granny smith",
   "tomato pie",
   "milk paint",
   "starlight",
   "cirrus",
   "kilimanjaro",
   "foggy",
   "eggshell",
   "starch",
   "lace white",
   "white sail",
   "picket fence",
   "casper",
   "clean white",
   "buttercream",
   "kona white",
   "sketchpad",
   "cue ball",
   "chalk white"
  ],
  "vendor": "Tenax",
  "subtype": "Two-part methacrylate (acrylic) cartridge adhesive, 10:1 mix, pre-colored for seam color-match",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "Fixture time 20-30 min; ~90% ultimate strength at 45-60 min at 65-85F room-temp cure",
  "mix_ratio": "10:1 (resin:activator, by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "10-15 min working time; 5-10 min de-rope time"
 },
 "pid:8304531800134": {
  "app": [
   "seaming",
   "laminating",
   "repair",
   "rodding",
   "mitering"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "chameleon",
   "transparent white",
   "glacier white",
   "pure white",
   "perfect white",
   "translucent",
   "transparent black",
   "galaxy black",
   "oyster",
   "newport grey",
   "graphite",
   "dusk",
   "beach",
   "beige olimpo",
   "dark grey",
   "dark brown",
   "dirty white",
   "medium brown",
   "white north",
   "cloud"
  ],
  "vendor": "Superior Stone Products",
  "subtype": "Two-part modified acrylic vinyl ester adhesive + color-matched hardener (GV-5/EV-5 Knife Grade)",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "13 min average (kit page); full cure approx. 20 min per general Gold Evolution EXT directions",
  "mix_ratio": "Colored hardener at approx. 3-5% by weight of adhesive (digital scale recommended)",
  "uv_stable": true,
  "viscosity": "Knife Grade",
  "work_time": "10 min average at 70F (kit-specific); general Gold Evolution EXT line 3-5 min average at 70F per manufacturer directions, shorter at higher temps"
 },
 "pid:8300791988294": {
  "app": [
   "seaming",
   "laminating",
   "repair",
   "fissures"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [],
  "vendor": "Tenax",
  "subtype": "vinyl ester, knife grade",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "Tack-free in 20-35 min at 77F",
  "mix_ratio": "100 parts resin : 1-3% paste hardener (by weight)",
  "uv_stable": true,
  "viscosity": "Knife Grade",
  "work_time": "Gel time ~3.5-4.5 min at 77F; workable/finishing window ~25-40 min at 77F"
 },
 "pid:8304383656006": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "porcelain",
   "concrete"
  ],
  "disc": false,
  "type": "sealer",
  "colors": [],
  "vendor": "Akemi",
  "subtype": "Solvent-based penetrating/impregnating stain-repellent sealer (Nano-Effect)",
  "problems": [
   "stain",
   "water-damage"
  ],
  "cure_time": "Initial water/oil/grease repellency in 10-20 min at 68F (20C); full protection after 2-3 hours",
  "mix_ratio": "",
  "uv_stable": true,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:8342858235974": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain",
   "concrete"
  ],
  "disc": false,
  "type": "sealer",
  "colors": [],
  "vendor": "FILA",
  "subtype": "penetrating sealer, water-based",
  "problems": [
   "stain",
   "water-damage"
  ],
  "cure_time": "Walkable after 4 hours; full cure at 8 hours",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": "10-15 min dwell before wipe-off (matte/honed stone: 10 min; polished stone/porcelain: up to 1 hr)"
 },
 "pid:7916496519238": {
  "app": [
   "restoration"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "porcelain",
   "concrete"
  ],
  "disc": false,
  "type": "stain-remover",
  "colors": [],
  "vendor": "FILA",
  "subtype": "Sodium hypochlorite (chlorine bleach) + sodium hydroxide based organic stain remover, pH 13.5 (alkaline, not acidic)",
  "problems": [
   "stain"
  ],
  "cure_time": "",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:7892891107398": {
  "app": [
   "seaming",
   "laminating",
   "repair",
   "mitering",
   "substrate-bonding"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "clear"
  ],
  "vendor": "K-Bond (InnoChem LLC)",
  "subtype": "Vinyl ester",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "Tack-free in 10-20 minutes; machinable in 20-30 minutes",
  "mix_ratio": "1-3% hardener to adhesive by weight",
  "uv_stable": false,
  "viscosity": "Knife Grade",
  "work_time": "4-6 minutes"
 },
 "pid:7916466110534": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "chalk"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate (MMA) seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes; full handling strength at 30 minutes",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:8300791660614": {
  "app": [
   "laminating",
   "repair",
   "fissures",
   "seaming"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "white",
   "optical white",
   "paper white"
  ],
  "vendor": "Tenax",
  "subtype": "Knife-grade polyester mastic, color-matched to engineered quartz, w/ hardener",
  "problems": [
   "crack"
  ],
  "cure_time": "Bulk gel 3-5 min; tack-free in thin layer 25-30 min, both at 77F (25C); cured product usable 32-230F (0-110C)",
  "mix_ratio": "100:2-3 (mastic : hardener, by weight)",
  "uv_stable": null,
  "viscosity": "Knife Grade",
  "work_time": "60-80 minutes working time at 77F (25C)"
 },
 "pid:8300848054342": {
  "app": [
   "repair"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain"
  ],
  "disc": false,
  "type": "epoxy",
  "colors": [],
  "vendor": "Tenax",
  "subtype": "Two-part epoxy chip & edge repair kit (6x50ml cartridges + 5 color pastes)",
  "problems": [
   "crack"
  ],
  "cure_time": "24 hours",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Paste",
  "work_time": ""
 },
 "pid:8304363208774": {
  "app": [
   "enhancing",
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered"
  ],
  "disc": false,
  "type": "enhancer",
  "colors": [],
  "vendor": "Tenax",
  "subtype": "stone color enhancer touch-up pen",
  "problems": [
   "stain"
  ],
  "cure_time": "avoid foot traffic 4-6 hours; full absorption/set ~24 hours (per base Ager chemistry TDS)",
  "mix_ratio": "",
  "uv_stable": true,
  "viscosity": "Liquid",
  "work_time": "~5 minutes before wiping excess"
 },
 "pid:8330941857862": {
  "app": [
   "seaming",
   "laminating",
   "repair",
   "rodding"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "buff"
  ],
  "vendor": "K-Bond",
  "subtype": "polyester knife-grade paste, buff pigment, gloss finish",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "tack-free 10-30 min; machinable 30-60 min",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Knife Grade",
  "work_time": "5-7 min at 77F"
 },
 "pid:8330942316614": {
  "app": [
   "laminating",
   "repair",
   "rodding",
   "substrate-bonding"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "white"
  ],
  "vendor": "K-Bond",
  "subtype": "polyester",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "Tack-free in 10-30 minutes; machinable in 30-60 minutes",
  "mix_ratio": "100:3 by weight, polyester resin to BPO cream hardener",
  "uv_stable": null,
  "viscosity": "Flowing",
  "work_time": "5-7 minutes"
 },
 "pid:8330942906438": {
  "app": [
   "laminating",
   "repair",
   "rodding",
   "substrate-bonding"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [],
  "vendor": "K-Bond (InnoChem LLC, member of the AKEMI Group)",
  "subtype": "Acrylic-blend reactive stone adhesive (BPO-cured, styrene/MMA)",
  "problems": [
   "crack"
  ],
  "cure_time": "Tack-free in 10-20 minutes; machinable in 20-30 minutes",
  "mix_ratio": "2-4% BPO hardener by weight to ELITE resin",
  "uv_stable": true,
  "viscosity": "Flowing",
  "work_time": "4-6 minutes"
 },
 "pid:8330943135814": {
  "app": [
   "seaming",
   "laminating",
   "repair",
   "mitering"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [],
  "vendor": "InnoChem LLC (K-Bond)",
  "subtype": "vinyl ester, low color, flowing",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "Tack-free 10-20 min, machinable 20-30 min",
  "mix_ratio": "1-3% BPO hardener paste by volume",
  "uv_stable": null,
  "viscosity": "Flowing",
  "work_time": "4-6 minutes"
 },
 "pid:8330944708678": {
  "app": [
   "seaming",
   "laminating",
   "repair",
   "fissures",
   "rodding"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "transparent"
  ],
  "vendor": "K-Bond",
  "subtype": "Knife Grade Polyester Paste",
  "problems": [
   "crack"
  ],
  "cure_time": "Machinable in 30-60 min",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Knife Grade",
  "work_time": "4-6 min working time; tack-free in 20-30 min"
 },
 "pid:8330945593414": {
  "app": [
   "rodding",
   "laminating",
   "repair",
   "substrate-bonding"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "transparent"
  ],
  "vendor": "K-Bond (InnoChem LLC)",
  "subtype": "Polyester Flowing Adhesive, BPO-cured 2-component (100:3 resin:hardener by weight)",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "Tack-free in 20-30 minutes; machinable in 30-60 minutes",
  "mix_ratio": "100 parts polyester resin to 3 parts BPO cream hardener, by weight",
  "uv_stable": null,
  "viscosity": "Flowing",
  "work_time": "4-6 minutes"
 },
 "pid:8330946412614": {
  "app": [
   "seaming",
   "laminating",
   "repair",
   "rodding",
   "fissures"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [],
  "vendor": "K-Bond",
  "subtype": "Vinyl ester / polyester blend knife-grade paste, BPO (benzoyl peroxide) cured - NOT a true amine-cured epoxy despite the 'Poly-Epoxy' marketing name",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "Tack-free in 10-20 minutes; machinable in 20-30 minutes",
  "mix_ratio": "2-4% BPO cream hardener to adhesive, by weight",
  "uv_stable": true,
  "viscosity": "Knife Grade",
  "work_time": "4-6 minutes working (gel) time"
 },
 "pid:8330946510918": {
  "app": [
   "seaming",
   "laminating",
   "repair",
   "rodding",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "clear"
  ],
  "vendor": "K-Bond (InnoChem LLC, member of the AKEMI Group)",
  "subtype": "acrylic/epoxy-blend, BPO-cream-hardener cured, knife grade",
  "problems": [
   "crack"
  ],
  "cure_time": "Tack-free in 10-20 minutes; machinable in 20-30 minutes",
  "mix_ratio": "2-4% ELITE BPO cream hardener to ELITE resin, by weight",
  "uv_stable": true,
  "viscosity": "Knife Grade",
  "work_time": "4-6 minutes at 77F (25C)"
 },
 "pid:8384257097798": {
  "app": [
   "enhancing",
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite"
  ],
  "disc": false,
  "type": "enhancer",
  "colors": [],
  "vendor": "Tenax",
  "subtype": "Solvent-Based Color Enhancer & Sealer for Exotic Natural Granite",
  "problems": [
   "fading",
   "stain"
  ],
  "cure_time": "4-6 hours before foot traffic; 24 hours full cure",
  "mix_ratio": "",
  "uv_stable": true,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:8304790798406": {
  "app": [],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "disc": false,
  "type": "stain-remover",
  "colors": [],
  "vendor": "Akemi",
  "subtype": "Solvent-based gel paint/graffiti remover",
  "problems": [
   "stain"
  ],
  "cure_time": "",
  "mix_ratio": "Ready to use - no dilution",
  "uv_stable": null,
  "viscosity": "Gel",
  "work_time": "10-15 min dwell time to soften paint before rinsing; repeat for stubborn graffiti"
 },
 "pid:8300791562310": {
  "app": [
   "seaming",
   "mitering"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "sintered"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "grey",
   "white",
   "dark grey",
   "kelya",
   "keranium",
   "kira",
   "laos",
   "light white",
   "onirika",
   "standard cream",
   "trilium",
   "fossil",
   "grigio",
   "keon",
   "micron",
   "nacre",
   "valterra"
  ],
  "vendor": "Tenax",
  "subtype": "methyl methacrylate (MMA) two-part color-matched cartridge adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Cut and polish in approximately 45-60 minutes (manufacturer, tenaxusa.com)",
  "mix_ratio": "2:1 (pre-dosed resin:hardener in cartridge)",
  "uv_stable": null,
  "viscosity": "Dripless Cartridge",
  "work_time": "Gel time ~15-20 min at 77F; tacky-free ~60-70 min at 77F (distributor-sourced, same TDS text repeated across 2+ independent sellers; not independently confirmed on manufacturer own page text)"
 },
 "pid:8304396042310": {
  "app": [
   "enhancing",
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered"
  ],
  "disc": false,
  "type": "enhancer",
  "colors": [],
  "vendor": "Tenax",
  "subtype": "Impregnating Color Enhancer and Sealer for Quartz/Engineered Stone, Granite, Marble (Food-Safe) - rebranded Ager FS",
  "problems": [
   "stain",
   "fading",
   "water-damage"
  ],
  "cure_time": "24 hours before foot traffic (floor applications)",
  "mix_ratio": "",
  "uv_stable": true,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:7819722588230": {
  "app": [
   "seaming",
   "repair"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "oxford brown"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-Part Methacrylate (MMA)",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "20-25 minutes to ~90% strength; fully movable/handled at 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819722653766": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "slate"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (acrylic) seaming adhesive, no-drip",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min; ~90% ultimate strength and can move part at 30 min",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F"
 },
 "pid:7819722686534": {
  "app": [
   "seaming",
   "repair"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "crystal clear"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-Part Methacrylate (MMA)",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "20-25 minutes to ~90% strength; fully movable/handled at 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819724914758": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "rain"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part no-drip acrylic/methacrylate seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min; part can be moved at 30 min; reaches about 90% ultimate strength at 30 min, room temperature (65-85F)",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:8133280333894": {
  "app": [
   "seaming",
   "repair",
   "fissures"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [],
  "vendor": "Satellite City",
  "subtype": "cyanoacrylate (CA) instant adhesive kit",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "~5 sec (thin Hot Stuff Original) to ~60 sec (thick Special T) on tight joints; faster with NCF Quick accelerator",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:8304791388230": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "disc": false,
  "type": "sealant",
  "colors": [
   "transparent"
  ],
  "vendor": "Akemi",
  "subtype": "Oxime-Cure Neutral (pH 7) Stone-Safe Silicone Sealant",
  "problems": [
   "water-damage"
  ],
  "cure_time": "Cures approx. 1-3 mm per 24 hr at 73F/50% RH, depth-dependent; working temp 41-95F (5-35C)",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Paste",
  "work_time": "Builds a skin in approx. 5-10 min at 73F/50% RH (23C/50% RH); must be tooled/smoothed within that window"
 },
 "pid:7923370328134": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "concrete"
  ],
  "disc": false,
  "type": "sealant",
  "colors": [
   "white"
  ],
  "vendor": "Kraken Bond",
  "subtype": "Siliconized acrylic caulk (AS 103), acrylic dispersion, pH 7-9",
  "problems": [
   "water-damage"
  ],
  "cure_time": "Skin time 50 +/- 20 min (73F/50% RH); cures ~0.1 in/day; keep joint dry 2+ hrs after tooling",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Paste",
  "work_time": "Tool/smooth within 5 minutes of application"
 },
 "pid:7938912124998": {
  "app": [
   "sealing",
   "enhancing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered"
  ],
  "disc": false,
  "type": "enhancer",
  "colors": [],
  "vendor": "Tenax",
  "subtype": "solvent-based color enhancer and sealer",
  "problems": [
   "stain",
   "water-damage"
  ],
  "cure_time": "Foot traffic after 4-6 hours; full protection develops in 24 hours",
  "mix_ratio": "",
  "uv_stable": true,
  "viscosity": "Liquid",
  "work_time": "Wipe off excess within seconds to a few minutes of application to avoid a sticky or glossy film; a second coat may be applied after about 10-15 minutes for deeper color"
 },
 "pid:8300791922758": {
  "app": [
   "repair",
   "fissures"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "marble",
   "granite",
   "engineered",
   "concrete"
  ],
  "disc": false,
  "type": "filler",
  "colors": [
   "buff"
  ],
  "vendor": "Tenax",
  "subtype": "Two-Part Polyester Stone Filler (travertine/marble hole-filling and joint grouting)",
  "problems": [
   "crack"
  ],
  "cure_time": "",
  "mix_ratio": "100 parts filler to 2-3 parts hardener (catalyst paste) by weight",
  "uv_stable": null,
  "viscosity": "Paste",
  "work_time": "Working time about 15-20 min at 75F; gels in bulk in 1.5-3 min; tack-free in a thin layer in 5-10 min"
 },
 "pid:7819724030022": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "pea"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate (acrylic) two-part no-drip seaming adhesive",
  "problems": [],
  "cure_time": "fixture ~20-25 min; can be moved at 30 min; ~90% ultimate strength at 30 min (75 F)",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75 F / 24 C"
 },
 "pid:7819724128326": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "steel grey"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minutes to about 90 percent ultimate strength; movable after 30 minutes",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819724259398": {
  "app": [
   "seaming",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "pink"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 min to ~90% ultimate strength; movable after 30 min (room temp)",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75\u00b0F/24\u00b0C"
 },
 "pid:7819724456006": {
  "app": [
   "seaming",
   "mitering",
   "laminating"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "tan"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) flowable seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20-25 min (~90% ultimate strength) at 75\u00b0F; can be moved at 30 min",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75\u00b0F (24\u00b0C)"
 },
 "pid:7819724554310": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "gray"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "two-part methacrylate (MMA) flowable, dripless-cartridge seaming adhesive, 10:1 mix",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minutes to ~90% ultimate strength (fixture time) at 75 F / 24 C; can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin : activator, by volume/weight)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75 F / 24 C"
 },
 "pid:7819724652614": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "rouge"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "Two-part methacrylate (MMA) flowable, dripless-cartridge seaming adhesive, 10:1 mix",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes to ~90% ultimate strength at 75F; can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C (65-85F operating range)"
 },
 "pid:7819724718150": {
  "app": [
   "seaming",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "grey"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) flowable seaming adhesive",
  "problems": [],
  "cure_time": "20-25 min to ~90% ultimate strength (fixture time); can be moved in 30 min; room-temp cure",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75\u00b0F/24\u00b0C"
 },
 "pid:7819724947526": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "carbon"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "two-part methacrylate (MMA) no-drip, dripless-cartridge seaming adhesive, 10:1 mix",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minutes fixture time to ~90% ultimate strength at 75 F / 24 C; can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin : activator, by volume/weight)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75 F / 24 C"
 },
 "pid:7819723178054": {
  "app": [
   "seaming",
   "repair"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "mystic gray"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-Part Methacrylate (MMA)",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "20-25 minutes to ~90% strength; fully movable/handled at 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819723440198": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "bourbon"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate (MMA) seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes; full handling strength at 30 minutes",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819723571270": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "moose"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) flowable seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minutes to about 90 percent ultimate strength at 75F/24C; movable after 30 minutes",
  "mix_ratio": "10:1 resin to activator (volume/weight)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819723702342": {
  "app": [
   "seaming",
   "laminating",
   "repair",
   "mitering"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "nirvana"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "20-25",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12"
 },
 "pid:7819723735110": {
  "app": [
   "seaming",
   "repair"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "coral"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "20-25",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12"
 },
 "pid:7819723866182": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "paprika"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part no-drip acrylic/methacrylate seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min; part can be moved at 30 min; reaches about 90 percent ultimate strength at 30 min, room temperature (65-85F)",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819723964486": {
  "app": [
   "seaming",
   "mitering",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "emperador"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) dripless cartridge seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture/~90% ultimate strength in 20 to 25 minutes at 75F; can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator) by weight or volume",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F (24C)"
 },
 "pid:7819722850374": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "wax"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "methacrylate (MMA)",
  "problems": [],
  "cure_time": "Fixture 20-25 min (~90% strength) at 75F/24C; can be moved in about 30 min",
  "mix_ratio": "10:1 (resin:hardener)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes"
 },
 "pid:7819722948678": {
  "app": [
   "seaming",
   "mitering",
   "laminating"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "dark roast"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) dripless seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minutes to ~90% of ultimate strength at room temperature",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes"
 },
 "pid:7819723145286": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "marmi"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "methacrylate (MMA) two-part seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20-25 min; can be moved in 30 min; ~90% ultimate strength at 20-25 min (room-temperature cure)",
  "mix_ratio": "10:1 resin to activator (by volume/weight)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75\u00b0F/24\u00b0C"
 },
 "pid:8330943430726": {
  "app": [
   "seaming",
   "laminating",
   "repair",
   "mitering",
   "substrate-bonding"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [],
  "vendor": "K-Bond",
  "subtype": "vinyl ester",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "tack-free 10-20 min, machinable 20-30 min",
  "mix_ratio": "1-3% hardener to adhesive by volume",
  "uv_stable": null,
  "viscosity": "Knife Grade",
  "work_time": "4-6 minutes at 77F"
 },
 "pid:8384284164166": {
  "app": [
   "enhancing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "concrete"
  ],
  "disc": false,
  "type": "enhancer",
  "colors": [],
  "vendor": "Akemi",
  "subtype": "color enhancer / darkener",
  "problems": [
   "fading"
  ],
  "cure_time": "Protect treated surface from rain for approx. 24 hrs after application (manufacturer TDS states no separate full color-fixing cure duration)",
  "mix_ratio": "",
  "uv_stable": true,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:8304794173510": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "porcelain",
   "concrete"
  ],
  "disc": false,
  "type": "sealer",
  "colors": [],
  "vendor": "Akemi",
  "subtype": "solvent-based penetrating impregnator",
  "problems": [
   "stain"
  ],
  "cure_time": "Water-repellent effect develops within minutes; full protection after 2-3 hours at 50-86F (10-30C).",
  "mix_ratio": "",
  "uv_stable": true,
  "viscosity": "Liquid",
  "work_time": "Wipe off any excess that has not absorbed within about 20 minutes, before it dries on the surface."
 },
 "pid:8330942120006": {
  "app": [
   "seaming",
   "laminating",
   "repair",
   "rodding"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "buff"
  ],
  "vendor": "K-Bond",
  "subtype": "Polyester Knife Grade (buff, matte)",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "Tack-free 10-30 min; machinable in 30-60 min",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Knife Grade",
  "work_time": "5-7 minutes"
 },
 "pid:8342854303814": {
  "app": [
   "seaming",
   "laminating",
   "repair",
   "fissures",
   "rodding"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "transparent"
  ],
  "vendor": "K-Bond",
  "subtype": "polyester knife-grade paste adhesive",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "Tack-free in 20-30 minutes; machinable in 30-60 minutes at 77F (full structural cure time not published)",
  "mix_ratio": "Resin mixed with included BPO cream hardener tube (quart size ships with a 1 oz. tube); manufacturer does not publish an exact percentage for this SKU size, follow the supplied tube ratio",
  "uv_stable": null,
  "viscosity": "Paste",
  "work_time": "4-6 minutes at 77F"
 },
 "pid:7807837339718": {
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "repair",
   "rodding",
   "substrate-bonding"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "colorless"
  ],
  "vendor": "K-Bond (InnoChem LLC)",
  "subtype": "MMA hybrid, styrene-free, colorless knife grade",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "Tack-free in 15-30 minutes; machinable in 20-30 minutes",
  "mix_ratio": "2-3% BPO hardener paste to adhesive base, by weight (2% for best color/cure)",
  "uv_stable": true,
  "viscosity": "Knife Grade",
  "work_time": "5-7 minutes"
 },
 "pid:8384256770118": {
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "repair",
   "rodding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [],
  "vendor": "Superior Stone Products",
  "subtype": "Acrylic Knife-Grade Seaming Adhesive (BPO-catalyzed)",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "under 20 minutes (tack-free)",
  "mix_ratio": "1-2% BPO (white paste hardener)",
  "uv_stable": true,
  "viscosity": "Knife Grade",
  "work_time": "3-5 min gel time"
 },
 "pid:7712142196806": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "disc": false,
  "type": "sealer",
  "colors": [],
  "vendor": "Dry-Treat / STAIN-PROOF",
  "subtype": "Premium Deep-Penetrating Impregnating Sealer",
  "problems": [
   "stain",
   "water-damage"
  ],
  "cure_time": "24 hr initial cure; full bond/stain-resistance develops over 3-4 weeks",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:7819725078598": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "azul"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (acrylic) seam adhesive",
  "problems": [],
  "cure_time": "20-25 minutes fixture time at 75 F (24 C); seam can be handled after about 30 minutes",
  "mix_ratio": "10:1 (resin:activator) by weight or volume",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes open/working time at 75 F (24 C)"
 },
 "pid:7819725144134": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "vino"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (acrylic) flowable seaming adhesive",
  "problems": [],
  "cure_time": "20-25 min to ~90% ultimate strength (fixture time); can be moved in 30 min at room temp",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75\u00b0F/24\u00b0C"
 },
 "pid:7819725209670": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "blue"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-Part Methacrylate (Acrylic) Flowable Seaming Adhesive",
  "problems": [],
  "cure_time": "20-25 minutes to ~90% ultimate strength; movable at 30 minutes",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes"
 },
 "pid:7819725373510": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "putty"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes; can be moved after 30 minutes; reaches about 90% ultimate strength in 20-25 minutes at room temperature",
  "mix_ratio": "10:1 (resin:activator, by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819725602886": {
  "app": [
   "seaming",
   "repair"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "mango"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-Part Methacrylate (MMA)",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "20-25 minutes to ~90% strength; fully movable/handled at 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819725668422": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "jungle"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate (acrylic) two-part no-drip seaming adhesive",
  "problems": [],
  "cure_time": "fixture ~20-25 min; can be moved at 30 min; ~90% ultimate strength at 30 min (75 F)",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75 F / 24 C"
 },
 "pid:7819725733958": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "brume"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "Two-part methacrylate (MMA) flowable, dripless-cartridge seaming adhesive, 10:1 mix",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes to ~90% ultimate strength at 75F; can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C (65-85F operating range)"
 },
 "pid:7819725930566": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "brown"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) flowable seaming adhesive, 10:1",
  "problems": [],
  "cure_time": "Fixture time 20-25 min (~90% ultimate strength); can be moved/sanded at 30 min, room-temp cure",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819726094406": {
  "app": [
   "seaming",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "vega rose"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate (MMA) two-part no-drip acrylic seaming adhesive",
  "problems": [],
  "cure_time": "Fixture 20-25 min; movable at 30 min; ~90% ultimate strength in 30 min at room temp",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F"
 },
 "pid:7819726159942": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "sahara"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part acrylic (methyl methacrylate) seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20-25 min; movable in 30 min (room-temp cure)",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75\u00b0F/24\u00b0C"
 },
 "pid:7819726323782": {
  "app": [
   "seaming",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "oyster"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "methacrylate (MMA), two-part",
  "problems": [],
  "cure_time": "20 to 25 minutes to ~90% ultimate strength (fixture time); can be moved in 30 minutes",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819726487622": {
  "app": [
   "seaming",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "grey"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) dripless cartridge seaming adhesive",
  "problems": [],
  "cure_time": "Fixture (~90% ultimate strength) in 20 to 25 minutes at 75F/24C; can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by volume/weight)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819726553158": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "meteor grey"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "Two-part methacrylate (MMA) dripless-cartridge seaming adhesive, 10:1 mix",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minutes to ~90% ultimate strength (fixture time) at 75F/24C; can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C (65-85F operating range)"
 },
 "pid:10255118860358": {
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "repair"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "translucent"
  ],
  "vendor": "Bellinzoni",
  "subtype": "vinyl ester (BPO-hardened, knife grade)",
  "problems": [
   "crack"
  ],
  "cure_time": "Movable after 20 min; sandable/polishable after 2 hr (varies with temp and hardener %)",
  "mix_ratio": "100:1-3 (Part A : Part B BPO hardener) by weight",
  "uv_stable": null,
  "viscosity": "Knife Grade",
  "work_time": "10-12 min at approx. 72F (22C)"
 },
 "pid:7819724357702": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "tawny"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate",
  "problems": [],
  "cure_time": "20-25 minutes",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes"
 },
 "pid:8303772205126": {
  "app": [
   "repair",
   "fissures",
   "restoration"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "marble"
  ],
  "disc": false,
  "type": "filler",
  "colors": [
   "buff"
  ],
  "vendor": "Tenax",
  "subtype": "catalyzed polyester stone filler (semi-solid putty)",
  "problems": [
   "crack"
  ],
  "cure_time": "",
  "mix_ratio": "100:2-3 by weight (filler:catalyst/hardener paste)",
  "uv_stable": null,
  "viscosity": "Paste",
  "work_time": "15-20 min workability time at 77F/25C (bulk gel time approx. 1.5-2.5 min)"
 },
 "pid:8304365600838": {
  "app": [
   "fissures"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite"
  ],
  "disc": false,
  "type": "repair",
  "colors": [
   "black"
  ],
  "vendor": "Tenax",
  "subtype": "Micro-fissure and webbing concealer for dark/black granite",
  "problems": [
   "crack"
  ],
  "cure_time": "Dries in approximately 5 minutes; keep foot traffic off until fully dry",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": ""
 },
 "pid:7819726684230": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "mercury grey"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (acrylic) flowable seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20-25 min (~90% ultimate strength); can be moved in 30 min",
  "mix_ratio": "10:1 by weight/volume (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819726749766": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "limestone"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) seaming adhesive, dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 min fixture time to ~90% ultimate strength at 75 F; can be moved in 30 min",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75 F / 24 C"
 },
 "pid:7819726782534": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "black"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part no-drip acrylic/methacrylate seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes (approx 90% ultimate strength); can be moved/handled at 30 minutes",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819726946374": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "i-galaxy black"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) seaming adhesive, dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes to ~90% ultimate strength; can be moved in 30 minutes (75 F)",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75 F / 24 C"
 },
 "pid:7819727011910": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "diana pearl"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (acrylic) seam adhesive, dripless static-mix cartridge, 10:1 resin:activator",
  "problems": [],
  "cure_time": "20-25 minutes fixture time at 75F/24C; movable at 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819727077446": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "concrete"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "methacrylate (MMA) dripless seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 min to ~90% ultimate strength (fixture time); can be moved in 30 min",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75F (24C)"
 },
 "pid:7819727175750": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "cloud"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "two-part methacrylate (MMA) dripless seaming adhesive",
  "problems": [],
  "cure_time": "20-25 minutes to ~90% ultimate strength at 75F; can be moved in 30 minutes",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819727470662": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "brazilian brown"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "methacrylate",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes; can be moved in 30 minutes; full cure range 65-85F",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819727568966": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "black"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) flowable, dripless-cartridge seaming adhesive, 10:1 mix",
  "problems": [],
  "cure_time": "Fixture time 20-25 minutes to ~90% ultimate strength at 75 F / 24 C; can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75 F (24 C)"
 },
 "pid:7819727732806": {
  "app": [
   "seaming",
   "laminating"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "amazon"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate (two-part, flowable seaming adhesive)",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes; can be moved in 30 minutes (65-85F operating range)",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819727863878": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "alabaster"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) dripless seaming adhesive, color-matched",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 min to ~90% ultimate strength (fixture time); can be moved/handled in 30 min; full operating range 65-85F",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819727929414": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "grey"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "two-part methacrylate (MMA) no-drip, dripless-cartridge seaming adhesive, 10:1 mix",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minutes fixture time to ~90% ultimate strength at 75F / 24C; can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin : activator, by volume/weight)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F / 24C"
 },
 "pid:7819727994950": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "white north"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "two-part methacrylate (MMA) no-drip, dripless-cartridge seaming adhesive, 10:1 mix",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minutes fixture time to ~90% ultimate strength at 75F / 24C; can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin : activator, by volume/weight)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F / 24C"
 },
 "pid:7819728126022": {
  "app": [
   "seaming",
   "mitering",
   "laminating",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "white"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20 to 25 minutes to ~90% ultimate strength; movable in 30 minutes (room temp cure)",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75\u00b0F/24\u00b0C"
 },
 "pid:7819728191558": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "stellar grey"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "Two-part methacrylate (MMA) flowable, dripless-cartridge seaming adhesive, 10:1 mix",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minutes fixture time to ~90% ultimate strength at 75F/24C; can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin : activator, by volume/weight)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C (65-85F operating range)"
 },
 "pid:7819728289862": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "grey"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) seam adhesive, dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes (~90% ultimate strength); can be moved after 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819728355398": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "neutral"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate flowable seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20 to 25 min to ~90% strength (fixture time); can be handled at 30 min",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819728486470": {
  "app": [
   "seaming",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "mocha"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20 to 25 minutes to about 90 percent ultimate strength (fixture time); can be moved in 30 minutes",
  "mix_ratio": "10:1 resin to activator (250 mL dripless cartridge)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F (24C)"
 },
 "pid:7819728552006": {
  "app": [
   "seaming",
   "repair"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "dusk"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) flowable seaming adhesive",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min (~90% ultimate strength) at 75\u00b0F; can be moved in 30 min",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75\u00b0F / 24\u00b0C"
 },
 "pid:7819724161094": {
  "app": [
   "seaming",
   "repair"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "fossil"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-Part Methacrylate (MMA)",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "20-25 minutes to about 90% strength (fixture time); fully movable at 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819723276358": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "bento"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate (MMA) no-drip seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture 20-25 min, movable at 30 min, ~90% ultimate strength in 30 min at room temp",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7932018196550": {
  "app": [
   "sealing"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "concrete"
  ],
  "disc": false,
  "type": "sealer",
  "colors": [],
  "vendor": "FILA Solutions",
  "subtype": "water-based penetrating stone & grout sealer (natural look, no color change)",
  "problems": [
   "stain",
   "water-damage"
  ],
  "cure_time": "light foot traffic after 4 hr; full cure / max protection at 8 hr",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Liquid",
  "work_time": "10-15 min dwell before wiping off excess; apply a 2nd coat immediately the same way if still needed"
 },
 "pid:8342855057478": {
  "app": [
   "laminating",
   "repair",
   "rodding"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "clear"
  ],
  "vendor": "InnoChem LLC (K-Bond)",
  "subtype": "",
  "problems": [
   "crack"
  ],
  "cure_time": "Tack-free in 20-30 min; machinable in 30-60 min",
  "mix_ratio": "",
  "uv_stable": null,
  "viscosity": "Flowing",
  "work_time": "4 to 6 minutes"
 },
 "pid:7808008323142": {
  "app": [
   "seaming",
   "laminating",
   "repair",
   "rodding",
   "substrate-bonding"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "transparent"
  ],
  "vendor": "K-Bond (InnoChem LLC)",
  "subtype": "Knife Grade Polyester (BPO-cured)",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "Tack-free in 20-30 minutes; machinable in 30-60 minutes at 77F",
  "mix_ratio": "100:3 by weight (polyester resin : BPO hardener paste)",
  "uv_stable": null,
  "viscosity": "Knife Grade",
  "work_time": "4-6 minutes"
 },
 "pid:7819728781382": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "crystal clear"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (acrylic) flowable seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "~90% strength in 20-25 minutes (fixture time) at 75F/24C; can be moved/handled after 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by volume or weight)",
  "uv_stable": true,
  "viscosity": "Flowing",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819728814150": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "coffee"
  ],
  "vendor": "Big Dog Adhesives (SeamLock)",
  "subtype": "two-part methacrylate (MMA) flowable seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 min fixture time (~90% strength) at 75\u00b0F; full room-temp cure; shelf life 12 months unopened",
  "mix_ratio": "10:1 by volume/weight (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75\u00b0F/24\u00b0C"
 },
 "pid:7819728945222": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "amarillo"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) color-matched seaming adhesive",
  "problems": [],
  "cure_time": "20 to 25 minutes to near 90 percent ultimate strength (fixture time); full handling after 30 minutes, at 75F/24C",
  "mix_ratio": "10:1 by weight/volume (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819729207366": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "aztec gold"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes; can be moved after 30 minutes; reaches about 90% ultimate strength at 30 minutes at room temperature",
  "mix_ratio": "10:1 (resin:activator, by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819729338438": {
  "app": [
   "seaming",
   "laminating",
   "repair"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "transparent black"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "20-25 min",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min"
 },
 "pid:7819729371206": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "uba tuba"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (acrylic) seaming adhesive, pre-pigmented",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 min fixture time (~90% ultimate strength); can be moved in 30 min; room-temp cure",
  "mix_ratio": "10:1 by weight/volume (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C (65-85F operating range)"
 },
 "pid:7819729535046": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "tusk"
  ],
  "vendor": "Big Dog Adhesives (SeamLock Pro)",
  "subtype": "Two-part no-drip acrylic (methyl methacrylate) seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture 20-25 min; movable at 30 min; ~90% ultimate strength in 30 min at room temp",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min @ 75F/24C"
 },
 "pid:7819729600582": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "tidal sand"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (acrylic) dripless seam adhesive, 10:1 resin:activator",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "Fixture/handling time 20-25 min at 75F; approx. 90% strength at 30 min",
  "mix_ratio": "10:1 (resin:activator) by weight or volume",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F"
 },
 "pid:7819729633350": {
  "app": [
   "seaming",
   "mitering"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "thunder grey"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minutes to ~90% strength (fixture); movable at 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819729829958": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "silver"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part acrylic (methyl methacrylate) seaming adhesive, dripless no-sag cartridge",
  "problems": [],
  "cure_time": "20-25 min fixture time; movable at 30 min; ~90% ultimate strength in 30 min at room temp",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Paste",
  "work_time": "8-12 min at 75F/24C"
 },
 "pid:7819729895494": {
  "app": [
   "seaming",
   "mitering",
   "laminating",
   "substrate-bonding"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "oat"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) seaming adhesive, 10:1, dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "~90% ultimate strength in 20 to 25 minutes at room temperature",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes"
 },
 "pid:7819730026566": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "rhin"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part no-drip acrylic/methacrylate (MMA) dripless-cartridge seaming adhesive, 10:1 mix",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes at 75F; can be moved in 30 minutes; ~90% ultimate strength at 30 minutes at room temperature",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819730157638": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "i-rambone"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part no-drip acrylic (methacrylate) seaming adhesive, pre-pigmented 10:1 dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes; can be moved in 30 minutes; approximately 90 percent ultimate strength in 30 minutes at room temperature",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819730288710": {
  "app": [
   "seaming",
   "laminating",
   "mitering",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "pudding brown"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "methacrylate (MMA) seaming adhesive, pre-pigmented",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min; can be moved in 30 min; ~90% ultimate strength at 30 min room-temp cure",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75F/24C"
 },
 "pid:7819730419782": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "natural"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "Two-part methacrylate (MMA) no-drip, dripless-cartridge seaming adhesive, 10:1 mix",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minutes fixture time to ~90% ultimate strength at 75 F / 24 C; can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin : activator, by volume/weight)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75 F / 24 C"
 },
 "pid:7819730583622": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "lunar pearl"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate seaming adhesive, dripless cartridge",
  "problems": [],
  "cure_time": "20-25 min to approx. 90 percent ultimate strength (fixture time); can be moved in 30 min; full cure longer",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F (24C)"
 },
 "pid:7819730681926": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "espresso"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) seaming adhesive",
  "problems": [],
  "cure_time": "Fixture/~90% strength in 20-25 minutes at 75F; can be moved/handled after 30 minutes",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819726192710": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "white"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) seaming adhesive, i-series pre-pigmented",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes at 75F; movable after 30 minutes at room temperature, by which point it reaches about 90% of ultimate strength.",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819725865030": {
  "app": [
   "seaming",
   "laminating",
   "repair"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "quarry"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "20-25",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12"
 },
 "pid:7819725963334": {
  "app": [
   "seaming",
   "mitering",
   "laminating"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "zenith"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "two-part methacrylate (MMA) dripless cartridge seaming adhesive, pre-pigmented (i-Zenith color match)",
  "problems": [],
  "cure_time": "~90% ultimate strength in 20-25 minutes at room temperature (75F/24C); can be moved in 30 minutes",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes"
 },
 "pid:7819726389318": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "onyx"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes; can be moved after 30 minutes; reaches about 90% ultimate strength in 20-25 minutes at room temperature",
  "mix_ratio": "10:1 (resin:activator, by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819725471814": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "apple"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20 to 25 minutes; movable after 30 minutes; reaches about 90 percent ultimate strength in 30 minutes at room temperature",
  "mix_ratio": "10:1 resin to activator by volume",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F (24C)"
 },
 "pid:7819730780230": {
  "app": [
   "seaming",
   "mitering",
   "laminating",
   "substrate-bonding"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "pure white"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) seaming adhesive, 10:1, dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "~90% ultimate strength in 20 to 25 minutes at room temperature",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes"
 },
 "pid:7819730911302": {
  "app": [
   "seaming",
   "mitering",
   "laminating",
   "substrate-bonding"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "desert"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) seaming adhesive, 10:1, dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "~90% ultimate strength in 20 to 25 minutes at room temperature",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes"
 },
 "pid:7819731009606": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "cambrian gold"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part acrylic (methacrylate) seaming adhesive, dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "~90% strength / movable in 20-30 min; full operating range 65-85F",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75F/24C"
 },
 "pid:7819731075142": {
  "app": [
   "seaming",
   "mitering",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "i-beach"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) seaming adhesive, dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 min fixture time (~90% ultimate strength); can be moved in 30 min; full cure continues at room temp after that",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819731107910": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "autumn light"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture 20-25 min; movable in 30 min; ~90% ultimate strength at 20-25 min (75F/24C)",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819731238982": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "aqueous"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part no-drip methacrylate (acrylic) seaming adhesive, 10:1 resin:activator",
  "problems": [],
  "cure_time": "Fixture time 20-25 min (~90% ultimate strength) at 75\u00b0F; can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator), by weight or volume",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75\u00b0F (24\u00b0C)"
 },
 "pid:7819731304518": {
  "app": [
   "seaming",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "toffee"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) dripless seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min (~90% ultimate strength) at 75F; parts can be moved at 30 min; full cure longer",
  "mix_ratio": "10:1 (resin:activator) by volume/weight",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819731468358": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "acorn"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minutes to ~90% strength (fixture); movable after 30 minutes",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes"
 },
 "pid:7819731632198": {
  "app": [
   "seaming",
   "mitering",
   "laminating",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "satin black"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) seaming adhesive, dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture/~90% strength in 20 to 25 minutes at 75\u00b0F/24\u00b0C; can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator by volume/weight)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75\u00b0F/24\u00b0C"
 },
 "pid:7819731861574": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "butterscotch"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part no-drip acrylic/methacrylate (MMA) dripless-cartridge seaming adhesive, 10:1 mix (Seamlock Pro 9000)",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes at room temperature; can be moved in 30 minutes (~90% ultimate strength)",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819731927110": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "charcoal"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "two-part methacrylate (MMA) flowable, dripless-cartridge seaming adhesive, 10:1 mix",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minutes to ~90% ultimate strength (fixture time) at 75 F / 24 C; can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin : activator, by volume/weight)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75 F / 24 C"
 },
 "pid:7819731992646": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "bright white"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "two-part methacrylate (MMA) dripless-cartridge seaming adhesive, 10:1 mix, color-matched Bright White",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes to ~90% ultimate strength at 75F/24C; can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C (65-85F operating range)"
 },
 "pid:7819732156486": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "sage"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) seaming adhesive, dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 min to fixture (~90% ultimate strength); movable in 30 min",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min"
 },
 "pid:7819732287558": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "earth brown"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part no-drip acrylic/methacrylate (MMA) dripless-cartridge seaming adhesive, 10:1 mix (Seamlock Pro 9000)",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes at room temperature; can be moved in 30 minutes (~90% ultimate strength)",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:8384284229702": {
  "app": [
   "seaming",
   "mitering",
   "repair",
   "fissures"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain",
   "concrete"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "transparent",
   "white",
   "cream",
   "beige",
   "gray",
   "black",
   "red",
   "blue",
   "khaki",
   "brown"
  ],
  "vendor": "Akemi",
  "subtype": "epoxy-acrylate (polyester-resin family) 2-component pre-tinted seam/joint adhesive",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Gel",
  "work_time": "approx. 5-7 minutes at 20 C (68 F)"
 },
 "pid:7819727634502": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "beige"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 min to ~90% ultimate strength (fixture); movable at 30 min",
  "mix_ratio": "10:1 (resin:activator, by volume or weight)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819732484166": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "bone"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes; can be moved in 30 minutes (room-temperature cure)",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819732615238": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "pewter"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) dripless seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min (~90% ultimate strength) at 75\u00b0F; can be moved in 30 min",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75\u00b0F / 24\u00b0C"
 },
 "pid:7819732746310": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "white chocolate"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-Part Methacrylate Flowable Seaming Adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 min to ~90% strength (fixture time); movable at 30 min, at 75F (24C)",
  "mix_ratio": "10:1 (resin:activator, by volume/weight)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819732844614": {
  "app": [
   "seaming",
   "mitering",
   "laminating"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "flint"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minutes to about 90% ultimate strength at room temperature",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes"
 },
 "pid:7819733041222": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "boulder"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20-25 min (~90% ultimate strength) at 75F; can be moved in 30 min",
  "mix_ratio": "10:1 (resin:activator by weight/volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819733106758": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "taupe"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) dripless seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min (~90% ultimate strength) at 75\u00b0F; can be moved in 30 min",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75\u00b0F / 24\u00b0C"
 },
 "pid:7819733237830": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "i-dawn"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part no-drip acrylic (methacrylate) seaming adhesive - SeamLock Pro 9000 (SL9000) resin line, i-series pre-pigmented",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes at 75F; movable after 30 minutes, by which point it reaches about 90% of ultimate strength",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F (24C)"
 },
 "pid:7819733270598": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "casper"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (acrylic) seam adhesive, dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min (~90% ultimate strength) at 75\u00b0F; movable in 30 min; shelf life 12 months from manufacture at room temp",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75\u00b0F (24\u00b0C)"
 },
 "pid:7819733499974": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "tan"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) flowable seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 min to ~90% strength (fixture); movable after 30 min",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes"
 },
 "pid:7819733631046": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "seashell"
  ],
  "vendor": "Big Dog Adhesives (SeamLock)",
  "subtype": "two-part acrylic/methacrylate seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min; can be moved at 30 min; ~90% ultimate strength in 30 min at room temp (65-85\u00b0F / 18-30\u00b0C)",
  "mix_ratio": "10:1 (resin:activator) by weight/volume",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75\u00b0F (24\u00b0C)"
 },
 "pid:7819733794886": {
  "app": [
   "seaming",
   "mitering"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "natural grey"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) flowable seaming adhesive, dripless cartridge",
  "problems": [],
  "cure_time": "20-25 min fixture time (~90% ultimate strength); can be moved/handled at 30 min",
  "mix_ratio": "10:1 (resin:activator) by weight or volume",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75\u00b0F/24\u00b0C (65-85\u00b0F operating range)"
 },
 "pid:7819733991494": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "iron grey"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "Two-part methacrylate (MMA) seaming adhesive, dripless cartridge, 10:1 mix ratio",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20 to 25 minutes (about 90 percent ultimate strength); can be moved in 30 minutes, at 75F/24C",
  "mix_ratio": "10:1 (resin to activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819734220870": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "cinnamon spice"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (acrylic) seaming adhesive, 10:1 dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes; can be moved in 30 minutes; ~90 percent ultimate strength at 20-25 minutes",
  "mix_ratio": "10:1 by volume (resin to activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F (24C)"
 },
 "pid:7819734548550": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "winter white"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA), flowable seaming adhesive, 10:1, dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture (~90% ultimate strength) in 20-25 minutes; parts can be moved/handled after 30 minutes, all at room temperature",
  "mix_ratio": "10:1 (resin:activator, by volume/weight)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75\u00b0F (24\u00b0C); operating range 65-85\u00b0F"
 },
 "pid:7819734777926": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "polar white"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) seaming adhesive",
  "problems": [],
  "cure_time": "20 to 25 minutes to ~90% ultimate strength (can be moved in 30 minutes) at room temp",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819734876230": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (acrylic) dripless cartridge seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20 to 25 minutes at 75F/24C (~90% ultimate strength); can be moved in 30 minutes",
  "mix_ratio": "10:1 by volume/weight (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819729764422": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "storm grey"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (acrylic) flowable seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20-25 min (~90% ultimate strength); can be moved in 30 min; full cure longer",
  "mix_ratio": "10:1 by volume/weight (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75\u00b0F/24\u00b0C"
 },
 "pid:7819728683078": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "cygnus pearl"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate dripless seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minutes to ~90% ultimate strength (fixture time) at 75\u00b0F/24\u00b0C; can be moved/handled at 30 minutes",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75\u00b0F/24\u00b0C"
 },
 "pid:7819730354246": {
  "app": [
   "seaming",
   "repair"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "pearl"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-Part Methacrylate (MMA)",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "20-25 minutes to ~90% strength; fully movable/handled at 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819734941766": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "graphite"
  ],
  "vendor": "Big Dog Adhesives (SeamLock Pro)",
  "subtype": "Two-part methacrylate (MMA) dripless seaming adhesive, 10:1 resin:activator, pre-pigmented graphite",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min at 75F (~90% ultimate strength); can be moved in 30 min",
  "mix_ratio": "10:1 (resin:activator) by weight or volume",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75F/24C"
 },
 "pid:7819735400518": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "arctic white"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (acrylic) flowable seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20 to 25 minutes (about 90 percent ultimate strength); parts can be moved after 30 minutes at 75F/24C",
  "mix_ratio": "10:1 resin to activator, by weight or volume",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819735728198": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate (MMA) two-part seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min; movable in 30 min; ~90% ultimate strength in 30 min at 75F",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819736252486": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "tempest"
  ],
  "vendor": "Big Dog Adhesives (SeamLock Pro)",
  "subtype": "two-part acrylic/methacrylate no-drip seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min; movable in 30 min; ~90% ultimate strength in 30 min at room temp (65-85F)",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819736350790": {
  "app": [
   "seaming",
   "repair"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "vicenza"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-Part Methacrylate (MMA)",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "20-25 minutes to ~90% strength; fully movable/handled at 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819736580166": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "butternut"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) flowable seaming adhesive, 10:1",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minutes to approx. 90% ultimate strength; can be moved after 30 minutes (at 75F)",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F"
 },
 "pid:7819736612934": {
  "app": [
   "seaming",
   "repair"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "bisque"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-Part Methacrylate (MMA)",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "20-25 minutes to ~90% strength; fully movable/handled at 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819736744006": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "glacier white"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (acrylic) seaming adhesive, dripless cartridge",
  "problems": [],
  "cure_time": "Fixture time 20-25 min (about 90% strength); parts can be moved after 30 min",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75F/24C"
 },
 "pid:7819736842310": {
  "app": [
   "seaming",
   "repair"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "trufa"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 min to ~90% strength at 75F; movable after 30 min",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes"
 },
 "pid:7819736973382": {
  "app": [
   "seaming",
   "repair"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "celestial"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-Part Methacrylate (MMA)",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "20-25 minutes to ~90% strength; fully movable/handled at 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819737038918": {
  "app": [
   "seaming",
   "repair"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "shadow"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-Part Methacrylate (MMA)",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "20-25 minutes to ~90% strength; fully movable/handled at 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819737137222": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "brownie"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "Two-part methacrylate (MMA) flowable, dripless-cartridge seaming adhesive, 10:1 mix",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes to ~90% ultimate strength at 75F; can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C (65-85F operating range)"
 },
 "pid:7819737268294": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "reading"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (acrylic) flowable seaming adhesive, dripless 10:1 cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "~90% ultimate strength in 20-25 min; parts can be moved after 30 min (room-temp cure)",
  "mix_ratio": "10:1 (resin:activator, by volume/weight)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75\u00b0F/24\u00b0C"
 },
 "pid:7819737464902": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "sussex"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) dripless seam adhesive",
  "problems": [],
  "cure_time": "Fixture time 20-25 min (~90% ultimate strength); can be moved in 30 min",
  "mix_ratio": "10:1 (resin:activator, by volume or weight)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75F (65-85F range)"
 },
 "pid:7819737628742": {
  "app": [
   "seaming",
   "repair"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "sandshire"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-Part Methacrylate (MMA)",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "20-25 minutes to ~90% strength; fully movable/handled at 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819737890886": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "orange"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate (MMA) flowable seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20 to 25 minutes (about 90% ultimate strength) at 75F/24C; can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819731173446": {
  "app": [
   "seaming",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "ash"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) seaming adhesive, dripless cartridge (benzoyl-peroxide-cured activator)",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minutes to ~90% ultimate strength; movable at 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819732320326": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "i-slate"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) seaming adhesive, dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes to ~90 percent ultimate strength; can be moved in 30 minutes (75F)",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F / 24C"
 },
 "pid:7819731533894": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "khaki"
  ],
  "vendor": "Big Dog Adhesives (SeamLock)",
  "subtype": "Two-part acrylic/methacrylate dripless seaming adhesive (10:1), pre-pigmented",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min at 75F; can be moved in 30 min; ~90% ultimate strength at 30 min (room-temp cure)",
  "mix_ratio": "10:1 by volume (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min working time at 75F/24C"
 },
 "pid:7819737956422": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "conche"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part no-drip acrylic (methacrylate) seaming adhesive - SeamLock Pro 9000 (SL9000) resin line, pre-pigmented color variant",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes at 75F; movable after 30 minutes, by which point it reaches about 90% of ultimate strength",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F (24C)"
 },
 "pid:7819738087494": {
  "app": [
   "seaming",
   "laminating",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "battleship"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "20-25 min to ~90% strength (can be moved/handled in 30 min)",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min"
 },
 "pid:7819738153030": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "tierra"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part no-drip acrylic/methacrylate (MMA) dripless-cartridge seaming adhesive, 10:1 mix",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes at 75F; can be moved in 30 minutes (~90% ultimate strength)",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C); operating range 65-85F"
 },
 "pid:7819738382406": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "hemp"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20 to 25 minutes to ~90% ultimate strength at 75\u00b0F; movable after 30 minutes",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75\u00b0F (24\u00b0C)"
 },
 "pid:7819738513478": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "happy red"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20-25 min (~90% ultimate strength) at 75F; can be moved in 30 min",
  "mix_ratio": "10:1 (resin:activator by weight/volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819738611782": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "botticino"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-Part Methacrylate (MMA) acrylic, no-drip",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes; movable at 30 minutes; ~90% ultimate strength at 30 minutes (75F/24C)",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819738742854": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "sand storm"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part no-drip acrylic (methacrylate) seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20-25 min; can be moved in 30 min; approximately 90 percent ultimate strength at 30 min room-temp cure",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819739103302": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "leather"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate (MMA) color-matched seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture/90% strength in 20-25 min; can be moved in 30 min (75\u00b0F/24\u00b0C room-temp cure)",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75\u00b0F/24\u00b0C"
 },
 "pid:7819739201606": {
  "app": [
   "seaming",
   "mitering",
   "laminating"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "danae"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "Two-part methacrylate (MMA) dripless-cartridge seaming adhesive, pre-pigmented (Danae color match), 10:1 mix",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes; can be moved after 30 minutes; reaches about 90% ultimate strength in 20-25 minutes at room temperature",
  "mix_ratio": "10:1 (resin:activator, by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819739332678": {
  "app": [
   "seaming",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "mojave"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) dripless seaming adhesive, 10:1 cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "~90% strength (fixture) in 20 to 25 minutes at 75\u00b0F; can be moved in 30 minutes",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75\u00b0F (24\u00b0C)"
 },
 "pid:7819739463750": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "clam"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) seaming adhesive, 10:1, dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "~90% ultimate strength in 20 to 25 minutes at room temperature; movable after ~30 minutes",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes (at 75\u00b0F/24\u00b0C)"
 },
 "pid:7819739594822": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "shell"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "Two-part no-drip acrylic/methacrylate (MMA) dripless-cartridge seaming adhesive, 10:1 mix",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes at 75F; can be moved in 30 minutes (~90% ultimate strength)",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C); operating range 65-85F"
 },
 "pid:7819739725894": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "delfino"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate dripless seaming adhesive, 10:1",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20 to 25 minutes to ~90% strength (fixture time); movable in 30 minutes at 75F/24C",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819739824198": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "wood"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO 9000)",
  "subtype": "Two-part no-drip acrylic/methacrylate (MMA) seaming adhesive, 10:1 dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minute fixture time to ~90% ultimate strength (75F/24C); can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819739988038": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "rossa"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part no-drip acrylic/methacrylate (MMA) seaming adhesive, 10:1 dripless cartridge",
  "problems": [],
  "cure_time": "20-25 minute fixture time to ~90% ultimate strength (75F/24C); can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819740348486": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "honeydew"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "Two-part no-drip acrylic (methacrylate, MMA) dripless-cartridge seaming adhesive, pre-pigmented (Honeydew color match), 10:1 mix",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes; movable at 30 minutes; ~90% ultimate strength at 30 minutes (75F/24C)",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819732516934": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "pearl grey"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part no-drip acrylic (methacrylate) seaming adhesive - SeamLock Pro 9000 (SL9000) resin line, i-series pre-pigmented",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes at 75F; movable after 30 minutes, by which point it reaches about 90% of ultimate strength",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F (24C)"
 },
 "pid:7819733860422": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "almond"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20 to 25 minutes fixture time (approx 90% strength); handle after 30 minutes",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819734384710": {
  "app": [
   "seaming",
   "repair"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "champagne"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-Part Methacrylate (MMA)",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "Fixture time 20-25 minutes; can be moved/handled after 30 minutes; reaches about 90 percent ultimate strength at 30 minutes (room temp 65-85F)",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819733434438": {
  "app": [
   "seaming",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "chameleon"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min; about 90% strength at 30 min (75F)",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F"
 },
 "pid:7819733696582": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "nougat"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (acrylic) flowable seaming adhesive, 10:1 dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture 20-25 min (~90% ultimate strength); movable in 30 min",
  "mix_ratio": "10:1 (vol/wt)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819740512326": {
  "app": [
   "seaming",
   "mitering",
   "laminating"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "cherry"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) dripless seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes to ~90% of ultimate strength at room temp; can be moved in 30 minutes",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes (at 75F/24C)"
 },
 "pid:7819740643398": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "laguna"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-Part No-Drip Acrylic/Methacrylate (MMA) Seaming Adhesive, Pre-Pigmented Cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min; parts can be moved at 30 min (75\u00b0F/24\u00b0C)",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75\u00b0F/24\u00b0C"
 },
 "pid:7819740807238": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "silt"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) dripless seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20-25 minutes (~90% ultimate strength) at 75F/24C; can be moved/handled after 30 minutes",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819740938310": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "whisper"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) dripless-cartridge seaming adhesive",
  "problems": [],
  "cure_time": "20 to 25 minutes to fixture (~90% ultimate strength); can be moved at 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75\u00b0F/24\u00b0C"
 },
 "pid:7819741298758": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "bala blue"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) seaming adhesive, 10:1, dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "~90% ultimate strength in 20 to 25 minutes at room temperature; movable after ~30 minutes",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes (at 75\u00b0F/24\u00b0C)"
 },
 "pid:7819741495366": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "banana"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20 to 25 minutes to about 90 percent ultimate strength (fixture time); can be moved in 30 minutes, at 75F/24C",
  "mix_ratio": "10:1 (resin to activator, cartridge dispensed through a static mixing tip)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819741855814": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "moss stone"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) seaming adhesive, dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes to ~90% ultimate strength; can be moved in 30 minutes (75 F)",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75 F / 24 C"
 },
 "pid:7819742511174": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "riverstone"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "Two-part methacrylate (MMA) seaming adhesive, 10:1 dripless cartridge",
  "problems": [],
  "cure_time": "20-25 min fixture time (~90% ultimate strength); full handling at 30 min",
  "mix_ratio": "10:1 (resin:activator, by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75\u00b0F/24\u00b0C"
 },
 "pid:7819742642246": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "chai"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) seaming adhesive, 10:1, dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "~90% ultimate strength in 20 to 25 minutes at room temperature; movable after ~30 minutes",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes (at 75\u00b0F/24\u00b0C)"
 },
 "pid:7819742937158": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "nickel"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) seaming adhesive, 10:1, dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "~90% ultimate strength in 20 to 25 minutes at room temperature; movable after ~30 minutes",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes (at 75\u00b0F/24\u00b0C)"
 },
 "pid:7819743035462": {
  "app": [
   "seaming",
   "laminating",
   "mitering"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "ecru"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minutes to ~90% ultimate strength at room temperature",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Knife Grade",
  "work_time": "8-12 minutes"
 },
 "pid:7819743199302": {
  "app": [
   "seaming",
   "repair"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "oregano"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate (MMA), two-part dripless cartridge seam adhesive",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "Fixture time 20-25 min at 75F/24C; can be moved in 30 min; full room-temp cure window 65-85F",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75F/24C"
 },
 "pid:7819736121414": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "marone"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate (MMA) seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes; full handling strength at 30 minutes",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819735105606": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "ginger"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part no-drip acrylic/methacrylate (MMA) dripless-cartridge seaming adhesive, 10:1 mix (SeamLock Pro 9000)",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes at room temperature; can be moved in 30 minutes (~90% ultimate strength)",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819735564358": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "nacreto"
  ],
  "vendor": "Big Dog Adhesives (SeamLock Pro)",
  "subtype": "Two-part methacrylate (MMA) dripless seaming adhesive, 10:1 resin:activator, pre-pigmented Nacreto",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min at 75F (~90% ultimate strength); can be moved in 30 min",
  "mix_ratio": "10:1 (resin:activator) by weight or volume",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75F/24C"
 },
 "pid:7819743363142": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "nutmeg"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO 9000)",
  "subtype": "Two-part no-drip acrylic/methacrylate (MMA) seaming adhesive, 10:1 dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minute fixture time to ~90% ultimate strength (75F/24C); can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819743559750": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "orange"
  ],
  "vendor": "Big Dog Adhesives (SeamLock)",
  "subtype": "two-part methacrylate (MMA) dripless seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "~90% strength in 20-25 min at 75F; can be moved/handled at 30 min",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819743756358": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "lime"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO 9000)",
  "subtype": "Two-part no-drip clear acrylic/methacrylate (MMA) seaming adhesive, 10:1 dripless cartridge (SeamLock Pro 9000)",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minute fixture time to ~90% ultimate strength (75F/24C); can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C (65-85F operating range)"
 },
 "pid:7819744084038": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "flax"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) flowable seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture/~90% strength in 20-25 min; can be moved in 30 min (room-temp cure)",
  "mix_ratio": "10:1 (resin:activator, by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75\u00b0F/24\u00b0C (65-85\u00b0F operating range)"
 },
 "pid:7819744444486": {
  "app": [
   "seaming",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "malt"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate seaming adhesive",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "Fixture time 20-25 min (~90% ultimate strength); can be moved in 30 min at 75F/24C",
  "mix_ratio": "10:1 (vol/wt), resin:activator",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819744575558": {
  "app": [
   "seaming",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "ash"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) no-drip/dripless seaming adhesive, pre-pigmented color-matched cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min (~90% ultimate strength); can be moved in 30 min at 75\u00b0F/24\u00b0C",
  "mix_ratio": "10:1 resin:activator (weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75\u00b0F/24\u00b0C"
 },
 "pid:7819744870470": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "fire"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO 9000)",
  "subtype": "Two-part no-drip acrylic/methacrylate (MMA) seaming adhesive, 10:1 dripless cartridge (SeamLock Pro 9000)",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minute fixture time; ~90% ultimate strength reached within 30 minutes; can be moved in 30 minutes (75F/24C)",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C (65-85F operating range)"
 },
 "pid:7819745034310": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "mandarin"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) dripless seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 min fixture time (about 90% strength); full handling at 30 min",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819745263686": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "hot"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate",
  "problems": [],
  "cure_time": "20-25 minute fixture time (~90% ultimate strength); parts can be moved at 30 minutes",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F"
 },
 "pid:7819745427526": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "sun"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) dripless seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes; can be moved in 30 minutes; ~90% ultimate strength in 20-25 min at room temp",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C (65-85F operating range)"
 },
 "pid:7819745624134": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "camel"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate",
  "problems": [],
  "cure_time": "20-25 minute fixture time (~90% ultimate strength); parts can be moved at 30 minutes",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F"
 },
 "pid:7819746148422": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "umber"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate flowable seaming adhesive",
  "problems": [],
  "cure_time": "20-25 min fixture time (~90% strength); can be moved in 30 min; full cure longer",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819746312262": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "mesa"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (acrylic) flowable seaming adhesive",
  "problems": [],
  "cure_time": "20-25 min fixture time (about 90 percent ultimate strength); can be moved in 30 min",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75F/24C"
 },
 "pid:7819746508870": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "frosty"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) seaming adhesive, 10:1 dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min (~90% ultimate strength); can be moved after 30 min",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes working time at 75F/24C"
 },
 "pid:7819746738246": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "design"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA), dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 min fixture time (~90% ultimate strength); movable at 30 min",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75\u00b0F/24\u00b0C (operating range 65-85\u00b0F)"
 },
 "pid:7819738316870": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "crimson"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) dripless seaming adhesive, 10:1 cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes (about 90 percent of ultimate strength) at 75F/24C; parts can be moved after 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819740217414": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "pomegranite"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (acrylic) seaming adhesive, 10:1 resin:activator dripless cartridge",
  "problems": [],
  "cure_time": "Fixture time 20-25 min (~90% ultimate strength); can be moved in 30 min at room temp",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C (65-85F operating range)"
 },
 "pid:7819746869318": {
  "app": [
   "seaming",
   "repair"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "nova"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-Part Methacrylate (MMA)",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "20-25 minutes to ~90% strength; fully movable/handled at 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819747000390": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "designer white"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate (MMA), two-part",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 min fixture to ~90% strength; movable in 30 min",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75F/24C"
 },
 "pid:7819747164230": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "tower bone"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate flowable seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 min fixture time to ~90% ultimate strength at 75\u00b0F/24\u00b0C; can be moved/handled after 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75\u00b0F/24\u00b0C"
 },
 "pid:7819747229766": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "tower bisque"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate (MMA) seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes; full handling strength at 30 minutes",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819747590214": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "cherry pink"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO 9000)",
  "subtype": "Two-part no-drip acrylic/methacrylate (MMA) seaming adhesive, 10:1 dripless cartridge (SeamLock Pro 9000)",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minute fixture time to ~90% ultimate strength (75F/24C); can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C (65-85F operating range)"
 },
 "pid:7819747819590": {
  "app": [
   "seaming",
   "mitering"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "fieldstone"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) dripless-cartridge seaming adhesive, 10:1 mix, pre-pigmented i-Fieldstone color match",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "~90% ultimate strength in 20-25 minutes at room temp (65-85F); can be moved/handled after 30 minutes",
  "mix_ratio": "10:1 resin:activator",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F (24C)"
 },
 "pid:7819748081734": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "antique blue"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "two-part methacrylate (MMA) flowable, dripless-cartridge seaming adhesive, 10:1 mix",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min (~90% ultimate strength) at 75\u00b0F; can be moved at 30 min",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75\u00b0F (24\u00b0C)"
 },
 "pid:7819748376646": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "tornado gray"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "two-part methacrylate (MMA) no-drip, dripless-cartridge seaming adhesive, 10:1 mix (SeamLock Pro 9000)",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minutes fixture time to ~90% ultimate strength at 75F/24C; can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F (24C)"
 },
 "pid:7819748442182": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "snow white"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20 to 25 minutes; can be moved in 30 minutes; about 90 percent ultimate strength in 30 minutes at room temperature",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F (24C)"
 },
 "pid:7819748638790": {
  "app": [
   "seaming",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "pitch stone"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) dripless seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 min fixture time (about 90 percent strength); parts can be moved after 30 min",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819748737094": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "titanium"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (acrylic) seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes at 75F/24C; ~90% ultimate strength and safe to move in 30 minutes at room temperature",
  "mix_ratio": "10:1 (resin : activator, by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819748835398": {
  "app": [
   "seaming",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "midnight stone"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate (MMA) two-part dripless seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture 20-25 min; movable after 30 min at 75F (24C)",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819749228614": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "coal"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate/acrylic seaming adhesive, dripless cartridge",
  "problems": [],
  "cure_time": "Fixture time 20-25 min at 75\u00b0F; movable in 30 min",
  "mix_ratio": "10:1 by weight or volume (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75\u00b0F/24\u00b0C"
 },
 "pid:7819749556294": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "espresso"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part no-drip acrylic/methacrylate seaming adhesive, dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture/~90% strength in 20-25 min; can be moved in 30 min (room temp cure, 65-85F)",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819749654598": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "new concrete"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part acrylic (methacrylate) no-drip seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20 to 25 minutes; can be moved in 30 minutes (at 75\u00b0F/24\u00b0C, ~90% ultimate strength)",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75\u00b0F/24\u00b0C"
 },
 "pid:7819742380102": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "aluminum"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (acrylic) flowable/dripless seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min; ~90% ultimate strength at 20-25 min; can be moved in 30 min (room temp cure)",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes (at 75\u00b0F/24\u00b0C)"
 },
 "pid:7819741954118": {
  "app": [
   "seaming",
   "mitering",
   "laminating"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "chestnut"
  ],
  "vendor": "Big Dog Adhesives (SeamLock Pro)",
  "subtype": "two-part methacrylate (MMA) dripless seaming adhesive, 10:1 resin/activator cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minutes to about 90% of ultimate strength at room temperature; piece can typically be moved by about 30 minutes",
  "mix_ratio": "10:1 (resin : activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at approximately 70-75F room temperature"
 },
 "pid:7819741167686": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "dover"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part no-drip acrylic (methacrylate) seaming adhesive, pre-pigmented color-matched cartridge",
  "problems": [],
  "cure_time": "Fixture time 20-25 min at 75F/24C; movable at 30 min; approximately 90 percent of ultimate bond strength reached at 30 min",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 65-85F (75F/24C typical)"
 },
 "pid:7819749851206": {
  "app": [
   "seaming",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "clay"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) seam adhesive, pre-pigmented cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes; movable in 30 minutes; about 90 percent ultimate strength in 30 minutes at room temperature",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819749916742": {
  "app": [
   "seaming",
   "laminating",
   "repair"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "shale"
  ],
  "vendor": "Big Dog Adhesives (SeamLock Pro)",
  "subtype": "Two-part methacrylate (MMA) dripless cartridge seaming adhesive, 10:1 resin:activator, pre-pigmented Shale",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "Fixture time 20-25 minutes (~90% ultimate strength); full handling strength at 30 minutes",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819750277190": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "smoke"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part acrylic/methacrylate no-drip seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20 to 25 minutes (about 90% ultimate strength); can be moved in 30 minutes at 75F/24C",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819750441030": {
  "app": [
   "seaming",
   "repair"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "thunder"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-Part Methacrylate (MMA)",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "20-25 minutes to ~90% strength; fully movable/handled at 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819750637638": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "lava"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "methacrylate (MMA two-part acrylic seaming adhesive)",
  "problems": [],
  "cure_time": "20-25 min fixture time; movable at 30 min; ~90% ultimate strength at 30 min (room temp cure)",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819750768710": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "olive"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "Two-part no-drip acrylic/methacrylate (MMA) seaming adhesive, 10:1 dripless cartridge (SeamLock Pro 9000 line)",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minute fixture time to ~90% ultimate strength (75F/24C); can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C (65-85F operating range)"
 },
 "pid:7819751227462": {
  "app": [
   "seaming",
   "mitering",
   "laminating"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "gray"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) acrylic seaming adhesive, pre-pigmented, dripless cartridge",
  "problems": [],
  "cure_time": "Fixture time 20-25 min; can be moved in 30 min; approximately 90 percent ultimate strength in 20-25 min at 75F",
  "mix_ratio": "10:1 (resin:activator, by volume/weight)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819751358534": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "prairie"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture / movable in 20-30 minutes; about 90 percent ultimate strength in 30 minutes at room temperature",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819751489606": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "ore"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part acrylic (methacrylate/MMA) seaming adhesive",
  "problems": [],
  "cure_time": "20-25 min fixture time; movable after 30 min; ~90% ultimate strength in 30 min at room temp",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819751587910": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "gray"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate (MMA) two-part seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 min fixture time; movable in 30 min (75F/24C)",
  "mix_ratio": "10:1 (resin:activator by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75F/24C"
 },
 "pid:7819751751750": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "slate"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate dripless seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minutes to ~90% ultimate strength at room temp; can be moved/handled after 30 minutes",
  "mix_ratio": "10:1 (resin:activator by volume/weight)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C (65-85F operating range)"
 },
 "pid:7819751850054": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "archer grey"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part acrylic/methacrylate dripless seaming adhesive (SeamLock Pro 9000 family)",
  "problems": [],
  "cure_time": "Fixture time 20-25 min; can be moved in 30 min; ~90% ultimate strength at 30 min (75\u00b0F/24\u00b0C)",
  "mix_ratio": "10:1 (resin:activator, by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75\u00b0F/24\u00b0C"
 },
 "pid:7819752177734": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "dove shimmer"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate (two-part acrylic)",
  "problems": [],
  "cure_time": "Fixture 20-25 min; movable at 30 min (at 75F/24C)",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min (at 75F/24C)"
 },
 "pid:7819752243270": {
  "app": [
   "seaming",
   "mitering",
   "laminating"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "titanium grey"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) seaming adhesive, 10:1, dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 min fixture time; can be moved in 30 min; ~90% ultimate strength at 30 min, 75\u00b0F",
  "mix_ratio": "10:1 (resin:activator, by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75\u00b0F/24\u00b0C"
 },
 "pid:7819752472646": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "splendor gray"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part acrylic/methacrylate seaming adhesive (10:1), pre-pigmented color match",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min; ~90% of ultimate strength and can be moved in 30 min at 75\u00b0F room temperature",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75\u00b0F (24\u00b0C)"
 },
 "pid:7819744772166": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "silver"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate",
  "problems": [],
  "cure_time": "20-25 minute fixture time, movable in 30 minutes, ~90% strength in 30 minutes at room temperature",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F"
 },
 "pid:7819745951814": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "pudding"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (acrylic) seaming adhesive, dripless/no-sag, factory pre-pigmented",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes; can be moved at 30 minutes; ~90% of ultimate strength reached at 30 minutes (75F/24C room-temp cure)",
  "mix_ratio": "10:1 by weight or volume (resin : activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C (65-85F operating range)"
 },
 "pid:7819742183494": {
  "app": [
   "seaming",
   "repair"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "coffee"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (acrylic) flowable seaming adhesive",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "20-25 min to ~90% ultimate strength; can be moved/handled in 30 min",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C (65-85F operating range)"
 },
 "pid:7819752636486": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "urban grey"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part acrylic/methacrylate seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min; movable in 30 min; ~90% ultimate strength at 30 min (75F/24C)",
  "mix_ratio": "10:1 (resin:activator, by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75F/24C"
 },
 "pid:7819752964166": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "skye"
  ],
  "vendor": "Big Dog Adhesives (SeamLock Pro)",
  "subtype": "Two-part no-drip acrylic (methyl methacrylate) seaming adhesive, pre-pigmented Skye shade, 10:1 resin:activator",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture 20-25 min; movable at 30 min; ~90% ultimate strength in 30 min at room temp",
  "mix_ratio": "10:1 (resin:activator, by weight/volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75F/24C (65-85F operating range)"
 },
 "pid:7819753357382": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "universe"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) dripless seaming adhesive",
  "problems": [],
  "cure_time": "20-25 minute fixture time; ~90% ultimate strength and can be moved in 30 minutes at 75\u00b0F",
  "mix_ratio": "10:1 (resin:activator, by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75\u00b0F (24\u00b0C)"
 },
 "pid:7819753390150": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "red lava"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-Part Methacrylate (MMA)",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes; movable/handleable at 30 minutes; ~90% ultimate strength at 30 minutes (75F)",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819753553990": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "red"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part acrylic/methacrylate seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minutes to ~90% strength (fixture time); can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819753816134": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "hazel"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) dripless seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20 to 25 minutes; can be moved in 30 minutes; ~90% ultimate strength in 30 minutes at room temperature (65-85F)",
  "mix_ratio": "10:1 (resin:activator) by volume/weight",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819754045510": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "copper"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part acrylic (methacrylate) dripless seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20 to 25 minutes; parts can be moved in 30 minutes at room temperature",
  "mix_ratio": "10:1 (resin to activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F (operating range 65-85F)"
 },
 "pid:7819754242118": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "orange zest"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate (MMA)",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minutes (fixture); 30 minutes to move",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes"
 },
 "pid:7819754373190": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "sunshine"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) seaming adhesive, dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes; can be moved in 30 minutes; ~90% ultimate strength in 30 minutes (75 F)",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75 F / 24 C"
 },
 "pid:7819754504262": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "roast"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part no-drip acrylic/methacrylate (MMA) seaming adhesive, 10:1 resin:activator, pre-pigmented dripless cartridge (SeamLock Pro 9000 line)",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min at 75\u00b0F/24\u00b0C; can be moved in 30 min; reaches ~90% ultimate strength at 30 min",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75\u00b0F/24\u00b0C"
 },
 "pid:7819754799174": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "suede"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part no-drip methacrylate (acrylic) seaming adhesive",
  "problems": [],
  "cure_time": "20 to 25 minutes to ~90% strength (fixture time); can be moved/handled after 30 minutes at 75F",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F (24C)"
 },
 "pid:7819754831942": {
  "app": [
   "seaming",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "chocolate"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part no-drip acrylic (methacrylate) seaming adhesive, 10:1 dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20 to 25 minutes at 75F; parts can be moved in 30 minutes; about 90 percent of ultimate strength at 30 minutes, room temperature",
  "mix_ratio": "10:1 (resin : activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F (24C)"
 },
 "pid:7819754963014": {
  "app": [
   "seaming",
   "repair"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "cocoa"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-Part Methacrylate (MMA)",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "Fixture time 20-25 minutes; movable/handled at 30 minutes; ~90% ultimate strength at 30 minutes (75F/24C)",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819755028550": {
  "app": [
   "seaming",
   "repair"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "mocha"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-Part Methacrylate (MMA)",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "Fixture time 20-25 minutes; movable/handled at 30 minutes; ~90% ultimate strength at 30 minutes (75F/24C)",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819755159622": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "toffee"
  ],
  "vendor": "Big Dog Adhesives (SeamLock Pro)",
  "subtype": "methacrylate (acrylic) two-part seam adhesive, 10:1 resin:activator",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min; can be moved in 30 min; ~90% ultimate strength in 30 min at room temp (75F); gap-fill limit 0.50 in",
  "mix_ratio": "10:1 (resin:activator) by volume/weight",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F (24C); 65-85F operating range"
 },
 "pid:7819755225158": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "sonora"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (acrylic) seaming adhesive, dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min; movable after 30 min; about 90 percent ultimate strength at 30 min (75F room temp)",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75F/24C"
 },
 "pid:7819749359686": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "oyster"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "no-drip acrylic (methacrylate) two-part seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20 to 25 minutes at 75F/24C; can be moved in 30 minutes; reaches about 90 percent ultimate strength in 30 minutes at room temperature",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819747393606": {
  "app": [
   "seaming",
   "repair"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "horizon haze"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-Part Methacrylate (MMA)",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "Fixture time 20-25 minutes at 75F/24C; reaches approximately 90 percent ultimate strength and can be handled/moved at 30 minutes (room-temperature cure)",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C (operating range 65-85F/18-30C)"
 },
 "pid:7819748245574": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "sandstone"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA), dripless cartridge, 10:1",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 min fixture time; ~90% ultimate strength reached and parts can be moved at 30 min; room-temperature cure",
  "mix_ratio": "10:1 (Resin:Activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75 F / 24 C"
 },
 "pid:7819747983430": {
  "app": [
   "seaming",
   "mitering"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "placid"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) dripless seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min at 75F, undisturbed; can be moved and reaches ~90% ultimate strength at 30 min (two distinct milestones)",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F (24C)"
 },
 "pid:7819735236678": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "cinder"
  ],
  "vendor": "Big Dog Adhesives (SeamLock Pro)",
  "subtype": "Two-part methacrylate (MMA) dripless seaming adhesive, 10:1 resin:activator, pre-pigmented cinder",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min at 75F (~90% ultimate strength); can be moved in 30 min",
  "mix_ratio": "10:1 (resin:activator) by weight or volume",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75F/24C"
 },
 "pid:7819755356230": {
  "app": [
   "seaming",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "fawn"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (acrylic) seaming adhesive, pre-pigmented 10:1 dripless cartridge",
  "problems": [],
  "cure_time": "Fixture time 20-25 min (~90% of ultimate strength); parts can be moved after 30 min at 75\u00b0F",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75\u00b0F / 24\u00b0C"
 },
 "pid:7819755454534": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "willow"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part acrylic (methacrylate) seaming adhesive, 10:1 dripless cartridge",
  "problems": [],
  "cure_time": "Fixture time 20 to 25 minutes (nearly 90% ultimate strength); parts can be moved in 30 minutes, at 75F/24C",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819755520070": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "latte"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part acrylic (methacrylate) no-drip seaming adhesive",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "Fixture time 20 to 25 minutes at 75F/24C; movable in 30 minutes; ~90% ultimate strength in 30 minutes",
  "mix_ratio": "10:1 (resin:activator) by weight or volume",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819755651142": {
  "app": [
   "seaming",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "dune"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate (MMA) no-drip seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 min fixture time; ~90% ultimate strength at 30 min (75F)",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75F"
 },
 "pid:7819755683910": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "serene"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part no-drip acrylic (methacrylate) seaming adhesive, 10:1",
  "problems": [],
  "cure_time": "20-25 min fixture time; movable at 30 min; ~90% ultimate strength at 30 min (room temp)",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819755814982": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "redfire"
  ],
  "vendor": "Big Dog Adhesives (SeamLock Pro)",
  "subtype": "two-part methacrylate (MMA) no-drip seaming adhesive, dual-cartridge, 10:1 resin:activator",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min at 75F; can be moved in 30 min; ~90% ultimate strength in 30 min at room temp; gap-fill limit 0.50 in",
  "mix_ratio": "10:1 (resin:activator) by weight/volume",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F (24C); operating range 65-85F (18-30C)"
 },
 "pid:7819755913286": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "grey nature"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "methacrylate",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min at 75\u00b0F; movable after 30 min; ~90% ultimate strength in 30 min at room temp",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75\u00b0F/24\u00b0C"
 },
 "pid:7819756011590": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "quartzite",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "warm nature"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methyl methacrylate (MMA) resin + benzoyl-peroxide activator, 10:1 dual-barrel cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes; movable after 30 minutes; about 90 percent ultimate strength at 30 minutes at room temperature",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819756306502": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "caramel"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "methyl methacrylate (MMA) acrylic, two-part 10:1",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min; can be moved in 30 min; approximately 90 percent of ultimate strength in 30 min at room temperature",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819756372038": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "cream"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) dripless cartridge seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20-25 min at 75F; parts can be moved after 30 min",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819756437574": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "manilla"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "Two-part no-drip acrylic/methacrylate (MMA) seaming adhesive, 10:1 dripless cartridge (SeamLock Pro 9000 line)",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minute fixture time to ~90% ultimate strength (75F/24C); can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C (65-85F operating range)"
 },
 "pid:7819756535878": {
  "app": [
   "seaming",
   "mitering",
   "laminating",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "beach"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) dripless seaming adhesive, 10:1",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes (~90% strength); movable in 30 minutes",
  "mix_ratio": "10:1 (resin:activator by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819756666950": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "butter"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part acrylic (methacrylate) seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes; movable at 30 minutes (at 75F); ~90% ultimate strength in 30 minutes at room temperature",
  "mix_ratio": "10:1 (resin:activator, by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819756830790": {
  "app": [
   "seaming",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "blonde"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (acrylic) seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20-25 min; movable in 30 min; ~90% ultimate strength in 30 min at room temp",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75\u00b0F (24\u00b0C)"
 },
 "pid:7819741069382": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "devon"
  ],
  "vendor": "Big Dog Adhesives (SeamLock)",
  "subtype": "two-part methacrylate (MMA) flowable seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20 to 25 minutes; reaches ~90% ultimate strength and can be moved in 30 minutes, at 75F/24C",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819750965318": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "mist gray"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate (no-drip acrylic) seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 min to ~90% strength (fixture time); movable in 30 min at 75F/24C",
  "mix_ratio": "10:1 (resin:activator, by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819751063622": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "pewter"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "methacrylate/acrylic seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min; parts can be moved at 30 min (75F/24C)",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75F/24C"
 },
 "pid:7819756994630": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "misty"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "Two-part no-drip acrylic/methacrylate (MMA) seaming adhesive, 10:1 dripless cartridge (SeamLock Pro 9000 line)",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minute fixture time to ~90% ultimate strength (75F/24C); can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C (65-85F operating range)"
 },
 "pid:7819757158470": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "sand"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part acrylic (methyl methacrylate) dripless cartridge seaming adhesive, 10:1 mix ratio",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 min fixture time; can be moved in 30 min; ~90% ultimate strength in 30 min at room temp",
  "mix_ratio": "10:1 (resin:activator, by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819757224006": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "natural"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (acrylic) seaming adhesive, no-drip",
  "problems": [],
  "cure_time": "Fixture time 20-25 min at 75F; movable in 30 min; ~90% ultimate strength at 30 min room-temp cure",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819757387846": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "fog"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (acrylic) seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20-25 min; parts can be moved in 30 min; ~90% ultimate strength at 30 min, room temp",
  "mix_ratio": "10:1 by volume/weight (resin : activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819757453382": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "clear"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) no-drip seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20-25 minutes; movable at 30 minutes; ~90% ultimate strength in 30 minutes at room temperature",
  "mix_ratio": "10:1 (resin : activator, by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819757617222": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "inf8701"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "Two-part no-drip acrylic/methacrylate (MMA) seaming adhesive, 10:1 dripless cartridge (SeamLock Pro 9000 line)",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minute fixture time to ~90% ultimate strength (75F/24C); can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C (65-85F operating range)"
 },
 "pid:7819757649990": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "arctic"
  ],
  "vendor": "Big Dog Adhesives (SeamLock)",
  "subtype": "two-part no-drip acrylic (methacrylate) seaming adhesive, pre-pigmented",
  "problems": [],
  "cure_time": "Fixture time 20-25 min; can be moved in 30 min; approx. 90% ultimate strength at 30 min (75 F / 24 C)",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75 F / 24 C"
 },
 "pid:7819757912134": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "cloud"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part acrylic/methacrylate (MMA) seaming adhesive, dripless 10:1 static-mix cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min at 75F/24C; can be moved in 30 min; ~90% ultimate strength in 30 min",
  "mix_ratio": "10:1 (resin:activator) by volume",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819758010438": {
  "app": [
   "seaming",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "white"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (acrylic) seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min; movable in 30 min; ~90% ultimate strength in 30 min at room temp",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75 F (24 C)"
 },
 "pid:7819758075974": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "newport"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "20-25 minutes (fixture); ~90% strength at 30 minutes; movable at 30 minutes",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes"
 },
 "pid:7819758141510": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "ghost"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate (MMA) seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes; can be moved in 30 minutes; ~90% ultimate strength at 30 minutes (75F)",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819758338118": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "blizzard"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "Two-part no-drip acrylic/methacrylate (MMA) seaming adhesive, 10:1 dripless cartridge (SeamLock Pro 9000 line)",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minute fixture time to ~90% ultimate strength (75F/24C); can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C (65-85F operating range)"
 },
 "pid:7819758436422": {
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "canvas"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part no-drip acrylic/methacrylate (MMA) seaming adhesive, 10:1 dripless cartridge",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "20-25 minute fixture time to ~90% ultimate strength (75F/24C); can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819758501958": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "glacier"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "Two-part no-drip acrylic/methacrylate (MMA) seaming adhesive, 10:1 dripless cartridge (SeamLock Pro 9000 line)",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minute fixture time to ~90% ultimate strength (75F/24C); can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C (65-85F operating range)"
 },
 "pid:7819752833094": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "elbert"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate (MMA) acrylic, two-part, 10:1",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min; movable at 30 min; ~90% ultimate strength at 30 min; operating range 65-85F",
  "mix_ratio": "10:1 (resin:activator, by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819758567494": {
  "app": [
   "seaming",
   "repair"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "satin"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate (MMA) two-part resin/activator",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "20-25 min fixture time; ~90% ultimate strength at 30 min; full handling 30 min",
  "mix_ratio": "10:1 (resin:activator, by volume/weight)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819758698566": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "antique"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) dripless seaming adhesive",
  "problems": [],
  "cure_time": "fixture time 20-25 min (~90% ultimate strength) at 75F/24C; can be moved in 30 min",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75F/24C"
 },
 "pid:7819758796870": {
  "app": [
   "seaming",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "snow"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 min fixture (90% strength); 30 min to move",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min"
 },
 "pid:7819758862406": {
  "app": [
   "seaming",
   "repair"
  ],
  "env": [
   "interior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "porcelain"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-Part Methacrylate (MMA)",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "20-25 minutes to ~90% ultimate strength; fully movable/handled at 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819758993478": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "marble"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate",
  "problems": [],
  "cure_time": "20-25 minute fixture time (~90% ultimate strength); parts can be moved at 30 minutes",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F"
 },
 "pid:7819759059014": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "vanilla"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "Two-part no-drip acrylic/methacrylate (MMA) seaming adhesive, 10:1 dripless cartridge (SeamLock Pro 9000 line)",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minute fixture time to ~90% ultimate strength (75F/24C); can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C (65-85F operating range)"
 },
 "pid:7819759157318": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "cotton stone"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (acrylic) seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20 to 25 minutes; can be moved/handled at 30 minutes (room temp 65-85\u00b0F)",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75\u00b0F/24\u00b0C"
 },
 "pid:7819759222854": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "brilliant"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO 9000)",
  "subtype": "Two-part no-drip clear acrylic/methacrylate (MMA) seaming adhesive, 10:1 dripless cartridge (SeamLock Pro 9000)",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 minute fixture time to ~90% ultimate strength (75F/24C); can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C (65-85F operating range)"
 },
 "pid:7819759288390": {
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "bright"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part no-drip acrylic/methacrylate (MMA) seaming adhesive, 10:1 dripless cartridge",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "20-25 minute fixture time to ~90% ultimate strength (75F/24C); can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819759386694": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "winter"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate (MMA) no-drip seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 min fixture time; movable after 30 min; ~90% ultimate strength at 30 min (75F)",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75F/24C"
 },
 "pid:7819759517766": {
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "salo"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part no-drip acrylic/methacrylate (MMA) seaming adhesive, 10:1 dripless cartridge",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "20-25 minute fixture time to ~90% ultimate strength (75F/24C); can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819759681606": {
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "messina"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part no-drip acrylic/methacrylate (MMA) seaming adhesive, 10:1 dripless cartridge",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "20-25 minute fixture time to ~90% ultimate strength (75F/24C); can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819759714374": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "uliano"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-Part Methacrylate (MMA)",
  "problems": [],
  "cure_time": "Fixture time 20-25 minutes; ~90% ultimate strength and can be moved/handled at 30 minutes (room temp cure)",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819759976518": {
  "app": [
   "seaming",
   "mitering",
   "laminating"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "balsa"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) seaming adhesive, 10:1 cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "~90% ultimate strength in 20-25 min fixture time at 75F; can be moved in 30 min",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819760173126": {
  "app": [
   "seaming",
   "laminating",
   "repair",
   "mitering"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "raven"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "20-25",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12"
 },
 "pid:7819760402502": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "silverite"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part no-drip acrylic (methacrylate) seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture 20-25 min; movable at 30 min; about 90 percent ultimate strength at 30 min (75F)",
  "mix_ratio": "10:1 (resin:activator, by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75F (24C)"
 },
 "pid:7819760631878": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "c neutral"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part acrylic (methacrylate) dripless-cartridge seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20-25 min; can be moved at 30 min; ~90% ultimate strength at 30 min (room temp)",
  "mix_ratio": "10:1 (resin:activator, by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75\u00b0F/24\u00b0C"
 },
 "pid:7819756240966": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "torano"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (acrylic) no-drip seaming adhesive, 10:1",
  "problems": [],
  "cure_time": "Fixture time 20 to 25 minutes; movable in 30 minutes; approximately 90% ultimate strength in 30 minutes at room temperature",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819760861254": {
  "app": [
   "seaming",
   "mitering",
   "laminating"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "cedar"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "Two-part methacrylate (MMA) dripless-cartridge seaming adhesive, pre-pigmented (p-Cedar color match), 10:1 mix",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes; can be moved after 30 minutes; reaches about 90% ultimate strength in 20-25 minutes at room temperature",
  "mix_ratio": "10:1 (resin:activator, by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F (24C)"
 },
 "pid:7819760926790": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "dove"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) no-drip seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes at 75F/24C; movable at 30 minutes; about 90 percent ultimate strength at 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819761090630": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "suede"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) color-matched seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20-25 minutes at 75\u00b0F (~90% ultimate strength); can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75\u00b0F/24\u00b0C"
 },
 "pid:7819761385542": {
  "app": [
   "seaming",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "pumice"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (acrylic) seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min; movable in 30 min; ~90% ultimate strength in 30 min at room temp",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75 F (24 C)"
 },
 "pid:7819761483846": {
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "sabbia"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part no-drip acrylic/methacrylate (MMA) seaming adhesive, 10:1 dripless cartridge",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "20-25 minute fixture time to ~90% ultimate strength (75F/24C); can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819761680454": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "wool"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part no-drip methacrylate seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min; can be moved in 30 min; ~90% ultimate strength in 30 min at room temp",
  "mix_ratio": "10:1 (resin:activator) by weight or volume",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C (65-85F operating range)"
 },
 "pid:7819761877062": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "p-lead"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA) seaming adhesive, dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes to ~90% ultimate strength; can be moved in 30 minutes (75 F)",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75 F / 24 C"
 },
 "pid:7819761942598": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "weeping willow"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (acrylic) seaming adhesive, no-drip",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min; ~90% ultimate strength and can move part at 30 min",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F"
 },
 "pid:7819762171974": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "cocoa"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (acrylic) seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20-25 min (~90% ultimate strength) at 75\u00b0F; safe to move parts after 30 min",
  "mix_ratio": "10:1 (resin:activator by volume/weight)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75\u00b0F (24\u00b0C)"
 },
 "pid:7819762368582": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "clamshell"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) no-drip seaming adhesive, 10:1",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20 to 25 minute fixture time; about 90 percent of ultimate strength in 30 minutes at room temperature (75F/24C)",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes working time at 75F/24C"
 },
 "pid:7819762434118": {
  "app": [
   "seaming",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "birch"
  ],
  "vendor": "Big Dog Adhesives (SeamLock PRO)",
  "subtype": "two-part acrylic/methacrylate seaming adhesive (no-drip)",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min; parts can be moved in 30 min; approx 90 percent ultimate strength in 30 min at room temp",
  "mix_ratio": "10:1 (resin:activator, by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819762499654": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "mountain"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "methacrylate (MMA) two-part seaming adhesive, 10:1 cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min; can be moved in 30 min; ~90% ultimate strength at 30 min room-temp cure",
  "mix_ratio": "10:1 (resin:activator by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819762565190": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "alabaster"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part acrylic (methacrylate) seaming adhesive",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20 to 25 minutes at 75F; can be moved in 30 minutes; reaches about 90 percent of ultimate strength in 30 minutes at room-temperature cure",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75F (24C)"
 },
 "pid:7819758272582": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "opal"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (acrylic) dripless seaming adhesive, pre-pigmented",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "20-25 min fixture time; movable after 30 min; about 90 percent of ultimate strength in 30 min at room temp",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 min at 75F/24C"
 },
 "pid:7819757551686": {
  "app": [
   "seaming",
   "repair"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "sterling white"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-Part Methacrylate (MMA)",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "20-25 minutes to ~90% strength; fully movable/handled at 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819762991174": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "blanco"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "methacrylate (MMA) acrylic seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20-25 min; ~90% ultimate strength and can be moved at 30 min (75F); full cure longer",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819763155014": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "raven"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate seaming adhesive",
  "problems": [],
  "cure_time": "20 to 25 min fixture time; ~90% ultimate strength by 30 min at room temp",
  "mix_ratio": "10:1 (resin:activator, by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75\u00b0F/24\u00b0C"
 },
 "pid:7819763351622": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "white"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part acrylic (methacrylate) seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20 to 25 minutes; parts can be moved in 30 minutes; about 90 percent of ultimate strength at 30 minutes, room temperature cure",
  "mix_ratio": "10:1 (resin to activator, by volume)",
  "uv_stable": true,
  "viscosity": "Paste",
  "work_time": "8 to 12 minutes at 75F/24C"
 },
 "pid:7819763810374": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "onias"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "methacrylate (MMA) seaming adhesive",
  "problems": [],
  "cure_time": "20 to 25 minutes fixture time at 75\u00b0F; parts can be moved in 30 minutes",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75\u00b0F"
 },
 "pid:7819764236358": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "frosty white"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA), 10:1 dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min at 75\u00b0F; movable at 30 min; ~90% ultimate strength at 30 min",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75\u00b0F"
 },
 "pid:7819764400198": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "daybreak"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA), 10:1 dripless cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min at 75\u00b0F; movable at 30 min; ~90% ultimate strength at 30 min",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75\u00b0F"
 },
 "pid:7819764531270": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "tuscan white"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Methacrylate (two-part, 10:1)",
  "problems": [
   "crack",
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 minutes; parts can be moved after 30 minutes at 75 F (24 C)",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75 F (24 C)"
 },
 "pid:7819764629574": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "steak red"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "No-drip acrylic (methacrylate) seaming adhesive, 2-part 10:1 cartridge",
  "problems": [
   "bond-failure"
  ],
  "cure_time": "Fixture time 20-25 min; can be moved in 30 min; ~90% ultimate strength at 30 min (room temp); full cure longer",
  "mix_ratio": "10:1 by volume/weight (Part A resin : Part B activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75\u00b0F/24\u00b0C"
 },
 "pid:7819764826182": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "industrial"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part acrylic/MMA (methyl methacrylate) seaming adhesive",
  "problems": [],
  "cure_time": "Fixture time 20 to 25 minutes; can be moved in 30 minutes; ~90% ultimate strength at 30 minutes (room temperature cure)",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75 F / 24 C"
 },
 "pid:7819764957254": {
  "app": [
   "seaming",
   "substrate-bonding"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "argento"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) no-drip seaming adhesive, SL9000 series",
  "problems": [],
  "cure_time": "Fixture time 20-25 min; movable in 30 min (room-temp cure, 65-85F operating range)",
  "mix_ratio": "10:1 (resin:activator, by volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819765317702": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "timber wolf"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part no-drip acrylic (methacrylate) seaming adhesive, 10:1 resin/activator",
  "problems": [],
  "cure_time": "Fixture time 20-25 min at 75 F; parts can be moved in 30 min; reaches ~90% ultimate strength at 30 min room-temp cure (65-85 F operating range)",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8 to 12 minutes at 75 F / 24 C"
 },
 "pid:7819765547078": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "bavarian cream"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part methacrylate (MMA), 10:1 dripless cartridge",
  "problems": [],
  "cure_time": "Fixture time 20-25 min at 75\u00b0F; movable at 30 min; ~90% ultimate strength at 30 min",
  "mix_ratio": "10:1 (resin:activator)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75\u00b0F (operating range 65-85\u00b0F)"
 },
 "pid:7819765612614": {
  "app": [
   "seaming",
   "repair",
   "laminating"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "sahara"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "Two-part no-drip acrylic/methacrylate (MMA) seaming adhesive, 10:1 dripless cartridge",
  "problems": [
   "bond-failure",
   "crack"
  ],
  "cure_time": "20-25 minute fixture time to ~90% ultimate strength (75F/24C); can be moved in 30 minutes",
  "mix_ratio": "10:1 (resin:activator, by weight or volume)",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 75F/24C"
 },
 "pid:7819766005830": {
  "app": [
   "seaming"
  ],
  "env": [
   "interior",
   "exterior"
  ],
  "mat": [
   "granite",
   "marble",
   "engineered",
   "sintered",
   "porcelain"
  ],
  "disc": false,
  "type": "adhesive",
  "colors": [
   "pebble"
  ],
  "vendor": "Big Dog Adhesives",
  "subtype": "two-part methacrylate (MMA) seaming adhesive",
  "problems": [],
  "cure_time": "~90% of ultimate strength in 20-25 minutes at room temperature",
  "mix_ratio": "10:1",
  "uv_stable": true,
  "viscosity": "Dripless Cartridge",
  "work_time": "8-12 minutes at 65-85F"
 }
};
